export const awsServices = {
  account: {
    name: "AWS Account Management",
    servicePrefix: "account",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsaccountmanagement.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/accounts/latest/reference/api-reference.html",
    resourceTypes: [
      {
        name: "account",
        referenceHref:
          "https://docs.aws.amazon.com/accounts/latest/reference/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-resources",
        arnPattern: "arn:${Partition}:account::${Account}:account",
        conditionKeys: [],
      },
      {
        name: "accountInOrganization",
        referenceHref:
          "https://docs.aws.amazon.com/accounts/latest/reference/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-resources",
        arnPattern:
          "arn:${Partition}:account::${ManagementAccountId}:account/o-${OrganizationId}/${MemberAccountId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "account:AccountResourceOrgPaths",
        referenceHref:
          "https://docs.aws.amazon.com/accounts/latest/reference/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the resource path for an account in an organization",
        type: "ArrayOfString",
      },
      {
        name: "account:AccountResourceOrgTags/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/accounts/latest/reference/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by resource tags for an account in an organization",
        type: "String",
      },
      {
        name: "account:AlternateContactTypes",
        referenceHref:
          "https://docs.aws.amazon.com/accounts/latest/reference/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by alternate contact types",
        type: "ArrayOfString",
      },
      {
        name: "account:TargetRegion",
        referenceHref:
          "https://docs.aws.amazon.com/accounts/latest/reference/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by a list of Regions. Enables or disables all the Regions specified here",
        type: "String",
      },
    ],
  },
  activate: {
    name: "AWS Activate",
    servicePrefix: "activate",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsactivate.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  a4b: {
    name: "Alexa for Business",
    servicePrefix: "a4b",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_alexaforbusiness.html",
    apiReferenceHref: "https://docs.aws.amazon.com/a4b/latest/APIReference/",
    resourceTypes: [
      {
        name: "profile",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_Profile.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:profile/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "room",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_Room.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:room/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "device",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_Device.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:device/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "skillgroup",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_SkillGroup.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:skill-group/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_UserData.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:user/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "addressbook",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_AddressBook.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:address-book/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "conferenceprovider",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_ConferenceProvider.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:conference-provider/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "contact",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_Contact.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:contact/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "schedule",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_BusinessReportSchedule.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:schedule/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "networkprofile",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_NetworkProfile.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:network-profile/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "gateway",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_Gateway.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:gateway/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "gatewaygroup",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_GatewayGroup.html",
        arnPattern:
          "arn:${Partition}:a4b:${Region}:${Account}:gateway-group/${ResourceId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "a4b:amazonId",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_RegisterAVSDevice.html",
        description: "Filters actions based on the Amazon Id in the request",
        type: "String",
      },
      {
        name: "a4b:filters_deviceType",
        referenceHref:
          "https://docs.aws.amazon.com/a4b/latest/APIReference/API_SearchDevices.html",
        description: "Filters actions based on the device type in the request",
        type: "ArrayOfString",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag-value assoicated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  mediaimport: {
    name: "AmazonMediaImport",
    servicePrefix: "mediaimport",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmediaimport.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonRDS/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  amplify: {
    name: "AWS Amplify",
    servicePrefix: "amplify",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsamplify.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amplify/latest/APIReference/",
    resourceTypes: [
      {
        name: "apps",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html",
        arnPattern:
          "arn:${Partition}:amplify:${Region}:${Account}:apps/${AppId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "branches",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html",
        arnPattern:
          "arn:${Partition}:amplify:${Region}:${Account}:apps/${AppId}/branches/${BranchName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "jobs",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html",
        arnPattern:
          "arn:${Partition}:amplify:${Region}:${Account}:apps/${AppId}/branches/${BranchName}/jobs/${JobId}",
        conditionKeys: [],
      },
      {
        name: "domains",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html",
        arnPattern:
          "arn:${Partition}:amplify:${Region}:${Account}:apps/${AppId}/domains/${DomainName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "webhooks",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/userguide/welcome.html",
        arnPattern:
          "arn:${Partition}:amplify:${Region}:${Account}:webhooks/${WebhookId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by a tag's key associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
    ],
  },
  amplifybackend: {
    name: "AWS Amplify Admin",
    servicePrefix: "amplifybackend",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsamplifyadmin.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/",
    resourceTypes: [
      {
        name: "backend",
        referenceHref:
          "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/backend.html",
        arnPattern:
          "arn:${Partition}:amplifybackend:${Region}:${Account}:backend/${AppId}",
        conditionKeys: [],
      },
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/backend-appid-api-backendenvironmentname-details.html",
        arnPattern:
          "arn:${Partition}:amplifybackend:${Region}:${Account}:backend/${AppId}/environments",
        conditionKeys: [],
      },
      {
        name: "api",
        referenceHref:
          "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/backend-appid-api.html",
        arnPattern:
          "arn:${Partition}:amplifybackend:${Region}:${Account}:backend/${AppId}/api",
        conditionKeys: [],
      },
      {
        name: "auth",
        referenceHref:
          "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/backend-appid-auth.html",
        arnPattern:
          "arn:${Partition}:amplifybackend:${Region}:${Account}:backend/${AppId}/auth",
        conditionKeys: [],
      },
      {
        name: "job",
        referenceHref:
          "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/backend-appid-job-backendenvironmentname.html",
        arnPattern:
          "arn:${Partition}:amplifybackend:${Region}:${Account}:backend/${AppId}/job",
        conditionKeys: [],
      },
      {
        name: "config",
        referenceHref:
          "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/backend-appid-config.html",
        arnPattern:
          "arn:${Partition}:amplifybackend:${Region}:${Account}:backend/${AppId}/config/*",
        conditionKeys: [],
      },
      {
        name: "token",
        referenceHref:
          "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/backend-appid-token.html",
        arnPattern:
          "arn:${Partition}:amplifybackend:${Region}:${Account}:backend/${AppId}/token",
        conditionKeys: [],
      },
      {
        name: "storage",
        referenceHref:
          "https://docs.aws.amazon.com/amplify-admin-ui/latest/APIReference/backend-appid-storage.html",
        arnPattern:
          "arn:${Partition}:amplifybackend:${Region}:${Account}:backend/${AppId}/storage",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  amplifyuibuilder: {
    name: "AWS Amplify UI Builder",
    servicePrefix: "amplifyuibuilder",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsamplifyuibuilder.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/",
    resourceTypes: [
      {
        name: "CodegenJobResource",
        referenceHref:
          "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/API_CodegenJob.html",
        arnPattern:
          "arn:${Partition}:amplifyuibuilder:${Region}:${Account}:app/${AppId}/environment/${EnvironmentName}/codegen-jobs/${Id}",
        conditionKeys: [
          "amplifyuibuilder:CodegenJobResourceAppId",
          "amplifyuibuilder:CodegenJobResourceEnvironmentName",
          "amplifyuibuilder:CodegenJobResourceId",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ComponentResource",
        referenceHref:
          "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/API_Component.html",
        arnPattern:
          "arn:${Partition}:amplifyuibuilder:${Region}:${Account}:app/${AppId}/environment/${EnvironmentName}/components/${Id}",
        conditionKeys: [
          "amplifyuibuilder:ComponentResourceAppId",
          "amplifyuibuilder:ComponentResourceEnvironmentName",
          "amplifyuibuilder:ComponentResourceId",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "FormResource",
        referenceHref:
          "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/API_Form.html",
        arnPattern:
          "arn:${Partition}:amplifyuibuilder:${Region}:${Account}:app/${AppId}/environment/${EnvironmentName}/forms/${Id}",
        conditionKeys: [
          "amplifyuibuilder:FormResourceAppId",
          "amplifyuibuilder:FormResourceEnvironmentName",
          "amplifyuibuilder:FormResourceId",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ThemeResource",
        referenceHref:
          "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/API_Theme.html",
        arnPattern:
          "arn:${Partition}:amplifyuibuilder:${Region}:${Account}:app/${AppId}/environment/${EnvironmentName}/themes/${Id}",
        conditionKeys: [
          "amplifyuibuilder:ThemeResourceAppId",
          "amplifyuibuilder:ThemeResourceEnvironmentName",
          "amplifyuibuilder:ThemeResourceId",
          "aws:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "amplifyuibuilder:CodegenJobResourceAppId",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/APIReference/API_App.html",
        description: "Filters access by the app ID",
        type: "String",
      },
      {
        name: "amplifyuibuilder:CodegenJobResourceEnvironmentName",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/APIReference/API_BackendEnvironment.html",
        description: "Filters access by the backend environment name",
        type: "String",
      },
      {
        name: "amplifyuibuilder:CodegenJobResourceId",
        referenceHref:
          "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/API_CodegenJob.html",
        description: "Filters access by the codegen job ID",
        type: "String",
      },
      {
        name: "amplifyuibuilder:ComponentResourceAppId",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/APIReference/API_App.html",
        description: "Filters access by the app ID",
        type: "String",
      },
      {
        name: "amplifyuibuilder:ComponentResourceEnvironmentName",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/APIReference/API_BackendEnvironment.html",
        description: "Filters access by the backend environment name",
        type: "String",
      },
      {
        name: "amplifyuibuilder:ComponentResourceId",
        referenceHref:
          "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/API_Component.html",
        description: "Filters access by the component ID",
        type: "String",
      },
      {
        name: "amplifyuibuilder:FormResourceAppId",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/APIReference/API_App.html",
        description: "Filters access by the app ID",
        type: "String",
      },
      {
        name: "amplifyuibuilder:FormResourceEnvironmentName",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/APIReference/API_BackendEnvironment.html",
        description: "Filters access by the backend environment name",
        type: "String",
      },
      {
        name: "amplifyuibuilder:FormResourceId",
        referenceHref:
          "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/API_Form.html",
        description: "Filters access by the form ID",
        type: "String",
      },
      {
        name: "amplifyuibuilder:ThemeResourceAppId",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/APIReference/API_App.html",
        description: "Filters access by the app ID",
        type: "String",
      },
      {
        name: "amplifyuibuilder:ThemeResourceEnvironmentName",
        referenceHref:
          "https://docs.aws.amazon.com/amplify/latest/APIReference/API_BackendEnvironment.html",
        description: "Filters access by the backend environment name",
        type: "String",
      },
      {
        name: "amplifyuibuilder:ThemeResourceId",
        referenceHref:
          "https://docs.aws.amazon.com/amplifyuibuilder/latest/APIReference/API_Theme.html",
        description: "Filters access by the theme ID",
        type: "String",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "kafka-cluster": {
    name: "Apache Kafka APIs for Amazon MSK clusters",
    servicePrefix: "kafka-cluster",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_apachekafkaapisforamazonmskclusters.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/msk/latest/developerguide/iam-access-control.html",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/msk/latest/developerguide/iam-access-control.html#msk-iam-resources",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:cluster/${ClusterName}/${ClusterUuid}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "topic",
        referenceHref:
          "https://docs.aws.amazon.com/msk/latest/developerguide/iam-access-control.html#msk-iam-resources",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:topic/${ClusterName}/${ClusterUuid}/${TopicName}",
        conditionKeys: [],
      },
      {
        name: "group",
        referenceHref:
          "https://docs.aws.amazon.com/msk/latest/developerguide/iam-access-control.html#msk-iam-resources",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:group/${ClusterName}/${ClusterUuid}/${GroupName}",
        conditionKeys: [],
      },
      {
        name: "transactional-id",
        referenceHref:
          "https://docs.aws.amazon.com/msk/latest/developerguide/iam-access-control.html#msk-iam-resources",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:transactional-id/${ClusterName}/${ClusterUuid}/${TransactionalId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource. The resource tag context key will only apply to the cluster resource, not topics, groups and transactional IDs",
        type: "String",
      },
    ],
  },
  "execute-api": {
    name: "Amazon API Gateway",
    servicePrefix: "execute-api",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonapigateway.html",
    apiReferenceHref: "https://docs.aws.amazon.com/apigateway/api-reference/",
    resourceTypes: [
      {
        name: "execute-api-general",
        arnPattern:
          "arn:${Partition}:execute-api:${Region}:${Account}:${ApiId}/${Stage}/${Method}/${ApiSpecificResourcePath}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  apigateway: {
    name: "Amazon API Gateway Management V2",
    servicePrefix: "apigateway",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonapigatewaymanagementv2.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/apigatewayv2/latest/api-reference/api-reference.html",
    resourceTypes: [
      {
        name: "AccessLogSettings",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/stages/${StageName}/accesslogsettings",
        conditionKeys: [],
      },
      {
        name: "Api",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern: "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}",
        conditionKeys: [
          "apigateway:Request/ApiKeyRequired",
          "apigateway:Request/ApiName",
          "apigateway:Request/AuthorizerType",
          "apigateway:Request/AuthorizerUri",
          "apigateway:Request/DisableExecuteApiEndpoint",
          "apigateway:Request/EndpointType",
          "apigateway:Request/RouteAuthorizationType",
          "apigateway:Resource/ApiKeyRequired",
          "apigateway:Resource/ApiName",
          "apigateway:Resource/AuthorizerType",
          "apigateway:Resource/AuthorizerUri",
          "apigateway:Resource/DisableExecuteApiEndpoint",
          "apigateway:Resource/EndpointType",
          "apigateway:Resource/RouteAuthorizationType",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "Apis",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern: "arn:${Partition}:apigateway:${Region}::/apis",
        conditionKeys: [
          "apigateway:Request/ApiKeyRequired",
          "apigateway:Request/ApiName",
          "apigateway:Request/AuthorizerType",
          "apigateway:Request/AuthorizerUri",
          "apigateway:Request/DisableExecuteApiEndpoint",
          "apigateway:Request/EndpointType",
          "apigateway:Request/RouteAuthorizationType",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ApiMapping",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/domainnames/${DomainName}/apimappings/${ApiMappingId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ApiMappings",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/domainnames/${DomainName}/apimappings",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Authorizer",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/authorizers/${AuthorizerId}",
        conditionKeys: [
          "apigateway:Request/AuthorizerType",
          "apigateway:Request/AuthorizerUri",
          "apigateway:Resource/AuthorizerType",
          "apigateway:Resource/AuthorizerUri",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "Authorizers",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/authorizers",
        conditionKeys: [
          "apigateway:Request/AuthorizerType",
          "apigateway:Request/AuthorizerUri",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "AuthorizersCache",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/stages/${StageName}/cache/authorizers",
        conditionKeys: [],
      },
      {
        name: "Cors",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/cors",
        conditionKeys: [],
      },
      {
        name: "Deployment",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/deployments/${DeploymentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Deployments",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/deployments",
        conditionKeys: [
          "apigateway:Request/StageName",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ExportedAPI",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/exports/${Specification}",
        conditionKeys: [],
      },
      {
        name: "Integration",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/integrations/${IntegrationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Integrations",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/integrations",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "IntegrationResponse",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/integrations/${IntegrationId}/integrationresponses/${IntegrationResponseId}",
        conditionKeys: [],
      },
      {
        name: "IntegrationResponses",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/integrations/${IntegrationId}/integrationresponses",
        conditionKeys: [],
      },
      {
        name: "Model",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/models/${ModelId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Models",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/models",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ModelTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/models/${ModelId}/template",
        conditionKeys: [],
      },
      {
        name: "Route",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/routes/${RouteId}",
        conditionKeys: [
          "apigateway:Request/ApiKeyRequired",
          "apigateway:Request/RouteAuthorizationType",
          "apigateway:Resource/ApiKeyRequired",
          "apigateway:Resource/RouteAuthorizationType",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "Routes",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/routes",
        conditionKeys: [
          "apigateway:Request/ApiKeyRequired",
          "apigateway:Request/RouteAuthorizationType",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "RouteResponse",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/routes/${RouteId}/routeresponses/${RouteResponseId}",
        conditionKeys: [],
      },
      {
        name: "RouteResponses",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/routes/${RouteId}/routeresponses",
        conditionKeys: [],
      },
      {
        name: "RouteRequestParameter",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/routes/${RouteId}/requestparameters/${RequestParameterKey}",
        conditionKeys: [],
      },
      {
        name: "RouteSettings",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/stages/${StageName}/routesettings/${RouteKey}",
        conditionKeys: [],
      },
      {
        name: "Stage",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/stages/${StageName}",
        conditionKeys: [
          "apigateway:Request/AccessLoggingDestination",
          "apigateway:Request/AccessLoggingFormat",
          "apigateway:Resource/AccessLoggingDestination",
          "apigateway:Resource/AccessLoggingFormat",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "Stages",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/apis/${ApiId}/stages",
        conditionKeys: [
          "apigateway:Request/AccessLoggingDestination",
          "apigateway:Request/AccessLoggingFormat",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "VpcLink",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/vpclinks/${VpcLinkId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "VpcLinks",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        arnPattern: "arn:${Partition}:apigateway:${Region}::/vpclinks",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "apigateway:Request/AccessLoggingDestination",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by access log destination. Available during the CreateStage and UpdateStage operations",
        type: "String",
      },
      {
        name: "apigateway:Request/AccessLoggingFormat",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by access log format. Available during the CreateStage and UpdateStage operations",
        type: "String",
      },
      {
        name: "apigateway:Request/ApiKeyRequired",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the requirement of API. Available during the CreateRoute and UpdateRoute operations. Also available as a collection during import and reimport",
        type: "ArrayOfBool",
      },
      {
        name: "apigateway:Request/ApiName",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by API name. Available during the CreateApi and UpdateApi operations",
        type: "String",
      },
      {
        name: "apigateway:Request/AuthorizerType",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by type of authorizer in the request, for example REQUEST or JWT. Available during CreateAuthorizer and UpdateAuthorizer. Also available during import and reimport as an ArrayOfString",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Request/AuthorizerUri",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by URI of a Lambda authorizer function. Available during CreateAuthorizer and UpdateAuthorizer. Also available during import and reimport as an ArrayOfString",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Request/DisableExecuteApiEndpoint",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by status of the default execute-api endpoint. Available during the CreateApi and UpdateApi operations",
        type: "Bool",
      },
      {
        name: "apigateway:Request/EndpointType",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by endpoint type. Available during the CreateDomainName, UpdateDomainName, CreateApi, and UpdateApi operations",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Request/MtlsTrustStoreUri",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by URI of the truststore used for mutual TLS authentication. Available during the CreateDomainName and UpdateDomainName operations",
        type: "String",
      },
      {
        name: "apigateway:Request/MtlsTrustStoreVersion",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by version of the truststore used for mutual TLS authentication. Available during the CreateDomainName and UpdateDomainName operations",
        type: "String",
      },
      {
        name: "apigateway:Request/RouteAuthorizationType",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by authorization type, for example NONE, AWS_IAM, CUSTOM, JWT. Available during the CreateRoute and UpdateRoute operations. Also available as a collection during import",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Request/SecurityPolicy",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by TLS version. Available during the CreateDomain and UpdateDomain operations",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Request/StageName",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by stage name of the deployment that you attempt to create. Available during the CreateDeployment operation",
        type: "String",
      },
      {
        name: "apigateway:Resource/AccessLoggingDestination",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by access log destination of the current Stage resource. Available during the UpdateStage and DeleteStage operations",
        type: "String",
      },
      {
        name: "apigateway:Resource/AccessLoggingFormat",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by access log format of the current Stage resource. Available during the UpdateStage and DeleteStage operations",
        type: "String",
      },
      {
        name: "apigateway:Resource/ApiKeyRequired",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the requirement of API key for the existing Route resource. Available during the UpdateRoute and DeleteRoute operations. Also available as a collection during reimport",
        type: "ArrayOfBool",
      },
      {
        name: "apigateway:Resource/ApiName",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by API name. Available during the UpdateApi and DeleteApi operations",
        type: "String",
      },
      {
        name: "apigateway:Resource/AuthorizerType",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the current type of authorizer, for example REQUEST or JWT. Available during UpdateAuthorizer and DeleteAuthorizer operations. Also available during import and reimport as an ArrayOfString",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Resource/AuthorizerUri",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the URI of the current Lambda authorizer associated with the current API. Available during UpdateAuthorizer and DeleteAuthorizer. Also available as a collection during reimport",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Resource/DisableExecuteApiEndpoint",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by status of the default execute-api endpoint. Available during the UpdateApi and DeleteApi operations",
        type: "Bool",
      },
      {
        name: "apigateway:Resource/EndpointType",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by endpoint type. Available during the UpdateDomainName, DeleteDomainName, UpdateApi, and DeleteApi operations",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Resource/MtlsTrustStoreUri",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by URI of the truststore used for mutual TLS authentication. Available during the UpdateDomainName and DeleteDomainName operations",
        type: "String",
      },
      {
        name: "apigateway:Resource/MtlsTrustStoreVersion",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by version of the truststore used for mutual TLS authentication. Available during the UpdateDomainName and DeleteDomainName operations",
        type: "String",
      },
      {
        name: "apigateway:Resource/RouteAuthorizationType",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by authorization type of the existing Route resource, for example NONE, AWS_IAM, CUSTOM. Available during the UpdateRoute and DeleteRoute operations. Also available as a collection during reimport",
        type: "ArrayOfString",
      },
      {
        name: "apigateway:Resource/SecurityPolicy",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/security_iam_service-with-iam.html",
        description:
          "Filters access by TLS version. Available during the UpdateDomainName and DeleteDomainName operations",
        type: "ArrayOfString",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/apigateway-tagging.html",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/apigateway-tagging.html",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/apigateway/latest/developerguide/apigateway-tagging.html",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  appmesh: {
    name: "AWS App Mesh",
    servicePrefix: "appmesh",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsappmesh.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/app-mesh/latest/APIReference/",
    resourceTypes: [
      {
        name: "mesh",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/meshes.html",
        arnPattern:
          "arn:${Partition}:appmesh:${Region}:${Account}:mesh/${MeshName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "virtualService",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_services.html",
        arnPattern:
          "arn:${Partition}:appmesh:${Region}:${Account}:mesh/${MeshName}/virtualService/${VirtualServiceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "virtualNode",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_nodes.html",
        arnPattern:
          "arn:${Partition}:appmesh:${Region}:${Account}:mesh/${MeshName}/virtualNode/${VirtualNodeName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "virtualRouter",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_routers.html",
        arnPattern:
          "arn:${Partition}:appmesh:${Region}:${Account}:mesh/${MeshName}/virtualRouter/${VirtualRouterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "route",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/routes.html",
        arnPattern:
          "arn:${Partition}:appmesh:${Region}:${Account}:mesh/${MeshName}/virtualRouter/${VirtualRouterName}/route/${RouteName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "virtualGateway",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_gateways.html",
        arnPattern:
          "arn:${Partition}:appmesh:${Region}:${Account}:mesh/${MeshName}/virtualGateway/${VirtualGatewayName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "gatewayRoute",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_gateways.html",
        arnPattern:
          "arn:${Partition}:appmesh:${Region}:${Account}:mesh/${MeshName}/virtualGateway/${VirtualGatewayName}/gatewayRoute/${GatewayRouteName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "appmesh-preview": {
    name: "AWS App Mesh Preview",
    servicePrefix: "appmesh-preview",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsappmeshpreview.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/app-mesh/latest/APIReference/",
    resourceTypes: [
      {
        name: "mesh",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/meshes.html",
        arnPattern:
          "arn:${Partition}:appmesh-preview:${Region}:${Account}:mesh/${MeshName}",
        conditionKeys: [],
      },
      {
        name: "virtualService",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_services.html",
        arnPattern:
          "arn:${Partition}:appmesh-preview:${Region}:${Account}:mesh/${MeshName}/virtualService/${VirtualServiceName}",
        conditionKeys: [],
      },
      {
        name: "virtualNode",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_nodes.html",
        arnPattern:
          "arn:${Partition}:appmesh-preview:${Region}:${Account}:mesh/${MeshName}/virtualNode/${VirtualNodeName}",
        conditionKeys: [],
      },
      {
        name: "virtualRouter",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_routers.html",
        arnPattern:
          "arn:${Partition}:appmesh-preview:${Region}:${Account}:mesh/${MeshName}/virtualRouter/${VirtualRouterName}",
        conditionKeys: [],
      },
      {
        name: "route",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/routes.html",
        arnPattern:
          "arn:${Partition}:appmesh-preview:${Region}:${Account}:mesh/${MeshName}/virtualRouter/${VirtualRouterName}/route/${RouteName}",
        conditionKeys: [],
      },
      {
        name: "virtualGateway",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_gateways.html",
        arnPattern:
          "arn:${Partition}:appmesh-preview:${Region}:${Account}:mesh/${MeshName}/virtualGateway/${VirtualGatewayName}",
        conditionKeys: [],
      },
      {
        name: "gatewayRoute",
        referenceHref:
          "https://docs.aws.amazon.com/app-mesh/latest/userguide/virtual_gateways.html",
        arnPattern:
          "arn:${Partition}:appmesh-preview:${Region}:${Account}:mesh/${MeshName}/virtualGateway/${VirtualGatewayName}/gatewayRoute/${GatewayRouteName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  apprunner: {
    name: "AWS App Runner",
    servicePrefix: "apprunner",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsapprunner.html",
    apiReferenceHref: "https://docs.aws.amazon.com/apprunner/latest/api/",
    resourceTypes: [
      {
        name: "service",
        referenceHref:
          "${UserGuideDocPage}architecture.html#architecture.resources",
        arnPattern:
          "arn:${Partition}:apprunner:${Region}:${Account}:service/${ServiceName}/${ServiceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "connection",
        referenceHref:
          "${UserGuideDocPage}architecture.html#architecture.resources",
        arnPattern:
          "arn:${Partition}:apprunner:${Region}:${Account}:connection/${ConnectionName}/${ConnectionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "autoscalingconfiguration",
        referenceHref:
          "${UserGuideDocPage}architecture.html#architecture.resources",
        arnPattern:
          "arn:${Partition}:apprunner:${Region}:${Account}:autoscalingconfiguration/${AutoscalingConfigurationName}/${AutoscalingConfigurationVersion}/${AutoscalingConfigurationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "observabilityconfiguration",
        referenceHref:
          "${UserGuideDocPage}architecture.html#architecture.resources",
        arnPattern:
          "arn:${Partition}:apprunner:${Region}:${Account}:observabilityconfiguration/${ObservabilityConfigurationName}/${ObservabilityConfigurationVersion}/${ObservabilityConfigurationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vpcconnector",
        referenceHref:
          "${UserGuideDocPage}architecture.html#architecture.resources",
        arnPattern:
          "arn:${Partition}:apprunner:${Region}:${Account}:vpcconnector/${VpcConnectorName}/${VpcConnectorVersion}/${VpcConnectorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vpcingressconnection",
        referenceHref:
          "${UserGuideDocPage}architecture.html#architecture.resources",
        arnPattern:
          "arn:${Partition}:apprunner:${Region}:${Account}:vpcingressconnection/${VpcIngressConnectionName}/${VpcIngressConnectionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "webacl",
        referenceHref: "${UserGuideDocPage}waf.html",
        arnPattern:
          "arn:${Partition}:wafv2:${Region}:${Account}:${Scope}/webacl/${Name}/${Id}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "apprunner:AutoScalingConfigurationArn",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by the CreateService and UpdateService actions based on the ARN of an associated AutoScalingConfiguration resource",
        type: "ARN",
      },
      {
        name: "apprunner:ConnectionArn",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by the CreateService and UpdateService actions based on the ARN of an associated Connection resource",
        type: "ARN",
      },
      {
        name: "apprunner:ObservabilityConfigurationArn",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by the CreateService and UpdateService actions based on the ARN of an associated ObservabilityConfiguration resource",
        type: "ARN",
      },
      {
        name: "apprunner:ServiceArn",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by the CreateVpcIngressConnection action based on the ARN of an associated Service resource",
        type: "ARN",
      },
      {
        name: "apprunner:VpcConnectorArn",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by the CreateService and UpdateService actions based on the ARN of an associated VpcConnector resource",
        type: "ARN",
      },
      {
        name: "apprunner:VpcEndpointId",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by the CreateVpcIngressConnection and UpdateVpcIngressConnection actions based on the VPC Endpoint in the request",
        type: "String",
      },
      {
        name: "apprunner:VpcId",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by the CreateVpcIngressConnection and UpdateVpcIngressConnection actions based on the VPC in the request",
        type: "String",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "${UserGuideDocPage}security_iam_service-with-iam.html#security_iam_service-with-iam-resource-based-policies",
        description:
          "Filters access by actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  a2c: {
    name: "AWS App2Container",
    servicePrefix: "a2c",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsapp2container.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/tk-dotnet-refactoring/latest/userguide/what-is-tk-dotnet-refactoring.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  appconfig: {
    name: "AWS AppConfig",
    servicePrefix: "appconfig",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsappconfig.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/appconfig/2019-10-09/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-creating-application.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:application/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-creating-environment.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:application/${ApplicationId}/environment/${EnvironmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "configurationprofile",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-creating-configuration-and-profile.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:application/${ApplicationId}/configurationprofile/${ConfigurationProfileId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deploymentstrategy",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-creating-deployment-strategy.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:deploymentstrategy/${DeploymentStrategyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deployment",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-deploying.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:application/${ApplicationId}/environment/${EnvironmentId}/deployment/${DeploymentNumber}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "hostedconfigurationversion",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-creating-configuration-and-profile.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:application/${ApplicationId}/configurationprofile/${ConfigurationProfileId}/hostedconfigurationversion/${VersionNumber}",
        conditionKeys: [],
      },
      {
        name: "configuration",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-retrieving-the-configuration.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:application/${ApplicationId}/environment/${EnvironmentId}/configuration/${ConfigurationProfileId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "extension",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/working-with-appconfig-extensions.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:extension/${ExtensionId}/${ExtensionVersionNumber}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "extensionassociation",
        referenceHref:
          "https://docs.aws.amazon.com/appconfig/latest/userguide/working-with-appconfig-extensions.html",
        arnPattern:
          "arn:${Partition}:appconfig:${Region}:${Account}:extensionassociation/${ExtensionAssociationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by the allowed set of values for a specified tag",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by a tag key-value pair assigned to the AWS resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  appfabric: {
    name: "AWS AppFabric",
    servicePrefix: "appfabric",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsappfabric.html",
    apiReferenceHref: "https://docs.aws.amazon.com/appfabric/latest/api/",
    resourceTypes: [
      {
        name: "appbundle",
        referenceHref:
          "https://docs.aws.amazon.com/appfabric/latest/api/API_AppBundle.html",
        arnPattern:
          "arn:${Partition}:appfabric:${Region}:${Account}:appbundle/${AppBundleIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "appauthorization",
        referenceHref:
          "https://docs.aws.amazon.com/appfabric/latest/api/API_AppAuthorization.html",
        arnPattern:
          "arn:${Partition}:appfabric:${Region}:${Account}:appbundle/${AppbundleId}/appauthorization/${AppAuthorizationIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ingestion",
        referenceHref:
          "https://docs.aws.amazon.com/appfabric/latest/api/API_Ingestion.html",
        arnPattern:
          "arn:${Partition}:appfabric:${Region}:${Account}:appbundle/${AppbundleId}/ingestion/${IngestionIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ingestiondestination",
        referenceHref:
          "https://docs.aws.amazon.com/appfabric/latest/api/API_IngestionDestination.html",
        arnPattern:
          "arn:${Partition}:appfabric:${Region}:${Account}:appbundle/${AppbundleId}/ingestion/${IngestionIdentifier}/ingestiondestination/${IngestionDestinationIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  appflow: {
    name: "Amazon AppFlow",
    servicePrefix: "appflow",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonappflow.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/appflow/1.0/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "connectorprofile",
        referenceHref:
          "https://docs.aws.amazon.com/appflow/1.0/APIReference/API_ConnectorProfile.html",
        arnPattern:
          "arn:${Partition}:appflow:${Region}:${Account}:connectorprofile/${ProfileName}",
        conditionKeys: [],
      },
      {
        name: "flow",
        referenceHref:
          "https://docs.aws.amazon.com/appflow/1.0/APIReference/API_FlowDefinition.html",
        arnPattern:
          "arn:${Partition}:appflow:${Region}:${Account}:flow/${FlowName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "connector",
        referenceHref:
          "https://docs.aws.amazon.com/appflow/1.0/APIReference/API_ConnectorDetail.html",
        arnPattern:
          "arn:${Partition}:appflow:${Region}:${Account}:connector/${ConnectorLabel}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "app-integrations": {
    name: "Amazon AppIntegrations",
    servicePrefix: "app-integrations",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonappintegrations.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/appintegrations/latest/APIReference/",
    resourceTypes: [
      {
        name: "event-integration",
        referenceHref:
          "https://docs.aws.amazon.com/appintegrations/latest/APIReference/API_EventIntegration.html",
        arnPattern:
          "arn:${Partition}:app-integrations:${Region}:${Account}:event-integration/${EventIntegrationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "event-integration-association",
        referenceHref:
          "https://docs.aws.amazon.com/appintegrations/latest/APIReference/API_EventIntegrationAssociation.html",
        arnPattern:
          "arn:${Partition}:app-integrations:${Region}:${Account}:event-integration-association/${EventIntegrationName}/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "data-integration",
        referenceHref:
          "https://docs.aws.amazon.com/appintegrations/latest/APIReference/API_DataIntegrationSummary.html",
        arnPattern:
          "arn:${Partition}:app-integrations:${Region}:${Account}:data-integration/${DataIntegrationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "data-integration-association",
        referenceHref:
          "https://docs.aws.amazon.com/appintegrations/latest/APIReference/API_DataIntegrationAssociationSummary.html",
        arnPattern:
          "arn:${Partition}:app-integrations:${Region}:${Account}:data-integration-association/${DataIntegrationId}/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/appintegrations/latest/APIReference/API_ApplicationSummary.html",
        arnPattern:
          "arn:${Partition}:app-integrations:${Region}:${Account}:application/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "application-association",
        referenceHref:
          "https://docs.aws.amazon.com/appintegrations/latest/APIReference/API_ApplicationAssociationSummary.html",
        arnPattern:
          "arn:${Partition}:app-integrations:${Region}:${Account}:application-association/${ApplicationId}/${ApplicationAssociationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "application-autoscaling": {
    name: "AWS Application Auto Scaling",
    servicePrefix: "application-autoscaling",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsapplicationautoscaling.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/autoscaling/application/APIReference/",
    resourceTypes: [
      {
        name: "ScalableTarget",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/application/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-resources",
        arnPattern:
          "arn:${Partition}:application-autoscaling:${Region}:${Account}:scalable-target/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "application-autoscaling:scalable-dimension",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/application/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the scalable dimension that is passed in the request",
        type: "String",
      },
      {
        name: "application-autoscaling:service-namespace",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/application/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the service namespace that is passed in the request",
        type: "String",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/application/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/application/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/application/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "application-cost-profiler": {
    name: "AWS Application Cost Profiler Service",
    servicePrefix: "application-cost-profiler",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsapplicationcostprofilerservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/application-cost-profiler/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  arsenal: {
    name: "Application Discovery Arsenal",
    servicePrefix: "arsenal",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_applicationdiscoveryarsenal.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/application-discovery/latest/userguide/",
    resourceTypes: [],
    conditionKeys: [],
  },
  discovery: {
    name: "AWS Application Discovery Service",
    servicePrefix: "discovery",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsapplicationdiscoveryservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/application-discovery/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  mgn: {
    name: "AWS Application Migration Service",
    servicePrefix: "mgn",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsapplicationmigrationservice.html",
    apiReferenceHref: "https://docs.aws.amazon.com/mgn/latest/APIReference/",
    resourceTypes: [
      {
        name: "JobResource",
        referenceHref:
          "https://docs.aws.amazon.com/mgn/latest/ug/launching-target-servers.html",
        arnPattern: "arn:${Partition}:mgn:${Region}:${Account}:job/${JobID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ReplicationConfigurationTemplateResource",
        referenceHref:
          "https://docs.aws.amazon.com/mgn/latest/ug/replication-settings-template.html",
        arnPattern:
          "arn:${Partition}:mgn:${Region}:${Account}:replication-configuration-template/${ReplicationConfigurationTemplateID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "LaunchConfigurationTemplateResource",
        referenceHref:
          "https://docs.aws.amazon.com/mgn/latest/ug/post-launch-settings.html",
        arnPattern:
          "arn:${Partition}:mgn:${Region}:${Account}:launch-configuration-template/${LaunchConfigurationTemplateID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "VcenterClientResource",
        referenceHref:
          "https://docs.aws.amazon.com/mgn/latest/ug/agentless-mgn.html",
        arnPattern:
          "arn:${Partition}:mgn:${Region}:${Account}:vcenter-client/${VcenterClientID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "SourceServerResource",
        referenceHref:
          "https://docs.aws.amazon.com/mgn/latest/ug/source-servers.html",
        arnPattern:
          "arn:${Partition}:mgn:${Region}:${Account}:source-server/${SourceServerID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ApplicationResource",
        referenceHref:
          "https://docs.aws.amazon.com/mgn/latest/ug/applications.html",
        arnPattern:
          "arn:${Partition}:mgn:${Region}:${Account}:application/${ApplicationID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "WaveResource",
        referenceHref: "https://docs.aws.amazon.com/mgn/latest/ug/waves.html",
        arnPattern: "arn:${Partition}:mgn:${Region}:${Account}:wave/${WaveID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ImportResource",
        referenceHref: "https://docs.aws.amazon.com/mgn/latest/ug/imports.html",
        arnPattern:
          "arn:${Partition}:mgn:${Region}:${Account}:import/${ImportID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ExportResource",
        referenceHref: "https://docs.aws.amazon.com/mgn/latest/ug/exports.html",
        arnPattern:
          "arn:${Partition}:mgn:${Region}:${Account}:export/${ExportID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ConnectorResource",
        referenceHref:
          "https://docs.aws.amazon.com/mgn/latest/ug/connectors.html",
        arnPattern:
          "arn:${Partition}:mgn:${Region}:${Account}:connector/${ConnectorID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "mgn:CreateAction",
        referenceHref:
          "https://docs.aws.amazon.com/mgn/latest/ug/supported-iam-actions-tagging.html",
        description:
          "Filters access by the name of a resource-creating API action",
        type: "String",
      },
    ],
  },
  "application-transformation": {
    name: "AWS Application Transformation Service",
    servicePrefix: "application-transformation",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsapplicationtransformationservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/microservice-extractor/latest/userguide/what-is-microservice-extractor.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  appstream: {
    name: "Amazon AppStream 2.0",
    servicePrefix: "appstream",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonappstream2.0.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/appstream2/latest/developerguide/",
    resourceTypes: [
      {
        name: "fleet",
        referenceHref:
          "https://docs.aws.amazon.com/appstream2/latest/developerguide/what-is-appstream.html#what-is-concepts",
        arnPattern:
          "arn:${Partition}:appstream:${Region}:${Account}:fleet/${FleetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "image",
        referenceHref:
          "https://docs.aws.amazon.com/appstream2/latest/developerguide/what-is-appstream.html#what-is-concepts",
        arnPattern:
          "arn:${Partition}:appstream:${Region}:${Account}:image/${ImageName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "image-builder",
        referenceHref:
          "https://docs.aws.amazon.com/appstream2/latest/developerguide/what-is-appstream.html#what-is-concepts",
        arnPattern:
          "arn:${Partition}:appstream:${Region}:${Account}:image-builder/${ImageBuilderName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "stack",
        referenceHref:
          "https://docs.aws.amazon.com/appstream2/latest/developerguide/what-is-appstream.html#what-is-concepts",
        arnPattern:
          "arn:${Partition}:appstream:${Region}:${Account}:stack/${StackName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "app-block",
        referenceHref:
          "https://docs.aws.amazon.com/appstream2/latest/developerguide/what-is-appstream.html#what-is-concepts",
        arnPattern:
          "arn:${Partition}:appstream:${Region}:${Account}:app-block/${AppBlockName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/appstream2/latest/developerguide/what-is-appstream.html#what-is-concepts",
        arnPattern:
          "arn:${Partition}:appstream:${Region}:${Account}:application/${ApplicationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "app-block-builder",
        referenceHref:
          "https://docs.aws.amazon.com/appstream2/latest/developerguide/what-is-appstream.html#what-is-concepts",
        arnPattern:
          "arn:${Partition}:appstream:${Region}:${Account}:app-block-builder/${AppBlockBuilderName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "appstream:userId",
        referenceHref:
          "https://docs.aws.amazon.com/appstream2/latest/developerguide/external-identity-providers-setting-up-saml.html#external-identity-providers-embed-inline-policy-for-IAM-role",
        description: "Filters access by the ID of the AppStream 2.0 user",
        type: "String",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  appsync: {
    name: "AWS AppSync",
    servicePrefix: "appsync",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsappsync.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/appsync/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "datasource",
        referenceHref:
          "https://docs.aws.amazon.com/appsync/latest/devguide/attaching-a-data-source.html",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:apis/${GraphQLAPIId}/datasources/${DatasourceName}",
        conditionKeys: [],
      },
      {
        name: "domain",
        referenceHref:
          "https://docs.aws.amazon.com/appsync/latest/devguide/custom-domain-name.html",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:domainnames/${DomainName}",
        conditionKeys: [],
      },
      {
        name: "graphqlapi",
        referenceHref:
          "https://docs.aws.amazon.com/appsync/latest/devguide/designing-a-graphql-api.html",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:apis/${GraphQLAPIId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "field",
        referenceHref:
          "https://docs.aws.amazon.com/appsync/latest/devguide/configuring-resolvers.html",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:apis/${GraphQLAPIId}/types/${TypeName}/fields/${FieldName}",
        conditionKeys: [],
      },
      {
        name: "type",
        referenceHref:
          "https://docs.aws.amazon.com/appsync/latest/devguide/designing-your-schema.html#adding-a-root-query-type",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:apis/${GraphQLAPIId}/types/${TypeName}",
        conditionKeys: [],
      },
      {
        name: "function",
        referenceHref:
          "https://docs.aws.amazon.com/appsync/latest/devguide/pipeline-resolvers.html",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:apis/${GraphQLAPIId}/functions/${FunctionId}",
        conditionKeys: [],
      },
      {
        name: "sourceApiAssociation",
        referenceHref:
          "https://docs.aws.amazon.com/appsync/latest/devguide/merged-api.html",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:apis/${MergedGraphQLAPIId}/sourceApiAssociations/${Associationid}",
        conditionKeys: [],
      },
      {
        name: "mergedApiAssociation",
        referenceHref:
          "https://docs.aws.amazon.com/appsync/latest/devguide/merged-api.html",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:apis/${SourceGraphQLAPIId}/mergedApiAssociations/${Associationid}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "appsync:Visibility",
        referenceHref: "iam-policy-structure.html#amazon-appsync-keys",
        description: "Filters access by the visibility of an API",
        type: "String",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  artifact: {
    name: "AWS Artifact",
    servicePrefix: "artifact",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsartifact.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/artifact/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "report-package",
        referenceHref:
          "https://docs.aws.amazon.com/artifact/latest/ug/what-is-aws-artifact.html",
        arnPattern: "arn:${Partition}:artifact:::report-package/*",
        conditionKeys: [],
      },
      {
        name: "customer-agreement",
        referenceHref:
          "https://docs.aws.amazon.com/artifact/latest/ug/managing-agreements.html",
        arnPattern:
          "arn:${Partition}:artifact::${Account}:customer-agreement/*",
        conditionKeys: [],
      },
      {
        name: "agreement",
        referenceHref:
          "https://docs.aws.amazon.com/artifact/latest/ug/managing-agreements.html",
        arnPattern: "arn:${Partition}:artifact:::agreement/*",
        conditionKeys: [],
      },
      {
        name: "report",
        referenceHref:
          "https://docs.aws.amazon.com/artifact/latest/ug/what-is-aws-artifact.html",
        arnPattern: "arn:${Partition}:artifact:${Region}::report/*",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "artifact:ReportCategory",
        referenceHref:
          "https://docs.aws.amazon.com/artifact/latest/ug/using-condition-keys.html",
        description:
          "Filters access by which category reports are associated with",
        type: "String",
      },
      {
        name: "artifact:ReportSeries",
        referenceHref:
          "https://docs.aws.amazon.com/artifact/latest/ug/using-condition-keys.html",
        description:
          "Filters access by which series reports are associated with",
        type: "String",
      },
    ],
  },
  athena: {
    name: "Amazon Athena",
    servicePrefix: "athena",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonathena.html",
    apiReferenceHref: "https://docs.aws.amazon.com/athena/latest/APIReference/",
    resourceTypes: [
      {
        name: "datacatalog",
        referenceHref:
          "https://docs.aws.amazon.com/athena/latest/ug/datacatalogs-example-policies.html",
        arnPattern:
          "arn:${Partition}:athena:${Region}:${Account}:datacatalog/${DataCatalogName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workgroup",
        referenceHref:
          "https://docs.aws.amazon.com/athena/latest/ug/example-policies-workgroup.html",
        arnPattern:
          "arn:${Partition}:athena:${Region}:${Account}:workgroup/${WorkGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "capacity-reservation",
        referenceHref:
          "https://docs.aws.amazon.com/athena/latest/ug/example-policies-capacity-reservations.html",
        arnPattern:
          "arn:${Partition}:athena:${Region}:${Account}:capacity-reservation/${CapacityReservationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  auditmanager: {
    name: "AWS Audit Manager",
    servicePrefix: "auditmanager",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsauditmanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/audit-manager/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "assessment",
        referenceHref:
          "https://docs.aws.amazon.com/audit-manager/latest/userguide/API_Assessment.html",
        arnPattern:
          "arn:${Partition}:auditmanager:${Region}:${Account}:assessment/${AssessmentId}",
        conditionKeys: [],
      },
      {
        name: "assessmentFramework",
        referenceHref:
          "https://docs.aws.amazon.com/audit-manager/latest/userguide/API_AssessmentFramework.html",
        arnPattern:
          "arn:${Partition}:auditmanager:${Region}:${Account}:assessmentFramework/${AssessmentFrameworkId}",
        conditionKeys: [],
      },
      {
        name: "assessmentControlSet",
        referenceHref:
          "https://docs.aws.amazon.com/audit-manager/latest/userguide/API_AssessmentControlSet.html",
        arnPattern:
          "arn:${Partition}:auditmanager:${Region}:${Account}:assessment/${AssessmentId}/controlSet/${ControlSetId}",
        conditionKeys: [],
      },
      {
        name: "control",
        referenceHref:
          "https://docs.aws.amazon.com/audit-manager/latest/userguide/API_Control.html",
        arnPattern:
          "arn:${Partition}:auditmanager:${Region}:${Account}:control/${ControlId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "autoscaling-plans": {
    name: "AWS Auto Scaling",
    servicePrefix: "autoscaling-plans",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsautoscaling.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/autoscaling/plans/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  b2bi: {
    name: "AWS B2B Data Interchange",
    servicePrefix: "b2bi",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsb2bdatainterchange.html",
    apiReferenceHref: "https://docs.aws.amazon.com/b2bi/latest/APIReference/",
    resourceTypes: [
      {
        name: "profile",
        referenceHref: "https://docs.aws.amazon.com/b2bi/latest/userguide/",
        arnPattern:
          "arn:${Partition}:b2bi:${Region}:${Account}:profile/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "capability",
        referenceHref: "https://docs.aws.amazon.com/b2bi/latest/userguide/",
        arnPattern:
          "arn:${Partition}:b2bi:${Region}:${Account}:capability/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "partnership",
        referenceHref: "https://docs.aws.amazon.com/b2bi/latest/userguide/",
        arnPattern:
          "arn:${Partition}:b2bi:${Region}:${Account}:partnership/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "transformer",
        referenceHref: "https://docs.aws.amazon.com/b2bi/latest/userguide/",
        arnPattern:
          "arn:${Partition}:b2bi:${Region}:${Account}:transformer/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  backup: {
    name: "AWS Backup",
    servicePrefix: "backup",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbackup.html",
    apiReferenceHref: "https://docs.aws.amazon.com/aws-backup/latest/devguide/",
    resourceTypes: [
      {
        name: "backupVault",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/vaults.html",
        arnPattern:
          "arn:${Partition}:backup:${Region}:${Account}:backup-vault:${BackupVaultName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "backupPlan",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/about-backup-plans.html",
        arnPattern:
          "arn:${Partition}:backup:${Region}:${Account}:backup-plan:${BackupPlanId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "recoveryPoint",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/recovery-points.html",
        arnPattern:
          "arn:${Partition}:${Vendor}:${Region}:*:${ResourceType}:${RecoveryPointId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "framework",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/working-with-audit-frameworks.html",
        arnPattern:
          "arn:${Partition}:backup:${Region}:${Account}:framework:${FrameworkName}-${FrameworkId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "reportPlan",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/create-report-plan-api.html",
        arnPattern:
          "arn:${Partition}:backup:${Region}:${Account}:report-plan:${ReportPlanName}-${ReportPlanId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "legalHold",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/legalhold.html",
        arnPattern:
          "arn:${Partition}:backup:${Region}:${Account}:legal-hold:${LegalHoldId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "restoreTestingPlan",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/restore-testing-plans.html",
        arnPattern:
          "arn:${Partition}:backup:${Region}:${Account}:restore-testing-plan:${RestoreTestingPlanName}-${RestoreTestingPlanId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "backup:ChangeableForDays",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/access-control.html#amazon-backup-keys",
        description:
          "Filters access by the value of the ChangeableForDays parameter",
        type: "Numeric",
      },
      {
        name: "backup:CopyTargetOrgPaths",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/access-control.html#amazon-backup-keys",
        description: "Filters access by the organization unit",
        type: "ArrayOfString",
      },
      {
        name: "backup:CopyTargets",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/access-control.html#amazon-backup-keys",
        description: "Filters access by the ARN of an backup vault",
        type: "ArrayOfARN",
      },
      {
        name: "backup:FrameworkArns",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/access-control.html#amazon-backup-keys",
        description: "Filters access by the Framework ARNs",
        type: "ArrayOfARN",
      },
      {
        name: "backup:MaxRetentionDays",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/access-control.html#amazon-backup-keys",
        description:
          "Filters access by the value of the MaxRetentionDays parameter",
        type: "Numeric",
      },
      {
        name: "backup:MinRetentionDays",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/access-control.html#amazon-backup-keys",
        description:
          "Filters access by the value of the MinRetentionDays parameter",
        type: "Numeric",
      },
    ],
  },
  "backup-gateway": {
    name: "AWS Backup Gateway",
    servicePrefix: "backup-gateway",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbackupgateway.html",
    apiReferenceHref: "https://docs.aws.amazon.com/aws-backup/latest/devguide/",
    resourceTypes: [
      {
        name: "gateway",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/API_BGW_Gateway.html",
        arnPattern:
          "arn:${Partition}:backup-gateway::${Account}:gateway/${GatewayId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "hypervisor",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/API_BGW_Hypervisor.html",
        arnPattern:
          "arn:${Partition}:backup-gateway::${Account}:hypervisor/${HypervisorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "virtualmachine",
        referenceHref:
          "https://docs.aws.amazon.com/aws-backup/latest/devguide/API_BGW_VirtualMachine.html",
        arnPattern:
          "arn:${Partition}:backup-gateway::${Account}:vm/${VirtualmachineId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "backup-storage": {
    name: "AWS Backup storage",
    servicePrefix: "backup-storage",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbackupstorage.html",
    apiReferenceHref: "https://docs.aws.amazon.com/aws-backup/latest/devguide/",
    resourceTypes: [],
    conditionKeys: [],
  },
  batch: {
    name: "AWS Batch",
    servicePrefix: "batch",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html",
    apiReferenceHref: "https://docs.aws.amazon.com/batch/latest/APIReference/",
    resourceTypes: [
      {
        name: "compute-environment",
        referenceHref:
          "https://docs.aws.amazon.com/batch/latest/userguide/compute_environments.html",
        arnPattern:
          "arn:${Partition}:batch:${Region}:${Account}:compute-environment/${ComputeEnvironmentName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "job-queue",
        referenceHref:
          "https://docs.aws.amazon.com/batch/latest/userguide/job_queues.html",
        arnPattern:
          "arn:${Partition}:batch:${Region}:${Account}:job-queue/${JobQueueName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "job-definition",
        referenceHref:
          "https://docs.aws.amazon.com/batch/latest/userguide/job_definitions.html",
        arnPattern:
          "arn:${Partition}:batch:${Region}:${Account}:job-definition/${JobDefinitionName}",
        conditionKeys: [],
      },
      {
        name: "job-definition-revision",
        referenceHref:
          "https://docs.aws.amazon.com/batch/latest/userguide/job_definitions.html",
        arnPattern:
          "arn:${Partition}:batch:${Region}:${Account}:job-definition/${JobDefinitionName}:${Revision}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "job",
        referenceHref:
          "https://docs.aws.amazon.com/batch/latest/userguide/jobs.html",
        arnPattern: "arn:${Partition}:batch:${Region}:${Account}:job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "scheduling-policy",
        referenceHref:
          "https://docs.aws.amazon.com/batch/latest/userguide/scheduling-policies.html",
        arnPattern:
          "arn:${Partition}:batch:${Region}:${Account}:scheduling-policy/${SchedulingPolicyName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "batch:AWSLogsCreateGroup",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the specified logging driver to determine whether awslogs group will be created for the logs",
        type: "Bool",
      },
      {
        name: "batch:AWSLogsGroup",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the awslogs group where the logs are located",
        type: "String",
      },
      {
        name: "batch:AWSLogsRegion",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description: "Filters access by the region where the logs are sent to",
        type: "String",
      },
      {
        name: "batch:AWSLogsStreamPrefix",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description: "Filters access by the awslogs log stream prefix",
        type: "String",
      },
      {
        name: "batch:EKSImage",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the image used to start a container for an Amazon EKS job",
        type: "String",
      },
      {
        name: "batch:EKSPrivileged",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the specified privileged parameter value that determines whether the container is given elevated privileges on the host container instance (similar to the root user) for an Amazon EKS job",
        type: "Bool",
      },
      {
        name: "batch:EKSRunAsGroup",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the specified group numeric ID (gid) used to start a container in an Amazon EKS job",
        type: "Numeric",
      },
      {
        name: "batch:EKSRunAsUser",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the specified user numeric ID (uid) used to start a a container in an Amazon EKS job",
        type: "Numeric",
      },
      {
        name: "batch:EKSServiceAccountName",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the name of the service account used to run the pod for an Amazon EKS job",
        type: "String",
      },
      {
        name: "batch:Image",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description: "Filters access by the image used to start a container",
        type: "String",
      },
      {
        name: "batch:LogDriver",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description: "Filters access by the log driver used for the container",
        type: "String",
      },
      {
        name: "batch:Privileged",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the specified privileged parameter value that determines whether the container is given elevated privileges on the host container instance (similar to the root user)",
        type: "Bool",
      },
      {
        name: "batch:ShareIdentifier",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by the shareIdentifier used inside submit job",
        type: "String",
      },
      {
        name: "batch:User",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbatch.html#awsbatch-policy-keys",
        description:
          "Filters access by user name or numeric uid used inside the container",
        type: "String",
      },
    ],
  },
  bedrock: {
    name: "Amazon Bedrock",
    servicePrefix: "bedrock",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonbedrock.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/bedrock/latest/APIReference/",
    resourceTypes: [
      {
        name: "foundation-model",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}::foundation-model/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "custom-model",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:custom-model/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "provisioned-model",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:provisioned-model/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "model-customization-job",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:model-customization-job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "agent",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:agent/${AgentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "agent-alias",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:agent-alias/${AgentId}/${AgentAliasId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "knowledge-base",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:knowledge-base/${KnowledgeBaseId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "model-evaluation-job",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:model-evaluation-job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "model-invocation-job",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:model-invocation-job/${JobIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "guardrail",
        referenceHref:
          "https://docs.aws.amazon.com/bedrock/latest/APIReference/welcome.html",
        arnPattern:
          "arn:${Partition}:bedrock:${Region}:${Account}:guardrail/${GuardrailId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by creating requests based on the allowed set of values for each of the mandatory tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by having actions based on the tag value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by creating requests based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "bedrock:ThirdPartyKnowledgeBaseCredentialsSecretArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by the secretArn containing the credentials of the third party platform",
        type: "ARN",
      },
    ],
  },
  billing: {
    name: "AWS Billing and Cost Management",
    servicePrefix: "billing",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbilling.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "bcm-data-exports": {
    name: "AWS Billing and Cost Management And Cost Management Data Exports",
    servicePrefix: "bcm-data-exports",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbillingandcostmanagementdataexports.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/API_Operations_AWS_Data_Exports.html",
    resourceTypes: [
      {
        name: "export",
        referenceHref:
          "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/API_Export.html",
        arnPattern:
          "arn:${Partition}:bcm-data-exports:${Region}:${Account}:export/${Identifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "table",
        referenceHref:
          "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/API_Table.html",
        arnPattern:
          "arn:${Partition}:bcm-data-exports:${Region}:${Account}:table/${Identifier}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  billingconductor: {
    name: "AWS Billing Conductor",
    servicePrefix: "billingconductor",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbillingconductor.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/billingconductor/latest/APIReference/",
    resourceTypes: [
      {
        name: "billinggroup",
        referenceHref:
          "https://docs.aws.amazon.com/billingconductor/latest/userguide/understanding-abc.html",
        arnPattern:
          "arn:${Partition}:billingconductor::${Account}:billinggroup/${BillingGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "pricingplan",
        referenceHref:
          "https://docs.aws.amazon.com/billingconductor/latest/userguide/understanding-abc.html",
        arnPattern:
          "arn:${Partition}:billingconductor::${Account}:pricingplan/${PricingPlanId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "pricingrule",
        referenceHref:
          "https://docs.aws.amazon.com/billingconductor/latest/userguide/understanding-abc.html",
        arnPattern:
          "arn:${Partition}:billingconductor::${Account}:pricingrule/${PricingRuleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "customlineitem",
        referenceHref:
          "https://docs.aws.amazon.com/billingconductor/latest/userguide/understanding-abc.html",
        arnPattern:
          "arn:${Partition}:billingconductor::${Account}:customlineitem/${CustomLineItemId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "aws-portal": {
    name: "AWS Billing and Cost Management Console",
    servicePrefix: "aws-portal",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbillingconsole.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/api-reference.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  braket: {
    name: "Amazon Braket",
    servicePrefix: "braket",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonbraket.html",
    apiReferenceHref: "https://docs.aws.amazon.com/braket/latest/APIReference/",
    resourceTypes: [
      {
        name: "quantum-task",
        referenceHref:
          "https://docs.aws.amazon.com/braket/latest/developerguide/braket-manage-access.html#resources",
        arnPattern:
          "arn:${Partition}:braket:${Region}:${Account}:quantum-task/${RandomId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "job",
        referenceHref:
          "https://docs.aws.amazon.com/braket/latest/developerguide/braket-manage-access.html#resources",
        arnPattern:
          "arn:${Partition}:braket:${Region}:${Account}:job/${JobName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  budgets: {
    name: "AWS Budget Service",
    servicePrefix: "budgets",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbudgetservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/api-reference.html",
    resourceTypes: [
      {
        name: "budget",
        referenceHref:
          "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/budgets-managing-costs.html",
        arnPattern: "arn:${Partition}:budgets::${Account}:budget/${BudgetName}",
        conditionKeys: [],
      },
      {
        name: "budgetAction",
        referenceHref:
          "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/budgets-managing-costs.html",
        arnPattern:
          "arn:${Partition}:budgets::${Account}:budget/${BudgetName}/action/${ActionId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  bugbust: {
    name: "AWS BugBust",
    servicePrefix: "bugbust",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsbugbust.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codeguru/latest/bugbust-ug/auth-and-access-control-permissions-reference.html",
    resourceTypes: [
      {
        name: "Event",
        referenceHref:
          "https://docs.aws.amazon.com/codeguru/latest/bugbust-ug/event-managing.html",
        arnPattern:
          "arn:${Partition}:bugbust:${Region}:${Account}:events/${EventId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  acm: {
    name: "AWS Certificate Manager",
    servicePrefix: "acm",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscertificatemanager.html",
    apiReferenceHref: "https://docs.aws.amazon.com/acm/latest/APIReference/",
    resourceTypes: [
      {
        name: "certificate",
        referenceHref:
          "https://docs.aws.amazon.com/acm/latest/userguide/acm-concepts.html#concept-acm-cert",
        arnPattern:
          "arn:${Partition}:acm:${Region}:${Account}:certificate/${CertificateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "acm:CertificateAuthority",
        referenceHref:
          "https://docs.aws.amazon.com/acm/latest/userguide/security-iam.html",
        description:
          "Filters access by certificateAuthority in the request. Can be used to restrict which Certificate Authorites certificates can be issued from",
        type: "String",
      },
      {
        name: "acm:CertificateTransparencyLogging",
        referenceHref:
          "https://docs.aws.amazon.com/acm/latest/userguide/security-iam.html",
        description:
          "Filters access by certificateTransparencyLogging option in the request. Default 'ENABLED' if no key is present in the request",
        type: "String",
      },
      {
        name: "acm:DomainNames",
        referenceHref:
          "https://docs.aws.amazon.com/acm/latest/userguide/security-iam.html",
        description:
          "Filters access by domainNames in the request. This key can be used to restrict which domains can be in certificate requests",
        type: "ArrayOfString",
      },
      {
        name: "acm:KeyAlgorithm",
        referenceHref:
          "https://docs.aws.amazon.com/acm/latest/userguide/security-iam.html",
        description: "Filters access by keyAlgorithm in the request",
        type: "String",
      },
      {
        name: "acm:ValidationMethod",
        referenceHref:
          "https://docs.aws.amazon.com/acm/latest/userguide/security-iam.html",
        description:
          "Filters access by validationMethod in the request. Default 'EMAIL' if no key is present in the request",
        type: "String",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  chatbot: {
    name: "AWS Chatbot",
    servicePrefix: "chatbot",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awschatbot.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/chatbot/latest/adminguide/what-is.html",
    resourceTypes: [
      {
        name: "ChatbotConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/chatbot/latest/adminguide/what-is.html",
        arnPattern:
          "arn:${Partition}:chatbot::${Account}:chat-configuration/${ConfigurationType}/${ChatbotConfigurationName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  chime: {
    name: "Amazon Chime",
    servicePrefix: "chime",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonchime.html",
    apiReferenceHref: "https://docs.aws.amazon.com/chime/latest/APIReference/",
    resourceTypes: [
      {
        name: "meeting",
        referenceHref:
          "https://docs.aws.amazon.com/chime/latest/APIReference/API_Meeting.html",
        arnPattern: "arn:${Partition}:chime::${AccountId}:meeting/${MeetingId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "app-instance",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_identity-chime_AppInstance.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:app-instance/${AppInstanceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "app-instance-user",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_identity-chime_AppInstanceUser.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:app-instance/${AppInstanceId}/user/${AppInstanceUserId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "app-instance-bot",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_identity-chime_AppInstanceBot.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:app-instance/${AppInstanceId}/bot/${AppInstanceBotId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "channel",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_messaging-chime_Channel.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:app-instance/${AppInstanceId}/channel/${ChannelId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "channel-flow",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_messaging-chime_ChannelFlow.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:app-instance/${AppInstanceId}/channel-flow/${ChannelFlowId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "media-pipeline",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_media-pipelines-chime_MediaPipeline.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:media-pipeline/${MediaPipelineId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "media-insights-pipeline-configuration",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_media-pipelines-chime_MediaInsightsPipelineConfiguration.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:media-insights-pipeline-configuration/${ConfigurationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "media-pipeline-kinesis-video-stream-pool",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_media-pipelines-chime_KinesisVideoStreamPoolConfiguration.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:media-pipeline-kinesis-video-stream-pool/${PoolName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "voice-profile-domain",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_voice-chime_CreateVoiceProfileDomain.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:voice-profile-domain/${VoiceProfileDomainId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "voice-profile",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_voice-chime_CreateVoiceProfile.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:voice-profile/${VoiceProfileId}",
        conditionKeys: [],
      },
      {
        name: "voice-connector",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_voice-chime_VoiceConnector.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:vc/${VoiceConnectorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "sip-media-application",
        referenceHref:
          "https://docs.aws.amazon.com/chime-sdk/latest/APIReference/API_voice-chime_SipMediaApplication.html",
        arnPattern:
          "arn:${Partition}:chime:${Region}:${AccountId}:sma/${SipMediaApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
    ],
  },
  cleanrooms: {
    name: "AWS Clean Rooms",
    servicePrefix: "cleanrooms",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscleanrooms.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/clean-rooms/latest/apireference/Welcome.html",
    resourceTypes: [
      {
        name: "analysistemplate",
        referenceHref:
          "https://docs.aws.amazon.com/clean-rooms/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:cleanrooms:${Region}:${Account}:membership/${MembershipId}/analysistemplate/${AnalysisTemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "collaboration",
        referenceHref:
          "https://docs.aws.amazon.com/clean-rooms/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:cleanrooms:${Region}:${Account}:collaboration/${CollaborationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "configuredaudiencemodelassociation",
        referenceHref:
          "https://docs.aws.amazon.com/clean-rooms/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:cleanrooms:${Region}:${Account}:membership/${MembershipId}/configuredaudiencemodelassociation/${ConfiguredAudienceModelAssociationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "configuredtable",
        referenceHref:
          "https://docs.aws.amazon.com/clean-rooms/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:cleanrooms:${Region}:${Account}:configuredtable/${ConfiguredTableId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "configuredtableassociation",
        referenceHref:
          "https://docs.aws.amazon.com/clean-rooms/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:cleanrooms:${Region}:${Account}:membership/${MembershipId}/configuredtableassociation/${ConfiguredTableAssociationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "membership",
        referenceHref:
          "https://docs.aws.amazon.com/clean-rooms/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:cleanrooms:${Region}:${Account}:membership/${MembershipId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "privacybudgettemplate",
        referenceHref:
          "https://docs.aws.amazon.com/clean-rooms/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:cleanrooms:${Region}:${Account}:membership/${MembershipId}/privacybudgettemplate/${PrivacyBudgetTemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "cleanrooms-ml": {
    name: "AWS Clean Rooms ML",
    servicePrefix: "cleanrooms-ml",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscleanroomsml.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cleanrooms-ml/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "trainingdataset",
        referenceHref:
          "https://docs.aws.amazon.com/cleanrooms-ml/latest/APIReference/API_TrainingDatasetSummary.html",
        arnPattern:
          "arn:${Partition}:cleanrooms-ml:${Region}:${Account}:training-dataset/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "audiencemodel",
        referenceHref:
          "https://docs.aws.amazon.com/cleanrooms-ml/latest/APIReference/API_AudienceModelSummary.html",
        arnPattern:
          "arn:${Partition}:cleanrooms-ml:${Region}:${Account}:audience-model/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "configuredaudiencemodel",
        referenceHref:
          "https://docs.aws.amazon.com/cleanrooms-ml/latest/APIReference/API_ConfiguredAudienceModelSummary.html",
        arnPattern:
          "arn:${Partition}:cleanrooms-ml:${Region}:${Account}:configured-audience-model/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "audiencegenerationjob",
        referenceHref:
          "https://docs.aws.amazon.com/cleanrooms-ml/latest/APIReference/API_AudienceGenerationJobSummary.html",
        arnPattern:
          "arn:${Partition}:cleanrooms-ml:${Region}:${Account}:audience-generation-job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "cleanrooms-ml:CollaborationId",
        referenceHref: "https://docs.aws.amazon.com/TBD",
        description: "Filters access by clean rooms collaboration id",
        type: "String",
      },
    ],
  },
  cloudformation: {
    name: "AWS CloudFormation",
    servicePrefix: "cloudformation",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscloudformation.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AWSCloudFormation/latest/APIReference/",
    resourceTypes: [
      {
        name: "changeset",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/cfn-whatis-concepts.html#w2ab1b5c15c11",
        arnPattern:
          "arn:${Partition}:cloudformation:${Region}:${Account}:changeSet/${ChangeSetName}/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "stack",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/cfn-whatis-concepts.html#w2ab1b5c15b9",
        arnPattern:
          "arn:${Partition}:cloudformation:${Region}:${Account}:stack/${StackName}/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "stackset",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/stacksets-concepts.html#stacksets-concepts-stackset",
        arnPattern:
          "arn:${Partition}:cloudformation:${Region}:${Account}:stackset/${StackSetName}:${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "stackset-target",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html",
        arnPattern:
          "arn:${Partition}:cloudformation:${Region}:${Account}:stackset-target/${StackSetTarget}",
        conditionKeys: [],
      },
      {
        name: "type",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html",
        arnPattern:
          "arn:${Partition}:cloudformation:${Region}:${Account}:type/resource/${Type}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "cloudformation:ChangeSetName",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by an AWS CloudFormation change set name. Use to control which change sets IAM users can execute or delete",
        type: "String",
      },
      {
        name: "cloudformation:ImportResourceTypes",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by the template resource types, such as AWS::EC2::Instance. Use to control which resource types IAM users can work with when they want to import a resource into a stack",
        type: "String",
      },
      {
        name: "cloudformation:ResourceTypes",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by the template resource types, such as AWS::EC2::Instance. Use to control which resource types IAM users can work with when they create or update a stack",
        type: "ArrayOfString",
      },
      {
        name: "cloudformation:RoleArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by the ARN of an IAM service role. Use to control which service role IAM users can use to work with stacks or change sets",
        type: "ARN",
      },
      {
        name: "cloudformation:StackPolicyUrl",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by an Amazon S3 stack policy URL. Use to control which stack policies IAM users can associate with a stack during a create or update stack action",
        type: "String",
      },
      {
        name: "cloudformation:TargetRegion",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by stack set target region. Use to control which regions IAM users can use when they create or update stack sets",
        type: "ArrayOfString",
      },
      {
        name: "cloudformation:TemplateUrl",
        referenceHref:
          "https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/using-iam-template.html#using-iam-template-conditions",
        description:
          "Filters access by an Amazon S3 template URL. Use to control which templates IAM users can use when they create or update stacks",
        type: "String",
      },
    ],
  },
  clouddirectory: {
    name: "Amazon Cloud Directory",
    servicePrefix: "clouddirectory",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonclouddirectory.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/directoryservice/latest/APIReference/",
    resourceTypes: [
      {
        name: "appliedSchema",
        referenceHref:
          "https://docs.aws.amazon.com/directoryservice/latest/admin-guide/cd_key_concepts.html#whatisdirectory",
        arnPattern:
          "arn:${Partition}:clouddirectory:${Region}:${Account}:directory/${DirectoryId}/schema/${SchemaName}/${Version}",
        conditionKeys: [],
      },
      {
        name: "developmentSchema",
        referenceHref:
          "https://docs.aws.amazon.com/directoryservice/latest/admin-guide/cd_key_concepts.html#whatisdirectory",
        arnPattern:
          "arn:${Partition}:clouddirectory:${Region}:${Account}:schema/development/${SchemaName}",
        conditionKeys: [],
      },
      {
        name: "directory",
        referenceHref:
          "https://docs.aws.amazon.com/directoryservice/latest/admin-guide/cd_key_concepts.html#whatisdirectory",
        arnPattern:
          "arn:${Partition}:clouddirectory:${Region}:${Account}:directory/${DirectoryId}",
        conditionKeys: [],
      },
      {
        name: "publishedSchema",
        referenceHref:
          "https://docs.aws.amazon.com/directoryservice/latest/admin-guide/cd_key_concepts.html#whatisdirectory",
        arnPattern:
          "arn:${Partition}:clouddirectory:${Region}:${Account}:schema/published/${SchemaName}/${Version}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  servicediscovery: {
    name: "AWS Cloud Map",
    servicePrefix: "servicediscovery",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscloudmap.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloud-map/latest/api/Welcome.html",
    resourceTypes: [
      {
        name: "namespace",
        referenceHref:
          "https://docs.aws.amazon.com/cloud-map/latest/dg/API_Namespace.html",
        arnPattern:
          "arn:${Partition}:servicediscovery:${Region}:${Account}:namespace/${NamespaceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "service",
        referenceHref:
          "https://docs.aws.amazon.com/cloud-map/latest/dg/API_Service.html",
        arnPattern:
          "arn:${Partition}:servicediscovery:${Region}:${Account}:service/${ServiceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "servicediscovery:NamespaceArn",
        referenceHref:
          "https://docs.aws.amazon.com/cloud-map/latest/dg/access-control-overview.html#specifying-conditions",
        description:
          "Filters access by specifying the Amazon Resource Name (ARN) for the related namespace",
        type: "ARN",
      },
      {
        name: "servicediscovery:NamespaceName",
        referenceHref:
          "https://docs.aws.amazon.com/cloud-map/latest/dg/access-control-overview.html#specifying-conditions",
        description:
          "Filters access by specifying the name of the related namespace",
        type: "String",
      },
      {
        name: "servicediscovery:ServiceArn",
        referenceHref:
          "https://docs.aws.amazon.com/cloud-map/latest/dg/access-control-overview.html#specifying-conditions",
        description:
          "Filters access by specifying the Amazon Resource Name (ARN) for the related service",
        type: "ARN",
      },
      {
        name: "servicediscovery:ServiceName",
        referenceHref:
          "https://docs.aws.amazon.com/cloud-map/latest/dg/access-control-overview.html#specifying-conditions",
        description:
          "Filters access by specifying the name of the related service",
        type: "String",
      },
    ],
  },
  cloud9: {
    name: "AWS Cloud9",
    servicePrefix: "cloud9",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscloud9.html",
    apiReferenceHref: "https://docs.aws.amazon.com/cloud9/latest/APIReference/",
    resourceTypes: [
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_awscloud9.html##awscloud9-environment",
        arnPattern:
          "arn:${Partition}:cloud9:${Region}:${Account}:environment:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "cloud9:EnvironmentId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_awscloud9.html##awscloud9-cloud9_EnvironmentId",
        description: "Filters access by the AWS Cloud9 environment ID",
        type: "String",
      },
      {
        name: "cloud9:EnvironmentName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_awscloud9.html##awscloud9-cloud9_EnvironmentName",
        description: "Filters access by the AWS Cloud9 environment name",
        type: "String",
      },
      {
        name: "cloud9:InstanceType",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_awscloud9.html##awscloud9-cloud9_InstanceType",
        description:
          "Filters access by the instance type of the AWS Cloud9 environment's Amazon EC2 instance",
        type: "String",
      },
      {
        name: "cloud9:OwnerArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_awscloud9.html##awscloud9-cloud9_OwnerArn",
        description: "Filters access by the owner ARN specified",
        type: "ARN",
      },
      {
        name: "cloud9:Permissions",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_awscloud9.html##awscloud9-cloud9_Permissions",
        description: "Filters access by the type of AWS Cloud9 permissions",
        type: "String",
      },
      {
        name: "cloud9:SubnetId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_awscloud9.html##awscloud9-cloud9_SubnetId",
        description:
          "Filters access by the subnet ID that the AWS Cloud9 environment will be created in",
        type: "String",
      },
      {
        name: "cloud9:UserArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_awscloud9.html##awscloud9-cloud9_UserArn",
        description: "Filters access by the user ARN specified",
        type: "ARN",
      },
    ],
  },
  cloudfront: {
    name: "Amazon CloudFront",
    servicePrefix: "cloudfront",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudfront.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloudfront/latest/APIReference/",
    resourceTypes: [
      {
        name: "distribution",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/distribution-working-with.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:distribution/${DistributionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "streaming-distribution",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/distribution-working-with.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:streaming-distribution/${DistributionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "origin-access-identity",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/private-content-restricting-access-to-s3.html#private-content-restricting-access-to-s3-overview",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:origin-access-identity/${Id}",
        conditionKeys: [],
      },
      {
        name: "field-level-encryption-config",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/field-level-encryption.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:field-level-encryption-config/${Id}",
        conditionKeys: [],
      },
      {
        name: "field-level-encryption-profile",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/field-level-encryption.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:field-level-encryption-profile/${Id}",
        conditionKeys: [],
      },
      {
        name: "cache-policy",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/working-with-policies.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:cache-policy/${Id}",
        conditionKeys: [],
      },
      {
        name: "origin-request-policy",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/working-with-policies.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:origin-request-policy/${Id}",
        conditionKeys: [],
      },
      {
        name: "realtime-log-config",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/real-time-logs.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:realtime-log-config/${Name}",
        conditionKeys: [],
      },
      {
        name: "function",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-functions.html",
        arnPattern: "arn:${Partition}:cloudfront::${Account}:function/${Name}",
        conditionKeys: [],
      },
      {
        name: "key-value-store",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/kvs-with-functions.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:key-value-store/${Name}",
        conditionKeys: [],
      },
      {
        name: "response-headers-policy",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/working-with-policies.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:response-headers-policy/${Id}",
        conditionKeys: [],
      },
      {
        name: "origin-access-control",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/working-with-policies.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:origin-access-control/${Id}",
        conditionKeys: [],
      },
      {
        name: "continuous-deployment-policy",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/working-with-policies.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:continuous-deployment-policy/${Id}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "cloudfront-keyvaluestore": {
    name: "Amazon CloudFront KeyValueStore",
    servicePrefix: "cloudfront-keyvaluestore",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudfrontkeyvaluestore.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloudfront/latest/APIReference/",
    resourceTypes: [
      {
        name: "key-value-store",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/kvs-with-functions.html",
        arnPattern:
          "arn:${Partition}:cloudfront::${Account}:key-value-store/${ResourceId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  cloudhsm: {
    name: "AWS CloudHSM",
    servicePrefix: "cloudhsm",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscloudhsm.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloudhsm/latest/APIReference/",
    resourceTypes: [
      {
        name: "backup",
        referenceHref:
          "https://docs.aws.amazon.com/cloudhsm/latest/userguide/backups.html",
        arnPattern:
          "arn:${Partition}:cloudhsm:${Region}:${Account}:backup/${CloudHsmBackupInstanceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/cloudhsm/latest/userguide/clusters.html",
        arnPattern:
          "arn:${Partition}:cloudhsm:${Region}:${Account}:cluster/${CloudHsmClusterInstanceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  cloudsearch: {
    name: "Amazon CloudSearch",
    servicePrefix: "cloudsearch",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudsearch.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloudsearch/latest/developerguide/api-ref.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  cloudshell: {
    name: "AWS CloudShell",
    servicePrefix: "cloudshell",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscloudshell.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloudshell/latest/userguide/sec-auth-with-identities.html",
    resourceTypes: [
      {
        name: "Environment",
        referenceHref:
          "https://docs.aws.amazon.com/cloudshell/latest/userguide/sec-auth-with-identities.html#Environment",
        arnPattern:
          "arn:${Partition}:cloudshell:${Region}:${Account}:environment/${EnvironmentId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  cloudtrail: {
    name: "AWS CloudTrail",
    servicePrefix: "cloudtrail",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscloudtrail.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awscloudtrail/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
    ],
  },
  "cloudtrail-data": {
    name: "AWS CloudTrail Data",
    servicePrefix: "cloudtrail-data",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscloudtraildata.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awscloudtraildata/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
    ],
  },
  cloudwatch: {
    name: "Amazon CloudWatch",
    servicePrefix: "cloudwatch",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudwatch.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonCloudWatch/latest/APIReference/",
    resourceTypes: [
      {
        name: "alarm",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/auth-and-access-control-cw.html",
        arnPattern:
          "arn:${Partition}:cloudwatch:${Region}:${Account}:alarm:${AlarmName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dashboard",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/auth-and-access-control-cw.html",
        arnPattern:
          "arn:${Partition}:cloudwatch::${Account}:dashboard/${DashboardName}",
        conditionKeys: [],
      },
      {
        name: "insight-rule",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/auth-and-access-control-cw.html",
        arnPattern:
          "arn:${Partition}:cloudwatch:${Region}:${Account}:insight-rule/${InsightRuleName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "metric-stream",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/auth-and-access-control-cw.html",
        arnPattern:
          "arn:${Partition}:cloudwatch:${Region}:${Account}:metric-stream/${MetricStreamName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "slo",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/auth-and-access-control-cw.html",
        arnPattern:
          "arn:${Partition}:cloudwatch:${Region}:${Account}:slo/${SloName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "service",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/auth-and-access-control-cw.html",
        arnPattern:
          "arn:${Partition}:cloudwatch:${Region}:${Account}:service/${ServiceName}-${UniqueAttributesHex}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "cloudwatch:AlarmActions",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/iam-cw-condition-keys-alarm-actions.html",
        description: "Filters actions based on defined alarm actions",
        type: "ArrayOfString",
      },
      {
        name: "cloudwatch:namespace",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/iam-cw-condition-keys-namespace.html",
        description:
          "Filters actions based on the presence of optional namespace values",
        type: "String",
      },
      {
        name: "cloudwatch:requestInsightRuleLogGroups",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/iam-cw-condition-keys-contributor.html",
        description:
          "Filters actions based on the Log Groups specified in an Insight Rule",
        type: "ArrayOfString",
      },
      {
        name: "cloudwatch:requestManagedResourceARNs",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/iam-cw-condition-keys-contributor.html",
        description:
          "Filters access by the Resource ARNs specified in a managed Insight Rule",
        type: "ArrayOfARN",
      },
    ],
  },
  applicationinsights: {
    name: "Amazon CloudWatch Application Insights",
    servicePrefix: "applicationinsights",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudwatchapplicationinsights.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloudwatch/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  evidently: {
    name: "Amazon CloudWatch Evidently",
    servicePrefix: "evidently",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudwatchevidently.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloudwatchevidently/latest/APIReference/",
    resourceTypes: [
      {
        name: "Project",
        referenceHref:
          "https://docs.aws.amazon.com/cloudwatchevidently/latest/APIReference/API_Project.html",
        arnPattern:
          "arn:${Partition}:evidently:${Region}:${Account}:project/${ProjectName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Feature",
        referenceHref:
          "https://docs.aws.amazon.com/cloudwatchevidently/latest/APIReference/API_Feature.html",
        arnPattern:
          "arn:${Partition}:evidently:${Region}:${Account}:project/${ProjectName}/feature/${FeatureName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Experiment",
        referenceHref:
          "https://docs.aws.amazon.com/cloudwatchevidently/latest/APIReference/API_Experiment.html",
        arnPattern:
          "arn:${Partition}:evidently:${Region}:${Account}:project/${ProjectName}/experiment/${ExperimentName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Launch",
        referenceHref:
          "https://docs.aws.amazon.com/cloudwatchevidently/latest/APIReference/API_Launch.html",
        arnPattern:
          "arn:${Partition}:evidently:${Region}:${Account}:project/${ProjectName}/launch/${LaunchName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Segment",
        referenceHref:
          "https://docs.aws.amazon.com/cloudwatchevidently/latest/APIReference/API_Segment.html",
        arnPattern:
          "arn:${Partition}:evidently:${Region}:${Account}:segment/${SegmentName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed the request on behalf of the IAM principal",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html",
        description:
          "Filters access by the tags associated with the resource that make the request on behalf of the IAM principal",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request on behalf of the IAM principal",
        type: "ArrayOfString",
      },
    ],
  },
  internetmonitor: {
    name: "Amazon CloudWatch Internet Monitor",
    servicePrefix: "internetmonitor",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudwatchinternetmonitor.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/internet-monitor/latest/api/Welcome.html",
    resourceTypes: [
      {
        name: "HealthEvent",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-IM-components.html",
        arnPattern:
          "arn:${Partition}:internetmonitor:${Region}:${Account}:monitor/${MonitorName}/health-event/${EventId}",
        conditionKeys: [],
      },
      {
        name: "Monitor",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-IM-components.html",
        arnPattern:
          "arn:${Partition}:internetmonitor:${Region}:${Account}:monitor/${MonitorName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  logs: {
    name: "Amazon CloudWatch Logs",
    servicePrefix: "logs",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudwatchlogs.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/",
    resourceTypes: [
      {
        name: "log-group",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_LogGroup.html",
        arnPattern:
          "arn:${Partition}:logs:${Region}:${Account}:log-group:${LogGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "log-stream",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_LogStream.html",
        arnPattern:
          "arn:${Partition}:logs:${Region}:${Account}:log-group:${LogGroupName}:log-stream:${LogStreamName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "destination",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_Destination.html",
        arnPattern:
          "arn:${Partition}:logs:${Region}:${Account}:destination:${DestinationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "delivery-source",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_DeliverySource.html",
        arnPattern:
          "arn:${Partition}:logs:${Region}:${Account}:delivery-source:${DeliverySourceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "delivery",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_Delivery.html",
        arnPattern:
          "arn:${Partition}:logs:${Region}:${Account}:delivery:${DeliveryName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "delivery-destination",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_DeliveryDestination.html",
        arnPattern:
          "arn:${Partition}:logs:${Region}:${Account}:delivery-destination:${DeliveryDestinationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "anomaly-detector",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_AnomalyDetector.html",
        arnPattern:
          "arn:${Partition}:logs:${Region}:${Account}:anomaly-detector:${DetectorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "logs:DeliveryDestinationResourceArn",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/iam-identity-based-access-control-cwl.html",
        description:
          "Filters access by the Log Destination ARN passed in the request",
        type: "ARN",
      },
      {
        name: "logs:LogGeneratingResourceArns",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/iam-identity-based-access-control-cwl.html",
        description:
          "Filters access by the Log Generating Resource ARNs passed in the request",
        type: "ArrayOfARN",
      },
    ],
  },
  networkmonitor: {
    name: "Amazon CloudWatch Network Monitor",
    servicePrefix: "networkmonitor",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudwatchnetworkmonitor.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/network-monitor/latest/api/Welcome.html",
    resourceTypes: [
      {
        name: "monitor",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-NM-components.html",
        arnPattern:
          "arn:${Partition}:networkmonitor:${Region}:${Account}:monitor/${MonitorName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "probe",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-NM-components.html",
        arnPattern:
          "arn:${Partition}:networkmonitor:${Region}:${Account}:probe/${ProbeId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  oam: {
    name: "Amazon CloudWatch Observability Access Manager",
    servicePrefix: "oam",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudwatchobservabilityaccessmanager.html",
    apiReferenceHref: "https://docs.aws.amazon.com/OAM/latest/APIReference/",
    resourceTypes: [
      {
        name: "Link",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-Unified-Cross-Account.html",
        arnPattern:
          "arn:${Partition}:oam:${Region}:${Account}:link/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Sink",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch-Unified-Cross-Account.html",
        arnPattern:
          "arn:${Partition}:oam:${Region}:${Account}:sink/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "oam:ResourceTypes",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazoncloudwatchobservabilityaccessmanager.html",
        description:
          "Filters access by the presence of resource types in the request",
        type: "ArrayOfString",
      },
    ],
  },
  rum: {
    name: "AWS CloudWatch RUM",
    servicePrefix: "rum",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscloudwatchrum.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cloudwatchrum/latest/APIReference/",
    resourceTypes: [
      {
        name: "AppMonitorResource",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/API_AppMonitor.html",
        arnPattern:
          "arn:${Partition}:rum:${Region}:${Account}:appmonitor/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed the request on behalf of the IAM principal",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html",
        description:
          "Filters access by the tags associated with the resource that make the request on behalf of the IAM principal",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request on behalf of the IAM principal",
        type: "ArrayOfString",
      },
    ],
  },
  synthetics: {
    name: "Amazon CloudWatch Synthetics",
    servicePrefix: "synthetics",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncloudwatchsynthetics.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonSynthetics/latest/APIReference/",
    resourceTypes: [
      {
        name: "canary",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch_Synthetics_Canaries.html",
        arnPattern:
          "arn:${Partition}:synthetics:${Region}:${Account}:canary:${CanaryName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "group",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch_Synthetics_Groups.html",
        arnPattern:
          "arn:${Partition}:synthetics:${Region}:${Account}:group:${GroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "synthetics:Names",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonCloudWatch/latest/monitoring/CloudWatch_Synthetics_Canaries_Restricted.html",
        description: "Filters access based on the name of the canary",
        type: "ArrayOfString",
      },
    ],
  },
  codeartifact: {
    name: "AWS CodeArtifact",
    servicePrefix: "codeartifact",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodeartifact.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codeartifact/latest/APIReference/",
    resourceTypes: [
      {
        name: "domain",
        referenceHref:
          "https://docs.aws.amazon.com/codeartifact/latest/ug/auth-and-access-control-iam-access-control-identity-based.html#arn-formats",
        arnPattern:
          "arn:${Partition}:codeartifact:${Region}:${Account}:domain/${DomainName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "repository",
        referenceHref:
          "https://docs.aws.amazon.com/codeartifact/latest/ug/repo-policies.html",
        arnPattern:
          "arn:${Partition}:codeartifact:${Region}:${Account}:repository/${DomainName}/${RepositoryName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "package",
        referenceHref:
          "https://docs.aws.amazon.com/codeartifact/latest/ug/repo-policies.html",
        arnPattern:
          "arn:${Partition}:codeartifact:${Region}:${Account}:package/${DomainName}/${RepositoryName}/${PackageFormat}/${PackageNamespace}/${PackageName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  codebuild: {
    name: "AWS CodeBuild",
    servicePrefix: "codebuild",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodebuild.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codebuild/latest/APIReference/",
    resourceTypes: [
      {
        name: "build",
        referenceHref:
          "https://docs.aws.amazon.com/codebuild/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#arn-formats",
        arnPattern:
          "arn:${Partition}:codebuild:${Region}:${Account}:build/${BuildId}",
        conditionKeys: [],
      },
      {
        name: "build-batch",
        referenceHref:
          "https://docs.aws.amazon.com/codebuild/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#arn-formats",
        arnPattern:
          "arn:${Partition}:codebuild:${Region}:${Account}:build-batch/${BuildBatchId}",
        conditionKeys: [],
      },
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/codebuild/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#arn-formats",
        arnPattern:
          "arn:${Partition}:codebuild:${Region}:${Account}:project/${ProjectName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "report-group",
        referenceHref:
          "https://docs.aws.amazon.com/codebuild/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#arn-formats",
        arnPattern:
          "arn:${Partition}:codebuild:${Region}:${Account}:report-group/${ReportGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "report",
        referenceHref:
          "https://docs.aws.amazon.com/codebuild/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#arn-formats",
        arnPattern:
          "arn:${Partition}:codebuild:${Region}:${Account}:report/${ReportGroupName}:${ReportId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  codecatalyst: {
    name: "Amazon CodeCatalyst",
    servicePrefix: "codecatalyst",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncodecatalyst.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codecatalyst/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "connections",
        referenceHref:
          "https://docs.aws.amazon.com/codecatalyst/latest/userguide/#",
        arnPattern:
          "arn:${Partition}:codecatalyst:${Region}:${Account}:/connections/${ConnectionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "identity-center-applications",
        referenceHref:
          "https://docs.aws.amazon.com/codecatalyst/latest/userguide/#",
        arnPattern:
          "arn:${Partition}:codecatalyst:${Region}:${Account}:/identity-center-applications/${IdentityCenterApplicationId}",
        conditionKeys: [],
      },
      {
        name: "space",
        referenceHref:
          "https://docs.aws.amazon.com/codecatalyst/latest/userguide/#",
        arnPattern: "arn:${Partition}:codecatalyst:::space/${SpaceId}",
        conditionKeys: [],
      },
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/codecatalyst/latest/userguide/#",
        arnPattern:
          "arn:${Partition}:codecatalyst:::space/${SpaceId}/project/${ProjectId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
    ],
  },
  codecommit: {
    name: "AWS CodeCommit",
    servicePrefix: "codecommit",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodecommit.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codecommit/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "repository",
        referenceHref:
          "https://docs.aws.amazon.com/codecommit/latest/userguide/auth-and-access-control.html#arn-formats",
        arnPattern:
          "arn:${Partition}:codecommit:${Region}:${Account}:${RepositoryName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "codecommit:References",
        referenceHref:
          "https://docs.aws.amazon.com/codecommit/latest/userguide/how-to-conditional-branch.html",
        description:
          "Filters access by Git reference to specified AWS CodeCommit actions",
        type: "String",
      },
    ],
  },
  codedeploy: {
    name: "AWS CodeDeploy",
    servicePrefix: "codedeploy",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodedeploy.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codedeploy/latest/APIReference/",
    resourceTypes: [
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/codedeploy/latest/userguide/auth-and-access-control-permissions-reference.html",
        arnPattern:
          "arn:${Partition}:codedeploy:${Region}:${Account}:application:${ApplicationName}",
        conditionKeys: [],
      },
      {
        name: "deploymentconfig",
        referenceHref:
          "https://docs.aws.amazon.com/codedeploy/latest/userguide/auth-and-access-control-permissions-reference.html",
        arnPattern:
          "arn:${Partition}:codedeploy:${Region}:${Account}:deploymentconfig:${DeploymentConfigurationName}",
        conditionKeys: [],
      },
      {
        name: "deploymentgroup",
        referenceHref:
          "https://docs.aws.amazon.com/codedeploy/latest/userguide/auth-and-access-control-permissions-reference.html",
        arnPattern:
          "arn:${Partition}:codedeploy:${Region}:${Account}:deploymentgroup:${ApplicationName}/${DeploymentGroupName}",
        conditionKeys: [],
      },
      {
        name: "instance",
        referenceHref:
          "https://docs.aws.amazon.com/codedeploy/latest/userguide/auth-and-access-control-permissions-reference.html",
        arnPattern:
          "arn:${Partition}:codedeploy:${Region}:${Account}:instance:${InstanceName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "codedeploy-commands-secure": {
    name: "AWS CodeDeploy secure host commands service",
    servicePrefix: "codedeploy-commands-secure",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodedeploysecurehostcommandsservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codedeploy/latest/userguide/vpc-endpoints.html#vpc-codedeploy-agent-configuration",
    resourceTypes: [],
    conditionKeys: [],
  },
  codeguru: {
    name: "Amazon CodeGuru",
    servicePrefix: "codeguru",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncodeguru.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codeguru/latest/profiler-api/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "codeguru-profiler": {
    name: "Amazon CodeGuru Profiler",
    servicePrefix: "codeguru-profiler",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncodeguruprofiler.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codeguru/latest/profiler-api/",
    resourceTypes: [
      {
        name: "ProfilingGroup",
        referenceHref:
          "https://docs.aws.amazon.com/codeguru/latest/profiler-ug/working-with-profiling-groups.html",
        arnPattern:
          "arn:${Partition}:codeguru-profiler:${Region}:${Account}:profilingGroup/${ProfilingGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "codeguru-reviewer": {
    name: "Amazon CodeGuru Reviewer",
    servicePrefix: "codeguru-reviewer",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncodegurureviewer.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codeguru/latest/reviewer-api/Welcome.html",
    resourceTypes: [
      {
        name: "association",
        referenceHref:
          "https://docs.aws.amazon.com/codeguru/latest/reviewer-ug/working-with-repositories.html",
        arnPattern:
          "arn:${Partition}:codeguru-reviewer:${Region}:${Account}:association:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "codereview",
        referenceHref:
          "https://docs.aws.amazon.com/codeguru/latest/reviewer-ug/code-reviews.html",
        arnPattern:
          "arn:${Partition}:codeguru-reviewer:${Region}:${Account}:association:${ResourceId}:codereview:${CodeReviewId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "codeguru-security": {
    name: "Amazon CodeGuru Security",
    servicePrefix: "codeguru-security",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncodegurusecurity.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codeguru/latest/security-api/Welcome.html",
    resourceTypes: [
      {
        name: "ScanName",
        referenceHref:
          "https://docs.aws.amazon.com/codeguru/latest/security-ug/working-with-code-scans.html",
        arnPattern:
          "arn:${Partition}:codeguru-security:${Region}:${Account}:scans/${ScanName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  codepipeline: {
    name: "AWS CodePipeline",
    servicePrefix: "codepipeline",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodepipeline.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codepipeline/latest/APIReference/",
    resourceTypes: [
      {
        name: "action",
        referenceHref:
          "https://docs.aws.amazon.com/codepipeline/latest/userguide/iam-access-control-identity-based.html#ACP_ARN_Format",
        arnPattern:
          "arn:${Partition}:codepipeline:${Region}:${Account}:${PipelineName}/${StageName}/${ActionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "actiontype",
        referenceHref:
          "https://docs.aws.amazon.com/codepipeline/latest/userguide/iam-access-control-identity-based.html#ACP_ARN_Format",
        arnPattern:
          "arn:${Partition}:codepipeline:${Region}:${Account}:actiontype:${Owner}/${Category}/${Provider}/${Version}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "pipeline",
        referenceHref:
          "https://docs.aws.amazon.com/codepipeline/latest/userguide/iam-access-control-identity-based.html#ACP_ARN_Format",
        arnPattern:
          "arn:${Partition}:codepipeline:${Region}:${Account}:${PipelineName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "stage",
        referenceHref:
          "https://docs.aws.amazon.com/codepipeline/latest/userguide/iam-access-control-identity-based.html#ACP_ARN_Format",
        arnPattern:
          "arn:${Partition}:codepipeline:${Region}:${Account}:${PipelineName}/${StageName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "webhook",
        referenceHref:
          "https://docs.aws.amazon.com/codepipeline/latest/userguide/iam-access-control-identity-based.html#ACP_ARN_Format",
        arnPattern:
          "arn:${Partition}:codepipeline:${Region}:${Account}:webhook:${WebhookName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  codestar: {
    name: "AWS CodeStar",
    servicePrefix: "codestar",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodestar.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codestar/latest/APIReference/",
    resourceTypes: [
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/codestar/latest/userguide/working-with-projects.html",
        arnPattern:
          "arn:${Partition}:codestar:${Region}:${Account}:project/${ProjectId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/codestar/latest/userguide/working-with-user-info.html",
        arnPattern: "arn:${Partition}:iam::${Account}:user/${AwsUserName}",
        conditionKeys: ["iam:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        description:
          "Filters access by requests based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        description:
          "Filters access by actions based on tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        description:
          "Filters access by requests based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "iam:ResourceTag/${TagKey}",
        description:
          "Filters access by actions based on tag-value associated with the resource",
        type: "String",
      },
    ],
  },
  "codestar-connections": {
    name: "AWS CodeStar Connections",
    servicePrefix: "codestar-connections",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodestarconnections.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codestar-connections/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "Connection",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/connections.html",
        arnPattern:
          "arn:${Partition}:codestar-connections:${Region}:${Account}:connection/${ConnectionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Host",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/connections-hosts.html",
        arnPattern:
          "arn:${Partition}:codestar-connections:${Region}:${Account}:host/${HostId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "RepositoryLink",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/repositorylinks.html",
        arnPattern:
          "arn:${Partition}:codestar-connections:${Region}:${Account}:repository-link/${RepositoryLinkId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "codestar-connections:Branch",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-handshake",
        description:
          "Filters access by the branch name that is passed in the request",
        type: "String",
      },
      {
        name: "codestar-connections:BranchName",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-use",
        description:
          "Filters access by the branch name that is passed in the request. Applies only to UseConnection requests for access to a specific repository branch",
        type: "String",
      },
      {
        name: "codestar-connections:FullRepositoryId",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-use",
        description:
          "Filters access by the repository that is passed in the request. Applies only to UseConnection requests for access to a specific repository",
        type: "String",
      },
      {
        name: "codestar-connections:HostArn",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-hosts",
        description:
          "Filters access by the host resource associated with the connection used in the request",
        type: "ARN",
      },
      {
        name: "codestar-connections:InstallationId",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-handshake",
        description:
          "Filters access by the third-party ID (such as the Bitbucket App installation ID for CodeStar Connections) that is used to update a Connection. Allows you to restrict which third-party App installations can be used to make a Connection",
        type: "String",
      },
      {
        name: "codestar-connections:OwnerId",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-use",
        description:
          "Filters access by the owner of the third-party repository. Applies only to UseConnection requests for access to repositories owned by a specific user",
        type: "String",
      },
      {
        name: "codestar-connections:PassedToService",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-passconnection",
        description:
          "Filters access by the service to which the principal is allowed to pass a Connection or RepositoryLink",
        type: "String",
      },
      {
        name: "codestar-connections:ProviderAction",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-access",
        description:
          "Filters access by the provider action in a UseConnection request such as ListRepositories. See documentation for all valid values",
        type: "ArrayOfString",
      },
      {
        name: "codestar-connections:ProviderPermissionsRequired",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-use",
        description:
          "Filters access by the write permissions of a provider action in a UseConnection request. Valid types include read_only and read_write",
        type: "String",
      },
      {
        name: "codestar-connections:ProviderType",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-managing",
        description:
          "Filters access by the type of third-party provider passed in the request",
        type: "String",
      },
      {
        name: "codestar-connections:ProviderTypeFilter",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-managing",
        description:
          "Filters access by the type of third-party provider used to filter results",
        type: "String",
      },
      {
        name: "codestar-connections:RepositoryName",
        referenceHref:
          "https://docs.aws.amazon.com/dtconsole/latest/userguide/security-iam.html#permissions-reference-connections-use",
        description:
          "Filters access by the repository name that is passed in the request. Applies only to UseConnection requests for access to repositories owned by a specific user",
        type: "String",
      },
    ],
  },
  "codestar-notifications": {
    name: "AWS CodeStar Notifications",
    servicePrefix: "codestar-notifications",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscodestarnotifications.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codestar-notifications/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "notificationrule",
        referenceHref:
          "https://docs.aws.amazon.com/codestar-notifications/latest/userguide/security_iam_service-with-iam.html",
        arnPattern:
          "arn:${Partition}:codestar-notifications:${Region}:${Account}:notificationrule/${NotificationRuleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "codestar-notifications:NotificationsForResource",
        referenceHref:
          "https://docs.aws.amazon.com/codestar-notifications/latest/userguide/security_iam_id-based-policy-examples.html",
        description:
          "Filters access based on the ARN of the resource for which notifications are configured",
        type: "ARN",
      },
    ],
  },
  codewhisperer: {
    name: "Amazon CodeWhisperer",
    servicePrefix: "codewhisperer",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncodewhisperer.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/codewhisperer/latest/userguide/security_iam_id-based-policy-examples.html#permissions-required-console/",
    resourceTypes: [
      {
        name: "profile",
        referenceHref:
          "https://docs.aws.amazon.com/codewhisperer/latest/userguide/as-whisper-admin.html#about-profiles",
        arnPattern:
          "arn:${Partition}:codewhisperer::${Account}:profile/${Identifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "customization",
        referenceHref:
          "https://docs.aws.amazon.com/codewhisperer/latest/userguide/as-whisper-admin.html#about-customizations",
        arnPattern:
          "arn:${Partition}:codewhisperer::${Account}:customization/${Identifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/codewhisperer/latest/userguide/codewhisperer-setup-enterprise-admin.html",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/codewhisperer/latest/userguide/codewhisperer-setup-enterprise-admin.html",
        description:
          "Filters access by the tags associated with CodeWhisperer resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/codewhisperer/latest/userguide/codewhisperer-setup-enterprise-admin.html",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "cognito-identity": {
    name: "Amazon Cognito Identity",
    servicePrefix: "cognito-identity",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncognitoidentity.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/",
    resourceTypes: [
      {
        name: "identitypool",
        referenceHref:
          "https://docs.aws.amazon.com/cognito/latest/developerguide/identity-pools.html",
        arnPattern:
          "arn:${Partition}:cognito-identity:${Region}:${Account}:identitypool/${IdentityPoolId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by a key that is present in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "cognito-sync": {
    name: "Amazon Cognito Sync",
    servicePrefix: "cognito-sync",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncognitosync.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cognitosync/latest/APIReference/",
    resourceTypes: [
      {
        name: "dataset",
        referenceHref:
          "https://docs.aws.amazon.com/cognito/latest/developerguide/synchronizing-data.html#understanding-datasets",
        arnPattern:
          "arn:${Partition}:cognito-sync:${Region}:${Account}:identitypool/${IdentityPoolId}/identity/${IdentityId}/dataset/${DatasetName}",
        conditionKeys: [],
      },
      {
        name: "identity",
        referenceHref:
          "https://docs.aws.amazon.com/cognito/latest/developerguide/identity-pools.html#authenticated-and-unauthenticated-identities",
        arnPattern:
          "arn:${Partition}:cognito-sync:${Region}:${Account}:identitypool/${IdentityPoolId}/identity/${IdentityId}",
        conditionKeys: [],
      },
      {
        name: "identitypool",
        referenceHref:
          "https://docs.aws.amazon.com/cognito/latest/developerguide/identity-pools.html",
        arnPattern:
          "arn:${Partition}:cognito-sync:${Region}:${Account}:identitypool/${IdentityPoolId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  "cognito-idp": {
    name: "Amazon Cognito User Pools",
    servicePrefix: "cognito-idp",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncognitouserpools.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/",
    resourceTypes: [
      {
        name: "userpool",
        referenceHref:
          "https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-user-identity-pools.html",
        arnPattern:
          "arn:${Partition}:cognito-idp:${Region}:${Account}:userpool/${UserPoolId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "webacl",
        referenceHref:
          "https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-waf.html",
        arnPattern:
          "arn:${Partition}:wafv2:${Region}:${Account}:${Scope}/webacl/${Name}/${Id}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by a key that is present in the request",
        type: "ArrayOfString",
      },
    ],
  },
  comprehend: {
    name: "Amazon Comprehend",
    servicePrefix: "comprehend",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncomprehend.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/comprehend/latest/APIReference/welcome.html",
    resourceTypes: [
      {
        name: "targeted-sentiment-detection-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartTargetedSentimentDetectionJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:targeted-sentiment-detection-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "document-classifier",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/dg/how-document-classification-training.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:document-classifier/${DocumentClassifierName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "document-classifier-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/dg/manage-endpoints.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:document-classifier-endpoint/${DocumentClassifierEndpointName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "entity-recognizer",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/dg/training-recognizers.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:entity-recognizer/${EntityRecognizerName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "entity-recognizer-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/dg/manage-endpoints.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:entity-recognizer-endpoint/${EntityRecognizerEndpointName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dominant-language-detection-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartDominantLanguageDetectionJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:dominant-language-detection-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "entities-detection-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartEntitiesDetectionJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:entities-detection-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "pii-entities-detection-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartPiiEntitiesDetectionJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:pii-entities-detection-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "events-detection-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartEventsDetectionJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:events-detection-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "key-phrases-detection-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartKeyPhrasesDetectionJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:key-phrases-detection-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "sentiment-detection-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartSentimentDetectionJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:sentiment-detection-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "topics-detection-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartTopicsDetectionJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:topics-detection-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "document-classification-job",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_StartDocumentClassificationJob.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:document-classification-job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "flywheel",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_CreateFlywheel.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:flywheel/${FlywheelName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "flywheel-dataset",
        referenceHref:
          "https://docs.aws.amazon.com/comprehend/latest/APIReference/API_CreateDataset.html",
        arnPattern:
          "arn:${Partition}:comprehend:${Region}:${Account}:flywheel/${FlywheelName}/dataset/${DatasetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring tag values present in a resource creation request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring tag value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "comprehend:DataLakeKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazoncomprehend.html#amazoncomprehend-policy-keys",
        description:
          "Filters access by the DataLake Kms Key associated with the flywheel resource in the request",
        type: "ARN",
      },
      {
        name: "comprehend:FlywheelIterationId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazoncomprehend.html#amazoncomprehend-policy-keys",
        description: "Filters access by particular Iteration Id for a flywheel",
        type: "String",
      },
      {
        name: "comprehend:ModelKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazoncomprehend.html#amazoncomprehend-policy-keys",
        description:
          "Filters access by the model KMS key associated with the resource in the request",
        type: "ARN",
      },
      {
        name: "comprehend:OutputKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazoncomprehend.html#amazoncomprehend-policy-keys",
        description:
          "Filters access by the output KMS key associated with the resource in the request",
        type: "ARN",
      },
      {
        name: "comprehend:VolumeKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazoncomprehend.html#amazoncomprehend-policy-keys",
        description:
          "Filters access by the volume KMS key associated with the resource in the request",
        type: "ARN",
      },
      {
        name: "comprehend:VpcSecurityGroupIds",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazoncomprehend.html#amazoncomprehend-policy-keys",
        description:
          "Filters access by the list of all VPC security group ids associated with the resource in the request",
        type: "ArrayOfString",
      },
      {
        name: "comprehend:VpcSubnets",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazoncomprehend.html#amazoncomprehend-policy-keys",
        description:
          "Filters access by the list of all VPC subnets associated with the resource in the request",
        type: "ArrayOfString",
      },
    ],
  },
  comprehendmedical: {
    name: "Amazon Comprehend Medical",
    servicePrefix: "comprehendmedical",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoncomprehendmedical.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/comprehend-medical/latest/api/Welcome.html",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "compute-optimizer": {
    name: "AWS Compute Optimizer",
    servicePrefix: "compute-optimizer",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscomputeoptimizer.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/compute-optimizer/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "compute-optimizer:ResourceType",
        referenceHref:
          "https://docs.aws.amazon.com/compute-optimizer/latest/ug/security-iam.html",
        description: "Filters access by the resource type",
        type: "String",
      },
    ],
  },
  config: {
    name: "AWS Config",
    servicePrefix: "config",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsconfig.html",
    apiReferenceHref: "https://docs.aws.amazon.com/config/latest/APIReference/",
    resourceTypes: [
      {
        name: "AggregationAuthorization",
        referenceHref:
          "https://docs.aws.amazon.com/config/latest/APIReference/API_AggregationAuthorization.html",
        arnPattern:
          "arn:${Partition}:config:${Region}:${Account}:aggregation-authorization/${AggregatorAccount}/${AggregatorRegion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ConfigurationAggregator",
        referenceHref:
          "https://docs.aws.amazon.com/config/latest/APIReference/API_ConfigurationAggregator.html",
        arnPattern:
          "arn:${Partition}:config:${Region}:${Account}:config-aggregator/${AggregatorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ConfigRule",
        referenceHref:
          "https://docs.aws.amazon.com/config/latest/APIReference/API_ConfigRule.html",
        arnPattern:
          "arn:${Partition}:config:${Region}:${Account}:config-rule/${ConfigRuleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ConformancePack",
        referenceHref:
          "https://docs.aws.amazon.com/config/latest/APIReference/API_ConformancePackDetail.html",
        arnPattern:
          "arn:${Partition}:config:${Region}:${Account}:conformance-pack/${ConformancePackName}/${ConformancePackId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "OrganizationConfigRule",
        referenceHref:
          "https://docs.aws.amazon.com/config/latest/APIReference/API_OrganizationConfigRule.html",
        arnPattern:
          "arn:${Partition}:config:${Region}:${Account}:organization-config-rule/${OrganizationConfigRuleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "OrganizationConformancePack",
        referenceHref:
          "https://docs.aws.amazon.com/config/latest/APIReference/API_OrganizationConformancePack.html",
        arnPattern:
          "arn:${Partition}:config:${Region}:${Account}:organization-conformance-pack/${OrganizationConformancePackId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "RemediationConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/config/latest/APIReference/API_RemediationConfiguration.html",
        arnPattern:
          "arn:${Partition}:config:${Region}:${Account}:remediation-configuration/${RemediationConfigurationId}",
        conditionKeys: [],
      },
      {
        name: "StoredQuery",
        referenceHref:
          "https://docs.aws.amazon.com/config/latest/APIReference/API_StoredQuery.html",
        arnPattern:
          "arn:${Partition}:config:${Region}:${Account}:stored-query/${StoredQueryName}/${StoredQueryId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  connect: {
    name: "Amazon Connect",
    servicePrefix: "connect",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonconnect.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/connect/latest/APIReference/",
    resourceTypes: [
      {
        name: "instance",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/amazon-connect-instances.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "contact",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/connect-contact-attributes.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/contact/${ContactId}",
        conditionKeys: [],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/connect-agents.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/agent/${UserId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "routing-profile",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/routing-profiles.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/routing-profile/${RoutingProfileId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "security-profile",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/connect-security-profiles.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/security-profile/${SecurityProfileId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "hierarchy-group",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/agent-hierarchy.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/agent-group/${HierarchyGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "queue",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/create-queue.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/queue/${QueueId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "wildcard-queue",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/create-queue.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/queue/*",
        conditionKeys: [],
      },
      {
        name: "quick-connect",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/quick-connects.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/transfer-destination/${QuickConnectId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "wildcard-quick-connect",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/quick-connects.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/transfer-destination/*",
        conditionKeys: [],
      },
      {
        name: "contact-flow",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/connect-contact-flows.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/contact-flow/${ContactFlowId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "task-template",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/task-templates.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/task-template/${TaskTemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "contact-flow-module",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/contact-flow-modules.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/flow-module/${ContactFlowModuleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "wildcard-contact-flow",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/connect-contact-flows.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/contact-flow/*",
        conditionKeys: [],
      },
      {
        name: "hours-of-operation",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/set-hours-operation.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/operating-hours/${HoursOfOperationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "agent-status",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/metrics-agent-status.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/agent-state/${AgentStatusId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "wildcard-agent-status",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/metrics-agent-status.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/agent-state/*",
        conditionKeys: [],
      },
      {
        name: "legacy-phone-number",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/ag-overview-numbers.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/phone-number/${PhoneNumberId}",
        conditionKeys: [],
      },
      {
        name: "wildcard-legacy-phone-number",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/ag-overview-numbers.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/phone-number/*",
        conditionKeys: [],
      },
      {
        name: "phone-number",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/ag-overview-numbers.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:phone-number/${PhoneNumberId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "wildcard-phone-number",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/ag-overview-numbers.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:phone-number/*",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "integration-association",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/connect-rules.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/integration-association/${IntegrationAssociationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "use-case",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/add-rules-task-creation.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/use-case/${UseCaseId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vocabulary",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/add-custom-vocabulary.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/vocabulary/${VocabularyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "traffic-distribution-group",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/setup-traffic-distribution-groups.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:traffic-distribution-group/${TrafficDistributionGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "rule",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/connect-rules.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/rule/${RuleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "evaluation-form",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/create-evaluation-forms.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/evaluation-form/${FormId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "contact-evaluation",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/evaluations.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/contact-evaluation/${EvaluationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "prompt",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/prompts.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/prompt/${PromptId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "customer-managed-view",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/view-resources-sg.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/view/${ViewId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "aws-managed-view",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/view-resources-sg.html",
        arnPattern: "arn:${Partition}:connect:${Region}:aws:view/${ViewId}",
        conditionKeys: [],
      },
      {
        name: "qualified-customer-managed-view",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/view-resources-sg.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/view/${ViewId}:${ViewQualifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "qualified-aws-managed-view",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/view-resources-sg.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:aws:view/${ViewId}:${ViewQualifier}",
        conditionKeys: [],
      },
      {
        name: "customer-managed-view-version",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/view-resources-sg.html",
        arnPattern:
          "arn:${Partition}:connect:${Region}:${Account}:instance/${InstanceId}/view/${ViewId}:${ViewVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by using tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by using tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by using tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "connect:AttributeType",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the attribute type of the Amazon Connect instance",
        type: "String",
      },
      {
        name: "connect:InstanceId",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/security_iam_service-with-iam.html",
        description:
          "Filters access by restricting federation into specified Amazon Connect instances",
        type: "String",
      },
      {
        name: "connect:MonitorCapabilities",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/security_iam_service-with-iam.html",
        description:
          "Filters access by restricting the monitor capabilities of the user in the request",
        type: "ArrayOfString",
      },
      {
        name: "connect:SearchContactsByContactAnalysis",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/security_iam_service-with-iam.html",
        description:
          "Filters access by restricting searches using analysis outputs from Amazon Connect Contact Lens",
        type: "ArrayOfString",
      },
      {
        name: "connect:SearchTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/security_iam_service-with-iam.html",
        description:
          "Filters access by TagFilter condition passed in the search request",
        type: "String",
      },
      {
        name: "connect:StorageResourceType",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/security_iam_service-with-iam.html",
        description:
          "Filters access by restricting the storage resource type of the Amazon Connect instance storage configuration",
        type: "String",
      },
    ],
  },
  cases: {
    name: "Amazon Connect Cases",
    servicePrefix: "cases",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonconnectcases.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cases/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "Case",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/cases.html",
        arnPattern:
          "arn:${Partition}:cases:${Region}:${Account}:domain/${DomainId}/case/${CaseId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Domain",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/cases.html",
        arnPattern:
          "arn:${Partition}:cases:${Region}:${Account}:domain/${DomainId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Field",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/case-fields.html",
        arnPattern:
          "arn:${Partition}:cases:${Region}:${Account}:domain/${DomainId}/field/${FieldId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Layout",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/case-layouts.html",
        arnPattern:
          "arn:${Partition}:cases:${Region}:${Account}:domain/${DomainId}/layout/${LayoutId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "RelatedItem",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/associatecontactandcase.html",
        arnPattern:
          "arn:${Partition}:cases:${Region}:${Account}:domain/${DomainId}/case/${CaseId}/related-item/${RelatedItemId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Template",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/case-templates.html",
        arnPattern:
          "arn:${Partition}:cases:${Region}:${Account}:domain/${DomainId}/template/${TemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "connect:UserArn",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/APIReference/API_UserReference.html",
        description: "Filters access by connect's UserArn",
        type: "String",
      },
    ],
  },
  profile: {
    name: "Amazon Connect Customer Profiles",
    servicePrefix: "profile",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonconnectcustomerprofiles.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/customerprofiles/latest/APIReference/",
    resourceTypes: [
      {
        name: "domains",
        referenceHref:
          "https://docs.aws.amazon.com/customerprofiles/latest/APIReference/",
        arnPattern:
          "arn:${Partition}:profile:${Region}:${Account}:domains/${DomainName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "object-types",
        referenceHref:
          "https://docs.aws.amazon.com/customerprofiles/latest/APIReference/",
        arnPattern:
          "arn:${Partition}:profile:${Region}:${Account}:domains/${DomainName}/object-types/${ObjectTypeName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "integrations",
        referenceHref:
          "https://docs.aws.amazon.com/customerprofiles/latest/APIReference/",
        arnPattern:
          "arn:${Partition}:profile:${Region}:${Account}:domains/${DomainName}/integrations/${Uri}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "event-streams",
        referenceHref:
          "https://docs.aws.amazon.com/customerprofiles/latest/APIReference/",
        arnPattern:
          "arn:${Partition}:profile:${Region}:${Account}:domains/${DomainName}/event-streams/${EventStreamName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "calculated-attributes",
        referenceHref:
          "https://docs.aws.amazon.com/customerprofiles/latest/APIReference/",
        arnPattern:
          "arn:${Partition}:profile:${Region}:${Account}:domains/${DomainName}/calculated-attributes/${CalculatedAttributeName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by a key that is present in the request the user makes to the customer profile service",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description: "Filters access by a tag key and value pair",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the list of all the tag key names present in the request the user makes to the customer profile service",
        type: "ArrayOfString",
      },
    ],
  },
  voiceid: {
    name: "Amazon Connect Voice ID",
    servicePrefix: "voiceid",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonconnectvoiceid.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/voiceid/latest/APIReference/",
    resourceTypes: [
      {
        name: "domain",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/enable-voiceid.html#voiceid-domain",
        arnPattern:
          "arn:${Partition}:voiceid:${Region}:${Account}:domain/${DomainId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  awsconnector: {
    name: "AWS Connector Service",
    servicePrefix: "awsconnector",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsconnectorservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/server-migration-service/latest/APIReference/API_Operations.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  consoleapp: {
    name: "AWS Management Console Mobile App",
    servicePrefix: "consoleapp",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsconsolemobileapp.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/consolemobileapp/latest/userguide/permissions-policies.html",
    resourceTypes: [
      {
        name: "DeviceIdentity",
        referenceHref:
          "https://docs.aws.amazon.com/consolemobileapp/latest/userguide/permissions-policies.html",
        arnPattern:
          "arn:${Partition}:consoleapp::${Account}:device/${DeviceId}/identity/${IdentityId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  consolidatedbilling: {
    name: "AWS Consolidated Billing",
    servicePrefix: "consolidatedbilling",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsconsolidatedbilling.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/billing-permissions-ref.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  controltower: {
    name: "AWS Control Tower",
    servicePrefix: "controltower",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscontroltower.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/controltower/latest/APIReference/",
    resourceTypes: [
      {
        name: "EnabledControl",
        referenceHref:
          "https://docs.aws.amazon.com/controltower/latest/APIReference/API_EnableControl.html",
        arnPattern:
          "arn:${Partition}:controltower:${Region}:${Account}:enabledcontrol/${EnabledControlId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "LandingZone",
        referenceHref:
          "https://docs.aws.amazon.com/controltower/latest/APIReference/API_CreateLandingZone.html",
        arnPattern:
          "arn:${Partition}:controltower:${Region}:${Account}:landingzone/${LandingZoneId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  cur: {
    name: "AWS Cost and Usage Report",
    servicePrefix: "cur",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscostandusagereport.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/",
    resourceTypes: [
      {
        name: "cur",
        referenceHref:
          "https://docs.aws.amazon.com/cur/latest/userguide/what-is-cur.html",
        arnPattern:
          "arn:${Partition}:cur:${Region}:${Account}:definition/${ReportName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  ce: {
    name: "AWS Cost Explorer Service",
    servicePrefix: "ce",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscostexplorerservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/API_Operations_AWS_Cost_Explorer_Service.html",
    resourceTypes: [
      {
        name: "anomalysubscription",
        referenceHref:
          "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/API_AnomalySubscription.html",
        arnPattern:
          "arn:${Partition}:ce::${Account}:anomalysubscription/${Identifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "anomalymonitor",
        referenceHref:
          "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/API_AnomalyMonitor.html",
        arnPattern:
          "arn:${Partition}:ce::${Account}:anomalymonitor/${Identifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "costcategory",
        referenceHref:
          "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/API_CostCategory.html",
        arnPattern:
          "arn:${Partition}:ce::${Account}:costcategory/${Identifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "cost-optimization-hub": {
    name: "AWS Cost Optimization Hub",
    servicePrefix: "cost-optimization-hub",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscostoptimizationhub.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/cost-optimization-hub/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "customer-verification": {
    name: "AWS Customer Verification Service",
    servicePrefix: "customer-verification",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awscustomerverificationservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/",
    resourceTypes: [],
    conditionKeys: [],
  },
  dataexchange: {
    name: "AWS Data Exchange",
    servicePrefix: "dataexchange",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdataexchange.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/data-exchange/latest/apireference/welcome.html",
    resourceTypes: [
      {
        name: "jobs",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/jobs.html",
        arnPattern:
          "arn:${Partition}:dataexchange:${Region}:${Account}:jobs/${JobId}",
        conditionKeys: ["dataexchange:JobType"],
      },
      {
        name: "data-sets",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/data-sets.html",
        arnPattern:
          "arn:${Partition}:dataexchange:${Region}:${Account}:data-sets/${DataSetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "entitled-data-sets",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/data-sets.html",
        arnPattern:
          "arn:${Partition}:dataexchange:${Region}::data-sets/${DataSetId}",
        conditionKeys: [],
      },
      {
        name: "revisions",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/data-sets.html#revisions",
        arnPattern:
          "arn:${Partition}:dataexchange:${Region}:${Account}:data-sets/${DataSetId}/revisions/${RevisionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "entitled-revisions",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/data-sets.html#revisions",
        arnPattern:
          "arn:${Partition}:dataexchange:${Region}::data-sets/${DataSetId}/revisions/${RevisionId}",
        conditionKeys: [],
      },
      {
        name: "assets",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/data-sets.html#assets",
        arnPattern:
          "arn:${Partition}:dataexchange:${Region}:${Account}:data-sets/${DataSetId}/revisions/${RevisionId}/assets/${AssetId}",
        conditionKeys: [],
      },
      {
        name: "entitled-assets",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/data-sets.html#assets",
        arnPattern:
          "arn:${Partition}:dataexchange:${Region}::data-sets/${DataSetId}/revisions/${RevisionId}/assets/${AssetId}",
        conditionKeys: [],
      },
      {
        name: "event-actions",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/data-sets.html",
        arnPattern:
          "arn:${Partition}:dataexchange:${Region}:${Account}:event-actions/${EventActionId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by the allowed set of values for each of the mandatory tags in the create request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by the tag value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by the presence of mandatory tags in the create request",
        type: "ArrayOfString",
      },
      {
        name: "dataexchange:JobType",
        referenceHref:
          "https://docs.aws.amazon.com/data-exchange/latest/userguide/access-control.html",
        description: "Filters access by the specified job type",
        type: "String",
      },
    ],
  },
  dlm: {
    name: "Amazon Data Lifecycle Manager",
    servicePrefix: "dlm",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazondatalifecyclemanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/dlm/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "policy",
        referenceHref:
          "https://docs.aws.amazon.com/dlm/latest/APIReference/API_LifecyclePolicy.html",
        arnPattern:
          "arn:${Partition}:dlm:${Region}:${Account}:policy/${ResourceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  datapipeline: {
    name: "AWS Data Pipeline",
    servicePrefix: "datapipeline",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatapipeline.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/datapipeline/latest/APIReference/",
    resourceTypes: [
      {
        name: "pipeline",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatapipeline.html",
        arnPattern:
          "arn:${Partition}:datapipeline:${Region}:${Account}:pipeline/${PipelineId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "datapipeline:PipelineCreator",
        referenceHref:
          "https://docs.aws.amazon.com/datapipeline/latest/DeveloperGuide/dp-example-tag-policies.html#ex3",
        description: "Filters access by the IAM user that created the pipeline",
        type: "ArrayOfString",
      },
      {
        name: "datapipeline:Tag",
        referenceHref:
          "https://docs.aws.amazon.com/datapipeline/latest/DeveloperGuide/dp-iam-resourcebased-access.html#dp-control-access-tags",
        description:
          "Filters access by customer-specified key/value pair that can be attached to a resource",
        type: "ArrayOfString",
      },
      {
        name: "datapipeline:workerGroup",
        referenceHref:
          "https://docs.aws.amazon.com/datapipeline/latest/DeveloperGuide/dp-iam-resourcebased-access.html#dp-control-access-workergroup",
        description:
          "Filters access by the name of a worker group for which a Task Runner retrieves work",
        type: "ArrayOfString",
      },
    ],
  },
  dms: {
    name: "AWS Database Migration Service",
    servicePrefix: "dms",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html",
    apiReferenceHref: "https://docs.aws.amazon.com/dms/latest/APIReference/",
    resourceTypes: [
      {
        name: "Certificate",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/API_Certificate.html",
        arnPattern: "arn:${Partition}:dms:${Region}:${Account}:cert:*",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "dms:cert-tag/${TagKey}"],
      },
      {
        name: "DataProvider",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/Welcome.html",
        arnPattern: "arn:${Partition}:dms:${Region}:${Account}:data-provider:*",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "dms:data-provider-tag/${TagKey}",
        ],
      },
      {
        name: "DataMigration",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/Welcome.html",
        arnPattern:
          "arn:${Partition}:dms:${Region}:${Account}:data-migration:*",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "dms:data-migration-tag/${TagKey}",
        ],
      },
      {
        name: "Endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/API_Endpoint.html",
        arnPattern: "arn:${Partition}:dms:${Region}:${Account}:endpoint:*",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "dms:endpoint-tag/${TagKey}",
        ],
      },
      {
        name: "EventSubscription",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/API_EventSubscription.html",
        arnPattern: "arn:${Partition}:dms:${Region}:${Account}:es:*",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "dms:es-tag/${TagKey}"],
      },
      {
        name: "InstanceProfile",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/Welcome.html",
        arnPattern:
          "arn:${Partition}:dms:${Region}:${Account}:instance-profile:*",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "dms:instance-profile-tag/${TagKey}",
        ],
      },
      {
        name: "MigrationProject",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/Welcome.html",
        arnPattern:
          "arn:${Partition}:dms:${Region}:${Account}:migration-project:*",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "dms:migration-project-tag/${TagKey}",
        ],
      },
      {
        name: "ReplicationConfig",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/Welcome.html",
        arnPattern:
          "arn:${Partition}:dms:${Region}:${Account}:replication-config:*",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "dms:replication-config-tag/${TagKey}",
        ],
      },
      {
        name: "ReplicationInstance",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/API_ReplicationInstance.html",
        arnPattern: "arn:${Partition}:dms:${Region}:${Account}:rep:*",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "dms:rep-tag/${TagKey}"],
      },
      {
        name: "ReplicationSubnetGroup",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/API_ReplicationSubnetGroup.html",
        arnPattern: "arn:${Partition}:dms:${Region}:${Account}:subgrp:*",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "dms:subgrp-tag/${TagKey}",
        ],
      },
      {
        name: "ReplicationTask",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/API_ReplicationTask.html",
        arnPattern: "arn:${Partition}:dms:${Region}:${Account}:task:*",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "dms:task-tag/${TagKey}"],
      },
      {
        name: "ReplicationTaskAssessmentRun",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/API_ReplicationTaskAssessmentRun.html",
        arnPattern:
          "arn:${Partition}:dms:${Region}:${Account}:assessment-run:*",
        conditionKeys: [],
      },
      {
        name: "ReplicationTaskIndividualAssessment",
        referenceHref:
          "https://docs.aws.amazon.com/dms/latest/APIReference/API_ReplicationTaskIndividualAssessment.html",
        arnPattern:
          "arn:${Partition}:dms:${Region}:${Account}:individual-assessment:*",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "dms:cert-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice--dms_cert-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for Certificate",
        type: "String",
      },
      {
        name: "dms:data-migration-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice--dms_data-migration-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for DataMigration",
        type: "String",
      },
      {
        name: "dms:data-provider-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice--dms_dp-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for DataProvider",
        type: "String",
      },
      {
        name: "dms:endpoint-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice-dms_endpoint-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for Endpoint",
        type: "String",
      },
      {
        name: "dms:es-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice-dms_es-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for EventSubscription",
        type: "String",
      },
      {
        name: "dms:instance-profile-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice--dms_ip-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for InstanceProfile",
        type: "String",
      },
      {
        name: "dms:migration-project-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice--dms_mp-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for MigrationProject",
        type: "String",
      },
      {
        name: "dms:rep-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice-dms_rep-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for ReplicationInstance",
        type: "String",
      },
      {
        name: "dms:replication-config-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice%E2%80%94dms_replication-config-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for ReplicationConfig",
        type: "String",
      },
      {
        name: "dms:req-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice-dms_req-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the given request",
        type: "String",
      },
      {
        name: "dms:subgrp-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice-dms_subgrp-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for ReplicationSubnetGroup",
        type: "String",
      },
      {
        name: "dms:task-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatabasemigrationservice.html#awsdatabasemigrationservice-dms_task-tag___TagKey_",
        description:
          "Filters access by the presence of tag key-value pairs in the request for ReplicationTask",
        type: "String",
      },
    ],
  },
  dbqms: {
    name: "Database Query Metadata Service",
    servicePrefix: "dbqms",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_databasequerymetadataservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/qldb/latest/developerguide/dbqms-api.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  datasync: {
    name: "AWS DataSync",
    servicePrefix: "datasync",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdatasync.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/datasync/latest/userguide/API_Reference.html",
    resourceTypes: [
      {
        name: "agent",
        referenceHref:
          "https://docs.aws.amazon.com/datasync/latest/userguide/working-with-agents.html",
        arnPattern:
          "arn:${Partition}:datasync:${Region}:${AccountId}:agent/${AgentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "location",
        referenceHref:
          "https://docs.aws.amazon.com/datasync/latest/userguide/working-with-locations.html",
        arnPattern:
          "arn:${Partition}:datasync:${Region}:${AccountId}:location/${LocationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "task",
        referenceHref:
          "https://docs.aws.amazon.com/datasync/latest/userguide/working-with-tasks.html",
        arnPattern:
          "arn:${Partition}:datasync:${Region}:${AccountId}:task/${TaskId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "taskexecution",
        referenceHref:
          "https://docs.aws.amazon.com/datasync/latest/userguide/working-with-task-executions.html",
        arnPattern:
          "arn:${Partition}:datasync:${Region}:${AccountId}:task/${TaskId}/execution/${ExecutionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "storagesystem",
        referenceHref:
          "https://docs.aws.amazon.com/datasync/latest/userguide/discovery-configure-storage.html",
        arnPattern:
          "arn:${Partition}:datasync:${Region}:${AccountId}:system/${StorageSystemId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "discoveryjob",
        referenceHref:
          "https://docs.aws.amazon.com/datasync/latest/userguide/discovery-job-create.html",
        arnPattern:
          "arn:${Partition}:datasync:${Region}:${AccountId}:system/${StorageSystemId}/job/${DiscoveryJobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  datazone: {
    name: "Amazon DataZone",
    servicePrefix: "datazone",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazondatazone.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/datazone/latest/APIReference/",
    resourceTypes: [
      {
        name: "domain",
        referenceHref:
          "https://docs.aws.amazon.com/datazone/latest/userguide/create-domain.html",
        arnPattern:
          "arn:${Partition}:datazone:${Region}:${Account}:domain/${DomainId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  deepcomposer: {
    name: "AWS DeepComposer",
    servicePrefix: "deepcomposer",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdeepcomposer.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/deepcomposer/latest/devguide/what-it-is.html",
    resourceTypes: [
      {
        name: "model",
        referenceHref:
          "https://docs.aws.amazon.com/deepcomposer/latest/devguide/get-started-custom-model.html",
        arnPattern:
          "arn:${Partition}:deepcomposer:${Region}:${Account}:model/${ModelId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "composition",
        referenceHref:
          "https://docs.aws.amazon.com/deepcomposer/latest/devguide/get-started-learn-from-pre-trained-models.html",
        arnPattern:
          "arn:${Partition}:deepcomposer:${Region}:${Account}:composition/${CompositionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "audio",
        referenceHref:
          "https://docs.aws.amazon.com/deepcomposer/latest/devguide/get-started-learn-from-pre-trained-models.html",
        arnPattern:
          "arn:${Partition}:deepcomposer:${Region}:${Account}:audio/${AudioId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  deeplens: {
    name: "AWS DeepLens",
    servicePrefix: "deeplens",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdeeplens.html",
    resourceTypes: [
      {
        name: "device",
        arnPattern:
          "arn:${Partition}:deeplens:${Region}:${Account}:device/${DeviceName}",
        conditionKeys: [],
      },
      {
        name: "project",
        arnPattern:
          "arn:${Partition}:deeplens:${Region}:${Account}:project/${ProjectName}",
        conditionKeys: [],
      },
      {
        name: "model",
        arnPattern:
          "arn:${Partition}:deeplens:${Region}:${Account}:model/${ModelName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  deepracer: {
    name: "AWS DeepRacer",
    servicePrefix: "deepracer",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdeepracer.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/deepracer/latest/developerguide/what-is-deepracer.html",
    resourceTypes: [
      {
        name: "car",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/deepracer-choose-race-type.html",
        arnPattern:
          "arn:${Partition}:deepracer:${Region}:${Account}:car/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "evaluation_job",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/deepracer-get-started-test-in-simulator.html",
        arnPattern:
          "arn:${Partition}:deepracer:${Region}:${Account}:evaluation_job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "leaderboard",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/deepracer-submit-model-to-leaderboard.html",
        arnPattern:
          "arn:${Partition}:deepracer:${Region}::leaderboard/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "leaderboard_evaluation_job",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/deepracer-submit-model-to-leaderboard.html",
        arnPattern:
          "arn:${Partition}:deepracer:${Region}:${Account}:leaderboard_evaluation_job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "reinforcement_learning_model",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/deepracer-get-started-training-model.html",
        arnPattern:
          "arn:${Partition}:deepracer:${Region}:${Account}:model/reinforcement_learning/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "track",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/deepracer-console-train-evaluate-models.html",
        arnPattern: "arn:${Partition}:deepracer:${Region}::track/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "training_job",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/deepracer-get-started-training-model.html",
        arnPattern:
          "arn:${Partition}:deepracer:${Region}:${Account}:training_job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters actions by tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters actions by tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "deepracer:MultiUser",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/reference_policies_iam-condition-keys.html#condition-keys-multiuser",
        description: "Filters access by multiuser flag",
        type: "Bool",
      },
      {
        name: "deepracer:UserToken",
        referenceHref:
          "https://docs.aws.amazon.com/deepracer/latest/developerguide/reference_policies_iam-condition-keys.html#condition-keys-usertoken",
        description: "Filters access by user token in the request",
        type: "String",
      },
    ],
  },
  detective: {
    name: "Amazon Detective",
    servicePrefix: "detective",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazondetective.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/detective/latest/APIReference/",
    resourceTypes: [
      {
        name: "Graph",
        referenceHref:
          "https://docs.aws.amazon.com/detective/latest/adminguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-resources",
        arnPattern:
          "arn:${Partition}:detective:${Region}:${Account}:graph:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by specifying the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by specifying the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by specifying the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  devicefarm: {
    name: "AWS Device Farm",
    servicePrefix: "devicefarm",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdevicefarm.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Project.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:project:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "run",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Run.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:run:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "job",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Job.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:job:${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "suite",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Suite.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:suite:${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "test",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Test.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:test:${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "upload",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Upload.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:upload:${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "artifact",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Artifact.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:artifact:${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "sample",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Sample.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:sample:${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "networkprofile",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_NetworkProfile.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:networkprofile:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deviceinstance",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_DeviceInstance.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}::deviceinstance:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "session",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_RemoteAccessSession.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:session:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "devicepool",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_DevicePool.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:devicepool:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "device",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_Device.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}::device:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "instanceprofile",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_InstanceProfile.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:instanceprofile:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vpceconfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_VPCEConfiguration.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:vpceconfiguration:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "testgrid-project",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_TestGridProject.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:testgrid-project:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "testgrid-session",
        referenceHref:
          "https://docs.aws.amazon.com/devicefarm/latest/APIReference/API_TestGridSession.html",
        arnPattern:
          "arn:${Partition}:devicefarm:${Region}:${Account}:testgrid-session:${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag-value assoicated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "devops-guru": {
    name: "Amazon DevOps Guru",
    servicePrefix: "devops-guru",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazondevopsguru.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/devops-guru/latest/APIReference/",
    resourceTypes: [
      {
        name: "topic",
        referenceHref:
          "https://docs.aws.amazon.com/devops-guru/latest/userguide/setting-up.html#setting-up-notifications",
        arnPattern: "arn:${Partition}:sns:${Region}:${Account}:${TopicName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "devops-guru:ServiceNames",
        referenceHref:
          "https://docs.aws.amazon.com/devops-guru/latest/APIReference/API_ServiceCollection.html",
        description:
          "Filters access by API to restrict access to given AWS service names",
        type: "ArrayOfString",
      },
    ],
  },
  ts: {
    name: "AWS Diagnostic tools",
    servicePrefix: "ts",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdiagnostictools.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/diagnostic-tools/latest/APIReference/",
    resourceTypes: [
      {
        name: "execution",
        referenceHref:
          "https://docs.aws.amazon.com/diagnostic-tools/latest/APIReference/API_Execution.html",
        arnPattern:
          "arn:${Partition}:ts::${Account}:execution/${UserId}/${ToolId}/${ExecutionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "tool",
        referenceHref:
          "https://docs.aws.amazon.com/diagnostic-tools/latest/APIReference/API_Tool.html",
        arnPattern: "arn:${Partition}:ts::aws:tool/${ToolId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  directconnect: {
    name: "AWS Direct Connect",
    servicePrefix: "directconnect",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdirectconnect.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/directconnect/latest/APIReference/",
    resourceTypes: [
      {
        name: "dxcon",
        referenceHref:
          "https://docs.aws.amazon.com/directconnect/latest/APIReference/API_Connection.html",
        arnPattern:
          "arn:${Partition}:directconnect:${Region}:${Account}:dxcon/${ConnectionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dxlag",
        referenceHref:
          "https://docs.aws.amazon.com/directconnect/latest/APIReference/API_Lag.html",
        arnPattern:
          "arn:${Partition}:directconnect:${Region}:${Account}:dxlag/${LagId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dxvif",
        referenceHref:
          "https://docs.aws.amazon.com/directconnect/latest/APIReference/API_VirtualInterface.html",
        arnPattern:
          "arn:${Partition}:directconnect:${Region}:${Account}:dxvif/${VirtualInterfaceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dx-gateway",
        referenceHref:
          "https://docs.aws.amazon.com/directconnect/latest/APIReference/API_DirectConnectGateway.html",
        arnPattern:
          "arn:${Partition}:directconnect::${Account}:dx-gateway/${DirectConnectGatewayId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by actions based on the presence of tag keys in the request",
        type: "String",
      },
    ],
  },
  ds: {
    name: "AWS Directory Service",
    servicePrefix: "ds",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsdirectoryservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/directoryservice/latest/devguide/welcome.html",
    resourceTypes: [
      {
        name: "directory",
        referenceHref:
          "https://docs.aws.amazon.com/directoryservice/latest/devguide/welcome.html",
        arnPattern:
          "arn:${Partition}:ds:${Region}:${Account}:directory/${DirectoryId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/directoryservice/latest/devguide/API_Tag.html",
        description: "Filters access by the value of the request to AWS DS",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/directoryservice/latest/devguide/API_Tag.html",
        description: "Filters access by the AWS DS Resource being acted upon",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/directoryservice/latest/devguide/API_Tag.html",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "docdb-elastic": {
    name: "Amazon DocumentDB Elastic Clusters",
    servicePrefix: "docdb-elastic",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazondocumentdbelasticclusters.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/documentdb/latest/developerguide/API_Operations_Amazon_DocumentDB_Elastic_Clusters.html",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/documentdb/latest/developerguide/elastic-managing.html",
        arnPattern:
          "arn:${Partition}:docdb-elastic:${Region}:${Account}:cluster/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "cluster-snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/documentdb/latest/developerguide/elastic-managing.html#elastic-manage-snapshots",
        arnPattern:
          "arn:${Partition}:docdb-elastic:${Region}:${Account}:cluster-snapshot/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the set of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the set of tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the set of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  dynamodb: {
    name: "Amazon DynamoDB",
    servicePrefix: "dynamodb",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazondynamodb.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amazondynamodb/latest/APIReference/",
    resourceTypes: [
      {
        name: "index",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/HowItWorks.CoreComponents.html#HowItWorks.CoreComponents.PrimaryKey",
        arnPattern:
          "arn:${Partition}:dynamodb:${Region}:${Account}:table/${TableName}/index/${IndexName}",
        conditionKeys: [],
      },
      {
        name: "stream",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/HowItWorks.CoreComponents.html#HowItWorks.CoreComponents.Streams",
        arnPattern:
          "arn:${Partition}:dynamodb:${Region}:${Account}:table/${TableName}/stream/${StreamLabel}",
        conditionKeys: [],
      },
      {
        name: "table",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/HowItWorks.CoreComponents.html#HowItWorks.CoreComponents.TablesItemsAttributes",
        arnPattern:
          "arn:${Partition}:dynamodb:${Region}:${Account}:table/${TableName}",
        conditionKeys: [],
      },
      {
        name: "backup",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/backuprestore_HowItWorks.html",
        arnPattern:
          "arn:${Partition}:dynamodb:${Region}:${Account}:table/${TableName}/backup/${BackupName}",
        conditionKeys: [],
      },
      {
        name: "export",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/S3DataExport.HowItWorks.html",
        arnPattern:
          "arn:${Partition}:dynamodb:${Region}:${Account}:table/${TableName}/export/${ExportName}",
        conditionKeys: [],
      },
      {
        name: "global-table",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/globaltables_HowItWorks.html",
        arnPattern:
          "arn:${Partition}:dynamodb::${Account}:global-table/${GlobalTableName}",
        conditionKeys: [],
      },
      {
        name: "import",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/S3DataImport.HowItWorks.html",
        arnPattern:
          "arn:${Partition}:dynamodb:${Region}:${Account}:table/${TableName}/import/${ImportName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  dax: {
    name: "Amazon DynamoDB Accelerator (DAX)",
    servicePrefix: "dax",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazondynamodbacceleratordax.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amazondynamodb/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DAX.access-control.html",
        arnPattern:
          "arn:${Partition}:dax:${Region}:${Account}:cache/${ClusterName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "dax:EnclosingOperation",
        referenceHref:
          "https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DAX.access-control.htmlspecifying-conditions.html#FGAC_DDB.ConditionKeys",
        description:
          "Used to block Transactions APIs calls and allow the non-Transaction APIs calls and vice-versa",
        type: "String",
      },
    ],
  },
  ec2: {
    name: "Amazon EC2",
    servicePrefix: "ec2",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonec2.html",
    apiReferenceHref: "https://docs.aws.amazon.com/AWSEC2/latest/APIReference/",
    resourceTypes: [
      {
        name: "elastic-ip",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/elastic-ip-addresses-eip.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:elastic-ip/${AllocationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:AllocationId",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Domain",
          "ec2:PublicIpAddress",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "capacity-reservation-fleet",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:capacity-reservation-fleet/${CapacityReservationFleetId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "capacity-reservation",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/ec2-capacity-reservations.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:capacity-reservation/${CapacityReservationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:CapacityReservationFleet",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "carrier-gateway",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/Carrier_Gateway.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:carrier-gateway/${CarrierGatewayId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:Tenancy",
          "ec2:Vpc",
        ],
      },
      {
        name: "certificate",
        referenceHref:
          "https://docs.aws.amazon.com/acm/latest/userguide/authen-overview.html#acm-resources-operations",
        arnPattern:
          "arn:${Partition}:acm:${Region}:${Account}:certificate/${CertificateId}",
        conditionKeys: [],
      },
      {
        name: "client-vpn-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/clientvpn-admin/what-is.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:client-vpn-endpoint/${ClientVpnEndpointId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:ClientRootCertificateChainArn",
          "ec2:CloudwatchLogGroupArn",
          "ec2:CloudwatchLogStreamArn",
          "ec2:DirectoryArn",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:SamlProviderArn",
          "ec2:ServerCertificateArn",
        ],
      },
      {
        name: "customer-gateway",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/VPC_VPN.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:customer-gateway/${CustomerGatewayId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "dedicated-host",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/dedicated-hosts-overview.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:dedicated-host/${DedicatedHostId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:AutoPlacement",
          "ec2:AvailabilityZone",
          "ec2:HostRecovery",
          "ec2:InstanceType",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:Quantity",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "dhcp-options",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/VPC_DHCP_Options.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:dhcp-options/${DhcpOptionsId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:DhcpOptionsID",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "egress-only-internet-gateway",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/egress-only-internet-gateway.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:egress-only-internet-gateway/${EgressOnlyInternetGatewayId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "elastic-gpu",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/WindowsGuide/elastic-gpus.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:elastic-gpu/${ElasticGpuId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:ElasticGpuType",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "elastic-inference",
        referenceHref:
          "https://docs.aws.amazon.com/elastic-inference/latest/developerguide/what-is-ei.html",
        arnPattern:
          "arn:${Partition}:elastic-inference:${Region}:${Account}:elastic-inference-accelerator/${AcceleratorId}",
        conditionKeys: [],
      },
      {
        name: "export-image-task",
        referenceHref:
          "https://docs.aws.amazon.com/vm-import/latest/userguide/vmimport-image-import.html#export-vm-image",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:export-image-task/${ExportImageTaskId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "export-instance-task",
        referenceHref:
          "https://docs.aws.amazon.com/vm-import/latest/userguide/vmexport.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:export-instance-task/${ExportTaskId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "fleet",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/ec2-fleet.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:fleet/${FleetId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "fpga-image",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:fpga-image/${FpgaImageId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Owner",
          "ec2:Public",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "host-reservation",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:host-reservation/${HostReservationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "image",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/AMIs.html",
        arnPattern: "arn:${Partition}:ec2:${Region}::image/${ImageId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:ImageID",
          "ec2:ImageType",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:Owner",
          "ec2:Public",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:RootDeviceType",
        ],
      },
      {
        name: "import-image-task",
        referenceHref:
          "https://docs.aws.amazon.com/vm-import/latest/userguide/vmimport-image-import.html#import-vm-image",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:import-image-task/${ImportImageTaskId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "import-snapshot-task",
        referenceHref:
          "https://docs.aws.amazon.com/vm-import/latest/userguide/vmimport-import-snapshot.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:import-snapshot-task/${ImportSnapshotTaskId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "instance-connect-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:instance-connect-endpoint/${InstanceConnectEndpointId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:SubnetID",
        ],
      },
      {
        name: "instance-event-window",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:instance-event-window/${InstanceEventWindowId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "instance",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/Instances.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:instance/${InstanceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:AvailabilityZone",
          "ec2:EbsOptimized",
          "ec2:InstanceAutoRecovery",
          "ec2:InstanceID",
          "ec2:InstanceMarketType",
          "ec2:InstanceMetadataTags",
          "ec2:InstanceProfile",
          "ec2:InstanceType",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:MetadataHttpEndpoint",
          "ec2:MetadataHttpPutResponseHopLimit",
          "ec2:MetadataHttpTokens",
          "ec2:NewInstanceProfile",
          "ec2:PlacementGroup",
          "ec2:ProductCode",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:RootDeviceType",
          "ec2:Tenancy",
        ],
      },
      {
        name: "internet-gateway",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/VPC_Internet_Gateway.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:internet-gateway/${InternetGatewayId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:InternetGatewayID",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ipam",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern: "arn:${Partition}:ec2::${Account}:ipam/${IpamId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ipam-pool",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern: "arn:${Partition}:ec2::${Account}:ipam-pool/${IpamPoolId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ipam-resource-discovery-association",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2::${Account}:ipam-resource-discovery-association/${IpamResourceDiscoveryAssociationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ipam-resource-discovery",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2::${Account}:ipam-resource-discovery/${IpamResourceDiscoveryId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ipam-scope",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2::${Account}:ipam-scope/${IpamScopeId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "coip-pool",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:coip-pool/${Ipv4PoolCoipId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ipv4pool-ec2",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/using-instance-addressing.html#ip-addressing-eips",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:ipv4pool-ec2/${Ipv4PoolEc2Id}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "ipv6pool-ec2",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/using-instance-addressing.html#ipv6-addressing",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:ipv6pool-ec2/${Ipv6PoolEc2Id}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "key-pair",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/ec2-key-pairs.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:key-pair/${KeyPairName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:IsLaunchTemplateResource",
          "ec2:KeyPairName",
          "ec2:KeyPairType",
          "ec2:LaunchTemplate",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "launch-template",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/ec2-launch-templates.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:launch-template/${LaunchTemplateId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "license-configuration",
        referenceHref:
          "https://docs.aws.amazon.com/license-manager/latest/userguide/create-license-configuration.html",
        arnPattern:
          "arn:${Partition}:license-manager:${Region}:${Account}:license-configuration:${LicenseConfigurationId}",
        conditionKeys: [],
      },
      {
        name: "local-gateway",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/outposts-local-gateways.html#lgw",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:local-gateway/${LocalGatewayId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "local-gateway-route-table-virtual-interface-group-association",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/outposts-local-gateways.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:local-gateway-route-table-virtual-interface-group-association/${LocalGatewayRouteTableVirtualInterfaceGroupAssociationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "local-gateway-route-table-vpc-association",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/outposts-local-gateways.html#vpc-associations",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:local-gateway-route-table-vpc-association/${LocalGatewayRouteTableVpcAssociationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "local-gateway-route-table",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/outposts-local-gateways.html#route-tables",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:local-gateway-route-table/${LocalGatewayRoutetableId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "local-gateway-virtual-interface-group",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/outposts-local-gateways.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:local-gateway-virtual-interface-group/${LocalGatewayVirtualInterfaceGroupId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "local-gateway-virtual-interface",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/outposts-local-gateways.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:local-gateway-virtual-interface/${LocalGatewayVirtualInterfaceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "natgateway",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/vpc-nat-gateway.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:natgateway/${NatGatewayId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "network-acl",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/vpc-network-acls.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:network-acl/${NaclId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:NetworkAclID",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:Vpc",
        ],
      },
      {
        name: "network-insights-access-scope-analysis",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:network-insights-access-scope-analysis/${NetworkInsightsAccessScopeAnalysisId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "network-insights-access-scope",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:network-insights-access-scope/${NetworkInsightsAccessScopeId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "network-insights-analysis",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:network-insights-analysis/${NetworkInsightsAnalysisId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "network-insights-path",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:network-insights-path/${NetworkInsightsPathId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "network-interface",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/using-eni.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:network-interface/${NetworkInterfaceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:AssociatePublicIpAddress",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:AuthorizedService",
          "ec2:AuthorizedUser",
          "ec2:AvailabilityZone",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:NetworkInterfaceID",
          "ec2:Permission",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:Subnet",
          "ec2:Vpc",
        ],
      },
      {
        name: "placement-group",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/placement-groups.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:placement-group/${PlacementGroupName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:PlacementGroupName",
          "ec2:PlacementGroupStrategy",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "prefix-list",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/managed-prefix-lists.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:prefix-list/${PrefixListId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "replace-root-volume-task",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/replace-root.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:replace-root-volume-task/${ReplaceRootVolumeTaskId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "reserved-instances",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/ec2-reserved-instances.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:reserved-instances/${ReservationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:AvailabilityZone",
          "ec2:InstanceType",
          "ec2:Region",
          "ec2:ReservedInstancesOfferingType",
          "ec2:ResourceTag/${TagKey}",
          "ec2:Tenancy",
        ],
      },
      {
        name: "group",
        referenceHref:
          "https://docs.aws.amazon.com/ARG/latest/userguide/resource-groups.html",
        arnPattern:
          "arn:${Partition}:resource-groups:${Region}:${Account}:group/${GroupName}",
        conditionKeys: [],
      },
      {
        name: "role",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles.html",
        arnPattern: "arn:${Partition}:iam::${Account}:role/${RoleNameWithPath}",
        conditionKeys: [],
      },
      {
        name: "route-table",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/VPC_Route_Tables.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:route-table/${RouteTableId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:RouteTableID",
          "ec2:Vpc",
        ],
      },
      {
        name: "security-group",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/ec2-security-groups.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:security-group/${SecurityGroupId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:SecurityGroupID",
          "ec2:Vpc",
        ],
      },
      {
        name: "security-group-rule",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:security-group-rule/${SecurityGroupRuleId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/EBSSnapshots.html",
        arnPattern: "arn:${Partition}:ec2:${Region}::snapshot/${SnapshotId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Add/group",
          "ec2:Add/userId",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:AvailabilityZone",
          "ec2:Encrypted",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:OutpostArn",
          "ec2:Owner",
          "ec2:ParentVolume",
          "ec2:Region",
          "ec2:Remove/group",
          "ec2:Remove/userId",
          "ec2:ResourceTag/${TagKey}",
          "ec2:SnapshotCoolOffPeriod",
          "ec2:SnapshotID",
          "ec2:SnapshotLockDuration",
          "ec2:SnapshotTime",
          "ec2:SourceOutpostArn",
          "ec2:VolumeSize",
        ],
      },
      {
        name: "spot-fleet-request",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:spot-fleet-request/${SpotFleetRequestId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "spot-instances-request",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/using-spot-instances.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:spot-instances-request/${SpotInstanceRequestId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "subnet-cidr-reservation",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/subnet-cidr-reservation.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:subnet-cidr-reservation/${SubnetCidrReservationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "subnet",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/VPC_Subnets.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:subnet/${SubnetId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:AvailabilityZone",
          "ec2:IsLaunchTemplateResource",
          "ec2:LaunchTemplate",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:SubnetID",
          "ec2:Vpc",
        ],
      },
      {
        name: "traffic-mirror-filter",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/mirroring/traffic-mirroring-filter.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:traffic-mirror-filter/${TrafficMirrorFilterId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "traffic-mirror-filter-rule",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/mirroring/traffic-mirroring-filter.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:traffic-mirror-filter-rule/${TrafficMirrorFilterRuleId}",
        conditionKeys: [
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
        ],
      },
      {
        name: "traffic-mirror-session",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/mirroring/traffic-mirroring-session.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:traffic-mirror-session/${TrafficMirrorSessionId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "traffic-mirror-target",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/mirroring/traffic-mirroring-target.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:traffic-mirror-target/${TrafficMirrorTargetId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "transit-gateway-attachment",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/how-transit-gateways-work.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:transit-gateway-attachment/${TransitGatewayAttachmentId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "transit-gateway-connect-peer",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:transit-gateway-connect-peer/${TransitGatewayConnectPeerId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "transit-gateway",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/how-transit-gateways-work.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:transit-gateway/${TransitGatewayId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "transit-gateway-multicast-domain",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/tgw-multicast-overview.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:transit-gateway-multicast-domain/${TransitGatewayMulticastDomainId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "transit-gateway-policy-table",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:transit-gateway-policy-table/${TransitGatewayPolicyTableId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "transit-gateway-route-table-announcement",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:transit-gateway-route-table-announcement/${TransitGatewayRouteTableAnnouncementId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "transit-gateway-route-table",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/how-transit-gateways-work.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:transit-gateway-route-table/${TransitGatewayRouteTableId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "verified-access-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:verified-access-endpoint/${VerifiedAccessEndpointId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "verified-access-group",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:verified-access-group/${VerifiedAccessGroupId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "verified-access-instance",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:verified-access-instance/${VerifiedAccessInstanceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "verified-access-policy",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:verified-access-policy/${VerifiedAccessPolicyId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "verified-access-trust-provider",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:verified-access-trust-provider/${VerifiedAccessTrustProviderId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "volume",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/ebs-volumes.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:volume/${VolumeId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:AvailabilityZone",
          "ec2:Encrypted",
          "ec2:IsLaunchTemplateResource",
          "ec2:KmsKeyId",
          "ec2:LaunchTemplate",
          "ec2:ParentSnapshot",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:VolumeID",
          "ec2:VolumeIops",
          "ec2:VolumeSize",
          "ec2:VolumeThroughput",
          "ec2:VolumeType",
        ],
      },
      {
        name: "vpc-endpoint-connection",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/endpoint-services-overview.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpc-endpoint-connection/${VpcEndpointConnectionId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "vpc-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/endpoint-services-overview.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpc-endpoint/${VpcEndpointId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:VpceServiceName",
          "ec2:VpceServiceOwner",
        ],
      },
      {
        name: "vpc-endpoint-service",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/endpoint-services-overview.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpc-endpoint-service/${VpcEndpointServiceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:VpceServicePrivateDnsName",
        ],
      },
      {
        name: "vpc-endpoint-service-permission",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/privatelink/vpc-endpoints-access.html#vpc-endpoint-policies",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpc-endpoint-service-permission/${VpcEndpointServicePermissionId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "vpc-flow-log",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/flow-logs.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpc-flow-log/${VpcFlowLogId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "vpc",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/VPC_Subnets.html",
        arnPattern: "arn:${Partition}:ec2:${Region}:${Account}:vpc/${VpcId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Ipv4IpamPoolId",
          "ec2:Ipv6IpamPoolId",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
          "ec2:Tenancy",
          "ec2:VpcID",
        ],
      },
      {
        name: "vpc-peering-connection",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/peering/what-is-vpc-peering.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpc-peering-connection/${VpcPeeringConnectionId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:AccepterVpc",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:Region",
          "ec2:RequesterVpc",
          "ec2:ResourceTag/${TagKey}",
          "ec2:VpcPeeringConnectionID",
        ],
      },
      {
        name: "vpn-connection-device-type",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/VPC_VPN.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpn-connection-device-type/${VpnConnectionDeviceTypeId}",
        conditionKeys: ["ec2:Region"],
      },
      {
        name: "vpn-connection",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/VPC_VPN.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpn-connection/${VpnConnectionId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Attribute",
          "ec2:Attribute/${AttributeName}",
          "ec2:AuthenticationType",
          "ec2:DPDTimeoutSeconds",
          "ec2:GatewayType",
          "ec2:IKEVersions",
          "ec2:InsideTunnelCidr",
          "ec2:InsideTunnelIpv6Cidr",
          "ec2:Phase1DHGroup",
          "ec2:Phase1EncryptionAlgorithms",
          "ec2:Phase1IntegrityAlgorithms",
          "ec2:Phase1LifetimeSeconds",
          "ec2:Phase2DHGroup",
          "ec2:Phase2EncryptionAlgorithms",
          "ec2:Phase2IntegrityAlgorithms",
          "ec2:Phase2LifetimeSeconds",
          "ec2:PreSharedKeys",
          "ec2:Region",
          "ec2:RekeyFuzzPercentage",
          "ec2:RekeyMarginTimeSeconds",
          "ec2:ReplayWindowSizePackets",
          "ec2:ResourceTag/${TagKey}",
          "ec2:RoutingType",
        ],
      },
      {
        name: "vpn-gateway",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/VPC_VPN.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:vpn-gateway/${VpnGatewayId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ec2:Region",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/supported-iam-actions-tagging.html#control-tagging",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/control-access-with-tags.html",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/supported-iam-actions-tagging.html#control-tagging",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "ec2:AccepterVpc",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/peering/security-iam.html",
        description:
          "Filters access by the ARN of an accepter VPC in a VPC peering connection",
        type: "ARN",
      },
      {
        name: "ec2:Add/group",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the group being added to a snapshot",
        type: "String",
      },
      {
        name: "ec2:Add/userId",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the account id being added to a snapshot",
        type: "String",
      },
      {
        name: "ec2:AllocationId",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the allocation ID of the Elastic IP address",
        type: "String",
      },
      {
        name: "ec2:AssociatePublicIpAddress",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether the user wants to associate a public IP address with the instance",
        type: "Bool",
      },
      {
        name: "ec2:Attribute",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by an attribute of a resource",
        type: "String",
      },
      {
        name: "ec2:Attribute/${AttributeName}",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by an attribute being set on a resource",
        type: "String",
      },
      {
        name: "ec2:AuthenticationType",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the authentication type for the VPN tunnel endpoints",
        type: "String",
      },
      {
        name: "ec2:AuthorizedService",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the AWS service that has permission to use a resource",
        type: "String",
      },
      {
        name: "ec2:AuthorizedUser",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by an IAM principal that has permission to use a resource",
        type: "String",
      },
      {
        name: "ec2:AutoPlacement",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the Auto Placement properties of a Dedicated Host",
        type: "String",
      },
      {
        name: "ec2:AvailabilityZone",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the name of an Availability Zone in an AWS Region",
        type: "String",
      },
      {
        name: "ec2:CapacityReservationFleet",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the Capacity Reservation Fleet",
        type: "ARN",
      },
      {
        name: "ec2:ClientRootCertificateChainArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the client root certificate chain",
        type: "ARN",
      },
      {
        name: "ec2:CloudwatchLogGroupArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the CloudWatch Logs log group",
        type: "ARN",
      },
      {
        name: "ec2:CloudwatchLogStreamArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the CloudWatch Logs log stream",
        type: "ARN",
      },
      {
        name: "ec2:CreateAction",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/supported-iam-actions-tagging.html",
        description:
          "Filters access by the name of a resource-creating API action",
        type: "String",
      },
      {
        name: "ec2:DPDTimeoutSeconds",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the duration after which DPD timeout occurs on a VPN tunnel",
        type: "Numeric",
      },
      {
        name: "ec2:DhcpOptionsID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description:
          "Filters access by the ID of a dynamic host configuration protocol (DHCP) options set",
        type: "String",
      },
      {
        name: "ec2:DirectoryArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of the directory",
        type: "ARN",
      },
      {
        name: "ec2:Domain",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the domain of the Elastic IP address",
        type: "String",
      },
      {
        name: "ec2:EbsOptimized",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether the instance is enabled for EBS optimization",
        type: "Bool",
      },
      {
        name: "ec2:ElasticGpuType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the type of Elastic Graphics accelerator",
        type: "String",
      },
      {
        name: "ec2:Encrypted",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by whether the EBS volume is encrypted",
        type: "Bool",
      },
      {
        name: "ec2:FisActionId",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/fis-actions-reference.html",
        description: "Filters access by the ID of an AWS FIS action",
        type: "String",
      },
      {
        name: "ec2:FisTargetArns",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/fis-actions-reference.html",
        description: "Filters access by the ARN of an AWS FIS target",
        type: "ArrayOfARN",
      },
      {
        name: "ec2:GatewayType",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the gateway type for a VPN endpoint on the AWS side of a VPN connection",
        type: "String",
      },
      {
        name: "ec2:HostRecovery",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether host recovery is enabled for a Dedicated Host",
        type: "String",
      },
      {
        name: "ec2:IKEVersions",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the internet key exchange (IKE) versions that are permitted for a VPN tunnel",
        type: "ArrayOfString",
      },
      {
        name: "ec2:ImageID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of an image",
        type: "String",
      },
      {
        name: "ec2:ImageType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the type of image (machine, aki, or ari)",
        type: "String",
      },
      {
        name: "ec2:InsideTunnelCidr",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the range of inside IP addresses for a VPN tunnel",
        type: "String",
      },
      {
        name: "ec2:InsideTunnelIpv6Cidr",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by a range of inside IPv6 addresses for a VPN tunnel",
        type: "String",
      },
      {
        name: "ec2:InstanceAutoRecovery",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether the instance type supports auto recovery",
        type: "String",
      },
      {
        name: "ec2:InstanceID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of an instance",
        type: "String",
      },
      {
        name: "ec2:InstanceMarketType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the market or purchasing option of an instance (capacity-block, on-demand, or spot)",
        type: "String",
      },
      {
        name: "ec2:InstanceMetadataTags",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether the instance allows access to instance tags from the instance metadata",
        type: "String",
      },
      {
        name: "ec2:InstanceProfile",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of an instance profile",
        type: "ARN",
      },
      {
        name: "ec2:InstanceType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the type of instance",
        type: "String",
      },
      {
        name: "ec2:InternetGatewayID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of an internet gateway",
        type: "String",
      },
      {
        name: "ec2:Ipv4IpamPoolId",
        referenceHref: "iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ID of an IPAM pool provided for IPv4 CIDR block allocation",
        type: "String",
      },
      {
        name: "ec2:Ipv6IpamPoolId",
        referenceHref: "iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ID of an IPAM pool provided for IPv6 CIDR block allocation",
        type: "String",
      },
      {
        name: "ec2:IsLaunchTemplateResource",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether users are able to override resources that are specified in the launch template",
        type: "Bool",
      },
      {
        name: "ec2:KeyPairName",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the name of a key pair",
        type: "String",
      },
      {
        name: "ec2:KeyPairType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the type of a key pair",
        type: "String",
      },
      {
        name: "ec2:KmsKeyId",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ID of an AWS KMS key provided in the request",
        type: "String",
      },
      {
        name: "ec2:LaunchTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of a launch template",
        type: "ARN",
      },
      {
        name: "ec2:MetadataHttpEndpoint",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether the HTTP endpoint is enabled for the instance metadata service",
        type: "String",
      },
      {
        name: "ec2:MetadataHttpPutResponseHopLimit",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the allowed number of hops when calling the instance metadata service",
        type: "Numeric",
      },
      {
        name: "ec2:MetadataHttpTokens",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether tokens are required when calling the instance metadata service (optional or required)",
        type: "String",
      },
      {
        name: "ec2:NetworkAclID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description:
          "Filters access by the ID of a network access control list (ACL)",
        type: "String",
      },
      {
        name: "ec2:NetworkInterfaceID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of an elastic network interface",
        type: "String",
      },
      {
        name: "ec2:NewInstanceProfile",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the instance profile being attached",
        type: "ARN",
      },
      {
        name: "ec2:OutpostArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of the Outpost",
        type: "ARN",
      },
      {
        name: "ec2:Owner",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the owner of the resource (amazon, aws-marketplace, or an AWS account ID)",
        type: "String",
      },
      {
        name: "ec2:ParentSnapshot",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of the parent snapshot",
        type: "ARN",
      },
      {
        name: "ec2:ParentVolume",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the parent volume from which the snapshot was created",
        type: "ARN",
      },
      {
        name: "ec2:Permission",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the type of permission for a resource (INSTANCE-ATTACH or EIP-ASSOCIATE)",
        type: "String",
      },
      {
        name: "ec2:Phase1DHGroup",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the Diffie-Hellman group numbers that are permitted for a VPN tunnel for the phase 1 IKE negotiations",
        type: "ArrayOfString",
      },
      {
        name: "ec2:Phase1EncryptionAlgorithms",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the encryption algorithms that are permitted for a VPN tunnel for the phase 1 IKE negotiations",
        type: "ArrayOfString",
      },
      {
        name: "ec2:Phase1IntegrityAlgorithms",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the integrity algorithms that are permitted for a VPN tunnel for the phase 1 IKE negotiations",
        type: "ArrayOfString",
      },
      {
        name: "ec2:Phase1LifetimeSeconds",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the lifetime in seconds for phase 1 of the IKE negotiations for a VPN tunnel",
        type: "Numeric",
      },
      {
        name: "ec2:Phase2DHGroup",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the Diffie-Hellman group numbers that are permitted for a VPN tunnel for the phase 2 IKE negotiations",
        type: "ArrayOfString",
      },
      {
        name: "ec2:Phase2EncryptionAlgorithms",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the encryption algorithms that are permitted for a VPN tunnel for the phase 2 IKE negotiations",
        type: "ArrayOfString",
      },
      {
        name: "ec2:Phase2IntegrityAlgorithms",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the integrity algorithms that are permitted for a VPN tunnel for the phase 2 IKE negotiations",
        type: "ArrayOfString",
      },
      {
        name: "ec2:Phase2LifetimeSeconds",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the lifetime in seconds for phase 2 of the IKE negotiations for a VPN tunnel",
        type: "Numeric",
      },
      {
        name: "ec2:PlacementGroup",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of the placement group",
        type: "ARN",
      },
      {
        name: "ec2:PlacementGroupName",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the name of a placement group",
        type: "String",
      },
      {
        name: "ec2:PlacementGroupStrategy",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the instance placement strategy used by the placement group (cluster, spread, or partition)",
        type: "String",
      },
      {
        name: "ec2:PreSharedKeys",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the pre-shared key (PSK) used to establish the initial IKE security association between a virtual private gateway and a customer gateway",
        type: "String",
      },
      {
        name: "ec2:ProductCode",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the product code that is associated with the AMI",
        type: "String",
      },
      {
        name: "ec2:Public",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by whether the image has public launch permissions",
        type: "Bool",
      },
      {
        name: "ec2:PublicIpAddress",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by a public IP address",
        type: "String",
      },
      {
        name: "ec2:Quantity",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the number of Dedicated Hosts in a request",
        type: "Numeric",
      },
      {
        name: "ec2:Region",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the name of the AWS Region",
        type: "String",
      },
      {
        name: "ec2:RekeyFuzzPercentage",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the percentage of increase of the rekey window (determined by the rekey margin time) within which the rekey time is randomly selected for a VPN tunnel",
        type: "Numeric",
      },
      {
        name: "ec2:RekeyMarginTimeSeconds",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the margin time before the phase 2 lifetime expires for a VPN tunnel",
        type: "Numeric",
      },
      {
        name: "ec2:Remove/group",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the group being removed from a snapshot",
        type: "String",
      },
      {
        name: "ec2:Remove/userId",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the account id being removed from a snapshot",
        type: "String",
      },
      {
        name: "ec2:ReplayWindowSizePackets",
        referenceHref: "iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the number of packets in an IKE replay window",
        type: "String",
      },
      {
        name: "ec2:RequesterVpc",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/peering/security-iam.html",
        description:
          "Filters access by the ARN of a requester VPC in a VPC peering connection",
        type: "ARN",
      },
      {
        name: "ec2:ReservedInstancesOfferingType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/ec2-reserved-instances.html#ri-payment-options",
        description:
          "Filters access by the payment option of the Reserved Instance offering (No Upfront, Partial Upfront, or All Upfront)",
        type: "String",
      },
      {
        name: "ec2:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/control-access-with-tags.html",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "ec2:RoleDelivery",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the version of the instance metadata service for retrieving IAM role credentials for EC2",
        type: "Numeric",
      },
      {
        name: "ec2:RootDeviceType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the root device type of the instance (ebs or instance-store)",
        type: "String",
      },
      {
        name: "ec2:RouteTableID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of a route table",
        type: "String",
      },
      {
        name: "ec2:RoutingType",
        referenceHref:
          "https://docs.aws.amazon.com/vpn/latest/s2svpn/vpn-authentication-access-control.html",
        description:
          "Filters access by the routing type for the VPN connection",
        type: "String",
      },
      {
        name: "ec2:SamlProviderArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the IAM SAML identity provider",
        type: "ARN",
      },
      {
        name: "ec2:SecurityGroupID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of a security group",
        type: "String",
      },
      {
        name: "ec2:ServerCertificateArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of the server certificate",
        type: "ARN",
      },
      {
        name: "ec2:SnapshotCoolOffPeriod",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the compliance mode cooling-off period",
        type: "Numeric",
      },
      {
        name: "ec2:SnapshotID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of a snapshot",
        type: "String",
      },
      {
        name: "ec2:SnapshotLockDuration",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the snapshot lock duration",
        type: "Numeric",
      },
      {
        name: "ec2:SnapshotTime",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the initiation time of a snapshot",
        type: "String",
      },
      {
        name: "ec2:SourceInstanceARN",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the instance from which the request originated",
        type: "ARN",
      },
      {
        name: "ec2:SourceOutpostArn",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the Outpost from which the request originated",
        type: "ARN",
      },
      {
        name: "ec2:Subnet",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of the subnet",
        type: "ARN",
      },
      {
        name: "ec2:SubnetID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of a subnet",
        type: "String",
      },
      {
        name: "ec2:Tenancy",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the tenancy of the VPC or instance (default, dedicated, or host)",
        type: "String",
      },
      {
        name: "ec2:VolumeID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of a volume",
        type: "String",
      },
      {
        name: "ec2:VolumeIops",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the the number of input/output operations per second (IOPS) provisioned for the volume",
        type: "Numeric",
      },
      {
        name: "ec2:VolumeSize",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the size of the volume, in GiB",
        type: "Numeric",
      },
      {
        name: "ec2:VolumeThroughput",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the throughput of the volume, in MiBps",
        type: "Numeric",
      },
      {
        name: "ec2:VolumeType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the type of volume (gp2, gp3, io1, io2, st1, sc1, or standard)",
        type: "String",
      },
      {
        name: "ec2:Vpc",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description: "Filters access by the ARN of the VPC",
        type: "ARN",
      },
      {
        name: "ec2:VpcID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description:
          "Filters access by the ID of a virtual private cloud (VPC)",
        type: "String",
      },
      {
        name: "ec2:VpcPeeringConnectionID",
        referenceHref: "iam-policy-structure.html#imageId-key",
        description: "Filters access by the ID of a VPC peering connection",
        type: "String",
      },
      {
        name: "ec2:VpceServiceName",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/vpc-endpoints-iam.html",
        description: "Filters access by the name of the VPC endpoint service",
        type: "String",
      },
      {
        name: "ec2:VpceServiceOwner",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/vpc-endpoints-iam.html",
        description:
          "Filters access by the service owner of the VPC endpoint service (amazon, aws-marketplace, or an AWS account ID)",
        type: "String",
      },
      {
        name: "ec2:VpceServicePrivateDnsName",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/vpc-endpoints-iam.html",
        description:
          "Filters access by the private DNS name of the VPC endpoint service",
        type: "String",
      },
    ],
  },
  autoscaling: {
    name: "Amazon EC2 Auto Scaling",
    servicePrefix: "autoscaling",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonec2autoscaling.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AutoScaling/latest/APIReference/",
    resourceTypes: [
      {
        name: "autoScalingGroup",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-resources",
        arnPattern:
          "arn:${Partition}:autoscaling:${Region}:${Account}:autoScalingGroup:${GroupId}:autoScalingGroupName/${GroupFriendlyName}",
        conditionKeys: [
          "autoscaling:ResourceTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "launchConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-resources",
        arnPattern:
          "arn:${Partition}:autoscaling:${Region}:${Account}:launchConfiguration:${Id}:launchConfigurationName/${LaunchConfigurationName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "autoscaling:ImageId",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the AMI ID for the launch configuration",
        type: "String",
      },
      {
        name: "autoscaling:InstanceType",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the instance type for the launch configuration",
        type: "String",
      },
      {
        name: "autoscaling:InstanceTypes",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the instance types present as overrides to a launch template for a mixed instances policy. Use it to qualify which instance types can be explicitly defined in the policy",
        type: "String",
      },
      {
        name: "autoscaling:LaunchConfigurationName",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the name of a launch configuration",
        type: "String",
      },
      {
        name: "autoscaling:LaunchTemplateVersionSpecified",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on whether users can specify any version of a launch template or only the Latest or Default version",
        type: "Bool",
      },
      {
        name: "autoscaling:LoadBalancerNames",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description: "Filters access based on the name of the load balancer",
        type: "ArrayOfString",
      },
      {
        name: "autoscaling:MaxSize",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the maximum scaling size in the request",
        type: "Numeric",
      },
      {
        name: "autoscaling:MetadataHttpEndpoint",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on whether the HTTP endpoint is enabled for the instance metadata service",
        type: "String",
      },
      {
        name: "autoscaling:MetadataHttpPutResponseHopLimit",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the allowed number of hops when calling the instance metadata service",
        type: "Numeric",
      },
      {
        name: "autoscaling:MetadataHttpTokens",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on whether tokens are required when calling the instance metadata service (optional or required)",
        type: "String",
      },
      {
        name: "autoscaling:MinSize",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the minimum scaling size in the request",
        type: "Numeric",
      },
      {
        name: "autoscaling:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "autoscaling:SpotPrice",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the price for Spot Instances for the launch configuration",
        type: "Numeric",
      },
      {
        name: "autoscaling:TargetGroupARNs",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description: "Filters access based on the ARN of a target group",
        type: "ArrayOfARN",
      },
      {
        name: "autoscaling:TrafficSourceIdentifiers",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the identifiers of the traffic sources",
        type: "ArrayOfString",
      },
      {
        name: "autoscaling:VPCZoneIdentifiers",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description: "Filters access based on the identifier of a VPC zone",
        type: "ArrayOfString",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/autoscaling/latest/userguide/control-access-using-iam.html#policy-auto-scaling-condition-keys",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  imagebuilder: {
    name: "Amazon EC2 Image Builder",
    servicePrefix: "imagebuilder",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonec2imagebuilder.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/",
    resourceTypes: [
      {
        name: "component",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_Component.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:component/${ComponentName}/${ComponentVersion}/${ComponentBuildVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "componentVersion",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_ComponentVersion.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:component/${ComponentName}/${ComponentVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "distributionConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_DistributionConfiguration.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:distribution-configuration/${DistributionConfigurationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "image",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_Image.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:image/${ImageName}/${ImageVersion}/${ImageBuildVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "imageVersion",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_ImageVersion.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:image/${ImageName}/${ImageVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "imageRecipe",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_ImageRecipe.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:image-recipe/${ImageRecipeName}/${ImageRecipeVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "containerRecipe",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_ContainerRecipe.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:container-recipe/${ContainerRecipeName}/${ContainerRecipeVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "imagePipeline",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_ImagePipeline.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:image-pipeline/${ImagePipelineName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "infrastructureConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_InfrastructureConfiguration.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:infrastructure-configuration/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "kmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/concepts.html#master_keys",
        arnPattern: "arn:${Partition}:kms:${Region}:${Account}:key/${KeyId}",
        conditionKeys: [],
      },
      {
        name: "lifecycleExecution",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_LifecycleExecution.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:lifecycle-execution/${LifecycleExecutionId}",
        conditionKeys: [],
      },
      {
        name: "lifecyclePolicy",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_LifecyclePolicy.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:lifecycle-policy/${LifecyclePolicyName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workflow",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_Workflow.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:workflow/${WorkflowType}/${WorkflowName}/${WorkflowVersion}/${WorkflowBuildVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workflowVersion",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_WorkflowVersion.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:workflow/${WorkflowType}/${WorkflowName}/${WorkflowVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workflowExecution",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_WorkflowExecutionMetadata.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:workflow-execution/${WorkflowExecutionId}",
        conditionKeys: [],
      },
      {
        name: "workflowStepExecution",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/APIReference/API_WorkflowStepMetadata.html",
        arnPattern:
          "arn:${Partition}:imagebuilder:${Region}:${Account}:workflow-step-execution/${WorkflowStepExecutionId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "imagebuilder:CreatedResourceTag/<key>",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/userguide/security_iam_service-with-iam.html#image-builder-security-createdresourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource created by Image Builder",
        type: "String",
      },
      {
        name: "imagebuilder:CreatedResourceTagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/userguide/security_iam_service-with-iam.html#image-builder-security-createdresourcetagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "imagebuilder:Ec2MetadataHttpTokens",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/userguide/security_iam_service-with-iam.html#image-builder-security-ec2metadatahttptokens",
        description:
          "Filters access by the EC2 Instance Metadata HTTP Token Requirement specified in the request",
        type: "String",
      },
      {
        name: "imagebuilder:LifecyclePolicyResourceType",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/userguide/security_iam_service-with-iam.html#image-builder-security-ec2metadatahttptokens",
        description:
          "Filters access by the Lifecycle Policy Resource Type specified in the request",
        type: "String",
      },
      {
        name: "imagebuilder:StatusTopicArn",
        referenceHref:
          "https://docs.aws.amazon.com/imagebuilder/latest/userguide/security_iam_service-with-iam.html#image-builder-security-statustopicarn",
        description:
          "Filters access by the SNS Topic Arn in the request to which terminal state notifications will be published",
        type: "ARN",
      },
    ],
  },
  "ec2-instance-connect": {
    name: "Amazon EC2 Instance Connect",
    servicePrefix: "ec2-instance-connect",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonec2instanceconnect.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/ec2-instance-connect/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "instance",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#EC2_ARN_Format",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:instance/${InstanceId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "instance-connect-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/permissions-for-ec2-instance-connect-endpoint.html#iam-CreateInstanceConnectEndpoint",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:instance-connect-endpoint/${InstanceConnectEndpointId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ec2:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "ec2-instance-connect:maxTunnelDuration",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/permissions-for-ec2-instance-connect-endpoint.html#iam-OpenTunnel",
        description:
          "Filters access by maximum session duration associated with the instance",
        type: "Numeric",
      },
      {
        name: "ec2-instance-connect:privateIpAddress",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/permissions-for-ec2-instance-connect-endpoint.html#iam-OpenTunnel",
        description:
          "Filters access by private IP Address associated with the instance",
        type: "IPAddress",
      },
      {
        name: "ec2-instance-connect:remotePort",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/permissions-for-ec2-instance-connect-endpoint.html#iam-OpenTunnel",
        description:
          "Filters access by port number associated with the instance",
        type: "Numeric",
      },
      {
        name: "ec2:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "ec2:osuser",
        referenceHref:
          "https://docs.aws.amazon.com/ec2-instance-connect/latest/APIReference/API_SendSSHPublicKey.html",
        description:
          "Filters access by specifying the default user name for the AMI that you used to launch your instance",
        type: "String",
      },
    ],
  },
  "eks-auth": {
    name: "Amazon EKS Auth",
    servicePrefix: "eks-auth",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoneksauth.html",
    apiReferenceHref: "https://docs.aws.amazon.com/eks/latest/APIReference/",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/clusters.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:cluster/${ClusterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description: "Filters access by a tag key and value pair",
        type: "String",
      },
    ],
  },
  elasticbeanstalk: {
    name: "AWS Elastic Beanstalk",
    servicePrefix: "elasticbeanstalk",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselasticbeanstalk.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/elasticbeanstalk/latest/api/",
    resourceTypes: [
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.arn.html",
        arnPattern:
          "arn:${Partition}:elasticbeanstalk:${Region}:${Account}:application/${ApplicationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "applicationversion",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.arn.html",
        arnPattern:
          "arn:${Partition}:elasticbeanstalk:${Region}:${Account}:applicationversion/${ApplicationName}/${VersionLabel}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticbeanstalk:InApplication",
        ],
      },
      {
        name: "configurationtemplate",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.arn.html",
        arnPattern:
          "arn:${Partition}:elasticbeanstalk:${Region}:${Account}:configurationtemplate/${ApplicationName}/${TemplateName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticbeanstalk:InApplication",
        ],
      },
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.arn.html",
        arnPattern:
          "arn:${Partition}:elasticbeanstalk:${Region}:${Account}:environment/${ApplicationName}/${EnvironmentName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticbeanstalk:InApplication",
        ],
      },
      {
        name: "solutionstack",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.arn.html",
        arnPattern:
          "arn:${Partition}:elasticbeanstalk:${Region}::solutionstack/${SolutionStackName}",
        conditionKeys: [],
      },
      {
        name: "platform",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.arn.html",
        arnPattern:
          "arn:${Partition}:elasticbeanstalk:${Region}::platform/${PlatformNameWithVersion}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "elasticbeanstalk:FromApplication",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters access by an application as a dependency or a constraint on an input parameter",
        type: "ARN",
      },
      {
        name: "elasticbeanstalk:FromApplicationVersion",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters access by an application version as a dependency or a constraint on an input parameter",
        type: "ARN",
      },
      {
        name: "elasticbeanstalk:FromConfigurationTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters access by a configuration template as a dependency or a constraint on an input parameter",
        type: "ARN",
      },
      {
        name: "elasticbeanstalk:FromEnvironment",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters access by an environment as a dependency or a constraint on an input parameter",
        type: "ARN",
      },
      {
        name: "elasticbeanstalk:FromPlatform",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters access by a platform as a dependency or a constraint on an input parameter",
        type: "ARN",
      },
      {
        name: "elasticbeanstalk:FromSolutionStack",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters access by a solution stack as a dependency or a constraint on an input parameter",
        type: "ARN",
      },
      {
        name: "elasticbeanstalk:InApplication",
        referenceHref:
          "https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/AWSHowTo.iam.policies.actions.html#AWSHowTo.iam.policies.conditions",
        description:
          "Filters access by the application that contains the resource that the action operates on",
        type: "ARN",
      },
    ],
  },
  ebs: {
    name: "Amazon Elastic Block Store",
    servicePrefix: "ebs",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelasticblockstore.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/ebs/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/EBSSnapshots.html",
        arnPattern: "arn:${Partition}:ec2:${Region}::snapshot/${SnapshotId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "ebs:Description",
          "ebs:ParentSnapshot",
          "ebs:VolumeSize",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "ebs:Description",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonelasticblockstore.html#amazonelasticblockstore-policy-keys",
        description:
          "Filters access by the description of the snapshot being created",
        type: "String",
      },
      {
        name: "ebs:ParentSnapshot",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonelasticblockstore.html#amazonelasticblockstore-policy-keys",
        description: "Filters access by the ID of the parent snapshot",
        type: "String",
      },
      {
        name: "ebs:VolumeSize",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonelasticblockstore.html#amazonelasticblockstore-policy-keys",
        description:
          "Filters access by the size of the volume for the snapshot being created, in GiB",
        type: "Numeric",
      },
    ],
  },
  ecr: {
    name: "Amazon Elastic Container Registry",
    servicePrefix: "ecr",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelasticcontainerregistry.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonECR/latest/APIReference/",
    resourceTypes: [
      {
        name: "repository",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECR/latest/userguide/Repositories.html",
        arnPattern:
          "arn:${Partition}:ecr:${Region}:${Account}:repository/${RepositoryName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecr:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "ecr:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECR/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
    ],
  },
  "ecr-public": {
    name: "Amazon Elastic Container Registry Public",
    servicePrefix: "ecr-public",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelasticcontainerregistrypublic.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonECRPublic/latest/APIReference/",
    resourceTypes: [
      {
        name: "repository",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECR/latest/userguide/iam-policy-structure.html#ECR-Public_ARN_Format",
        arnPattern:
          "arn:${Partition}:ecr-public::${Account}:repository/${RepositoryName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecr-public:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "registry",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECR/latest/userguide/iam-policy-structure.html#ECR-Public_ARN_Format",
        arnPattern:
          "arn:${Partition}:ecr-public::${Account}:registry/${RegistryId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters create requests based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters create requests based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "ecr-public:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECR/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters actions based on tag-value associated with the resource",
        type: "String",
      },
    ],
  },
  ecs: {
    name: "Amazon Elastic Container Service",
    servicePrefix: "ecs",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelasticcontainerservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonECS/latest/APIReference/",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/clusters.html",
        arnPattern:
          "arn:${Partition}:ecs:${Region}:${Account}:cluster/${ClusterName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecs:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "container-instance",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/ECS_instances.html",
        arnPattern:
          "arn:${Partition}:ecs:${Region}:${Account}:container-instance/${ClusterName}/${ContainerInstanceId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecs:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "service",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/ecs_services.html",
        arnPattern:
          "arn:${Partition}:ecs:${Region}:${Account}:service/${ClusterName}/${ServiceName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecs:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "task",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/scheduling_tasks.html",
        arnPattern:
          "arn:${Partition}:ecs:${Region}:${Account}:task/${ClusterName}/${TaskId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecs:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "task-definition",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/task_definitions.html",
        arnPattern:
          "arn:${Partition}:ecs:${Region}:${Account}:task-definition/${TaskDefinitionFamilyName}:${TaskDefinitionRevisionNumber}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecs:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "capacity-provider",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/cluster-capacity-providers.html",
        arnPattern:
          "arn:${Partition}:ecs:${Region}:${Account}:capacity-provider/${CapacityProviderName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecs:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "task-set",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/deployment-type-external.html",
        arnPattern:
          "arn:${Partition}:ecs:${Region}:${Account}:task-set/${ClusterName}/${ServiceName}/${TaskSetId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ecs:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "ecs:CreateAction",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-createaction",
        description:
          "Filters access by the name of a resource-creating API action",
        type: "String",
      },
      {
        name: "ecs:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "ecs:account-setting",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the Amazon ECS account setting name",
        type: "String",
      },
      {
        name: "ecs:capacity-provider",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the ARN of an Amazon ECS capacity provider",
        type: "ARN",
      },
      {
        name: "ecs:cluster",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ARN of an Amazon ECS cluster",
        type: "ARN",
      },
      {
        name: "ecs:container-instances",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the ARN of an Amazon ECS container instance",
        type: "ARN",
      },
      {
        name: "ecs:container-name",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the name of an Amazon ECS container which is defined in the ECS task definition",
        type: "String",
      },
      {
        name: "ecs:enable-ebs-volumes",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the Amazon ECS managed Amazon EBS volume capability of your ECS task or service",
        type: "String",
      },
      {
        name: "ecs:enable-execute-command",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the execute-command capability of your Amazon ECS task or Amazon ECS service",
        type: "String",
      },
      {
        name: "ecs:enable-service-connect",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the enable field value in the Service Connect configuration",
        type: "String",
      },
      {
        name: "ecs:namespace",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the ARN of AWS Cloud Map namespace which is defined in the Service Connect Configuration",
        type: "ARN",
      },
      {
        name: "ecs:service",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ARN of an Amazon ECS service",
        type: "ARN",
      },
      {
        name: "ecs:task",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ARN of an Amazon ECS task",
        type: "ARN",
      },
      {
        name: "ecs:task-definition",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonECS/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the ARN of an Amazon ECS task definition",
        type: "ARN",
      },
    ],
  },
  drs: {
    name: "AWS Elastic Disaster Recovery",
    servicePrefix: "drs",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselasticdisasterrecovery.html",
    apiReferenceHref: "https://docs.aws.amazon.com/drs/latest/APIReference/",
    resourceTypes: [
      {
        name: "JobResource",
        referenceHref:
          "https://docs.aws.amazon.com/drs/latest/userguide/failback-overview.html",
        arnPattern: "arn:${Partition}:drs:${Region}:${Account}:job/${JobID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "RecoveryInstanceResource",
        referenceHref:
          "https://docs.aws.amazon.com/drs/latest/userguide/recovery-instances.html",
        arnPattern:
          "arn:${Partition}:drs:${Region}:${Account}:recovery-instance/${RecoveryInstanceID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "drs:EC2InstanceARN"],
      },
      {
        name: "ReplicationConfigurationTemplateResource",
        referenceHref:
          "https://docs.aws.amazon.com/drs/latest/userguide/replication-settings-template.html",
        arnPattern:
          "arn:${Partition}:drs:${Region}:${Account}:replication-configuration-template/${ReplicationConfigurationTemplateID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "LaunchConfigurationTemplateResource",
        referenceHref:
          "https://docs.aws.amazon.com/drs/latest/userguide/default-drs-launch-settings.html",
        arnPattern:
          "arn:${Partition}:drs:${Region}:${Account}:launch-configuration-template/${LaunchConfigurationTemplateID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "SourceServerResource",
        referenceHref:
          "https://docs.aws.amazon.com/drs/latest/userguide/source-servers.html",
        arnPattern:
          "arn:${Partition}:drs:${Region}:${Account}:source-server/${SourceServerID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "SourceNetworkResource",
        referenceHref:
          "https://docs.aws.amazon.com/drs/latest/userguide/source-networks.html",
        arnPattern:
          "arn:${Partition}:drs:${Region}:${Account}:source-network/${SourceNetworkID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "drs:CreateAction",
        referenceHref:
          "https://docs.aws.amazon.com/drs/latest/userguide/supported-iam-actions-tagging.html",
        description:
          "Filters access by the name of a resource-creating API action",
        type: "String",
      },
      {
        name: "drs:EC2InstanceARN",
        referenceHref:
          "https://docs.aws.amazon.com/drs/latest/userguide/security_iam_authentication.html",
        description:
          "Filters access by the EC2 instance the request originated from",
        type: "ARN",
      },
    ],
  },
  elasticfilesystem: {
    name: "Amazon Elastic File System",
    servicePrefix: "elasticfilesystem",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelasticfilesystem.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/efs/latest/ug/api-reference.html",
    resourceTypes: [
      {
        name: "file-system",
        referenceHref:
          "https://docs.aws.amazon.com/efs/latest/ug/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:elasticfilesystem:${Region}:${Account}:file-system/${FileSystemId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "access-point",
        referenceHref:
          "https://docs.aws.amazon.com/efs/latest/ug/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:elasticfilesystem:${Region}:${Account}:access-point/${AccessPointId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "elasticfilesystem:AccessPointArn",
        referenceHref:
          "https://docs.aws.amazon.com/efs/latest/ug/efs-access-points.html",
        description:
          "Filters access by the ARN of the access point used to mount the file system",
        type: "ARN",
      },
      {
        name: "elasticfilesystem:AccessedViaMountTarget",
        referenceHref:
          "https://docs.aws.amazon.com/efs/latest/ug/mounting-fs.html",
        description:
          "Filters access by whether the file system is accessed via mount targets",
        type: "Bool",
      },
      {
        name: "elasticfilesystem:CreateAction",
        referenceHref:
          "https://docs.aws.amazon.com/efs/latest/ug/using-tags-efs.html",
        description:
          "Filters access by the name of a resource-creating API action",
        type: "String",
      },
      {
        name: "elasticfilesystem:Encrypted",
        referenceHref:
          "https://docs.aws.amazon.com/efs/latest/ug/encryption.html",
        description:
          "Filters access by whether users can create only encrypted or unencrypted file systems",
        type: "Bool",
      },
    ],
  },
  "elastic-inference": {
    name: "Amazon Elastic Inference",
    servicePrefix: "elastic-inference",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelasticinference.html",
    apiReferenceHref: "https://docs.aws.amazon.com/AWSEC2/latest/APIReference",
    resourceTypes: [
      {
        name: "accelerator",
        arnPattern:
          "arn:${Partition}:elastic-inference:${Region}:${Account}:elastic-inference-accelerator/${AcceleratorId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  eks: {
    name: "Amazon Elastic Kubernetes Service",
    servicePrefix: "eks",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelastickubernetesservice.html",
    apiReferenceHref: "https://docs.aws.amazon.com/eks/latest/APIReference/",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/clusters.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:cluster/${ClusterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "nodegroup",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/managed-node-groups.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:nodegroup/${ClusterName}/${NodegroupName}/${UUID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "addon",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/eks-add-ons.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:addon/${ClusterName}/${AddonName}/${UUID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "fargateprofile",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/fargate-profile.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:fargateprofile/${ClusterName}/${FargateProfileName}/${UUID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "identityproviderconfig",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/authenticate-oidc-identity-provider.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:identityproviderconfig/${ClusterName}/${IdentityProviderType}/${IdentityProviderConfigName}/${UUID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "eks-anywhere-subscription",
        referenceHref:
          "https://anywhere.eks.amazonaws.com/docs/clustermgmt/support/cluster-license/",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:eks-anywhere-subscription/${UUID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "podidentityassociation",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/pod-identities.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:podidentityassociation/${ClusterName}/${UUID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "access-entry",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/access-entry.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:access-entry/${ClusterName}/${IamIdentityType}/${IamIdentityAccountID}/${IamIdentityName}/${UUID}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "eks:accessEntryType",
          "eks:clusterName",
          "eks:kubernetesGroups",
          "eks:principalArn",
          "eks:username",
        ],
      },
      {
        name: "access-policy",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/access-policy.html",
        arnPattern:
          "arn:${Partition}:eks::aws:cluster-access-policy/${AccessPolicyName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by a key that is present in the request the user makes to the EKS service",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description: "Filters access by a tag key and value pair",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by the list of all the tag key names present in the request the user makes to the EKS service",
        type: "ArrayOfString",
      },
      {
        name: "eks:accessEntryType",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the access entry type present in the access entry requests the user makes to the EKS service",
        type: "String",
      },
      {
        name: "eks:accessScope",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the accessScope present in the associate / disassociate access policy requests the user makes to the EKS service",
        type: "String",
      },
      {
        name: "eks:bootstrapClusterCreatorAdminPermissions",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the bootstrapClusterCreatorAdminPermissions present in the create cluster request",
        type: "String",
      },
      {
        name: "eks:clientId",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the clientId present in the associateIdentityProviderConfig request the user makes to the EKS service",
        type: "String",
      },
      {
        name: "eks:clusterName",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the clusterName present in the access entry requests the user makes to the EKS service",
        type: "String",
      },
      {
        name: "eks:issuerUrl",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the issuerUrl present in the associateIdentityProviderConfig request the user makes to the EKS service",
        type: "String",
      },
      {
        name: "eks:kubernetesGroups",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the kubernetesGroups present in the access entry requests the user makes to the EKS service",
        type: "String",
      },
      {
        name: "eks:namespaces",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the namespaces present in the associate / disassociate access policy requests the user makes to the EKS service",
        type: "ArrayOfString",
      },
      {
        name: "eks:policyArn",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the policyArn present in the access entry requests the user makes to the EKS service",
        type: "String",
      },
      {
        name: "eks:principalArn",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the principalArn present in the access entry requests requests the user makes to the EKS service",
        type: "String",
      },
      {
        name: "eks:username",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies",
        description:
          "Filters access by the Kubernetes username present in the access entry requests the user makes to the EKS service",
        type: "String",
      },
    ],
  },
  elasticloadbalancing: {
    name: "AWS Elastic Load Balancing V2",
    servicePrefix: "elasticloadbalancing",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselasticloadbalancingv2.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/elasticloadbalancing/latest/APIReference/",
    resourceTypes: [
      {
        name: "listener/app",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/application/load-balancer-listeners.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:listener/app/${LoadBalancerName}/${LoadBalancerId}/${ListenerId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "listener-rule/app",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/application/listener-update-rules.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:listener-rule/app/${LoadBalancerName}/${LoadBalancerId}/${ListenerId}/${ListenerRuleId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "listener/net",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/application/load-balancer-listeners.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:listener/net/${LoadBalancerName}/${LoadBalancerId}/${ListenerId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "listener-rule/net",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/application/listener-update-rules.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:listener-rule/net/${LoadBalancerName}/${LoadBalancerId}/${ListenerId}/${ListenerRuleId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "loadbalancer/app/",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/application/introduction.html#application-load-balancer-overview",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:loadbalancer/app/${LoadBalancerName}/${LoadBalancerId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "loadbalancer/net/",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/network/introduction.html#network-load-balancer-overview",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:loadbalancer/net/${LoadBalancerName}/${LoadBalancerId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "targetgroup",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/application/load-balancer-target-groups.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:targetgroup/${TargetGroupName}/${TargetGroupId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "truststore",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/application/trust-store.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:truststore/${TrustStoreName}/${TrustStoreId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "elasticloadbalancing:CreateAction",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/userguide/tagging-resources-during-creation.html",
        description:
          "Filters access by the name of a resource-creating API action",
        type: "String",
      },
      {
        name: "elasticloadbalancing:ListenerProtocol",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/userguide/security_iam_service-with-iam.html#listenerprotocol-condition",
        description:
          "Filters access by the listener protocol that is allowed in the request",
        type: "String",
      },
      {
        name: "elasticloadbalancing:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the preface string for a tag key and value pair that are attached to a resource",
        type: "String",
      },
      {
        name: "elasticloadbalancing:Scheme",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/userguide/security_iam_service-with-iam.html#scheme-condition",
        description:
          "Filters access by the load balancer scheme that is allowed in the request",
        type: "String",
      },
      {
        name: "elasticloadbalancing:SecurityGroup",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/userguide/security_iam_service-with-iam.html#securitygroup-condition",
        description:
          "Filters access by the security-group IDs that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "elasticloadbalancing:SecurityPolicy",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/userguide/security_iam_service-with-iam.html#securitypolicy-condition",
        description:
          "Filters access by the SSL Security Policies that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "elasticloadbalancing:Subnet",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/userguide/security_iam_service-with-iam.html#subnet-condition",
        description:
          "Filters access by the subnet IDs that are allowed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  elasticmapreduce: {
    name: "Amazon Elastic MapReduce",
    servicePrefix: "elasticmapreduce",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelasticmapreduce.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/emr/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-overview.html",
        arnPattern:
          "arn:${Partition}:elasticmapreduce:${Region}:${Account}:cluster/${ClusterId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticmapreduce:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "editor",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-managed-notebooks.html",
        arnPattern:
          "arn:${Partition}:elasticmapreduce:${Region}:${Account}:editor/${EditorId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticmapreduce:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "notebook-execution",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-managed-notebooks-headless.html",
        arnPattern:
          "arn:${Partition}:elasticmapreduce:${Region}:${Account}:notebook-execution/${NotebookExecutionId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticmapreduce:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "studio",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-studio.html",
        arnPattern:
          "arn:${Partition}:elasticmapreduce:${Region}:${Account}:studio/${StudioId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticmapreduce:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-plan-access-iam.html#emr-fine-grained-cluster-access",
        description:
          "Filters access by whether the tag and value pair is provided with the action",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-plan-access-iam.html#emr-fine-grained-cluster-access",
        description:
          "Filters access by the tag and value pair associated with an Amazon EMR resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-plan-access-iam.html#emr-fine-grained-cluster-access",
        description:
          "Filters access by whether the tag keys are provided with the action regardless of tag value",
        type: "ArrayOfString",
      },
      {
        name: "elasticmapreduce:ExecutionRoleArn",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-plan-access-iam.html#emr-security",
        description:
          "Filters access by whether the execution role ARN is provided with the action",
        type: "ARN",
      },
      {
        name: "elasticmapreduce:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-plan-access-iam.html#emr-fine-grained-cluster-access",
        description:
          "Filters access by whether the tag and value pair is provided with the action",
        type: "String",
      },
      {
        name: "elasticmapreduce:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-plan-access-iam.html#emr-fine-grained-cluster-access",
        description:
          "Filters access by the tag and value pair associated with an Amazon EMR resource",
        type: "String",
      },
    ],
  },
  elastictranscoder: {
    name: "Amazon Elastic Transcoder",
    servicePrefix: "elastictranscoder",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelastictranscoder.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/elastictranscoder/latest/developerguide/api-reference.html",
    resourceTypes: [
      {
        name: "job",
        referenceHref:
          "https://docs.aws.amazon.com/elastictranscoder/latest/developerguide/operations-jobs.html",
        arnPattern:
          "arn:${Partition}:elastictranscoder:${Region}:${Account}:job/${JobId}",
        conditionKeys: [],
      },
      {
        name: "pipeline",
        referenceHref:
          "https://docs.aws.amazon.com/elastictranscoder/latest/developerguide/operations-pipelines.html",
        arnPattern:
          "arn:${Partition}:elastictranscoder:${Region}:${Account}:pipeline/${PipelineId}",
        conditionKeys: [],
      },
      {
        name: "preset",
        referenceHref:
          "https://docs.aws.amazon.com/elastictranscoder/latest/developerguide/operations-presets.html",
        arnPattern:
          "arn:${Partition}:elastictranscoder:${Region}:${Account}:preset/${PresetId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  elasticache: {
    name: "Amazon ElastiCache",
    servicePrefix: "elasticache",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonelasticache.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonElastiCache/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "parametergroup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/WhatIs.Components.html#WhatIs.Components.ParameterGroups",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:parametergroup:${CacheParameterGroupName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "elasticache:CacheParameterGroupName",
        ],
      },
      {
        name: "securitygroup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/WhatIs.Components.html#WhatIs.Components.SecurityGroups",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:securitygroup:${CacheSecurityGroupName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
      {
        name: "subnetgroup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/WhatIs.Components.html#WhatIs.Components.SubnetGroups",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:subnetgroup:${CacheSubnetGroupName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
      {
        name: "replicationgroup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/WhatIs.Components.html#WhatIs.Components.ReplicationGroups",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:replicationgroup:${ReplicationGroupId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "elasticache:AtRestEncryptionEnabled",
          "elasticache:AuthTokenEnabled",
          "elasticache:AutomaticFailoverEnabled",
          "elasticache:CacheNodeType",
          "elasticache:CacheParameterGroupName",
          "elasticache:ClusterModeEnabled",
          "elasticache:EngineType",
          "elasticache:EngineVersion",
          "elasticache:KmsKeyId",
          "elasticache:MultiAZEnabled",
          "elasticache:NumNodeGroups",
          "elasticache:ReplicasPerNodeGroup",
          "elasticache:SnapshotRetentionLimit",
          "elasticache:TransitEncryptionEnabled",
        ],
      },
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/WhatIs.Components.html#WhatIs.Components.Clusters",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:cluster:${CacheClusterId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "elasticache:AuthTokenEnabled",
          "elasticache:CacheNodeType",
          "elasticache:CacheParameterGroupName",
          "elasticache:EngineType",
          "elasticache:EngineVersion",
          "elasticache:MultiAZEnabled",
          "elasticache:SnapshotRetentionLimit",
        ],
      },
      {
        name: "reserved-instance",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/reserved-nodes.html",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:reserved-instance:${ReservedCacheNodeId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
      {
        name: "snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/WhatIs.Components.html#WhatIs.Components.Snapshots",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:snapshot:${SnapshotName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "elasticache:KmsKeyId",
        ],
      },
      {
        name: "globalreplicationgroup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/Redis-Global-Datastore.html",
        arnPattern:
          "arn:${Partition}:elasticache::${Account}:globalreplicationgroup:${GlobalReplicationGroupId}",
        conditionKeys: [
          "elasticache:AtRestEncryptionEnabled",
          "elasticache:AuthTokenEnabled",
          "elasticache:AutomaticFailoverEnabled",
          "elasticache:CacheNodeType",
          "elasticache:CacheParameterGroupName",
          "elasticache:ClusterModeEnabled",
          "elasticache:EngineType",
          "elasticache:EngineVersion",
          "elasticache:KmsKeyId",
          "elasticache:MultiAZEnabled",
          "elasticache:NumNodeGroups",
          "elasticache:ReplicasPerNodeGroup",
          "elasticache:SnapshotRetentionLimit",
          "elasticache:TransitEncryptionEnabled",
        ],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/Clusters.RBAC.html",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:user:${UserId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "elasticache:UserAuthenticationMode",
        ],
      },
      {
        name: "usergroup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/Clusters.RBAC.html",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:usergroup:${UserGroupId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
      {
        name: "serverlesscache",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/WhatIs.html",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:serverlesscache:${ServerlessCacheName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "elasticache:DataStorageUnit",
          "elasticache:EngineType",
          "elasticache:EngineVersion",
          "elasticache:KmsKeyId",
          "elasticache:MaximumDataStorage",
          "elasticache:MaximumECPUPerSecond",
          "elasticache:SnapshotRetentionLimit",
        ],
      },
      {
        name: "serverlesscachesnapshot",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonElastiCache/latest/red-ug/WhatIs.html",
        arnPattern:
          "arn:${Partition}:elasticache:${Region}:${Account}:serverlesscachesnapshot:${ServerlessCacheSnapshotName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "elasticache:KmsKeyId",
        ],
      },
    ],
    conditionKeys: [],
  },
  "elemental-appliances-software": {
    name: "AWS Elemental Appliances and Software",
    servicePrefix: "elemental-appliances-software",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalappliancesandsoftware.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/elemental-appliances-software/latest/ug/",
    resourceTypes: [
      {
        name: "quote",
        referenceHref:
          "https://docs.aws.amazon.com/elemental-appliances-software",
        arnPattern:
          "arn:${Partition}:elemental-appliances-software:${Region}:${Account}:quote/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/elemental-appliances-software",
        description: "Filters access by request tag",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/elemental-appliances-software",
        description: "Filters access by resource tag",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/elemental-appliances-software",
        description: "Filters access by tag keys",
        type: "ArrayOfString",
      },
    ],
  },
  "elemental-activations": {
    name: "AWS Elemental Appliances and Software Activation Service",
    servicePrefix: "elemental-activations",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalappliancesandsoftwareactivationservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/elemental-appliances-software/",
    resourceTypes: [
      {
        name: "activation",
        referenceHref:
          "https://docs.aws.amazon.com/elemental-appliances-software/",
        arnPattern:
          "arn:${Partition}:elemental-activations:${Region}:${Account}:activation/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  mediaconnect: {
    name: "AWS Elemental MediaConnect",
    servicePrefix: "mediaconnect",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmediaconnect.html",
    apiReferenceHref: "https://docs.aws.amazon.com/mediaconnect/latest/api/",
    resourceTypes: [
      {
        name: "Entitlement",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconnect/latest/ug/entitlements.html",
        arnPattern:
          "arn:${Partition}:mediaconnect:${Region}:${Account}:entitlement:${FlowId}:${EntitlementName}",
        conditionKeys: [],
      },
      {
        name: "Flow",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconnect/latest/ug/flows.html",
        arnPattern:
          "arn:${Partition}:mediaconnect:${Region}:${Account}:flow:${FlowId}:${FlowName}",
        conditionKeys: [],
      },
      {
        name: "Output",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconnect/latest/ug/outputs.html",
        arnPattern:
          "arn:${Partition}:mediaconnect:${Region}:${Account}:output:${OutputId}:${OutputName}",
        conditionKeys: [],
      },
      {
        name: "Source",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconnect/latest/ug/sources.html",
        arnPattern:
          "arn:${Partition}:mediaconnect:${Region}:${Account}:source:${SourceId}:${SourceName}",
        conditionKeys: [],
      },
      {
        name: "Gateway",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconnect/latest/ug/gateway.html",
        arnPattern:
          "arn:${Partition}:mediaconnect:${Region}:${Account}:gateway:${GatewayId}:${GatewayName}",
        conditionKeys: [],
      },
      {
        name: "Bridge",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconnect/latest/ug/gateway-components-bridges.html",
        arnPattern:
          "arn:${Partition}:mediaconnect:${Region}:${Account}:bridge:${FlowId}:${FlowName}",
        conditionKeys: [],
      },
      {
        name: "GatewayInstance",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconnect/latest/ug/gateway-components-instances.html",
        arnPattern:
          "arn:${Partition}:mediaconnect:${Region}:${Account}:gateway:${GatewayId}:${GatewayName}:instance:${InstanceId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  mediaconvert: {
    name: "AWS Elemental MediaConvert",
    servicePrefix: "mediaconvert",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmediaconvert.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/mediaconvert/latest/apireference/",
    resourceTypes: [
      {
        name: "Job",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/jobs.html",
        arnPattern:
          "arn:${Partition}:mediaconvert:${Region}:${Account}:jobs/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Queue",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/queues.html",
        arnPattern:
          "arn:${Partition}:mediaconvert:${Region}:${Account}:queues/${QueueName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Preset",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/presets.html",
        arnPattern:
          "arn:${Partition}:mediaconvert:${Region}:${Account}:presets/${PresetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "JobTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/jobtemplates.html",
        arnPattern:
          "arn:${Partition}:mediaconvert:${Region}:${Account}:jobTemplates/${JobTemplateName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "CertificateAssociation",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/certificates.html",
        arnPattern:
          "arn:${Partition}:mediaconvert:${Region}:${Account}:certificates/${CertificateArn}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/tags.html",
        description: "Filters access by tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/tags.html",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/tags.html",
        description: "Filters access by tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "mediaconvert:HttpInputsAllowed",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/input-policies.html",
        description:
          "Filters access by an HTTP input policy present in the account",
        type: "Bool",
      },
      {
        name: "mediaconvert:HttpsInputsAllowed",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/input-policies.html",
        description:
          "Filters access by an HTTPS input policy present in the account",
        type: "Bool",
      },
      {
        name: "mediaconvert:S3InputsAllowed",
        referenceHref:
          "https://docs.aws.amazon.com/mediaconvert/latest/apireference/input-policies.html",
        description:
          "Filters access by an S3 input policy present in the account",
        type: "Bool",
      },
    ],
  },
  medialive: {
    name: "AWS Elemental MediaLive",
    servicePrefix: "medialive",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmedialive.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/medialive/latest/apireference/what-is.html",
    resourceTypes: [
      {
        name: "channel",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ug/channels.html",
        arnPattern:
          "arn:${Partition}:medialive:${Region}:${Account}:channel:${ChannelId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "input",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ug/inputs.html",
        arnPattern:
          "arn:${Partition}:medialive:${Region}:${Account}:input:${InputId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "input-device",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ug/eml-devices.html",
        arnPattern:
          "arn:${Partition}:medialive:${Region}:${Account}:inputDevice:${DeviceId}",
        conditionKeys: [],
      },
      {
        name: "input-security-group",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ug/inputsecuritygroups.html",
        arnPattern:
          "arn:${Partition}:medialive:${Region}:${Account}:inputSecurityGroup:${InputSecurityGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "multiplex",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ug/eml-multiplex.html",
        arnPattern:
          "arn:${Partition}:medialive:${Region}:${Account}:multiplex:${MultiplexId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "reservation",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ug/reservations.html",
        arnPattern:
          "arn:${Partition}:medialive:${Region}:${Account}:reservation:${ReservationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "offering",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ug/input-output-reservations.html",
        arnPattern:
          "arn:${Partition}:medialive:${Region}:${Account}:offering:${OfferingId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ugtagging.html",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ugtagging.html",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/medialive/latest/ugtagging.html",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  mediapackage: {
    name: "AWS Elemental MediaPackage",
    servicePrefix: "mediapackage",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmediapackage.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/mediapackage/latest/apireference/welcome.html",
    resourceTypes: [
      {
        name: "channels",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/ug/channels.html",
        arnPattern:
          "arn:${Partition}:mediapackage:${Region}:${Account}:channels/${ChannelIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "origin_endpoints",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/ug/endpoints.html",
        arnPattern:
          "arn:${Partition}:mediapackage:${Region}:${Account}:origin_endpoints/${OriginEndpointIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "harvest_jobs",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/ug/harvest-jobs.html",
        arnPattern:
          "arn:${Partition}:mediapackage:${Region}:${Account}:harvest_jobs/${HarvestJobIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag for a MediaPackage request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tag for a MediaPackage resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys for a MediaPackage resource or request",
        type: "ArrayOfString",
      },
    ],
  },
  mediapackagev2: {
    name: "AWS Elemental MediaPackage V2",
    servicePrefix: "mediapackagev2",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmediapackagev2.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/mediapackage/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "ChannelGroup",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/userguide/channel-groups.html",
        arnPattern:
          "arn:${Partition}:mediapackagev2:${Region}:${Account}:channelGroup/${ChannelGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Channel",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/userguide/channels.html",
        arnPattern:
          "arn:${Partition}:mediapackagev2:${Region}:${Account}:channelGroup/${ChannelGroupName}/channel/${ChannelName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "OriginEndpoint",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/userguide/endpoints.html",
        arnPattern:
          "arn:${Partition}:mediapackagev2:${Region}:${Account}:channelGroup/${ChannelGroupName}/channel/${ChannelName}/originEndpoint/${OriginEndpointName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "mediapackage-vod": {
    name: "AWS Elemental MediaPackage VOD",
    servicePrefix: "mediapackage-vod",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmediapackagevod.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/mediapackage-vod/latest/apireference/welcome.html",
    resourceTypes: [
      {
        name: "assets",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/ug/asset.html",
        arnPattern:
          "arn:${Partition}:mediapackage-vod:${Region}:${Account}:assets/${AssetIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "packaging-configurations",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/ug/pkg-cfig.html",
        arnPattern:
          "arn:${Partition}:mediapackage-vod:${Region}:${Account}:packaging-configurations/${PackagingConfigurationIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "packaging-groups",
        referenceHref:
          "https://docs.aws.amazon.com/mediapackage/latest/ug/pkg-group.html",
        arnPattern:
          "arn:${Partition}:mediapackage-vod:${Region}:${Account}:packaging-groups/${PackagingGroupIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  mediastore: {
    name: "AWS Elemental MediaStore",
    servicePrefix: "mediastore",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmediastore.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/mediastore/latest/apireference/",
    resourceTypes: [
      {
        name: "container",
        referenceHref:
          "https://docs.aws.amazon.com/mediastore/latest/ug/containers.html",
        arnPattern:
          "arn:${Partition}:mediastore:${Region}:${Account}:container/${ContainerName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "object",
        referenceHref:
          "https://docs.aws.amazon.com/mediastore/latest/ug/objects.html",
        arnPattern:
          "arn:${Partition}:mediastore:${Region}:${Account}:container/${ContainerName}/${ObjectPath}",
        conditionKeys: [],
      },
      {
        name: "folder",
        referenceHref:
          "https://docs.aws.amazon.com/mediastore/latest/ug/folders.html",
        arnPattern:
          "arn:${Partition}:mediastore:${Region}:${Account}:container/${ContainerName}/${FolderPath}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  mediatailor: {
    name: "AWS Elemental MediaTailor",
    servicePrefix: "mediatailor",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalmediatailor.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/mediatailor/latest/apireference/",
    resourceTypes: [
      {
        name: "playbackConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/mediatailor/latest/apireference/playbackconfiguration.html",
        arnPattern:
          "arn:${Partition}:mediatailor:${Region}:${Account}:playbackConfiguration/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "prefetchSchedule",
        referenceHref:
          "https://docs.aws.amazon.com/mediatailor/latest/apireference/prefetchschedule-playbackconfigurationname-name.html",
        arnPattern:
          "arn:${Partition}:mediatailor:${Region}:${Account}:prefetchSchedule/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "channel",
        referenceHref:
          "https://docs.aws.amazon.com/mediatailor/latest/apireference/channel-channelname.html",
        arnPattern:
          "arn:${Partition}:mediatailor:${Region}:${Account}:channel/${ChannelName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "program",
        referenceHref:
          "https://docs.aws.amazon.com/mediatailor/latest/apireference/channel-channelname-program-programname.html",
        arnPattern:
          "arn:${Partition}:mediatailor:${Region}:${Account}:program/${ChannelName}/${ProgramName}",
        conditionKeys: [],
      },
      {
        name: "sourceLocation",
        referenceHref:
          "https://docs.aws.amazon.com/mediatailor/latest/apireference/sourcelocation-sourcelocationname.html",
        arnPattern:
          "arn:${Partition}:mediatailor:${Region}:${Account}:sourceLocation/${SourceLocationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vodSource",
        referenceHref:
          "https://docs.aws.amazon.com/mediatailor/latest/apireference/sourcelocation-sourcelocationname-vodsource-vodsourcename.html",
        arnPattern:
          "arn:${Partition}:mediatailor:${Region}:${Account}:vodSource/${SourceLocationName}/${VodSourceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "liveSource",
        referenceHref:
          "https://docs.aws.amazon.com/mediatailor/latest/apireference/sourcelocation-sourcelocationname-livesource-livesourcename.html",
        arnPattern:
          "arn:${Partition}:mediatailor:${Region}:${Account}:liveSource/${SourceLocationName}/${LiveSourceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "elemental-support-cases": {
    name: "AWS Elemental Support Cases",
    servicePrefix: "elemental-support-cases",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalsupportcases.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/elemental-appliances-software/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "elemental-support-content": {
    name: "AWS Elemental Support Content",
    servicePrefix: "elemental-support-content",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awselementalsupportcontent.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/elemental-appliances-software/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "emr-containers": {
    name: "Amazon EMR on EKS (EMR Containers)",
    servicePrefix: "emr-containers",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonemroneksemrcontainers.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/emr-on-eks/latest/APIReference/",
    resourceTypes: [
      {
        name: "virtualCluster",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/EMR-on-EKS-DevelopmentGuide/virtual-cluster.html",
        arnPattern:
          "arn:${Partition}:emr-containers:${Region}:${Account}:/virtualclusters/${VirtualClusterId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "jobRun",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/EMR-on-EKS-DevelopmentGuide/job-runs.html",
        arnPattern:
          "arn:${Partition}:emr-containers:${Region}:${Account}:/virtualclusters/${VirtualClusterId}/jobruns/${JobRunId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "jobTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/EMR-on-EKS-DevelopmentGuide/job-templates.html",
        arnPattern:
          "arn:${Partition}:emr-containers:${Region}:${Account}:/jobtemplates/${JobTemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "managedEndpoint",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/ManagementGuide/emr-studio-create-eks-cluster.html#emr-studio-create-managed-endpoint",
        arnPattern:
          "arn:${Partition}:emr-containers:${Region}:${Account}:/virtualclusters/${VirtualClusterId}/endpoints/${EndpointId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tag key-value pairs present in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys present in the request",
        type: "ArrayOfString",
      },
      {
        name: "emr-containers:ExecutionRoleArn",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/EMR-on-EKS-DevelopmentGuide/iam-execution-role.html",
        description:
          "Filters access by the execution role arn present in the request",
        type: "ARN",
      },
      {
        name: "emr-containers:JobTemplateArn",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/EMR-on-EKS-DevelopmentGuide/iam-job-template.html",
        description:
          "Filters access by the job template arn present in the request",
        type: "ARN",
      },
    ],
  },
  "emr-serverless": {
    name: "Amazon EMR Serverless",
    servicePrefix: "emr-serverless",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonemrserverless.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/emr-serverless/latest/APIReference/",
    resourceTypes: [
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/EMR-Serverless-UserGuide/emr-serverless.html",
        arnPattern:
          "arn:${Partition}:emr-serverless:${Region}:${Account}:/applications/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "jobRun",
        referenceHref:
          "https://docs.aws.amazon.com/emr/latest/EMR-Serverless-UserGuide/emr-serverless.html",
        arnPattern:
          "arn:${Partition}:emr-serverless:${Region}:${Account}:/applications/${ApplicationId}/jobruns/${JobRunId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  entityresolution: {
    name: "AWS Entity Resolution",
    servicePrefix: "entityresolution",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsentityresolution.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/entityresolution/latest/userguide/",
    resourceTypes: [
      {
        name: "MatchingWorkflow",
        referenceHref:
          "https://docs.aws.amazon.com/entityresolution/latest/userguide/",
        arnPattern:
          "arn:${Partition}:entityresolution::${Account}:matchingworkflow/${WorkflowName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "SchemaMapping",
        referenceHref:
          "https://docs.aws.amazon.com/entityresolution/latest/userguide/",
        arnPattern:
          "arn:${Partition}:entityresolution::${Account}:schemamapping/${SchemaName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "IdMappingWorkflow",
        referenceHref:
          "https://docs.aws.amazon.com/entityresolution/latest/userguide/",
        arnPattern:
          "arn:${Partition}:entityresolution::${Account}:idmappingworkflow/${WorkflowName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ProviderService",
        referenceHref:
          "https://docs.aws.amazon.com/entityresolution/latest/userguide/",
        arnPattern:
          "arn:${Partition}:entityresolution::${Account}:providerservice/${ProviderName}/${ProviderServiceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by a key that is present in the request the user makes to the entity resolution service",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description: "Filters access by a tag key and value pair",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the list of all the tag key names present in the request the user makes to the entity resolution service",
        type: "ArrayOfString",
      },
    ],
  },
  events: {
    name: "Amazon EventBridge",
    servicePrefix: "events",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoneventbridge.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/eventbridge/latest/APIReference/",
    resourceTypes: [
      {
        name: "event-source",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}::event-source/${EventSourceName}",
        conditionKeys: [],
      },
      {
        name: "event-bus",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}:${Account}:event-bus/${EventBusName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "rule-on-default-event-bus",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}:${Account}:rule/${RuleName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "rule-on-custom-event-bus",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}:${Account}:rule/${EventBusName}/${RuleName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "archive",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}:${Account}:archive/${ArchiveName}",
        conditionKeys: [],
      },
      {
        name: "replay",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}:${Account}:replay/${ReplayName}",
        conditionKeys: [],
      },
      {
        name: "connection",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}:${Account}:connection/${ConnectionName}",
        conditionKeys: [],
      },
      {
        name: "api-destination",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}:${Account}:api-destination/${ApiDestinationName}",
        conditionKeys: [],
      },
      {
        name: "endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-manage-iam-access.html#eventbridge-arn-format",
        arnPattern:
          "arn:${Partition}:events:${Region}:${Account}:endpoint/${EndpointName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the allowed set of values for each of the tags to event bus and rule actions",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag-value associated with the resource to event bus and rule actions",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tags in the request to event bus and rule actions",
        type: "ArrayOfString",
      },
      {
        name: "events:EventBusArn",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#limiting-access-to-event-buses",
        description:
          "Filters access by the ARN of the event buses that can be associated with an endpoint to CreateEndpoint and UpdateEndpoint actions",
        type: "ArrayOfARN",
      },
      {
        name: "events:ManagedBy",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html",
        description:
          "Filters access by AWS services. If a rule is created by an AWS service on your behalf, the value is the principal name of the service that created the rule",
        type: "String",
      },
      {
        name: "events:TargetArn",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#limiting-access-to-targets",
        description:
          "Filters access by the ARN of a target that can be put to a rule to PutTargets actions. TargetARN doesn't include DeadLetterConfigArn",
        type: "ArrayOfARN",
      },
      {
        name: "events:creatorAccount",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#events-creator-account",
        description:
          "Filters access by the account the rule was created in to rule actions",
        type: "String",
      },
      {
        name: "events:detail-type",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#events-pattern-detail-type",
        description:
          "Filters access by the literal string of the detail-type of the event to PutEvents and PutRule actions",
        type: "String",
      },
      {
        name: "events:detail.eventTypeCode",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#limit-rule-by-type-code",
        description:
          "Filters access by the literal string for the detail.eventTypeCode field of the event to PutRule actions",
        type: "String",
      },
      {
        name: "events:detail.service",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#limit-rule-by-service",
        description:
          "Filters access by the literal string for the detail.service field of the event to PutRule actions",
        type: "String",
      },
      {
        name: "events:detail.userIdentity.principalId",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#consume-specific-events",
        description:
          "Filters access by the literal string for the detail.useridentity.principalid field of the event to PutRule actions",
        type: "String",
      },
      {
        name: "events:eventBusInvocation",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#events-bus-invocation",
        description:
          "Filters access by whether the event was generated via API or cross-account bus invocation to PutEvents actions",
        type: "String",
      },
      {
        name: "events:source",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/policy-keys-eventbridge.html#events-limit-access-control",
        description:
          "Filters access by the AWS service or AWS partner event source that generated the event to PutEvents and PutRule actions. Matches the literal string of the source field of the event",
        type: "ArrayOfString",
      },
    ],
  },
  pipes: {
    name: "Amazon EventBridge Pipes",
    servicePrefix: "pipes",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoneventbridgepipes.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/eventbridge/latest/pipes-reference/",
    resourceTypes: [
      {
        name: "pipe",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-pipes.html",
        arnPattern: "arn:${Partition}:pipes:${Region}:${Account}:pipe/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  scheduler: {
    name: "Amazon EventBridge Scheduler",
    servicePrefix: "scheduler",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoneventbridgescheduler.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/scheduler/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "schedule-group",
        referenceHref:
          "https://docs.aws.amazon.com/scheduler/latest/UserGuide/managing-schedule-group.html",
        arnPattern:
          "arn:${Partition}:scheduler:${Region}:${Account}:schedule-group/${GroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "schedule",
        referenceHref:
          "https://docs.aws.amazon.com/scheduler/latest/UserGuide/managing-schedule.html",
        arnPattern:
          "arn:${Partition}:scheduler:${Region}:${Account}:schedule/${GroupName}/${ScheduleName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  schemas: {
    name: "Amazon EventBridge Schemas",
    servicePrefix: "schemas",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoneventbridgeschemas.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/eventbridge/latest/schema-reference/",
    resourceTypes: [
      {
        name: "discoverer",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-schema.html",
        arnPattern:
          "arn:${Partition}:schemas:${Region}:${Account}:discoverer/${DiscovererId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "registry",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-schema.html",
        arnPattern:
          "arn:${Partition}:schemas:${Region}:${Account}:registry/${RegistryName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "schema",
        referenceHref:
          "https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-schema.html",
        arnPattern:
          "arn:${Partition}:schemas:${Region}:${Account}:schema/${RegistryName}/${SchemaName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  fis: {
    name: "AWS Fault Injection Service",
    servicePrefix: "fis",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsfaultinjectionservice.html",
    apiReferenceHref: "https://docs.aws.amazon.com/fis/latest/APIReference/",
    resourceTypes: [
      {
        name: "action",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/actions.html",
        arnPattern: "arn:${Partition}:fis:${Region}:${Account}:action/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "experiment",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/experiments.html",
        arnPattern:
          "arn:${Partition}:fis:${Region}:${Account}:experiment/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "experiment-template",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/working-with-templates.html",
        arnPattern:
          "arn:${Partition}:fis:${Region}:${Account}:experiment-template/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "fis:Operations",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the list of operations on the AWS service that is being affected by the AWS FIS action",
        type: "ArrayOfString",
      },
      {
        name: "fis:Percentage",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the percentage of calls being affected by the AWS FIS action",
        type: "Numeric",
      },
      {
        name: "fis:Service",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the AWS service that is being affected by the AWS FIS action",
        type: "String",
      },
      {
        name: "fis:Targets",
        referenceHref:
          "https://docs.aws.amazon.com/fis/latest/userguide/security_iam_service-with-iam.html",
        description:
          "Filters access by the list of resource ARNs being targeted by the AWS FIS action",
        type: "ArrayOfString",
      },
    ],
  },
  finspace: {
    name: "Amazon FinSpace",
    servicePrefix: "finspace",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfinspace.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/finspace/latest/management-api/",
    resourceTypes: [
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:environment/${EnvironmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:user/${UserId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "kxEnvironment",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:kxEnvironment/${EnvironmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "kxUser",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:kxEnvironment/${EnvironmentId}/kxUser/${UserName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "kxCluster",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:kxEnvironment/${EnvironmentId}/kxCluster/${KxCluster}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "kxDatabase",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:kxEnvironment/${EnvironmentId}/kxDatabase/${KxDatabase}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "kxScalingGroup",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:kxEnvironment/${EnvironmentId}/kxScalingGroup/${KxScalingGroup}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "kxDataview",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:kxEnvironment/${EnvironmentId}/kxDatabase/${KxDatabase}/kxDataview/${KxDataview}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "kxVolume",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace:${Region}:${Account}:kxEnvironment/${EnvironmentId}/kxVolume/${KxVolume}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "finspace-api": {
    name: "Amazon FinSpace API",
    servicePrefix: "finspace-api",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfinspaceapi.html",
    apiReferenceHref: "https://docs.aws.amazon.com/finspace/latest/data-api/",
    resourceTypes: [
      {
        name: "credential",
        referenceHref:
          "https://docs.aws.amazon.com/finspace/latest/userguide/finspace-example-policies.html",
        arnPattern:
          "arn:${Partition}:finspace-api:${Region}:${Account}:/credentials/programmatic",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  fms: {
    name: "AWS Firewall Manager",
    servicePrefix: "fms",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsfirewallmanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/fms/2018-01-01/APIReference/",
    resourceTypes: [
      {
        name: "policy",
        referenceHref:
          "https://docs.aws.amazon.com/fms/2018-01-01/APIReference/API_Policy.html",
        arnPattern: "arn:${Partition}:fms:${Region}:${Account}:policy/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "applications-list",
        referenceHref:
          "https://docs.aws.amazon.com/fms/2018-01-01/APIReference/API_AppsListData.html",
        arnPattern:
          "arn:${Partition}:fms:${Region}:${Account}:applications-list/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "protocols-list",
        referenceHref:
          "https://docs.aws.amazon.com/fms/2018-01-01/APIReference/API_ProtocolsListData.html",
        arnPattern:
          "arn:${Partition}:fms:${Region}:${Account}:protocols-list/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "resource-set",
        referenceHref:
          "https://docs.aws.amazon.com/fms/2018-01-01/APIReference/API_ResourceSet.html",
        arnPattern:
          "arn:${Partition}:fms:${Region}:${Account}:resource-set/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  forecast: {
    name: "Amazon Forecast",
    servicePrefix: "forecast",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonforecast.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/forecast/latest/dg/api-reference.html",
    resourceTypes: [
      {
        name: "dataset",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateDataset.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:dataset/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "datasetGroup",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateDatasetGroup.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:dataset-group/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "datasetImportJob",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateDatasetImportJob.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:dataset-import-job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "algorithm",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/aws-forecast-choosing-recipes.html",
        arnPattern: "arn:${Partition}:forecast:::algorithm/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "predictor",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreatePredictor.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:predictor/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "predictorBacktestExportJob",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreatePredictorBacktestExportJob.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:predictor-backtest-export-job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "forecast",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateForecast.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:forecast/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "forecastExport",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateForecastExportJob.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:forecast-export-job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "explainability",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateExplainability.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:explainability/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "explainabilityExport",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateExplainabilityExport.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:explainability-export/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "monitor",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateMonitor.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:monitor/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "whatIfAnalysis",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateWhatIfAnalysis.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:what-if-analysis/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "whatIfForecast",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateWhatIfForecast.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:what-if-forecast/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "whatIfForecastExport",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/API_CreateWhatIfForecastExport.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:what-if-forecast-export/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/forecast/latest/dg/what-is-forecast.html",
        arnPattern:
          "arn:${Partition}:forecast:${Region}:${Account}:forecast-endpoint/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  frauddetector: {
    name: "Amazon Fraud Detector",
    servicePrefix: "frauddetector",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html",
    apiReferenceHref: "https://docs.aws.amazon.com/frauddetector/latest/api/",
    resourceTypes: [
      {
        name: "batch-prediction",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:batch-prediction/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "detector",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:detector/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "detector-version",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:detector-version/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "entity-type",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:entity-type/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "external-model",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:external-model/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "event-type",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:event-type/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "label",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:label/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "model",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:model/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "model-version",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:model-version/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "outcome",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:outcome/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "rule",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:rule/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "variable",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:variable/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "batch-import",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:batch-import/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "list",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfrauddetector.html#amazonfrauddetector-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:frauddetector:${Region}:${Account}:list/${ResourcePath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  freetier: {
    name: "AWS Free Tier",
    servicePrefix: "freetier",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsfreetier.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/",
    resourceTypes: [],
    conditionKeys: [],
  },
  freertos: {
    name: "Amazon FreeRTOS",
    servicePrefix: "freertos",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfreertos.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/freertos/latest/userguide/freertos-ocw.html",
    resourceTypes: [
      {
        name: "configuration",
        referenceHref:
          "https://docs.aws.amazon.com/freertos/latest/userguide/freertos-ocw.html",
        arnPattern:
          "arn:${Partition}:freertos:${Region}:${Account}:configuration/${ConfigurationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "subscription",
        referenceHref:
          "https://docs.aws.amazon.com/freertos/latest/userguide/freertos-getting-started-emp.html",
        arnPattern:
          "arn:${Partition}:freertos:${Region}:${Account}:subscription/${SubscriptionID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/freertos/latest/userguide/console-tagging-iam.html/",
        description:
          "A tag key that is present in the request that the user makes to Amazon FreeRTOS",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/freertos/latest/userguide/console-tagging-iam.html/",
        description:
          "The tag key component of a tag attached to an Amazon FreeRTOS resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/freertos/latest/userguide/console-tagging-iam.html/",
        description:
          "The list of all the tag key names associated with the resource in the request",
        type: "ArrayOfString",
      },
    ],
  },
  fsx: {
    name: "Amazon FSx",
    servicePrefix: "fsx",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonfsx.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/fsx/latest/APIReference/welcome.html",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "fsx:IsBackupCopyDestination",
        referenceHref:
          "https://docs.aws.amazon.com/fsx/latest/WindowsGuide/access-control-manage-access-intro.htmlAPI_CopyBackup.html",
        description:
          "Filters access by whether the backup is a destination backup for a CopyBackup operation",
        type: "Bool",
      },
      {
        name: "fsx:IsBackupCopySource",
        referenceHref:
          "https://docs.aws.amazon.com/fsx/latest/WindowsGuide/access-control-manage-access-intro.htmlAPI_CopyBackup.html",
        description:
          "Filters access by whether the backup is a source backup for a CopyBackup operation",
        type: "Bool",
      },
      {
        name: "fsx:NfsDataRepositoryAuthenticationEnabled",
        referenceHref:
          "https://docs.aws.amazon.com/fsx/latest/WindowsGuide/access-control-manage-access-intro.htmlAPI_CreateFileCache.html",
        description:
          "Filters access by NFS data repositories which support authentication",
        type: "Bool",
      },
      {
        name: "fsx:NfsDataRepositoryEncryptionInTransitEnabled",
        referenceHref:
          "https://docs.aws.amazon.com/fsx/latest/WindowsGuide/access-control-manage-access-intro.htmlAPI_CreateFileCache.html",
        description:
          "Filters access by NFS data repositories which support encryption-in-transit",
        type: "Bool",
      },
      {
        name: "fsx:ParentVolumeId",
        referenceHref:
          "https://docs.aws.amazon.com/fsx/latest/WindowsGuide/access-control-manage-access-intro.htmlAPI_CreateVolume.html",
        description:
          "Filters access by the containing parent volume for mutating volume operations",
        type: "String",
      },
      {
        name: "fsx:StorageVirtualMachineId",
        referenceHref:
          "https://docs.aws.amazon.com/fsx/latest/WindowsGuide/access-control-manage-access-intro.htmlAPI_CreateVolume.html",
        description:
          "Filters access by the containing storage virtual machine for a volume for mutating volume operations",
        type: "String",
      },
    ],
  },
  gamelift: {
    name: "Amazon GameLift",
    servicePrefix: "gamelift",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazongamelift.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/gamelift/latest/apireference/",
    resourceTypes: [
      {
        name: "alias",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/developerguide/gamelift-console-aliases.html",
        arnPattern: "arn:${Partition}:gamelift:${Region}::alias/${AliasId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "build",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/developerguide/gamelift-console-builds.html",
        arnPattern:
          "arn:${Partition}:gamelift:${Region}:${Account}:build/${BuildId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "fleet",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/developerguide/gamelift-console-fleets.html",
        arnPattern:
          "arn:${Partition}:gamelift:${Region}:${Account}:fleet/${FleetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "gameServerGroup",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/fleetiqguide/gsg-integrate-gameservergroup.html",
        arnPattern:
          "arn:${Partition}:gamelift:${Region}:${Account}:gameservergroup/${GameServerGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "gameSessionQueue",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/developerguide/queues-console.html",
        arnPattern:
          "arn:${Partition}:gamelift:${Region}:${Account}:gamesessionqueue/${GameSessionQueueName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "location",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/developerguide/fleets-creating-anywhere.html#fleet-anywhere-location",
        arnPattern:
          "arn:${Partition}:gamelift:${Region}:${Account}:location/${LocationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "matchmakingConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/flexmatchguide/match-create-configuration.html",
        arnPattern:
          "arn:${Partition}:gamelift:${Region}:${Account}:matchmakingconfiguration/${MatchmakingConfigurationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "matchmakingRuleSet",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/flexmatchguide/match-rulesets.html",
        arnPattern:
          "arn:${Partition}:gamelift:${Region}:${Account}:matchmakingruleset/${MatchmakingRuleSetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "script",
        referenceHref:
          "https://docs.aws.amazon.com/gamelift/latest/developerguide/gamelift-console-scripts.html",
        arnPattern:
          "arn:${Partition}:gamelift:${Region}:${Account}:script/${ScriptId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  globalaccelerator: {
    name: "AWS Global Accelerator",
    servicePrefix: "globalaccelerator",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsglobalaccelerator.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/global-accelerator/latest/api/Welcome.html",
    resourceTypes: [
      {
        name: "accelerator",
        referenceHref:
          "https://docs.aws.amazon.com/global-accelerator/latest/api/API_Accelerator.html",
        arnPattern:
          "arn:${Partition}:globalaccelerator::${Account}:accelerator/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "listener",
        referenceHref:
          "https://docs.aws.amazon.com/global-accelerator/latest/api/API_Listener.html",
        arnPattern:
          "arn:${Partition}:globalaccelerator::${Account}:accelerator/${ResourceId}/listener/${ListenerId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "endpointgroup",
        referenceHref:
          "https://docs.aws.amazon.com/global-accelerator/latest/api/API_EndpointGroup.html",
        arnPattern:
          "arn:${Partition}:globalaccelerator::${Account}:accelerator/${ResourceId}/listener/${ListenerId}/endpoint-group/${EndpointGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "attachment",
        referenceHref:
          "https://docs.aws.amazon.com/global-accelerator/latest/api/API_CrossAccountAttachment.html",
        arnPattern:
          "arn:${Partition}:globalaccelerator::${Account}:attachment/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  glue: {
    name: "AWS Glue",
    servicePrefix: "glue",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsglue.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/glue/latest/dg/aws-glue-api.html",
    resourceTypes: [
      {
        name: "catalog",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern: "arn:${Partition}:glue:${Region}:${Account}:catalog",
        conditionKeys: [],
      },
      {
        name: "database",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:database/${DatabaseName}",
        conditionKeys: [],
      },
      {
        name: "table",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:table/${DatabaseName}/${TableName}",
        conditionKeys: [],
      },
      {
        name: "tableversion",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:tableVersion/${DatabaseName}/${TableName}/${TableVersionName}",
        conditionKeys: [],
      },
      {
        name: "connection",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:connection/${ConnectionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "userdefinedfunction",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:userDefinedFunction/${DatabaseName}/${UserDefinedFunctionName}",
        conditionKeys: [],
      },
      {
        name: "devendpoint",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:devEndpoint/${DevEndpointName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "job",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern: "arn:${Partition}:glue:${Region}:${Account}:job/${JobName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "trigger",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:trigger/${TriggerName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "crawler",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:crawler/${CrawlerName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workflow",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:workflow/${WorkflowName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "blueprint",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:blueprint/${BlueprintName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "mlTransform",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:mlTransform/${TransformId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "registry",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:registry/${RegistryName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "schema",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:schema/${SchemaName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "session",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:session/${SessionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dataQualityRuleset",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:dataQualityRuleset/${RulesetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "customEntityType",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:customEntityType/${CustomEntityTypeId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "completion",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/glue-specifying-resource-arns.html",
        arnPattern:
          "arn:${Partition}:glue:${Region}:${Account}:completion/${CompletionId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "glue:CredentialIssuingService",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/using-identity-based-policies.html#glue-identity-based-policy-condition-keys",
        description:
          "Filters access by the service from which the credentials of the request is issued",
        type: "String",
      },
      {
        name: "glue:RoleAssumedBy",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/using-identity-based-policies.html#glue-identity-based-policy-condition-keys",
        description:
          "Filters access by the service from which the credentials of the request is obtained by assuming the customer role",
        type: "String",
      },
      {
        name: "glue:SecurityGroupIds",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/using-identity-based-policies.html#glue-identity-based-policy-condition-keys",
        description:
          "Filters access by the ID of security groups configured for the Glue job",
        type: "ArrayOfString",
      },
      {
        name: "glue:SubnetIds",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/using-identity-based-policies.html#glue-identity-based-policy-condition-keys",
        description:
          "Filters access by the ID of subnets configured for the Glue job",
        type: "ArrayOfString",
      },
      {
        name: "glue:VpcIds",
        referenceHref:
          "https://docs.aws.amazon.com/glue/latest/dg/using-identity-based-policies.html#glue-identity-based-policy-condition-keys",
        description:
          "Filters access by the ID of the VPC configured for the Glue job",
        type: "ArrayOfString",
      },
    ],
  },
  databrew: {
    name: "AWS Glue DataBrew",
    servicePrefix: "databrew",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsgluedatabrew.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/databrew/latest/dg/api-reference.html",
    resourceTypes: [
      {
        name: "Project",
        referenceHref:
          "https://docs.aws.amazon.com/databrew/latest/dg/projects.html",
        arnPattern:
          "arn:${Partition}:databrew:${Region}:${Account}:project/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Dataset",
        referenceHref:
          "https://docs.aws.amazon.com/databrew/latest/dg/datasets.html",
        arnPattern:
          "arn:${Partition}:databrew:${Region}:${Account}:dataset/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Ruleset",
        referenceHref:
          "https://docs.aws.amazon.com/databrew/latest/dg/rulesets.html",
        arnPattern:
          "arn:${Partition}:databrew:${Region}:${Account}:ruleset/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Recipe",
        referenceHref:
          "https://docs.aws.amazon.com/databrew/latest/dg/recipes.html",
        arnPattern:
          "arn:${Partition}:databrew:${Region}:${Account}:recipe/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Job",
        referenceHref:
          "https://docs.aws.amazon.com/databrew/latest/dg/jobs.html",
        arnPattern:
          "arn:${Partition}:databrew:${Region}:${Account}:job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Schedule",
        referenceHref:
          "https://docs.aws.amazon.com/databrew/latest/dg/jobs.html#jobs.scheduling",
        arnPattern:
          "arn:${Partition}:databrew:${Region}:${Account}:schedule/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  groundstation: {
    name: "AWS Ground Station",
    servicePrefix: "groundstation",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsgroundstation.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/ground-station/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "Config",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_ConfigListItem.html",
        arnPattern:
          "arn:${Partition}:groundstation:${Region}:${Account}:config/${ConfigType}/${ConfigId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "groundstation:ConfigId",
          "groundstation:ConfigType",
        ],
      },
      {
        name: "Contact",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_ContactData.html",
        arnPattern:
          "arn:${Partition}:groundstation:${Region}:${Account}:contact/${ContactId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "groundstation:ContactId"],
      },
      {
        name: "DataflowEndpointGroup",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_DataflowEndpoint.html",
        arnPattern:
          "arn:${Partition}:groundstation:${Region}:${Account}:dataflow-endpoint-group/${DataflowEndpointGroupId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "groundstation:DataflowEndpointGroupId",
        ],
      },
      {
        name: "EphemerisItem",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_EphemerisItem.html",
        arnPattern:
          "arn:${Partition}:groundstation:${Region}:${Account}:ephemeris/${EphemerisId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "groundstation:EphemerisId",
        ],
      },
      {
        name: "GroundStationResource",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_GroundStationData.html",
        arnPattern:
          "arn:${Partition}:groundstation:${Region}:${Account}:groundstation:${GroundStationId}",
        conditionKeys: ["groundstation:GroundStationId"],
      },
      {
        name: "MissionProfile",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_MissionProfileListItem.html",
        arnPattern:
          "arn:${Partition}:groundstation:${Region}:${Account}:mission-profile/${MissionProfileId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "groundstation:MissionProfileId",
        ],
      },
      {
        name: "Satellite",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_SatelliteListItem.html",
        arnPattern:
          "arn:${Partition}:groundstation:${Region}:${Account}:satellite/${SatelliteId}",
        conditionKeys: ["groundstation:SatelliteId"],
      },
      {
        name: "Agent",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_AgentDetails.html",
        arnPattern:
          "arn:${Partition}:groundstation:${Region}:${Account}:agent/${AgentId}",
        conditionKeys: ["groundstation:AgentId"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "groundstation:AgentId",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_RegisterAgent.html#groundstation-RegisterAgent-response-agentId",
        description: "Filters access by the ID of an agent",
        type: "String",
      },
      {
        name: "groundstation:ConfigId",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_CreateConfig.html#groundstation-CreateConfig-response-configId",
        description: "Filters access by the ID of a config",
        type: "String",
      },
      {
        name: "groundstation:ConfigType",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_CreateConfig.html#groundstation-CreateConfig-response-configType",
        description: "Filters access by the type of a config",
        type: "String",
      },
      {
        name: "groundstation:ContactId",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_ReserveContact.html#groundstation-ReserveContact-response-contactId",
        description: "Filters access by the ID of a contact",
        type: "String",
      },
      {
        name: "groundstation:DataflowEndpointGroupId",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_CreateDataflowEndpointGroup.html#groundstation-CreateDataflowEndpointGroup-response-dataflowEndpointGroupId",
        description: "Filters access by the ID of a dataflow endpoint group",
        type: "String",
      },
      {
        name: "groundstation:EphemerisId",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_CreateEphemeris.html#groundstation-CreateEphemeris-response-ephemerisId",
        description: "Filters access by the ID of an ephemeris",
        type: "String",
      },
      {
        name: "groundstation:GroundStationId",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_GroundStationData.html#groundstation-Type-GroundStationData-groundStationId",
        description: "Filters access by the ID of a ground station",
        type: "String",
      },
      {
        name: "groundstation:MissionProfileId",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_CreateMissionProfile.html#groundstation-CreateMissionProfile-response-missionProfileId",
        description: "Filters access by the ID of a mission profile",
        type: "String",
      },
      {
        name: "groundstation:SatelliteId",
        referenceHref:
          "https://docs.aws.amazon.com/ground-station/latest/APIReference/API_SatelliteListItem.html#groundstation-Type-SatelliteListItem-satelliteId",
        description: "Filters access by the ID of a satellite",
        type: "String",
      },
    ],
  },
  groundtruthlabeling: {
    name: "Amazon GroundTruth Labeling",
    servicePrefix: "groundtruthlabeling",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazongroundtruthlabeling.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/sagemaker/latest/dg/sms-data-input.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  guardduty: {
    name: "Amazon GuardDuty",
    servicePrefix: "guardduty",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonguardduty.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/guardduty/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "detector",
        referenceHref:
          "https://docs.aws.amazon.com/guardduty/latest/ug/guardduty_managing_access.html#guardduty-resources",
        arnPattern:
          "arn:${Partition}:guardduty:${Region}:${Account}:detector/${DetectorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "filter",
        referenceHref:
          "https://docs.aws.amazon.com/guardduty/latest/ug/guardduty_managing_access.html#guardduty-resources",
        arnPattern:
          "arn:${Partition}:guardduty:${Region}:${Account}:detector/${DetectorId}/filter/${FilterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ipset",
        referenceHref:
          "https://docs.aws.amazon.com/guardduty/latest/ug/guardduty_managing_access.html#guardduty-resources",
        arnPattern:
          "arn:${Partition}:guardduty:${Region}:${Account}:detector/${DetectorId}/ipset/${IPSetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "threatintelset",
        referenceHref:
          "https://docs.aws.amazon.com/guardduty/latest/ug/guardduty_managing_access.html#guardduty-resources",
        arnPattern:
          "arn:${Partition}:guardduty:${Region}:${Account}:detector/${DetectorId}/threatintelset/${ThreatIntelSetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "publishingDestination",
        referenceHref:
          "https://docs.aws.amazon.com/guardduty/latest/ug/guardduty_managing_access.html#guardduty-resources",
        arnPattern:
          "arn:${Partition}:guardduty:${Region}:${Account}:detector/${DetectorId}/publishingDestination/${PublishingDestinationId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  health: {
    name: "AWS Health APIs and Notifications",
    servicePrefix: "health",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awshealthapisandnotifications.html",
    apiReferenceHref: "https://docs.aws.amazon.com/health/latest/APIReference/",
    resourceTypes: [
      {
        name: "event",
        referenceHref:
          "https://docs.aws.amazon.com/health/latest/ug/supported-operations.html",
        arnPattern:
          "arn:${Partition}:health:*::event/${Service}/${EventTypeCode}/*",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "health:eventTypeCode",
        referenceHref:
          "https://docs.aws.amazon.com/health/latest/ug/controlling-access.html",
        description: "Filters access by event type",
        type: "String",
      },
      {
        name: "health:service",
        referenceHref:
          "https://docs.aws.amazon.com/health/latest/ug/controlling-access.html",
        description: "Filters access by impacted service",
        type: "String",
      },
    ],
  },
  "medical-imaging": {
    name: "AWS HealthImaging",
    servicePrefix: "medical-imaging",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awshealthimaging.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/healthimaging/latest/APIReference/",
    resourceTypes: [
      {
        name: "datastore",
        referenceHref:
          "https://docs.aws.amazon.com/healthimaging/latest/devguide/API_DatastoreProperties.html",
        arnPattern:
          "arn:${Partition}:medical-imaging:${Region}:${Account}:datastore/${DatastoreId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "imageset",
        referenceHref:
          "https://docs.aws.amazon.com/healthimaging/latest/devguide/API_ImageSetProperties.html",
        arnPattern:
          "arn:${Partition}:medical-imaging:${Region}:${Account}:datastore/${DatastoreId}/imageset/${ImageSetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  healthlake: {
    name: "AWS HealthLake",
    servicePrefix: "healthlake",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awshealthlake.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/healthlake/latest/APIReference/",
    resourceTypes: [
      {
        name: "datastore",
        referenceHref:
          "https://docs.aws.amazon.com/healthlake/latest/APIReference/API_DatastoreProperties.html",
        arnPattern:
          "arn:${Partition}:healthlake:${Region}:${Account}:datastore/fhir/${DatastoreId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  omics: {
    name: "AWS HealthOmics",
    servicePrefix: "omics",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awshealthomics.html",
    apiReferenceHref: "https://docs.aws.amazon.com/omics/latest/api/",
    resourceTypes: [
      {
        name: "AnnotationImportJob",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_AnnotationImportJobItem.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:annotationImportJob/${AnnotationImportJobId}",
        conditionKeys: ["omics:AnnotationImportJobJobId"],
      },
      {
        name: "AnnotationStore",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_AnnotationStoreItem.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:annotationStore/${AnnotationStoreId}",
        conditionKeys: ["omics:AnnotationStoreName"],
      },
      {
        name: "AnnotationStoreVersion",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_AnnotationStoreVersionItem.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:annotationStore/${AnnotationStoreName}/version/${AnnotationStoreVersionName}",
        conditionKeys: ["omics:AnnotationStoreVersionName"],
      },
      {
        name: "readSet",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_ReadSetFiles.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:sequenceStore/${SequenceStoreId}/readSet/${ReadSetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "reference",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_ReferenceFiles.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:referenceStore/${ReferenceStoreId}/reference/${ReferenceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "referenceStore",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_ReferenceStoreDetail.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:referenceStore/${ReferenceStoreId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "run",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_RunListItem.html",
        arnPattern: "arn:${Partition}:omics:${Region}:${Account}:run/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "runGroup",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_RunGroupListItem.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:runGroup/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "sequenceStore",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_SequenceStoreDetail.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:sequenceStore/${SequenceStoreId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "TaggingResource",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_TagResource.html",
        arnPattern: "arn:${Partition}:omics:${Region}:${Account}:tag/${TagKey}",
        conditionKeys: [],
      },
      {
        name: "TaskResource",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_TaskListItem.html",
        arnPattern: "arn:${Partition}:omics:${Region}:${Account}:task/${Id}",
        conditionKeys: [],
      },
      {
        name: "VariantImportJob",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_VariantImportJobItem.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:variantImportJob/${VariantImportJobId}",
        conditionKeys: ["omics:VariantImportJobJobId"],
      },
      {
        name: "VariantStore",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_VariantStoreItem.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:variantStore/${VariantStoreId}",
        conditionKeys: ["omics:VariantStoreName"],
      },
      {
        name: "workflow",
        referenceHref:
          "https://docs.aws.amazon.com/omics/latest/api/API_WorkflowListItem.html",
        arnPattern:
          "arn:${Partition}:omics:${Region}:${Account}:workflow/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "omics:AnnotationImportJobJobId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-annotation-import-job-id",
        description: "Filters access by a unique resource identifier",
        type: "String",
      },
      {
        name: "omics:AnnotationStoreName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-annotation-store-name",
        description: "Filters access by the name of the store",
        type: "String",
      },
      {
        name: "omics:AnnotationStoreVersionName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-annotation-store-version-name",
        description:
          "Filters access by the name of the annotation store version",
        type: "String",
      },
      {
        name: "omics:VariantImportJobJobId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-variant-import-job-id",
        description: "Filters access by a unique resource identifier",
        type: "String",
      },
      {
        name: "omics:VariantStoreName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-variant-store-name",
        description: "Filters access by the name of the store",
        type: "String",
      },
    ],
  },
  "connect-campaigns": {
    name: "High-volume outbound communications",
    servicePrefix: "connect-campaigns",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_high-volumeoutboundcommunications.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/connect/latest/adminguide/enable-high-volume-outbound-communications.html",
    resourceTypes: [
      {
        name: "campaign",
        referenceHref:
          "https://docs.aws.amazon.com/connect/latest/adminguide/enable-high-volume-outbound-communications.html",
        arnPattern:
          "arn:${Partition}:connect-campaigns:${Region}:${Account}:campaign/${CampaignId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  honeycode: {
    name: "Amazon Honeycode",
    servicePrefix: "honeycode",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonhoneycode.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/honeycode/latest/APIReference/",
    resourceTypes: [
      {
        name: "workbook",
        referenceHref:
          "https://docs.aws.amazon.com/honeycode/latest/UserGuide/resource-workbook.html",
        arnPattern:
          "arn:${Partition}:honeycode:${Region}:${Account}:workbook:workbook/${WorkbookId}",
        conditionKeys: [],
      },
      {
        name: "table",
        referenceHref:
          "https://docs.aws.amazon.com/honeycode/latest/UserGuide/resource-table.html",
        arnPattern:
          "arn:${Partition}:honeycode:${Region}:${Account}:table:workbook/${WorkbookId}/table/${TableId}",
        conditionKeys: [],
      },
      {
        name: "screen",
        referenceHref:
          "https://docs.aws.amazon.com/honeycode/latest/UserGuide/resource-screen.html",
        arnPattern:
          "arn:${Partition}:honeycode:${Region}:${Account}:screen:workbook/${WorkbookId}/app/${AppId}/screen/${ScreenId}",
        conditionKeys: [],
      },
      {
        name: "screen-automation",
        referenceHref:
          "https://docs.aws.amazon.com/honeycode/latest/UserGuide/resource-screen-automation.html",
        arnPattern:
          "arn:${Partition}:honeycode:${Region}:${Account}:screen-automation:workbook/${WorkbookId}/app/${AppId}/screen/${ScreenId}/automation/${AutomationId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  "access-analyzer": {
    name: "AWS IAM Access Analyzer",
    servicePrefix: "access-analyzer",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiamaccessanalyzer.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/access-analyzer/latest/APIReference/",
    resourceTypes: [
      {
        name: "Analyzer",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/access-analyzer-getting-started.html#permission-resources",
        arnPattern:
          "arn:${Partition}:access-analyzer:${Region}:${Account}:analyzer/${AnalyzerName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ArchiveRule",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/access-analyzer-getting-started.html#permission-resources",
        arnPattern:
          "arn:${Partition}:access-analyzer:${Region}:${Account}:analyzer/${AnalyzerName}/archive-rule/${RuleName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  sso: {
    name: "AWS IAM Identity Center (successor to AWS Single Sign-On)",
    servicePrefix: "sso",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiamidentitycentersuccessortoawssinglesign-on.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/singlesignon/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "PermissionSet",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/permissionsetsconcept.html",
        arnPattern:
          "arn:${Partition}:sso:::permissionSet/${InstanceId}/${PermissionSetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Account",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/manage-your-accounts.html",
        arnPattern: "arn:${Partition}:sso:::account/${AccountId}",
        conditionKeys: [],
      },
      {
        name: "Instance",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/APIReference/API_InstanceMetadata.html",
        arnPattern: "arn:${Partition}:sso:::instance/${InstanceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Application",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/APIReference/API_Application.html",
        arnPattern:
          "arn:${Partition}:sso::${AccountId}:application/${InstanceId}/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "sso:ApplicationAccount"],
      },
      {
        name: "TrustedTokenIssuer",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/APIReference/API_TrustedTokenIssuerMetadata.html",
        arnPattern:
          "arn:${Partition}:sso::${AccountId}:trustedTokenIssuer/${InstanceId}/${TrustedTokenIssuerId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ApplicationProvider",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/APIReference/API_ApplicationProvider.html",
        arnPattern:
          "arn:${Partition}:sso::aws:applicationProvider/${ApplicationProviderId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/tagging.html",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/tagging.html",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/tagging.html",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "sso:ApplicationAccount",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/API_Application.html",
        description:
          "Filters access by the account which creates the application",
        type: "String",
      },
    ],
  },
  "sso-directory": {
    name: "AWS IAM Identity Center (successor to AWS Single Sign-On) directory",
    servicePrefix: "sso-directory",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiamidentitycentersuccessortoawssinglesign-ondirectory.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/singlesignon/latest/userguide/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "sso-oauth": {
    name: "AWS IAM Identity Center OIDC service",
    servicePrefix: "sso-oauth",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiamidentitycenteroidcservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/singlesignon/latest/OIDCAPIReference/",
    resourceTypes: [
      {
        name: "Application",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/get-started-enable-identity-center.html",
        arnPattern:
          "arn:${Partition}:sso::${AccountId}:application/${InstanceId}/${ApplicationId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  iam: {
    name: "AWS Identity and Access Management (IAM)",
    servicePrefix: "iam",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsidentityandaccessmanagementiam.html",
    apiReferenceHref: "https://docs.aws.amazon.com/IAM/latest/APIReference/",
    resourceTypes: [
      {
        name: "access-report",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/access_policies_access-advisor-view-data-orgs.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:access-report/${EntityPath}",
        conditionKeys: [],
      },
      {
        name: "assumed-role",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_temp_use-resources.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:assumed-role/${RoleName}/${RoleSessionName}",
        conditionKeys: [],
      },
      {
        name: "federated-user",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_providers_saml.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:federated-user/${UserName}",
        conditionKeys: [],
      },
      {
        name: "group",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_groups.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:group/${GroupNameWithPath}",
        conditionKeys: [],
      },
      {
        name: "instance-profile",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_use_switch-role-ec2_instance-profiles.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:instance-profile/${InstanceProfileNameWithPath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "mfa",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_mfa.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:mfa/${MfaTokenIdWithPath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "oidc-provider",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_providers_create_oidc.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:oidc-provider/${OidcProviderName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "policy",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/access_policies_managed-vs-inline.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:policy/${PolicyNameWithPath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "role",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles.html",
        arnPattern: "arn:${Partition}:iam::${Account}:role/${RoleNameWithPath}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "iam:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "saml-provider",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_providers_saml.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:saml-provider/${SamlProviderName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "server-certificate",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_server-certs.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:server-certificate/${CertificateNameWithPath}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "sms-mfa",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_mfa.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:sms-mfa/${MfaTokenIdWithPath}",
        conditionKeys: [],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_users.html",
        arnPattern: "arn:${Partition}:iam::${Account}:user/${UserNameWithPath}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "iam:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "iam:AWSServiceName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_AWSServiceName",
        description:
          "Filters access by the AWS service to which this role is attached",
        type: "String",
      },
      {
        name: "iam:AssociatedResourceArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_AssociatedResourceArn",
        description:
          "Filters access by the resource that the role will be used on behalf of",
        type: "ARN",
      },
      {
        name: "iam:FIDO-FIPS-140-2-certification",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_FIDO-FIPS-140-2-certification",
        description:
          "Filters access by the MFA device FIPS-140-2 validation certification level at the time of registration of a FIDO security key",
        type: "String",
      },
      {
        name: "iam:FIDO-FIPS-140-3-certification",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_FIDO-FIPS-140-3-certification",
        description:
          "Filters access by the MFA device FIPS-140-3 validation certification level at the time of registration of a FIDO security key",
        type: "String",
      },
      {
        name: "iam:FIDO-certification",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_FIDO-certification",
        description:
          "Filters access by the MFA device FIDO certification level at the time of registration of a FIDO security key",
        type: "String",
      },
      {
        name: "iam:OrganizationsPolicyId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_OrganizationsPolicyId",
        description: "Filters access by the ID of an AWS Organizations policy",
        type: "String",
      },
      {
        name: "iam:PassedToService",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_PassedToService",
        description:
          "Filters access by the AWS service to which this role is passed",
        type: "String",
      },
      {
        name: "iam:PermissionsBoundary",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_PermissionsBoundary",
        description:
          "Filters access if the specified policy is set as the permissions boundary on the IAM entity (user or role)",
        type: "ARN",
      },
      {
        name: "iam:PolicyARN",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_PolicyARN",
        description: "Filters access by the ARN of an IAM policy",
        type: "ARN",
      },
      {
        name: "iam:RegisterSecurityKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_RegisterSecurityKey",
        description:
          "Filters access by the current state of MFA device enablement",
        type: "String",
      },
      {
        name: "iam:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_ResourceTag",
        description:
          "Filters access by the tags attached to an IAM entity (user or role)",
        type: "String",
      },
    ],
  },
  rolesanywhere: {
    name: "AWS Identity and Access Management Roles Anywhere",
    servicePrefix: "rolesanywhere",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsidentityandaccessmanagementrolesanywhere.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/rolesanywhere/latest/APIReference/",
    resourceTypes: [
      {
        name: "trust-anchor",
        referenceHref:
          "https://docs.aws.amazon.com/rolesanywhere/latest/userguide/introduction.html#first-time-user",
        arnPattern:
          "arn:${Partition}:rolesanywhere:${Region}:${Account}:trust-anchor/${TrustAnchorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "profile",
        referenceHref:
          "https://docs.aws.amazon.com/rolesanywhere/latest/userguide/introduction.html#first-time-user",
        arnPattern:
          "arn:${Partition}:rolesanywhere:${Region}:${Account}:profile/${ProfileId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "subject",
        referenceHref:
          "https://docs.aws.amazon.com/rolesanywhere/latest/userguide/introduction.html#first-time-user",
        arnPattern:
          "arn:${Partition}:rolesanywhere:${Region}:${Account}:subject/${SubjectId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "crl",
        referenceHref:
          "https://docs.aws.amazon.com/rolesanywhere/latest/userguide/introduction.html#first-time-user",
        arnPattern:
          "arn:${Partition}:rolesanywhere:${Region}:${Account}:crl/${CrlId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  identitystore: {
    name: "AWS Identity Store",
    servicePrefix: "identitystore",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsidentitystore.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/singlesignon/latest/IdentityStoreAPIReference/Welcome.html",
    resourceTypes: [
      {
        name: "Identitystore",
        referenceHref: "https://docs.aws.amazon.com/singlesignon/latest/",
        arnPattern:
          "arn:${Partition}:identitystore::${Account}:identitystore/${IdentityStoreId}",
        conditionKeys: [],
      },
      {
        name: "User",
        referenceHref: "https://docs.aws.amazon.com/singlesignon/latest/",
        arnPattern: "arn:${Partition}:identitystore:::user/${UserId}",
        conditionKeys: [],
      },
      {
        name: "Group",
        referenceHref: "https://docs.aws.amazon.com/singlesignon/latest/",
        arnPattern: "arn:${Partition}:identitystore:::group/${GroupId}",
        conditionKeys: [],
      },
      {
        name: "GroupMembership",
        referenceHref: "https://docs.aws.amazon.com/singlesignon/latest/",
        arnPattern:
          "arn:${Partition}:identitystore:::membership/${MembershipId}",
        conditionKeys: [],
      },
      {
        name: "AllUsers",
        referenceHref: "https://docs.aws.amazon.com/singlesignon/latest/",
        arnPattern: "arn:${Partition}:identitystore:::user/*",
        conditionKeys: [],
      },
      {
        name: "AllGroups",
        referenceHref: "https://docs.aws.amazon.com/singlesignon/latest/",
        arnPattern: "arn:${Partition}:identitystore:::group/*",
        conditionKeys: [],
      },
      {
        name: "AllGroupMemberships",
        referenceHref: "https://docs.aws.amazon.com/singlesignon/latest/",
        arnPattern: "arn:${Partition}:identitystore:::membership/*",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "identitystore:UserId",
        referenceHref: "https://docs.aws.amazon.com/singlesignon/latest/",
        description: "Filters access by IAM Identity Center User ID",
        type: "String",
      },
    ],
  },
  "identitystore-auth": {
    name: "AWS Identity Store Auth",
    servicePrefix: "identitystore-auth",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsidentitystoreauth.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/singlesignon/latest/userguide/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "identity-sync": {
    name: "AWS Identity Sync",
    servicePrefix: "identity-sync",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsidentitysync.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/singlesignon/latest/userguide/",
    resourceTypes: [
      {
        name: "SyncProfileResource",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/security-iam-awsmanpol.html",
        arnPattern:
          "arn:${Partition}:identity-sync:${Region}:${Account}:profile/${SyncProfileName}",
        conditionKeys: [],
      },
      {
        name: "SyncTargetResource",
        referenceHref:
          "https://docs.aws.amazon.com/singlesignon/latest/userguide/security-iam-awsmanpol.html",
        arnPattern:
          "arn:${Partition}:identity-sync:${Region}:${Account}:target/${SyncProfileName}/${SyncTargetName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  importexport: {
    name: "AWS Import Export Disk Service",
    servicePrefix: "importexport",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsimportexportdiskservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AWSImportExport/latest/DG/api-reference.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  inspector: {
    name: "Amazon Inspector",
    servicePrefix: "inspector",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoninspector.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/inspector/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  inspector2: {
    name: "Amazon Inspector2",
    servicePrefix: "inspector2",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoninspector2.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/inspector/v2/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "Filter",
        referenceHref:
          "https://docs.aws.amazon.com/inspector/latest/user/what-is-inspector.html",
        arnPattern:
          "arn:${Partition}:inspector2:${Region}:${Account}:owner/${OwnerId}/filter/${FilterId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Finding",
        referenceHref:
          "https://docs.aws.amazon.com/inspector/latest/user/what-is-inspector.html",
        arnPattern:
          "arn:${Partition}:inspector2:${Region}:${Account}:finding/${FindingId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "inspector-scan": {
    name: "Amazon InspectorScan",
    servicePrefix: "inspector-scan",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoninspectorscan.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/inspector/v2/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  ivs: {
    name: "Amazon Interactive Video Service",
    servicePrefix: "ivs",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoninteractivevideoservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/ivs/latest/LowLatencyAPIReference/Welcome.html",
    resourceTypes: [
      {
        name: "Channel",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/LowLatencyAPIReference/API_Channel.html",
        arnPattern:
          "arn:${Partition}:ivs:${Region}:${Account}:channel/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Stream-Key",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/LowLatencyAPIReference/API_StreamKey.html",
        arnPattern:
          "arn:${Partition}:ivs:${Region}:${Account}:stream-key/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Playback-Key-Pair",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/LowLatencyAPIReference/API_PlaybackKeyPair.html",
        arnPattern:
          "arn:${Partition}:ivs:${Region}:${Account}:playback-key/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Recording-Configuration",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/LowLatencyAPIReference/API_RecordingConfiguration.html",
        arnPattern:
          "arn:${Partition}:ivs:${Region}:${Account}:recording-configuration/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Stage",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/RealTimeAPIReference/API_Stage.html",
        arnPattern:
          "arn:${Partition}:ivs:${Region}:${Account}:stage/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Composition",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/RealTimeAPIReference/API_Composition.html",
        arnPattern:
          "arn:${Partition}:ivs:${Region}:${Account}:composition/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Encoder-Configuration",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/RealTimeAPIReference/API_EncoderConfiguration.html",
        arnPattern:
          "arn:${Partition}:ivs:${Region}:${Account}:encoder-configuration/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Storage-Configuration",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/RealTimeAPIReference/API_StorageConfiguration.html",
        arnPattern:
          "arn:${Partition}:ivs:${Region}:${Account}:storage-configuration/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tags associated with the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  ivschat: {
    name: "Amazon Interactive Video Service Chat",
    servicePrefix: "ivschat",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazoninteractivevideoservicechat.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/ivs/latest/ChatAPIReference/Welcome.html",
    resourceTypes: [
      {
        name: "Room",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/ChatAPIReference/API_Room.html",
        arnPattern:
          "arn:${Partition}:ivschat:${Region}:${Account}:room/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Logging-Configuration",
        referenceHref:
          "https://docs.aws.amazon.com/ivs/latest/ChatAPIReference/API_LoggingConfiguration.html",
        arnPattern:
          "arn:${Partition}:ivschat:${Region}:${Account}:logging-configuration/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tags associated with the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  invoicing: {
    name: "AWS Invoicing Service",
    servicePrefix: "invoicing",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsinvoicingservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/billing-permissions-ref.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  iot: {
    name: "AWS IoT",
    servicePrefix: "iot",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiot.html",
    apiReferenceHref: "https://docs.aws.amazon.com/iot/latest/apireference/",
    resourceTypes: [
      {
        name: "client",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/iot-message-broker.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:client/${ClientId}",
        conditionKeys: [],
      },
      {
        name: "index",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/iot-indexing.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:index/${IndexName}",
        conditionKeys: [],
      },
      {
        name: "fleetmetric",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/iot-indexing.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:fleetmetric/${FleetMetricName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "job",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/iot-jobs.html",
        arnPattern: "arn:${Partition}:iot:${Region}:${Account}:job/${JobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "jobtemplate",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/job-templates.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:jobtemplate/${JobTemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "tunnel",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/iot-tunnels.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:tunnel/${TunnelId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "thing",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/thing-registry.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:thing/${ThingName}",
        conditionKeys: [],
      },
      {
        name: "thinggroup",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/thing-groups.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:thinggroup/${ThingGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "billinggroup",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/billing-groups.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:billinggroup/${BillingGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dynamicthinggroup",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/dynamic-thing-groups.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:thinggroup/${ThingGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "thingtype",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/thing-types.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:thingtype/${ThingTypeName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "topic",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/iot-message-broker.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:topic/${TopicName}",
        conditionKeys: [],
      },
      {
        name: "topicfilter",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/topics.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:topicfilter/${TopicFilter}",
        conditionKeys: [],
      },
      {
        name: "rolealias",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/authorizing-direct-aws.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:rolealias/${RoleAlias}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "authorizer",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/custom-authorizer.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:authorizer/${AuthorizerName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "policy",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/iot-policies.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:policy/${PolicyName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "cert",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/x509-certs.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:cert/${Certificate}",
        conditionKeys: [],
      },
      {
        name: "cacert",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/x509-certs.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:cacert/${CACertificate}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "stream",
        referenceHref:
          "https://docs.aws.amazon.com/freertos/latest/userguide/freertos-ota-dev.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:stream/${StreamId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "otaupdate",
        referenceHref:
          "https://docs.aws.amazon.com/freertos/latest/userguide/freertos-ota-dev.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:otaupdate/${OtaUpdateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "scheduledaudit",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/device-defender-audit.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:scheduledaudit/${ScheduleName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "mitigationaction",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/device-defender-mitigation-actions.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:mitigationaction/${MitigationActionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "securityprofile",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/device-defender-detect.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:securityprofile/${SecurityProfileName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "custommetric",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/device-defender-detect.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:custommetric/${MetricName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dimension",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/device-defender-detect.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:dimension/${DimensionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "rule",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/iot-rules.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:rule/${RuleName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "destination",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/rule-destination.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:destination/${DestinationType}/${Uuid}",
        conditionKeys: [],
      },
      {
        name: "provisioningtemplate",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/provision-template.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:provisioningtemplate/${ProvisioningTemplate}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "domainconfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/domain-configuration.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:domainconfiguration/${DomainConfigurationName}/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "package",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/software-package-catalog.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:package/${PackageName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "packageversion",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/software-package-catalog.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:package/${PackageName}/version/${VersionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "certificateprovider",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/provisioning-cert-provider.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:certificateprovider/${CertificateProviderName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html",
        description:
          "Filters access by a tag key that is present in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html",
        description:
          "Filters access by a tag key component of a tag associated to the IoT resource in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html",
        description:
          "Filters access by a list of tag keys associated to the IoT resource in the request",
        type: "ArrayOfString",
      },
      {
        name: "iot:ClientMode",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiot.html",
        description: "Filters access by the mode of the client for IoT Tunnel",
        type: "String",
      },
      {
        name: "iot:Delete",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiot.html",
        description:
          "Filters access by a flag indicating whether or not to also delete an IoT Tunnel immediately when making iot:CloseTunnel request",
        type: "Bool",
      },
      {
        name: "iot:DomainName",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiot.html",
        description:
          "Filters access by based on the domain name of an IoT DomainConfiguration",
        type: "String",
      },
      {
        name: "iot:ThingGroupArn",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiot.html",
        description:
          "Filters access by a list of IoT Thing Group ARNs that the destination IoT Thing belongs to for an IoT Tunnel",
        type: "ArrayOfARN",
      },
      {
        name: "iot:TunnelDestinationService",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiot.html",
        description:
          "Filters access by a list of destination services for an IoT Tunnel",
        type: "ArrayOfString",
      },
    ],
  },
  iot1click: {
    name: "AWS IoT 1-Click",
    servicePrefix: "iot1click",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiot1-click.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iot-1-click/latest/projects-apireference/",
    resourceTypes: [
      {
        name: "device",
        referenceHref:
          "https://docs.aws.amazon.com/iot-1-click/1.0/devices-apireference/resources.html",
        arnPattern:
          "arn:${Partition}:iot1click:${Region}:${Account}:devices/${DeviceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/iot-1-click/latest/projects-apireference/API_Operations.html",
        arnPattern:
          "arn:${Partition}:iot1click:${Region}:${Account}:projects/${ProjectName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  iotanalytics: {
    name: "AWS IoT Analytics",
    servicePrefix: "iotanalytics",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotanalytics.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iotanalytics/latest/APIReference/",
    resourceTypes: [
      {
        name: "channel",
        referenceHref:
          "https://docs.aws.amazon.com/iotanalytics/latest/userguide/welcome.html#aws-iot-analytics-how",
        arnPattern:
          "arn:${Partition}:iotanalytics:${Region}:${Account}:channel/${ChannelName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:TagKeys",
          "iotanalytics:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "dataset",
        referenceHref:
          "https://docs.aws.amazon.com/iotanalytics/latest/userguide/welcome.html#aws-iot-analytics-how",
        arnPattern:
          "arn:${Partition}:iotanalytics:${Region}:${Account}:dataset/${DatasetName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:TagKeys",
          "iotanalytics:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "datastore",
        referenceHref:
          "https://docs.aws.amazon.com/iotanalytics/latest/userguide/welcome.html#aws-iot-analytics-how",
        arnPattern:
          "arn:${Partition}:iotanalytics:${Region}:${Account}:datastore/${DatastoreName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:TagKeys",
          "iotanalytics:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "pipeline",
        referenceHref:
          "https://docs.aws.amazon.com/iotanalytics/latest/userguide/welcome.html#aws-iot-analytics-how",
        arnPattern:
          "arn:${Partition}:iotanalytics:${Region}:${Account}:pipeline/${PipelineName}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:TagKeys",
          "iotanalytics:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "iotanalytics:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/iotanalytics/latest/userguide/tagging.html#tagging-iam",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
    ],
  },
  iotdeviceadvisor: {
    name: "AWS IoT Core Device Advisor",
    servicePrefix: "iotdeviceadvisor",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotcoredeviceadvisor.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iot/latest/apireference/API_Operations_AWS_IoT_Core_Device_Advisor.html",
    resourceTypes: [
      {
        name: "Suitedefinition",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/device-advisor-workflow.html#device-advisor-workflow-create-suite-definition",
        arnPattern:
          "arn:${Partition}:iotdeviceadvisor:${Region}:${Account}:suitedefinition/${SuiteDefinitionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Suiterun",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/device-advisor-workflow.html#device-advisor-workflow-start-suite-run",
        arnPattern:
          "arn:${Partition}:iotdeviceadvisor:${Region}:${Account}:suiterun/${SuiteDefinitionId}/${SuiteRunId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "iot-device-tester": {
    name: "AWS IoT Device Tester",
    servicePrefix: "iot-device-tester",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotdevicetester.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/freertos/latest/userguide/dev-tester-prereqs.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  iotevents: {
    name: "AWS IoT Events",
    servicePrefix: "iotevents",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotevents.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iotevents/latest/apireference/",
    resourceTypes: [
      {
        name: "detectorModel",
        referenceHref:
          "https://docs.aws.amazon.com/iotevents/latest/developerguide/iotevents-getting-started.html",
        arnPattern:
          "arn:${Partition}:iotevents:${Region}:${Account}:detectorModel/${DetectorModelName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "alarmModel",
        referenceHref:
          "https://docs.aws.amazon.com/iotevents/latest/developerguide/iotevents-getting-started.html",
        arnPattern:
          "arn:${Partition}:iotevents:${Region}:${Account}:alarmModel/${AlarmModelName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "input",
        referenceHref:
          "https://docs.aws.amazon.com/iotevents/latest/developerguide/iotevents-getting-started.html",
        arnPattern:
          "arn:${Partition}:iotevents:${Region}:${Account}:input/${InputName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters actions by the tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "iotevents:keyValue",
        referenceHref:
          "https://docs.aws.amazon.com/iotevents/latest/developerguide/security_iam_id-based-policy-examples.htmlsecurity_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the instanceId (key-value) of the message",
        type: "String",
      },
    ],
  },
  iotfleethub: {
    name: "AWS IoT Fleet Hub for Device Management",
    servicePrefix: "iotfleethub",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotfleethubfordevicemanagement.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iot/latest/apireference/API_Operations_AWS_IoT_Fleet_Hub.html",
    resourceTypes: [
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/apireference/API_iotfleethub_ApplicationSummary.html",
        arnPattern:
          "arn:${Partition}:iotfleethub:${Region}:${Account}:application/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters actions by the tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  iotfleetwise: {
    name: "AWS IoT FleetWise",
    servicePrefix: "iotfleetwise",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotfleetwise.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iot-fleetwise/latest/APIReference/",
    resourceTypes: [
      {
        name: "campaign",
        referenceHref:
          "https://docs.aws.amazon.com/iot-fleetwise/latest/developerguide/campaigns.html",
        arnPattern:
          "arn:${Partition}:iotfleetwise:${Region}:${Account}:campaign/${CampaignName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "decodermanifest",
        referenceHref:
          "https://docs.aws.amazon.com/iot-fleetwise/latest/developerguide/decoder-manifests.html",
        arnPattern:
          "arn:${Partition}:iotfleetwise:${Region}:${Account}:decoder-manifest/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "fleet",
        referenceHref:
          "https://docs.aws.amazon.com/iot-fleetwise/latest/developerguide/fleets.html",
        arnPattern:
          "arn:${Partition}:iotfleetwise:${Region}:${Account}:fleet/${FleetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "modelmanifest",
        referenceHref:
          "https://docs.aws.amazon.com/iot-fleetwise/latest/developerguide/vehicle-models.html",
        arnPattern:
          "arn:${Partition}:iotfleetwise:${Region}:${Account}:model-manifest/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "signalcatalog",
        referenceHref:
          "https://docs.aws.amazon.com/iot-fleetwise/latest/developerguide/signal-catalogs.html",
        arnPattern:
          "arn:${Partition}:iotfleetwise:${Region}:${Account}:signal-catalog/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vehicle",
        referenceHref:
          "https://docs.aws.amazon.com/iot-fleetwise/latest/developerguide/vehicles.html",
        arnPattern:
          "arn:${Partition}:iotfleetwise:${Region}:${Account}:vehicle/${VehicleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "iotfleetwise:DestinationArn",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotfleetwise.html",
        description:
          "Filters access by campaign destination ARN, eg. an S3 bucket ARN or a Timestream ARN",
        type: "ARN",
      },
      {
        name: "iotfleetwise:UpdateToDecoderManifestArn",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotfleetwise.html",
        description:
          "Filters access by a list of IoT FleetWise Decoder Manifest ARNs",
        type: "ARN",
      },
      {
        name: "iotfleetwise:UpdateToModelManifestArn",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotfleetwise.html",
        description:
          "Filters access by a list of IoT FleetWise Model Manifest ARNs",
        type: "ARN",
      },
    ],
  },
  greengrass: {
    name: "AWS IoT Greengrass V2",
    servicePrefix: "greengrass",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotgreengrassv2.html",
    apiReferenceHref: "https://docs.aws.amazon.com/greengrass/v2/APIReference/",
    resourceTypes: [
      {
        name: "connectivityInfo",
        referenceHref:
          "https://docs.aws.amazon.com/greengrass/v2/APIReference/API_ConnectivityInfo.html",
        arnPattern:
          "arn:${Partition}:greengrass:${Region}:${Account}:/greengrass/things/${ThingName}/connectivityInfo",
        conditionKeys: [],
      },
      {
        name: "component",
        referenceHref:
          "https://docs.aws.amazon.com/greengrass/v2/APIReference/API_Component.html",
        arnPattern:
          "arn:${Partition}:greengrass:${Region}:${Account}:components:${ComponentName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "componentVersion",
        referenceHref:
          "https://docs.aws.amazon.com/greengrass/v2/APIReference/API_Component.html",
        arnPattern:
          "arn:${Partition}:greengrass:${Region}:${Account}:components:${ComponentName}:versions:${ComponentVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "coreDevice",
        referenceHref:
          "https://docs.aws.amazon.com/greengrass/v2/APIReference/API_CoreDevice.html",
        arnPattern:
          "arn:${Partition}:greengrass:${Region}:${Account}:coreDevices:${CoreDeviceThingName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deployment",
        referenceHref:
          "https://docs.aws.amazon.com/greengrass/v2/APIReference/API_Deployment.html",
        arnPattern:
          "arn:${Partition}:greengrass:${Region}:${Account}:deployments:${DeploymentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by checking tag key/value pairs included in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by checking tag key/value pairs associated with a specific resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by checking tag keys passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  iotjobsdata: {
    name: "AWS IoT Jobs DataPlane",
    servicePrefix: "iotjobsdata",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotjobsdataplane.html",
    apiReferenceHref: "https://docs.aws.amazon.com/iot/latest/apireference/",
    resourceTypes: [
      {
        name: "thing",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/thing-registry.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:thing/${ThingName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "iot:JobId",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiot.html",
        description:
          "Filters access by jobId for iotjobsdata:DescribeJobExecution and iotjobsdata:UpdateJobExecution APIs",
        type: "String",
      },
    ],
  },
  iotroborunner: {
    name: "AWS IoT RoboRunner",
    servicePrefix: "iotroborunner",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotroborunner.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iotroborunner/latest/api/Welcome.html",
    resourceTypes: [
      {
        name: "DestinationResource",
        referenceHref: "https://docs.aws.amazon.com/iotroborunner/latest/api/",
        arnPattern:
          "arn:${Partition}:iotroborunner:${Region}:${Account}:site/${SiteId}/destination/${DestinationId}",
        conditionKeys: ["iotroborunner:DestinationResourceId"],
      },
      {
        name: "SiteResource",
        referenceHref: "https://docs.aws.amazon.com/iotroborunner/latest/api/",
        arnPattern:
          "arn:${Partition}:iotroborunner:${Region}:${Account}:site/${SiteId}",
        conditionKeys: ["iotroborunner:SiteResourceId"],
      },
      {
        name: "WorkerFleetResource",
        referenceHref: "https://docs.aws.amazon.com/iotroborunner/latest/api/",
        arnPattern:
          "arn:${Partition}:iotroborunner:${Region}:${Account}:site/${SiteId}/worker-fleet/${WorkerFleetId}",
        conditionKeys: ["iotroborunner:WorkerFleetResourceId"],
      },
      {
        name: "WorkerResource",
        referenceHref: "https://docs.aws.amazon.com/iotroborunner/latest/api/",
        arnPattern:
          "arn:${Partition}:iotroborunner:${Region}:${Account}:site/${SiteId}/worker-fleet/${WorkerFleetId}/worker/${WorkerId}",
        conditionKeys: ["iotroborunner:WorkerResourceId"],
      },
    ],
    conditionKeys: [
      {
        name: "iotroborunner:DestinationResourceId",
        referenceHref:
          "https://docs.aws.amazon.com/iotroborunner/latest/dev/#Destination",
        description: "Filters access by the destination's identifier",
        type: "String",
      },
      {
        name: "iotroborunner:SiteResourceId",
        referenceHref:
          "https://docs.aws.amazon.com/iotroborunner/latest/dev/#Site",
        description: "Filters access by the site's identifier",
        type: "String",
      },
      {
        name: "iotroborunner:WorkerFleetResourceId",
        referenceHref:
          "https://docs.aws.amazon.com/iotroborunner/latest/dev/#WorkerFleet",
        description: "Filters access by the worker fleet's identifier",
        type: "String",
      },
      {
        name: "iotroborunner:WorkerResourceId",
        referenceHref:
          "https://docs.aws.amazon.com/iotroborunner/latest/dev/#Worker",
        description: "Filters access by the workers identifier",
        type: "String",
      },
    ],
  },
  iotsitewise: {
    name: "AWS IoT SiteWise",
    servicePrefix: "iotsitewise",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotsitewise.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/",
    resourceTypes: [
      {
        name: "asset",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/API_CreateAsset.html",
        arnPattern:
          "arn:${Partition}:iotsitewise:${Region}:${Account}:asset/${AssetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "asset-model",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/API_CreateAssetModel.html",
        arnPattern:
          "arn:${Partition}:iotsitewise:${Region}:${Account}:asset-model/${AssetModelId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "time-series",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/API_DescribeTimeSeries.html",
        arnPattern:
          "arn:${Partition}:iotsitewise:${Region}:${Account}:time-series/${TimeSeriesId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "gateway",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/API_CreateGateway.html",
        arnPattern:
          "arn:${Partition}:iotsitewise:${Region}:${Account}:gateway/${GatewayId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "portal",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/API_CreatePortal.html",
        arnPattern:
          "arn:${Partition}:iotsitewise:${Region}:${Account}:portal/${PortalId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/API_CreateProject.html",
        arnPattern:
          "arn:${Partition}:iotsitewise:${Region}:${Account}:project/${ProjectId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dashboard",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/API_CreateDashboard.html",
        arnPattern:
          "arn:${Partition}:iotsitewise:${Region}:${Account}:dashboard/${DashboardId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "access-policy",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/APIReference/API_CreateAccessPolicy.html",
        arnPattern:
          "arn:${Partition}:iotsitewise:${Region}:${Account}:access-policy/${AccessPolicyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "iotsitewise:assetHierarchyPath",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by an asset hierarchy path, which is the string of asset IDs in the asset's hierarchy, each separated by a forward slash",
        type: "String",
      },
      {
        name: "iotsitewise:childAssetId",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the ID of a child asset being associated whith a parent asset",
        type: "String",
      },
      {
        name: "iotsitewise:group",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ID of an AWS Single Sign-On group",
        type: "String",
      },
      {
        name: "iotsitewise:iam",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ID of an AWS IAM identity",
        type: "String",
      },
      {
        name: "iotsitewise:isAssociatedWithAssetProperty",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by data streams associated with or not associated with asset properties",
        type: "String",
      },
      {
        name: "iotsitewise:portal",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ID of a portal",
        type: "String",
      },
      {
        name: "iotsitewise:project",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ID of a project",
        type: "String",
      },
      {
        name: "iotsitewise:propertyAlias",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the property alias",
        type: "String",
      },
      {
        name: "iotsitewise:propertyId",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ID of an asset property",
        type: "String",
      },
      {
        name: "iotsitewise:user",
        referenceHref:
          "https://docs.aws.amazon.com/iot-sitewise/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the ID of an AWS Single Sign-On user",
        type: "String",
      },
    ],
  },
  iottwinmaker: {
    name: "AWS IoT TwinMaker",
    servicePrefix: "iottwinmaker",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiottwinmaker.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iot-twinmaker/latest/apireference/",
    resourceTypes: [
      {
        name: "workspace",
        referenceHref:
          "https://docs.aws.amazon.com/iot-twinmaker/latest/apireference/API_CreateWorkspace.html",
        arnPattern:
          "arn:${Partition}:iottwinmaker:${Region}:${Account}:workspace/${WorkspaceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "entity",
        referenceHref:
          "https://docs.aws.amazon.com/iot-twinmaker/latest/apireference/API_CreateEntity.html",
        arnPattern:
          "arn:${Partition}:iottwinmaker:${Region}:${Account}:workspace/${WorkspaceId}/entity/${EntityId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "componentType",
        referenceHref:
          "https://docs.aws.amazon.com/iot-twinmaker/latest/apireference/API_CreateComponentType.html",
        arnPattern:
          "arn:${Partition}:iottwinmaker:${Region}:${Account}:workspace/${WorkspaceId}/component-type/${ComponentTypeId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "scene",
        referenceHref:
          "https://docs.aws.amazon.com/iot-twinmaker/latest/apireference/API_CreateScene.html",
        arnPattern:
          "arn:${Partition}:iottwinmaker:${Region}:${Account}:workspace/${WorkspaceId}/scene/${SceneId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "syncJob",
        referenceHref:
          "https://docs.aws.amazon.com/iot-twinmaker/latest/apireference/API_CreateSyncJob.html",
        arnPattern:
          "arn:${Partition}:iottwinmaker:${Region}:${Account}:workspace/${WorkspaceId}/sync-job/${SyncJobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "metadataTransferJob",
        referenceHref:
          "https://docs.aws.amazon.com/iot-twinmaker/latest/apireference/API_CreateMetadataTransferJob.html",
        arnPattern:
          "arn:${Partition}:iottwinmaker:${Region}:${Account}:metadata-transfer-job/${MetadataTransferJobId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "iottwinmaker:destinationType",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiottwinmaker.html#awsiottwinmaker-policy-keys",
        description:
          "Filters access by destination type of metadata transfer job",
        type: "ArrayOfString",
      },
      {
        name: "iottwinmaker:linkedServices",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiottwinmaker.html#awsiottwinmaker-policy-keys",
        description: "Filters access by workspace linked to services",
        type: "ArrayOfString",
      },
      {
        name: "iottwinmaker:sourceType",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiottwinmaker.html#awsiottwinmaker-policy-keys",
        description: "Filters access by source type of metadata transfer job",
        type: "ArrayOfString",
      },
    ],
  },
  iotwireless: {
    name: "AWS IoT Wireless",
    servicePrefix: "iotwireless",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotwireless.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/Welcome.html",
    resourceTypes: [
      {
        name: "WirelessDevice",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateWirelessDevice.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:WirelessDevice/${WirelessDeviceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "WirelessGateway",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateWirelessGateway.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:WirelessGateway/${WirelessGatewayId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "DeviceProfile",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateDeviceProfile.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:DeviceProfile/${DeviceProfileId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ServiceProfile",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateServiceProfile.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:ServiceProfile/${ServiceProfileId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Destination",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateDestination.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:Destination/${DestinationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "SidewalkAccount",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_AssociateAwsAccountWithPartnerAccount.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:SidewalkAccount/${SidewalkAccountId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "WirelessGatewayTaskDefinition",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateWirelessGatewayTaskDefinition.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:WirelessGatewayTaskDefinition/${WirelessGatewayTaskDefinitionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "FuotaTask",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateFuotaTask.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:FuotaTask/${FuotaTaskId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "MulticastGroup",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateMulticastGroup.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:MulticastGroup/${MulticastGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "NetworkAnalyzerConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_CreateNetworkAnalyzerConfiguration.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:NetworkAnalyzerConfiguration/${NetworkAnalyzerConfigurationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "thing",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/thing-registry.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:thing/${ThingName}",
        conditionKeys: [],
      },
      {
        name: "cert",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/x509-client-certs.html",
        arnPattern:
          "arn:${Partition}:iot:${Region}:${Account}:cert/${Certificate}",
        conditionKeys: [],
      },
      {
        name: "ImportTask",
        referenceHref:
          "https://docs.aws.amazon.com/iot-wireless/2020-11-22/apireference/API_StartWirelessDeviceImportTask.html",
        arnPattern:
          "arn:${Partition}:iotwireless:${Region}:${Account}:ImportTask/${ImportTaskId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/tagging-iot-iam.html/",
        description:
          "Filters access by a tag key that is present in the request that the user makes to IoT Wireless",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/tagging-iot-iam.html/",
        description:
          "Filters access by tag key component of a tag attached to an IoT Wireless resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/iot/latest/developerguide/tagging-iot-iam.html/",
        description:
          "Filters access by the list of all the tag key names associated with the resource in the request",
        type: "ArrayOfString",
      },
    ],
  },
  iq: {
    name: "AWS IQ",
    servicePrefix: "iq",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiq.html",
    apiReferenceHref: "https://docs.aws.amazon.com/aws-iq/latest/user-guide/",
    resourceTypes: [
      {
        name: "conversation",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern:
          "arn:${Partition}:iq:${Region}::conversation/${ConversationId}",
        conditionKeys: [],
      },
      {
        name: "buyer",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern: "arn:${Partition}:iq:${Region}::buyer/${BuyerId}",
        conditionKeys: [],
      },
      {
        name: "expert",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern: "arn:${Partition}:iq:${Region}::expert/${ExpertId}",
        conditionKeys: [],
      },
      {
        name: "call",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern: "arn:${Partition}:iq:${Region}::call/${CallId}",
        conditionKeys: [],
      },
      {
        name: "token",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern: "arn:${Partition}:iq:${Region}::token/${TokenId}",
        conditionKeys: [],
      },
      {
        name: "proposal",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern:
          "arn:${Partition}:iq:${Region}::proposal/${ConversationId}/${ProposalId}",
        conditionKeys: [],
      },
      {
        name: "paymentRequest",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern:
          "arn:${Partition}:iq:${Region}::paymentRequest/${ConversationId}/${ProposalId}/${PaymentRequestId}",
        conditionKeys: [],
      },
      {
        name: "paymentSchedule",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern:
          "arn:${Partition}:iq:${Region}::paymentSchedule/${ConversationId}/${ProposalId}/${VersionId}",
        conditionKeys: [],
      },
      {
        name: "seller",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern:
          "arn:${Partition}:iq:${Region}::seller/${SellerAwsAccountId}",
        conditionKeys: [],
      },
      {
        name: "company",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern: "arn:${Partition}:iq:${Region}::company/${CompanyId}",
        conditionKeys: [],
      },
      {
        name: "request",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern: "arn:${Partition}:iq:${Region}::request/${RequestId}",
        conditionKeys: [],
      },
      {
        name: "listing",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern: "arn:${Partition}:iq:${Region}::listing/${ListingId}",
        conditionKeys: [],
      },
      {
        name: "attachment",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern: "arn:${Partition}:iq:${Region}::attachment/${AttachmentId}",
        conditionKeys: [],
      },
      {
        name: "permission",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern:
          "arn:${Partition}:iq-permission:${Region}::permission/${PermissionRequestId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  "iq-permission": {
    name: "AWS IQ Permissions",
    servicePrefix: "iq-permission",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiqpermissions.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/aws-iq/latest/experts-user-guide/",
    resourceTypes: [
      {
        name: "permission",
        referenceHref: "https://aws.amazon.com/iq/",
        arnPattern:
          "arn:${Partition}:iq-permission:${Region}::permission/${PermissionRequestId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  kendra: {
    name: "Amazon Kendra",
    servicePrefix: "kendra",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonkendra.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/kendra/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "index",
        referenceHref:
          "https://docs.aws.amazon.com/kendra/latest/dg/index.html",
        arnPattern:
          "arn:${Partition}:kendra:${Region}:${Account}:index/${IndexId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "data-source",
        referenceHref:
          "https://docs.aws.amazon.com/kendra/latest/dg/data-source.html",
        arnPattern:
          "arn:${Partition}:kendra:${Region}:${Account}:index/${IndexId}/data-source/${DataSourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "faq",
        referenceHref: "https://docs.aws.amazon.com/kendra/latest/dg/faq.html",
        arnPattern:
          "arn:${Partition}:kendra:${Region}:${Account}:index/${IndexId}/faq/${FaqId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "experience",
        referenceHref:
          "https://docs.aws.amazon.com/kendra/latest/dg/deploying-search-experience-no-code.html",
        arnPattern:
          "arn:${Partition}:kendra:${Region}:${Account}:index/${IndexId}/experience/${ExperienceId}",
        conditionKeys: [],
      },
      {
        name: "thesaurus",
        referenceHref:
          "https://docs.aws.amazon.com/kendra/latest/dg/thesaurus.html",
        arnPattern:
          "arn:${Partition}:kendra:${Region}:${Account}:index/${IndexId}/thesaurus/${ThesaurusId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "query-suggestions-block-list",
        referenceHref:
          "https://docs.aws.amazon.com/kendra/latest/dg/query-suggestions-block-list.html",
        arnPattern:
          "arn:${Partition}:kendra:${Region}:${Account}:index/${IndexId}/query-suggestions-block-list/${QuerySuggestionsBlockListId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "featured-results-set",
        referenceHref:
          "https://docs.aws.amazon.com/kendra/latest/dg/featured-results.html",
        arnPattern:
          "arn:${Partition}:kendra:${Region}:${Account}:index/${IndexId}/featured-results-set/${FeaturedResultsSetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "access-control-configuration",
        referenceHref:
          "https://docs.aws.amazon.com/kendra/latest/dg/API_CreateAccessControlConfiguration.html",
        arnPattern:
          "arn:${Partition}:kendra:${Region}:${Account}:index/${IndexId}/access-control-configuration/${AccessControlConfigurationId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "kendra-ranking": {
    name: "Amazon Kendra Intelligent Ranking",
    servicePrefix: "kendra-ranking",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonkendraintelligentranking.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/kendra/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "rescore-execution-plan",
        referenceHref:
          "https://docs.aws.amazon.com/kendra/latest/dg/search-service-rerank.html",
        arnPattern:
          "arn:${Partition}:kendra-ranking:${Region}:${Account}:rescore-execution-plan/${RescoreExecutionPlanId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  kms: {
    name: "AWS Key Management Service",
    servicePrefix: "kms",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awskeymanagementservice.html",
    apiReferenceHref: "https://docs.aws.amazon.com/kms/latest/APIReference/",
    resourceTypes: [
      {
        name: "alias",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/concepts.html#alias-concept",
        arnPattern: "arn:${Partition}:kms:${Region}:${Account}:alias/${Alias}",
        conditionKeys: [],
      },
      {
        name: "key",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/concepts.html#kms_keys",
        arnPattern: "arn:${Partition}:kms:${Region}:${Account}:key/${KeyId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "kms:KeyOrigin",
          "kms:KeySpec",
          "kms:KeyUsage",
          "kms:MultiRegion",
          "kms:MultiRegionKeyType",
          "kms:ResourceAliases",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access to the specified AWS KMS operations based on both the key and value of the tag in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/tag-authorization.html",
        description:
          "Filters access to the specified AWS KMS operations based on tags assigned to the AWS KMS key",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access to the specified AWS KMS operations based on tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "kms:BypassPolicyLockoutSafetyCheck",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-bypass-policy-lockout-safety-check",
        description:
          "Filters access to the CreateKey and PutKeyPolicy operations based on the value of the BypassPolicyLockoutSafetyCheck parameter in the request",
        type: "Bool",
      },
      {
        name: "kms:CallerAccount",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-caller-account",
        description:
          "Filters access to specified AWS KMS operations based on the AWS account ID of the caller. You can use this condition key to allow or deny access to all IAM users and roles in an AWS account in a single policy statement",
        type: "String",
      },
      {
        name: "kms:CustomerMasterKeySpec",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-key-spec-replaced",
        description:
          "The kms:CustomerMasterKeySpec condition key is deprecated. Instead, use the kms:KeySpec condition key",
        type: "String",
      },
      {
        name: "kms:CustomerMasterKeyUsage",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-key-usage-replaced",
        description:
          "The kms:CustomerMasterKeyUsage condition key is deprecated. Instead, use the kms:KeyUsage condition key",
        type: "String",
      },
      {
        name: "kms:DataKeyPairSpec",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-data-key-pair-spec",
        description:
          "Filters access to GenerateDataKeyPair and GenerateDataKeyPairWithoutPlaintext operations based on the value of the KeyPairSpec parameter in the request",
        type: "String",
      },
      {
        name: "kms:EncryptionAlgorithm",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-encryption-algorithm",
        description:
          "Filters access to encryption operations based on the value of the encryption algorithm in the request",
        type: "String",
      },
      {
        name: "kms:EncryptionContext:${EncryptionContextKey}",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-encryption-context",
        description:
          "Filters access to a symmetric AWS KMS key based on the encryption context in a cryptographic operation. This condition evaluates the key and value in each key-value encryption context pair",
        type: "String",
      },
      {
        name: "kms:EncryptionContextKeys",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-encryption-context-keys",
        description:
          "Filters access to a symmetric AWS KMS key based on the encryption context in a cryptographic operation. This condition key evaluates only the key in each key-value encryption context pair",
        type: "ArrayOfString",
      },
      {
        name: "kms:ExpirationModel",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-expiration-model",
        description:
          "Filters access to the ImportKeyMaterial operation based on the value of the ExpirationModel parameter in the request",
        type: "String",
      },
      {
        name: "kms:GrantConstraintType",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-grant-constraint-type",
        description:
          "Filters access to the CreateGrant operation based on the grant constraint in the request",
        type: "String",
      },
      {
        name: "kms:GrantIsForAWSResource",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-grant-is-for-aws-resource",
        description:
          "Filters access to the CreateGrant operation when the request comes from a specified AWS service",
        type: "Bool",
      },
      {
        name: "kms:GrantOperations",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-grant-operations",
        description:
          "Filters access to the CreateGrant operation based on the operations in the grant",
        type: "ArrayOfString",
      },
      {
        name: "kms:GranteePrincipal",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-grantee-principal",
        description:
          "Filters access to the CreateGrant operation based on the grantee principal in the grant",
        type: "String",
      },
      {
        name: "kms:KeyOrigin",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-key-origin",
        description:
          "Filters access to an API operation based on the Origin property of the AWS KMS key created by or used in the operation. Use it to qualify authorization of the CreateKey operation or any operation that is authorized for a KMS key",
        type: "String",
      },
      {
        name: "kms:KeySpec",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-key-spec",
        description:
          "Filters access to an API operation based on the KeySpec property of the AWS KMS key that is created by or used in the operation. Use it to qualify authorization of the CreateKey operation or any operation that is authorized for a KMS key resource",
        type: "String",
      },
      {
        name: "kms:KeyUsage",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-key-usage",
        description:
          "Filters access to an API operation based on the KeyUsage property of the AWS KMS key created by or used in the operation. Use it to qualify authorization of the CreateKey operation or any operation that is authorized for a KMS key resource",
        type: "String",
      },
      {
        name: "kms:MacAlgorithm",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-mac-algorithm",
        description:
          "Filters access to the GenerateMac and VerifyMac operations based on the MacAlgorithm parameter in the request",
        type: "String",
      },
      {
        name: "kms:MessageType",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-message-type",
        description:
          "Filters access to the Sign and Verify operations based on the value of the MessageType parameter in the request",
        type: "String",
      },
      {
        name: "kms:MultiRegion",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-multi-region",
        description:
          "Filters access to an API operation based on the MultiRegion property of the AWS KMS key created by or used in the operation. Use it to qualify authorization of the CreateKey operation or any operation that is authorized for a KMS key resource",
        type: "Bool",
      },
      {
        name: "kms:MultiRegionKeyType",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-multi-region-key-type",
        description:
          "Filters access to an API operation based on the MultiRegionKeyType property of the AWS KMS key created by or used in the operation. Use it to qualify authorization of the CreateKey operation or any operation that is authorized for a KMS key resource",
        type: "String",
      },
      {
        name: "kms:PrimaryRegion",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-primary-region",
        description:
          "Filters access to the UpdatePrimaryRegion operation based on the value of the PrimaryRegion parameter in the request",
        type: "String",
      },
      {
        name: "kms:ReEncryptOnSameKey",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-reencrypt-on-same-key",
        description:
          "Filters access to the ReEncrypt operation when it uses the same AWS KMS key that was used for the Encrypt operation",
        type: "Bool",
      },
      {
        name: "kms:RecipientAttestation:ImageSha384",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-nitro-enclaves.html#conditions-kms-recipient-image-sha",
        description:
          "Filters access to the Decrypt, GenerateDataKey, and GenerateRandom operations based on the image hash in the attestation document in the request",
        type: "String",
      },
      {
        name: "kms:RecipientAttestation:PCR",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-nitro-enclaves.html#conditions-kms-recipient-pcrs",
        description:
          "Filters access to the Decrypt, GenerateDataKey, and GenerateRandom operations based on the platform configuration registers (PCRs) in the attestation document in the request",
        type: "String",
      },
      {
        name: "kms:ReplicaRegion",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-replica-region",
        description:
          "Filters access to the ReplicateKey operation based on the value of the ReplicaRegion parameter in the request",
        type: "String",
      },
      {
        name: "kms:RequestAlias",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-request-alias",
        description:
          "Filters access to cryptographic operations, DescribeKey, and GetPublicKey based on the alias in the request",
        type: "String",
      },
      {
        name: "kms:ResourceAliases",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-resource-aliases",
        description:
          "Filters access to specified AWS KMS operations based on aliases associated with the AWS KMS key",
        type: "ArrayOfString",
      },
      {
        name: "kms:RetiringPrincipal",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-retiring-principal",
        description:
          "Filters access to the CreateGrant operation based on the retiring principal in the grant",
        type: "String",
      },
      {
        name: "kms:ScheduleKeyDeletionPendingWindowInDays",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-schedule-key-deletion-pending-window-in-days",
        description:
          "Filters access to the ScheduleKeyDeletion operation based on the value of the PendingWindowInDays parameter in the request",
        type: "Numeric",
      },
      {
        name: "kms:SigningAlgorithm",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-signing-algorithm",
        description:
          "Filters access to the Sign and Verify operations based on the signing algorithm in the request",
        type: "String",
      },
      {
        name: "kms:ValidTo",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-valid-to",
        description:
          "Filters access to the ImportKeyMaterial operation based on the value of the ValidTo parameter in the request. You can use this condition key to allow users to import key material only when it expires by the specified date",
        type: "Date",
      },
      {
        name: "kms:ViaService",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-via-service",
        description:
          "Filters access when a request made on the principal's behalf comes from a specified AWS service",
        type: "String",
      },
      {
        name: "kms:WrappingAlgorithm",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-wrapping-algorithm",
        description:
          "Filters access to the GetParametersForImport operation based on the value of the WrappingAlgorithm parameter in the request",
        type: "String",
      },
      {
        name: "kms:WrappingKeySpec",
        referenceHref:
          "https://docs.aws.amazon.com/kms/latest/developerguide/conditions-kms.html#conditions-kms-wrapping-key-spec",
        description:
          "Filters access to the GetParametersForImport operation based on the value of the WrappingKeySpec parameter in the request",
        type: "String",
      },
    ],
  },
  cassandra: {
    name: "Amazon Keyspaces (for Apache Cassandra)",
    servicePrefix: "cassandra",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonkeyspacesforapachecassandra.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/keyspaces/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "keyspace",
        referenceHref:
          "https://docs.aws.amazon.com/keyspaces/latest/devguide/what-is.html",
        arnPattern:
          "arn:${Partition}:cassandra:${Region}:${Account}:/keyspace/${KeyspaceName}/",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "table",
        referenceHref:
          "https://docs.aws.amazon.com/keyspaces/latest/devguide/what-is.html",
        arnPattern:
          "arn:${Partition}:cassandra:${Region}:${Account}:/keyspace/${KeyspaceName}/table/${TableName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/keyspaces/latest/devguide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/keyspaces/latest/devguide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/keyspaces/latest/devguide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  kinesisanalytics: {
    name: "Amazon Kinesis Analytics V2",
    servicePrefix: "kinesisanalytics",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonkinesisanalyticsv2.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/kinesisanalytics/latest/apiv2/Welcome.html",
    resourceTypes: [
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/kinesisanalytics/latest/java/how-it-works.html",
        arnPattern:
          "arn:${Partition}:kinesisanalytics:${Region}:${Account}:application/${ApplicationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value assoicated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  kinesis: {
    name: "Amazon Kinesis Data Streams",
    servicePrefix: "kinesis",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonkinesisdatastreams.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/kinesis/latest/APIReference/",
    resourceTypes: [
      {
        name: "stream",
        referenceHref:
          "https://docs.aws.amazon.com/kinesis/latest/dev/amazon-kinesis-streams.html",
        arnPattern:
          "arn:${Partition}:kinesis:${Region}:${Account}:stream/${StreamName}",
        conditionKeys: [],
      },
      {
        name: "consumer",
        referenceHref:
          "https://docs.aws.amazon.com/kinesis/latest/dev/amazon-kinesis-consumers.html",
        arnPattern:
          "arn:${Partition}:kinesis:${Region}:${Account}:${StreamType}/${StreamName}/consumer/${ConsumerName}:${ConsumerCreationTimpstamp}",
        conditionKeys: [],
      },
      {
        name: "kmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/kinesis/latest/dev/concepts.html#kms_keys",
        arnPattern: "arn:${Partition}:kms:${Region}:${Account}:key/${KeyId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  firehose: {
    name: "Amazon Kinesis Firehose",
    servicePrefix: "firehose",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonkinesisfirehose.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/firehose/latest/APIReference/",
    resourceTypes: [
      {
        name: "deliverystream",
        referenceHref:
          "https://docs.aws.amazon.com/firehose/latest/dev/basic-create.html",
        arnPattern:
          "arn:${Partition}:firehose:${Region}:${Account}:deliverystream/${DeliveryStreamName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  kinesisvideo: {
    name: "Amazon Kinesis Video Streams",
    servicePrefix: "kinesisvideo",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonkinesisvideostreams.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/kinesisvideostreams/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "stream",
        referenceHref:
          "https://docs.aws.amazon.com/kinesisvideostreams/latest/dg/how-it-works.html",
        arnPattern:
          "arn:${Partition}:kinesisvideo:${Region}:${Account}:stream/${StreamName}/${CreationTime}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "channel",
        referenceHref:
          "https://docs.aws.amazon.com/kinesisvideostreams-webrtc-dg/latest/devguide/kvswebrtc-how-it-works.html",
        arnPattern:
          "arn:${Partition}:kinesisvideo:${Region}:${Account}:channel/${ChannelName}/${CreationTime}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters requests based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag-value assoicated with the stream",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters requests based on the presence of mandatory tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  lakeformation: {
    name: "AWS Lake Formation",
    servicePrefix: "lakeformation",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awslakeformation.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/lake-formation/latest/dg/aws-lake-formation-api.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  lambda: {
    name: "AWS Lambda",
    servicePrefix: "lambda",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awslambda.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/lambda/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "code signing config",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        arnPattern:
          "arn:${Partition}:lambda:${Region}:${Account}:code-signing-config:${CodeSigningConfigId}",
        conditionKeys: [],
      },
      {
        name: "eventSourceMapping",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        arnPattern:
          "arn:${Partition}:lambda:${Region}:${Account}:event-source-mapping:${UUID}",
        conditionKeys: [],
      },
      {
        name: "function",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        arnPattern:
          "arn:${Partition}:lambda:${Region}:${Account}:function:${FunctionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "function alias",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        arnPattern:
          "arn:${Partition}:lambda:${Region}:${Account}:function:${FunctionName}:${Alias}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "function version",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        arnPattern:
          "arn:${Partition}:lambda:${Region}:${Account}:function:${FunctionName}:${Version}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "layer",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        arnPattern:
          "arn:${Partition}:lambda:${Region}:${Account}:layer:${LayerName}",
        conditionKeys: [],
      },
      {
        name: "layerVersion",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        arnPattern:
          "arn:${Partition}:lambda:${Region}:${Account}:layer:${LayerName}:${LayerVersion}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "lambda:CodeSigningConfigArn",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by the ARN of an AWS Lambda code signing config",
        type: "ARN",
      },
      {
        name: "lambda:EventSourceToken",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by the ID from a non-AWS event source configured for the AWS Lambda function",
        type: "String",
      },
      {
        name: "lambda:FunctionArn",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description: "Filters access by the ARN of an AWS Lambda function",
        type: "ARN",
      },
      {
        name: "lambda:FunctionUrlAuthType",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by authorization type specified in request. Available during CreateFunctionUrlConfig, UpdateFunctionUrlConfig, DeleteFunctionUrlConfig, GetFunctionUrlConfig, ListFunctionUrlConfig, AddPermission and RemovePermission operations",
        type: "String",
      },
      {
        name: "lambda:Layer",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by the ARN of a version of an AWS Lambda layer",
        type: "ArrayOfString",
      },
      {
        name: "lambda:Principal",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by restricting the AWS service or account that can invoke a function",
        type: "String",
      },
      {
        name: "lambda:SecurityGroupIds",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by the ID of security groups configured for the AWS Lambda function",
        type: "ArrayOfString",
      },
      {
        name: "lambda:SourceFunctionArn",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by the ARN of the AWS Lambda function from which the request originated",
        type: "ARN",
      },
      {
        name: "lambda:SubnetIds",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by the ID of subnets configured for the AWS Lambda function",
        type: "ArrayOfString",
      },
      {
        name: "lambda:VpcIds",
        referenceHref:
          "https://docs.aws.amazon.com/lambda/latest/dg/lambda-api-permissions-ref.html",
        description:
          "Filters access by the ID of the VPC configured for the AWS Lambda function",
        type: "String",
      },
    ],
  },
  launchwizard: {
    name: "AWS Launch Wizard",
    servicePrefix: "launchwizard",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awslaunchwizard.html",
    apiReferenceHref: "https://docs.aws.amazon.com/launchwizard/",
    resourceTypes: [],
    conditionKeys: [],
  },
  lex: {
    name: "Amazon Lex V2",
    servicePrefix: "lex",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonlexv2.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/lexv2/latest/APIReference/welcome.html",
    resourceTypes: [
      {
        name: "bot",
        referenceHref:
          "https://docs.aws.amazon.com/lexv2/latest/dg/how-it-works.html",
        arnPattern: "arn:${Partition}:lex:${Region}:${Account}:bot/${BotId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "bot alias",
        referenceHref:
          "https://docs.aws.amazon.com/lexv2/latest/dg/how-it-works.html",
        arnPattern:
          "arn:${Partition}:lex:${Region}:${Account}:bot-alias/${BotId}/${BotAliasId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "test set",
        referenceHref:
          "https://docs.aws.amazon.com/lexv2/latest/dg/test-workbench.html",
        arnPattern:
          "arn:${Partition}:lex:${Region}:${Account}:test-set/${TestSetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tags in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags attached to a Lex resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the set of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "license-manager": {
    name: "AWS License Manager",
    servicePrefix: "license-manager",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awslicensemanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/license-manager/latest/APIReference/",
    resourceTypes: [
      {
        name: "license-configuration",
        referenceHref:
          "https://docs.aws.amazon.com/license-manager/latest/userguide/license-configurations.html",
        arnPattern:
          "arn:${Partition}:license-manager:${Region}:${Account}:license-configuration:${LicenseConfigurationId}",
        conditionKeys: ["license-manager:ResourceTag/${TagKey}"],
      },
      {
        name: "license",
        referenceHref:
          "https://docs.aws.amazon.com/license-manager/latest/userguide/seller-issued-licenses.html",
        arnPattern:
          "arn:${Partition}:license-manager::${Account}:license:${LicenseId}",
        conditionKeys: [],
      },
      {
        name: "grant",
        referenceHref:
          "https://docs.aws.amazon.com/license-manager/latest/userguide/granted-licenses.html",
        arnPattern:
          "arn:${Partition}:license-manager::${Account}:grant:${GrantId}",
        conditionKeys: [],
      },
      {
        name: "report-generator",
        referenceHref:
          "https://docs.aws.amazon.com/license-manager/latest/userguide/report-generators.html",
        arnPattern:
          "arn:${Partition}:license-manager:${Region}:${Account}:report-generator:${ReportGeneratorId}",
        conditionKeys: ["license-manager:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/license-manager/latest/userguide/identity-access-management.html",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/license-manager/latest/userguide/identity-access-management.html",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "license-manager:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/license-manager/latest/userguide/identity-access-management.html",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
    ],
  },
  "license-manager-linux-subscriptions": {
    name: "AWS License Manager Linux Subscriptions Manager",
    servicePrefix: "license-manager-linux-subscriptions",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awslicensemanagerlinuxsubscriptionsmanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/license-manager/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "license-manager-user-subscriptions": {
    name: "AWS License Manager User Subscriptions",
    servicePrefix: "license-manager-user-subscriptions",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awslicensemanagerusersubscriptions.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/license-manager-user-subscriptions/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  lightsail: {
    name: "Amazon Lightsail",
    servicePrefix: "lightsail",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonlightsail.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/",
    resourceTypes: [
      {
        name: "Domain",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_Domain.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:Domain/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Instance",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_Instance.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:Instance/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "InstanceSnapshot",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_InstanceSnapshot.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:InstanceSnapshot/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "KeyPair",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_KeyPair.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:KeyPair/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "StaticIp",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_StaticIp.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:StaticIp/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Disk",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_Disk.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:Disk/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "DiskSnapshot",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_DiskSnapshot.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:DiskSnapshot/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "LoadBalancer",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_LoadBalancer.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:LoadBalancer/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "LoadBalancerTlsCertificate",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_LoadBalancerTlsCertificate.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:LoadBalancerTlsCertificate/${Id}",
        conditionKeys: [],
      },
      {
        name: "ExportSnapshotRecord",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_ExportSnapshotRecord.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:ExportSnapshotRecord/${Id}",
        conditionKeys: [],
      },
      {
        name: "CloudFormationStackRecord",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_CloudFormationStackRecord.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:CloudFormationStackRecord/${Id}",
        conditionKeys: [],
      },
      {
        name: "RelationalDatabase",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_RelationalDatabase.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:RelationalDatabase/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "RelationalDatabaseSnapshot",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_RelationalDatabaseSnapshot.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:RelationalDatabaseSnapshot/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Alarm",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_Alarm.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:Alarm/${Id}",
        conditionKeys: [],
      },
      {
        name: "Certificate",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_Certificate.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:Certificate/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ContactMethod",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_ContactMethod.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:ContactMethod/${Id}",
        conditionKeys: [],
      },
      {
        name: "ContainerService",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_ContainerService.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:ContainerService/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Distribution",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_LightsailDistribution.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:Distribution/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Bucket",
        referenceHref:
          "https://docs.aws.amazon.com/lightsail/2016-11-28/api-reference/API_Bucket.html",
        arnPattern:
          "arn:${Partition}:lightsail:${Region}:${Account}:Bucket/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  geo: {
    name: "Amazon Location",
    servicePrefix: "geo",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonlocation.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/location/latest/APIReference/",
    resourceTypes: [
      {
        name: "api-key",
        referenceHref:
          "https://docs.aws.amazon.com/location/latest/developerguide/using-apikeys.html",
        arnPattern:
          "arn:${Partition}:geo:${Region}:${Account}:api-key/${KeyName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "geofence-collection",
        referenceHref:
          "https://docs.aws.amazon.com/location/latest/developerguide/geofence-tracker-concepts.html",
        arnPattern:
          "arn:${Partition}:geo:${Region}:${Account}:geofence-collection/${GeofenceCollectionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "geo:GeofenceIds"],
      },
      {
        name: "map",
        referenceHref:
          "https://docs.aws.amazon.com/location/latest/developerguide/map-concepts.html",
        arnPattern: "arn:${Partition}:geo:${Region}:${Account}:map/${MapName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "place-index",
        referenceHref:
          "https://docs.aws.amazon.com/location/latest/developerguide/places-concepts.html",
        arnPattern:
          "arn:${Partition}:geo:${Region}:${Account}:place-index/${IndexName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "route-calculator",
        referenceHref:
          "https://docs.aws.amazon.com/location/latest/developerguide/route-concepts.html",
        arnPattern:
          "arn:${Partition}:geo:${Region}:${Account}:route-calculator/${CalculatorName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "tracker",
        referenceHref:
          "https://docs.aws.amazon.com/location/latest/developerguide/geofence-tracker-concepts.html",
        arnPattern:
          "arn:${Partition}:geo:${Region}:${Account}:tracker/${TrackerName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "geo:DeviceIds"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
      {
        name: "geo:DeviceIds",
        referenceHref:
          "https://docs.aws.amazon.com/location/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the presence of device ids in the request",
        type: "ArrayOfString",
      },
      {
        name: "geo:GeofenceIds",
        referenceHref:
          "https://docs.aws.amazon.com/location/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by the presence of geofence ids in the request",
        type: "ArrayOfString",
      },
    ],
  },
  lookoutequipment: {
    name: "Amazon Lookout for Equipment",
    servicePrefix: "lookoutequipment",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonlookoutforequipment.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/lookout-for-equipment/latest/ug/",
    resourceTypes: [
      {
        name: "dataset",
        referenceHref:
          "https://docs.aws.amazon.com/lookout-for-equipment/latest/ug/dataset.html",
        arnPattern:
          "arn:${Partition}:lookoutequipment:${Region}:${Account}:dataset/${DatasetName}/${DatasetId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "model",
        referenceHref:
          "https://docs.aws.amazon.com/lookout-for-equipment/latest/ug/model.html",
        arnPattern:
          "arn:${Partition}:lookoutequipment:${Region}:${Account}:model/${ModelName}/${ModelId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "model-version",
        referenceHref:
          "https://docs.aws.amazon.com/lookout-for-equipment/latest/ug/model-version.html",
        arnPattern:
          "arn:${Partition}:lookoutequipment:${Region}:${Account}:model/${ModelName}/${ModelId}/model-version/${ModelVersionNumber}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "inference-scheduler",
        referenceHref:
          "https://docs.aws.amazon.com/lookout-for-equipment/latest/ug/inference-scheduler.html",
        arnPattern:
          "arn:${Partition}:lookoutequipment:${Region}:${Account}:inference-scheduler/${InferenceSchedulerName}/${InferenceSchedulerId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "label-group",
        referenceHref:
          "https://docs.aws.amazon.com/lookout-for-equipment/latest/ug/label-group.html",
        arnPattern:
          "arn:${Partition}:lookoutequipment:${Region}:${Account}:label-group/${LabelGroupName}/${LabelGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "lookoutequipment:IsImportingData",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-isimportingdata",
        description: "Filters access by the import strategy of underlying data",
        type: "Bool",
      },
    ],
  },
  lookoutmetrics: {
    name: "Amazon Lookout for Metrics",
    servicePrefix: "lookoutmetrics",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonlookoutformetrics.html",
    apiReferenceHref: "https://docs.aws.amazon.com/lookoutmetrics/latest/api/",
    resourceTypes: [
      {
        name: "AnomalyDetector",
        referenceHref:
          "https://docs.aws.amazon.com/lookoutmetrics/latest/api/API_AnomalyDetectorSummary.html",
        arnPattern:
          "arn:${Partition}:lookoutmetrics:${Region}:${Account}:AnomalyDetector:${AnomalyDetectorName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "MetricSet",
        referenceHref:
          "https://docs.aws.amazon.com/lookoutmetrics/latest/api/API_MetricSetSummary.html",
        arnPattern:
          "arn:${Partition}:lookoutmetrics:${Region}:${Account}:MetricSet/${AnomalyDetectorName}/${MetricSetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Alert",
        referenceHref:
          "https://docs.aws.amazon.com/lookoutmetrics/latest/api/API_AlertSummary.html",
        arnPattern:
          "arn:${Partition}:lookoutmetrics:${Region}:${Account}:Alert:${AlertName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  lookoutvision: {
    name: "Amazon Lookout for Vision",
    servicePrefix: "lookoutvision",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonlookoutforvision.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/lookout-for-vision/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "model",
        referenceHref:
          "https://docs.aws.amazon.com/lookout-for-vision/latest/developer-guide/model-create-project.html",
        arnPattern:
          "arn:${Partition}:lookoutvision:${Region}:${Account}:model/${ProjectName}/${ModelVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/lookout-for-vision/latest/developer-guide/model-create-project.html",
        arnPattern:
          "arn:${Partition}:lookoutvision:${Region}:${Account}:project/${ProjectName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  machinelearning: {
    name: "Amazon Machine Learning",
    servicePrefix: "machinelearning",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmachinelearning.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/machine-learning/latest/APIReference/",
    resourceTypes: [
      {
        name: "batchprediction",
        referenceHref:
          "https://docs.aws.amazon.com/machine-learning/latest/dg/amazon-machine-learning-key-concepts.html#batch-predictions",
        arnPattern:
          "arn:${Partition}:machinelearning:${Region}:${Account}:batchprediction/${BatchPredictionId}",
        conditionKeys: [],
      },
      {
        name: "datasource",
        referenceHref:
          "https://docs.aws.amazon.com/machine-learning/latest/dg/amazon-machine-learning-key-concepts.html#datasources",
        arnPattern:
          "arn:${Partition}:machinelearning:${Region}:${Account}:datasource/${DatasourceId}",
        conditionKeys: [],
      },
      {
        name: "evaluation",
        referenceHref:
          "https://docs.aws.amazon.com/machine-learning/latest/dg/amazon-machine-learning-key-concepts.html#evaluations",
        arnPattern:
          "arn:${Partition}:machinelearning:${Region}:${Account}:evaluation/${EvaluationId}",
        conditionKeys: [],
      },
      {
        name: "mlmodel",
        referenceHref:
          "https://docs.aws.amazon.com/machine-learning/latest/dg/amazon-machine-learning-key-concepts.html#ml-models",
        arnPattern:
          "arn:${Partition}:machinelearning:${Region}:${Account}:mlmodel/${MlModelId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  macie2: {
    name: "Amazon Macie",
    servicePrefix: "macie2",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmacie.html",
    apiReferenceHref: "https://docs.aws.amazon.com/macie/latest/APIReference/",
    resourceTypes: [
      {
        name: "AllowList",
        referenceHref:
          "https://docs.aws.amazon.com/macie/latest/user/what-is-macie.html",
        arnPattern:
          "arn:${Partition}:macie2:${Region}:${Account}:allow-list/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ClassificationJob",
        referenceHref:
          "https://docs.aws.amazon.com/macie/latest/user/what-is-macie.html",
        arnPattern:
          "arn:${Partition}:macie2:${Region}:${Account}:classification-job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "CustomDataIdentifier",
        referenceHref:
          "https://docs.aws.amazon.com/macie/latest/user/what-is-macie.html.html",
        arnPattern:
          "arn:${Partition}:macie2:${Region}:${Account}:custom-data-identifier/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "FindingsFilter",
        referenceHref:
          "https://docs.aws.amazon.com/macie/latest/user/what-is-macie.html",
        arnPattern:
          "arn:${Partition}:macie2:${Region}:${Account}:findings-filter/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Member",
        referenceHref:
          "https://docs.aws.amazon.com/macie/latest/user/what-is-macie.html",
        arnPattern:
          "arn:${Partition}:macie2:${Region}:${Account}:member/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  m2: {
    name: "AWS Mainframe Modernization Service",
    servicePrefix: "m2",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmainframemodernizationservice.html",
    apiReferenceHref: "https://docs.aws.amazon.com/m2/latest/APIReference/",
    resourceTypes: [
      {
        name: "Application",
        referenceHref:
          "https://docs.aws.amazon.com/m2/latest/userguide/concept-m2.html#application-concept",
        arnPattern:
          "arn:${Partition}:m2:${Region}:${Account}:app/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Environment",
        referenceHref:
          "https://docs.aws.amazon.com/m2/latest/userguide/concept-m2.html#environment-concept",
        arnPattern:
          "arn:${Partition}:m2:${Region}:${Account}:env/${EnvironmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  managedblockchain: {
    name: "Amazon Managed Blockchain",
    servicePrefix: "managedblockchain",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmanagedblockchain.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/managed-blockchain/latest/APIReference/",
    resourceTypes: [
      {
        name: "network",
        referenceHref:
          "https://docs.aws.amazon.com/managed-blockchain/latest/APIReference/API_Network.html",
        arnPattern:
          "arn:${Partition}:managedblockchain:${Region}::networks/${NetworkId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "member",
        referenceHref:
          "https://docs.aws.amazon.com/managed-blockchain/latest/APIReference/API_Member.html",
        arnPattern:
          "arn:${Partition}:managedblockchain:${Region}:${Account}:members/${MemberId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "node",
        referenceHref:
          "https://docs.aws.amazon.com/managed-blockchain/latest/APIReference/API_Node.html",
        arnPattern:
          "arn:${Partition}:managedblockchain:${Region}:${Account}:nodes/${NodeId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "proposal",
        referenceHref:
          "https://docs.aws.amazon.com/managed-blockchain/latest/APIReference/API_Proposal.html",
        arnPattern:
          "arn:${Partition}:managedblockchain:${Region}::proposals/${ProposalId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "invitation",
        referenceHref:
          "https://docs.aws.amazon.com/managed-blockchain/latest/APIReference/API_Invitation.html",
        arnPattern:
          "arn:${Partition}:managedblockchain:${Region}:${Account}:invitations/${InvitationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "accessor",
        referenceHref:
          "https://docs.aws.amazon.com/managed-blockchain/latest/APIReference/API_Accessor.html",
        arnPattern:
          "arn:${Partition}:managedblockchain:${Region}:${Account}:accessors/${AccessorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on the tags associated with an Amazon Managed Blockchain resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "managedblockchain-query": {
    name: "Amazon Managed Blockchain Query",
    servicePrefix: "managedblockchain-query",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmanagedblockchainquery.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/managed-blockchain/latest/AMBQ-APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  grafana: {
    name: "Amazon Managed Grafana",
    servicePrefix: "grafana",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmanagedgrafana.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/grafana/latest/APIReference/",
    resourceTypes: [
      {
        name: "workspace",
        referenceHref:
          "https://docs.aws.amazon.com/grafana/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:grafana:${Region}:${Account}:/workspaces/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/grafana/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/grafana/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/grafana/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  aps: {
    name: "Amazon Managed Service for Prometheus",
    servicePrefix: "aps",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmanagedserviceforprometheus.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/prometheus/latest/userguide/AMP-APIReference.html",
    resourceTypes: [
      {
        name: "workspace",
        referenceHref:
          "https://docs.aws.amazon.com/prometheus/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:aps:${Region}:${Account}:workspace/${WorkspaceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
      {
        name: "rulegroupsnamespace",
        referenceHref:
          "https://docs.aws.amazon.com/prometheus/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:aps:${Region}:${Account}:rulegroupsnamespace/${WorkspaceId}/${Namespace}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
      {
        name: "scraper",
        referenceHref:
          "https://docs.aws.amazon.com/prometheus/latest/userguide/security-iam.html",
        arnPattern:
          "arn:${Partition}:aps:${Region}:${Account}:scraper/${ScraperId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/eks/latest/userguide/clusters.html",
        arnPattern:
          "arn:${Partition}:eks:${Region}:${Account}:cluster/${ClusterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  kafka: {
    name: "Amazon Managed Streaming for Apache Kafka",
    servicePrefix: "kafka",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmanagedstreamingforapachekafka.html",
    apiReferenceHref: "https://docs.aws.amazon.com/msk/1.0/apireference/",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/msk/1.0/apireference/clusters-clusterarn.html",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:cluster/${ClusterName}/${Uuid}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "configuration",
        referenceHref:
          "https://docs.aws.amazon.com/msk/1.0/apireference/configurations-arn.html",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:configuration/${ConfigurationName}/${Uuid}",
        conditionKeys: [],
      },
      {
        name: "vpc-connection",
        referenceHref:
          "https://docs.aws.amazon.com/msk/1.0/apireference/vpc-connections-arn.html",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${VpcOwnerAccount}:vpc-connection/${ClusterOwnerAccount}/${ClusterName}/${Uuid}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "replicator",
        referenceHref:
          "https://docs.aws.amazon.com/msk/latest/developerguide/v1-replicators.html",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:replicator/${ReplicatorName}/${Uuid}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "topic",
        referenceHref:
          "https://docs.aws.amazon.com/msk/latest/developerguide/iam-access-control.html#msk-iam-resources",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:topic/${ClusterName}/${ClusterUuid}/${TopicName}",
        conditionKeys: [],
      },
      {
        name: "group",
        referenceHref:
          "https://docs.aws.amazon.com/msk/latest/developerguide/iam-access-control.html#msk-iam-resources",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:group/${ClusterName}/${ClusterUuid}/${GroupName}",
        conditionKeys: [],
      },
      {
        name: "transactional-id",
        referenceHref:
          "https://docs.aws.amazon.com/msk/latest/developerguide/iam-access-control.html#msk-iam-resources",
        arnPattern:
          "arn:${Partition}:kafka:${Region}:${Account}:transactional-id/${ClusterName}/${ClusterUuid}/${TransactionalId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "kafka:publicAccessEnabled",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_apachekafkaapisforamazonmskclusters.html#apachekafkaapisforamazonmskclusters-policy-keys",
        description:
          "Filters access by the presence of public access enabled in the request",
        type: "Bool",
      },
    ],
  },
  kafkaconnect: {
    name: "Amazon Managed Streaming for Kafka Connect",
    servicePrefix: "kafkaconnect",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmanagedstreamingforkafkaconnect.html",
    apiReferenceHref: "https://docs.aws.amazon.com/MSKC/latest/mskc/",
    resourceTypes: [
      {
        name: "connector",
        referenceHref:
          "https://docs.aws.amazon.com/MSKC/latest/mskc/API_ConnectorSummary.html",
        arnPattern:
          "arn:${Partition}:kafkaconnect:${Region}:${Account}:connector/${ConnectorName}/${UUID}",
        conditionKeys: [],
      },
      {
        name: "custom plugin",
        referenceHref:
          "https://docs.aws.amazon.com/MSKC/latest/mskc/API_CustomPlugin.html",
        arnPattern:
          "arn:${Partition}:kafkaconnect:${Region}:${Account}:custom-plugin/${CustomPluginName}/${UUID}",
        conditionKeys: [],
      },
      {
        name: "worker configuration",
        referenceHref:
          "https://docs.aws.amazon.com/MSKC/latest/mskc/API_WorkerConfiguration.html",
        arnPattern:
          "arn:${Partition}:kafkaconnect:${Region}:${Account}:worker-configuration/${WorkerConfigurationName}/${UUID}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  airflow: {
    name: "Amazon Managed Workflows for Apache Airflow",
    servicePrefix: "airflow",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmanagedworkflowsforapacheairflow.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/mwaa/latest/API/API_Operations.html",
    resourceTypes: [
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/mwaa/latest/userguide/using-mwaa.html",
        arnPattern:
          "arn:${Partition}:airflow:${Region}:${Account}:environment/${EnvironmentName}",
        conditionKeys: [],
      },
      {
        name: "rbac-role",
        referenceHref:
          "https://docs.aws.amazon.com/mwaa/latest/userguide/access-policies.html",
        arnPattern:
          "arn:${Partition}:airflow:${Region}:${Account}:role/${EnvironmentName}/${RoleName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "aws-marketplace": {
    name: "AWS Marketplace Seller Reporting",
    servicePrefix: "aws-marketplace",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacesellerreporting.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/marketplace/latest/userguide/reports-and-data-feed.html",
    resourceTypes: [
      {
        name: "SellerDashboard",
        referenceHref:
          "https://docs.aws.amazon.com/marketplace/latest/userguide/dashboards.html#reports-accessing",
        arnPattern:
          "arn:${Partition}:aws-marketplace::${Account}:${Catalog}/ReportingData/${FactTable}/Dashboard/${DashboardName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  marketplacecommerceanalytics: {
    name: "AWS Marketplace Commerce Analytics Service",
    servicePrefix: "marketplacecommerceanalytics",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacecommerceanalyticsservice.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  "aws-marketplace-management": {
    name: "AWS Marketplace Management Portal",
    servicePrefix: "aws-marketplace-management",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacemanagementportal.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/marketplace/latest/userguide/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "vendor-insights": {
    name: "AWS Marketplace Vendor Insights",
    servicePrefix: "vendor-insights",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacevendorinsights.html",
    apiReferenceHref: "https://docs.aws.amazon.com/marketplace/",
    resourceTypes: [
      {
        name: "DataSource",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacevendorinsights.html#awsmarketplacevendorinsights-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:vendor-insights:::data-source:${ResourceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
      {
        name: "SecurityProfile",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmarketplacevendorinsights.html#awsmarketplacevendorinsights-resources-for-iam-policies",
        arnPattern:
          "arn:${Partition}:vendor-insights:::security-profile:${ResourceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  mechanicalturk: {
    name: "Amazon Mechanical Turk",
    servicePrefix: "mechanicalturk",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmechanicalturk.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AWSMechTurk/latest/AWSMturkAPI/",
    resourceTypes: [],
    conditionKeys: [],
  },
  memorydb: {
    name: "Amazon MemoryDB",
    servicePrefix: "memorydb",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmemorydb.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/memorydb/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "parametergroup",
        referenceHref:
          "https://docs.aws.amazon.com/memorydb/latest/devguide/WhatIs.Components.html",
        arnPattern:
          "arn:${Partition}:memorydb:${Region}:${Account}:parametergroup/${ParameterGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "subnetgroup",
        referenceHref:
          "https://docs.aws.amazon.com/memorydb/latest/devguide/WhatIs.Components.html",
        arnPattern:
          "arn:${Partition}:memorydb:${Region}:${Account}:subnetgroup/${SubnetGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/memorydb/latest/devguide/WhatIs.Components.html",
        arnPattern:
          "arn:${Partition}:memorydb:${Region}:${Account}:cluster/${ClusterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/memorydb/latest/devguide/WhatIs.Components.html",
        arnPattern:
          "arn:${Partition}:memorydb:${Region}:${Account}:snapshot/${SnapshotName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/memorydb/latest/devguide/WhatIs.Components.html",
        arnPattern:
          "arn:${Partition}:memorydb:${Region}:${Account}:user/${UserName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "acl",
        referenceHref:
          "https://docs.aws.amazon.com/memorydb/latest/devguide/WhatIs.Components.html",
        arnPattern:
          "arn:${Partition}:memorydb:${Region}:${Account}:acl/${AclName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "reservednode",
        referenceHref:
          "https://docs.aws.amazon.com/memorydb/latest/devguide/WhatIs.Components.html",
        arnPattern:
          "arn:${Partition}:memorydb:${Region}:${Account}:reservednode/${ReservationID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  ec2messages: {
    name: "Amazon Message Delivery Service",
    servicePrefix: "ec2messages",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmessagedeliveryservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/systems-manager/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "ec2:SourceInstanceARN",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the instance from which the request originated",
        type: "ARN",
      },
      {
        name: "ssm:SourceInstanceARN",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanager.html#awssystemsmanager-policy-keys",
        description:
          "Filters access by verifying the Amazon Resource Name (ARN) of the AWS Systems Manager's managed instance from which the request is made. This key is not present when the request comes from the managed instance authenticated with an IAM role associated with EC2 instance profile",
        type: "ARN",
      },
    ],
  },
  serviceextract: {
    name: "AWS Microservice Extractor for .NET",
    servicePrefix: "serviceextract",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmicroserviceextractorfor.net.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/microservice-extractor/latest/userguide/what-is-microservice-extractor.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  mapcredits: {
    name: "AWS Migration Acceleration Program Credits",
    servicePrefix: "mapcredits",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmigrationaccelerationprogramcredits.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/billing-permissions-ref.html",
    resourceTypes: [
      {
        name: "agreement",
        referenceHref:
          "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/billing-permissions-ref.html",
        arnPattern: "arn:${Partition}:mapcredits:::${Agreement}/${AgreementId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  mgh: {
    name: "AWS Migration Hub",
    servicePrefix: "mgh",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmigrationhub.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/migrationhub/latest/ug/api-reference.html",
    resourceTypes: [
      {
        name: "progressUpdateStream",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub/latest/ug/API_ProgressUpdateStreamSummary.html",
        arnPattern:
          "arn:${Partition}:mgh:${Region}:${Account}:progressUpdateStream/${Stream}",
        conditionKeys: [],
      },
      {
        name: "migrationTask",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub/latest/ug/API_MigrationTask.html",
        arnPattern:
          "arn:${Partition}:mgh:${Region}:${Account}:progressUpdateStream/${Stream}/migrationTask/${Task}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  "migrationhub-orchestrator": {
    name: "AWS Migration Hub Orchestrator",
    servicePrefix: "migrationhub-orchestrator",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmigrationhuborchestrator.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/migrationhub-orchestrator/latest/APIReference/",
    resourceTypes: [
      {
        name: "workflow",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-orchestrator/latest/userguide/workflow.html",
        arnPattern:
          "arn:${Partition}:migrationhub-orchestrator:${Region}:${Account}:workflow/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "refactor-spaces": {
    name: "AWS Migration Hub Refactor Spaces",
    servicePrefix: "refactor-spaces",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmigrationhubrefactorspaces.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/APIReference/",
    resourceTypes: [
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-resources",
        arnPattern:
          "arn:${Partition}:refactor-spaces:${Region}:${Account}:environment/${EnvironmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-resources",
        arnPattern:
          "arn:${Partition}:refactor-spaces:${Region}:${Account}:environment/${EnvironmentId}/application/${ApplicationId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "refactor-spaces:ApplicationCreatedByAccount",
          "refactor-spaces:CreatedByAccountIds",
        ],
      },
      {
        name: "service",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-resources",
        arnPattern:
          "arn:${Partition}:refactor-spaces:${Region}:${Account}:environment/${EnvironmentId}/application/${ApplicationId}/service/${ServiceId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "refactor-spaces:ApplicationCreatedByAccount",
          "refactor-spaces:CreatedByAccountIds",
          "refactor-spaces:ServiceCreatedByAccount",
        ],
      },
      {
        name: "route",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-resources",
        arnPattern:
          "arn:${Partition}:refactor-spaces:${Region}:${Account}:environment/${EnvironmentId}/application/${ApplicationId}/route/${RouteId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "refactor-spaces:ApplicationCreatedByAccount",
          "refactor-spaces:CreatedByAccountIds",
          "refactor-spaces:RouteCreatedByAccount",
          "refactor-spaces:ServiceCreatedByAccount",
          "refactor-spaces:SourcePath",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "refactor-spaces:ApplicationCreatedByAccount",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by restricting the action to only those accounts that created the application within an environment",
        type: "String",
      },
      {
        name: "refactor-spaces:CreatedByAccountIds",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the accounts that created the resource",
        type: "ArrayOfString",
      },
      {
        name: "refactor-spaces:RouteCreatedByAccount",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by restricting the action to only those accounts that created the route within an application",
        type: "String",
      },
      {
        name: "refactor-spaces:ServiceCreatedByAccount",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description:
          "Filters access by restricting the action to only those accounts that created the service within an application",
        type: "String",
      },
      {
        name: "refactor-spaces:SourcePath",
        referenceHref:
          "https://docs.aws.amazon.com/migrationhub-refactor-spaces/latest/userguide/security_iam_service-with-iam.html#security_iam_service-with-iam-id-based-policies-conditionkeys",
        description: "Filters access by the path of the route",
        type: "String",
      },
    ],
  },
  "migrationhub-strategy": {
    name: "AWS Migration Hub Strategy Recommendations",
    servicePrefix: "migrationhub-strategy",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsmigrationhubstrategyrecommendations.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/migrationhub-strategy/latest/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  mobileanalytics: {
    name: "Amazon Mobile Analytics",
    servicePrefix: "mobileanalytics",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmobileanalytics.html",
    apiReferenceHref: "https://docs.aws.amazon.com/mobileanalytics/latest/ug/",
    resourceTypes: [],
    conditionKeys: [],
  },
  monitron: {
    name: "Amazon Monitron",
    servicePrefix: "monitron",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmonitron.html",
    apiReferenceHref: "https://docs.aws.amazon.com/Monitron/latest/user-guide/",
    resourceTypes: [
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/Monitron/latest/user-guide/projects-chapter.html",
        arnPattern:
          "arn:${Partition}:monitron:${Region}:${Account}:project/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by the tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  mq: {
    name: "Amazon MQ",
    servicePrefix: "mq",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonmq.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amazon-mq/latest/api-reference/",
    resourceTypes: [
      {
        name: "brokers",
        referenceHref:
          "https://docs.aws.amazon.com/amazon-mq/latest/developer-guide/amazon-mq-how-it-works.html",
        arnPattern:
          "arn:${Partition}:mq:${Region}:${Account}:broker:${BrokerName}:${BrokerId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "configurations",
        referenceHref:
          "https://docs.aws.amazon.com/amazon-mq/latest/developer-guide/amazon-mq-how-it-works.html",
        arnPattern:
          "arn:${Partition}:mq:${Region}:${Account}:configuration:${ConfigurationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/amazon-mq/latest/developer-guide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/amazon-mq/latest/developer-guide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/amazon-mq/latest/developer-guide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "neptune-db": {
    name: "Amazon Neptune",
    servicePrefix: "neptune-db",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonneptune.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/neptune/latest/userguide/api.html",
    resourceTypes: [
      {
        name: "database",
        referenceHref:
          "https://docs.aws.amazon.com/neptune/latest/userguide/iam-data-resources.html",
        arnPattern:
          "arn:${Partition}:neptune-db:${Region}:${Account}:${RelativeId}/database",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "neptune-db:QueryLanguage",
        referenceHref:
          "https://docs.aws.amazon.com/neptune/latest/userguide/iam-dp-context-keys.html#querylanguage",
        description: "Filters access by graph model",
        type: "String",
      },
    ],
  },
  "neptune-graph": {
    name: "Amazon Neptune Analytics",
    servicePrefix: "neptune-graph",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonneptuneanalytics.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/neptune-analytics/latest/APIReference/",
    resourceTypes: [
      {
        name: "graph",
        referenceHref:
          "https://docs.aws.amazon.com/neptune-analytics/latest/userguide/iam-resources.html#graph",
        arnPattern:
          "arn:${Partition}:neptune-graph:${Region}:${Account}:graph/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "graph-snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/neptune-analytics/latest/userguide/iam-resources.html#graph-snapshot",
        arnPattern:
          "arn:${Partition}:neptune-graph:${Region}:${Account}:graph-snapshot/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "import-task",
        referenceHref:
          "https://docs.aws.amazon.com/neptune-analytics/latest/userguide/iam-resources.html#import-task",
        arnPattern:
          "arn:${Partition}:neptune-graph:${Region}:${Account}:import-task/${ResourceId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/neptune-analytics/latest/userguide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/neptune-analytics/latest/userguide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/neptune-analytics/latest/userguide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
    ],
  },
  "network-firewall": {
    name: "AWS Network Firewall",
    servicePrefix: "network-firewall",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsnetworkfirewall.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/network-firewall/latest/APIReference/",
    resourceTypes: [
      {
        name: "Firewall",
        referenceHref:
          "https://docs.aws.amazon.com/network-firewall/latest/APIReference/API_Firewall.html",
        arnPattern:
          "arn:${Partition}:network-firewall:${Region}:${Account}:firewall/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "FirewallPolicy",
        referenceHref:
          "https://docs.aws.amazon.com/network-firewall/latest/APIReference/API_FirewallPolicyResponse.html",
        arnPattern:
          "arn:${Partition}:network-firewall:${Region}:${Account}:firewall-policy/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "StatefulRuleGroup",
        referenceHref:
          "https://docs.aws.amazon.com/network-firewall/latest/APIReference/API_RuleGroupResponse.html",
        arnPattern:
          "arn:${Partition}:network-firewall:${Region}:${Account}:stateful-rulegroup/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "StatelessRuleGroup",
        referenceHref:
          "https://docs.aws.amazon.com/network-firewall/latest/APIReference/API_RuleGroupResponse.html",
        arnPattern:
          "arn:${Partition}:network-firewall:${Region}:${Account}:stateless-rulegroup/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "TLSInspectionConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/network-firewall/latest/APIReference/API_TLSInspectionConfigurationResponse.html",
        arnPattern:
          "arn:${Partition}:network-firewall:${Region}:${Account}:tls-configuration/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  networkmanager: {
    name: "AWS Network Manager",
    servicePrefix: "networkmanager",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsnetworkmanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/networkmanager/latest/APIReference/",
    resourceTypes: [
      {
        name: "global-network",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:global-network/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "site",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:site/${GlobalNetworkId}/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "link",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:link/${GlobalNetworkId}/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "device",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:device/${GlobalNetworkId}/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "connection",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:connection/${GlobalNetworkId}/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "core-network",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:core-network/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "attachment",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:attachment/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "connect-peer",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:connect-peer/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "peering",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/what-is-network-manager.html",
        arnPattern:
          "arn:${Partition}:networkmanager::${Account}:peering/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "networkmanager:cgwArn",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/nm-security-iam.html",
        description:
          "Filters access by which customer gateways can be associated or disassociated",
        type: "ARN",
      },
      {
        name: "networkmanager:subnetArns",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/nm-security-iam.html",
        description:
          "Filters access by which VPC subnets can be added or removed from a VPC attachment",
        type: "ArrayOfARN",
      },
      {
        name: "networkmanager:tgwArn",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/nm-security-iam.html",
        description:
          "Filters access by which transit gateways can be registered, deregistered, or peered",
        type: "ARN",
      },
      {
        name: "networkmanager:tgwConnectPeerArn",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/nm-security-iam.html",
        description:
          "Filters access by which transit gateway connect peers can be associated or disassociated",
        type: "ARN",
      },
      {
        name: "networkmanager:tgwRtbArn",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/nm-security-iam.html",
        description:
          "Filters access by which Transit Gateway Route Table can be used to create an attachment",
        type: "ARN",
      },
      {
        name: "networkmanager:vpcArn",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/nm-security-iam.html",
        description:
          "Filters access by which VPC can be used to a create/update attachment",
        type: "ARN",
      },
      {
        name: "networkmanager:vpnConnectionArn",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/tgw/nm-security-iam.html",
        description:
          "Filters access by which Site-to-Site VPN can be used to a create/update attachment",
        type: "ARN",
      },
    ],
  },
  "networkmanager-chat": {
    name: "AWS Network Manager Chat",
    servicePrefix: "networkmanager-chat",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsnetworkmanagerchat.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AWSEC2/latest/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  nimble: {
    name: "Amazon Nimble Studio",
    servicePrefix: "nimble",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonnimblestudio.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/",
    resourceTypes: [
      {
        name: "studio",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/API_Studio.html",
        arnPattern:
          "arn:${Partition}:nimble:${Region}:${Account}:studio/${StudioId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "nimble:studioId",
        ],
      },
      {
        name: "streaming-image",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/API_StreamingImage.html",
        arnPattern:
          "arn:${Partition}:nimble:${Region}:${Account}:streaming-image/${StreamingImageId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "nimble:studioId",
        ],
      },
      {
        name: "studio-component",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/API_StudioComponent.html",
        arnPattern:
          "arn:${Partition}:nimble:${Region}:${Account}:studio-component/${StudioComponentId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "nimble:studioId",
        ],
      },
      {
        name: "launch-profile",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/API_LaunchProfile.html",
        arnPattern:
          "arn:${Partition}:nimble:${Region}:${Account}:launch-profile/${LaunchProfileId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "nimble:studioId",
        ],
      },
      {
        name: "streaming-session",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/API_StreamingSession.html",
        arnPattern:
          "arn:${Partition}:nimble:${Region}:${Account}:streaming-session/${StreamingSessionId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "nimble:createdBy",
          "nimble:ownedBy",
        ],
      },
      {
        name: "streaming-session-backup",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/API_StreamingSessionBackup.html",
        arnPattern:
          "arn:${Partition}:nimble:${Region}:${Account}:streaming-session-backup/${StreamingSessionBackupId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "nimble:ownedBy",
        ],
      },
      {
        name: "eula",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/API_Eula.html",
        arnPattern:
          "arn:${Partition}:nimble:${Region}:${Account}:eula/${EulaId}",
        conditionKeys: [],
      },
      {
        name: "eula-acceptance",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/APIReference/API_EulaAcceptance.html",
        arnPattern:
          "arn:${Partition}:nimble:${Region}:${Account}:eula-acceptance/${EulaAcceptanceId}",
        conditionKeys: ["nimble:studioId"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "nimble:createdBy",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/userguide/security-iam-service-with-iam.html",
        description:
          "Filters access by the createdBy request parameter or the ID of the creator of the resource",
        type: "String",
      },
      {
        name: "nimble:ownedBy",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/userguide/security-iam-service-with-iam.html",
        description:
          "Filters access by the ownedBy request parameter or the ID of the owner of the resource",
        type: "String",
      },
      {
        name: "nimble:principalId",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/userguide/security-iam-service-with-iam.html",
        description: "Filters access by the principalId request parameter",
        type: "String",
      },
      {
        name: "nimble:requesterPrincipalId",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/userguide/security-iam-service-with-iam.html",
        description: "Filters access by the ID of the logged in user",
        type: "String",
      },
      {
        name: "nimble:studioId",
        referenceHref:
          "https://docs.aws.amazon.com/nimble-studio/latest/userguide/security-iam-service-with-iam.html",
        description: "Filters access by a specific studio",
        type: "ARN",
      },
    ],
  },
  one: {
    name: "Amazon One Enterprise",
    servicePrefix: "one",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazononeenterprise.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/one-enterprise/latest/userguide/",
    resourceTypes: [
      {
        name: "device-instance",
        referenceHref:
          "https://docs.aws.amazon.com/one-enterprise/latest/userguide/create-device-instance.html",
        arnPattern:
          "arn:${Partition}:one:${Region}:${Account}:device-instance/${DeviceInstanceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "configuration",
        referenceHref:
          "https://docs.aws.amazon.com/one-enterprise/latest/userguide/configure-instance.html",
        arnPattern:
          "arn:${Partition}:one:${Region}:${Account}:device-instance/${DeviceInstanceId}/configuration/${Version}",
        conditionKeys: [],
      },
      {
        name: "device-configuration-template",
        referenceHref:
          "https://docs.aws.amazon.com/one-enterprise/latest/userguide/create-config-template.html",
        arnPattern:
          "arn:${Partition}:one:${Region}:${Account}:device-configuration-template/${TemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "site",
        referenceHref:
          "https://docs.aws.amazon.com/one-enterprise/latest/userguide/create-sites.html",
        arnPattern: "arn:${Partition}:one:${Region}:${Account}:site/${SiteId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/one-enterprise/latest/userguide/enrollment-entry.html",
        arnPattern: "arn:${Partition}:one:${Region}:${Account}:user/${UserId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by using tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by using tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  osis: {
    name: "Amazon OpenSearch Ingestion",
    servicePrefix: "osis",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonopensearchingestion.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/opensearch-service/latest/APIReference/API_Operations_Amazon_OpenSearch_Ingestion.html",
    resourceTypes: [
      {
        name: "pipeline",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/APIReference/API_Pipeline.html",
        arnPattern:
          "arn:${Partition}:osis:${Region}:${Account}:pipeline/${PipelineName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "pipeline-blueprint",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/APIReference/API_PipelineBlueprint.html",
        arnPattern:
          "arn:${Partition}:osis:${Region}:${Account}:blueprint/${BlueprintName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  aoss: {
    name: "Amazon OpenSearch Serverless",
    servicePrefix: "aoss",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonopensearchserverless.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/opensearch-service/latest/ServerlessAPIReference/",
    resourceTypes: [
      {
        name: "Collection",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/developerguide/serverless-overview.html",
        arnPattern:
          "arn:${Partition}:aoss:${Region}:${Account}:collection/${CollectionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Dashboards",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/developerguide/serverless-overview.html",
        arnPattern:
          "arn:${Partition}:aoss:${Region}:${Account}:dashboards/default",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aoss:CollectionId",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/developerguide/security-iam-serverless.html#security_iam_serverless-conditionkeys",
        description: "Filters access by the identifier of the collection",
        type: "String",
      },
      {
        name: "aoss:collection",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/developerguide/security-iam-serverless.html#security_iam_serverless-conditionkeys",
        description: "Filters access by the collection name",
        type: "String",
      },
      {
        name: "aoss:index",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/developerguide/security-iam-serverless.html#security_iam_serverless-conditionkeys",
        description: "Filters access by the index",
        type: "String",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref: "security-iam-serverless.html#condition-keys-requesttag",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "security-iam-serverless.html#condition-keys-resourcetag",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref: "security-iam-serverless.html#condition-keys-tagkeys",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  es: {
    name: "Amazon OpenSearch Service",
    servicePrefix: "es",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonopensearchservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/opensearch-service/latest/APIReference/",
    resourceTypes: [
      {
        name: "domain",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/developerguide/ac.html",
        arnPattern:
          "arn:${Partition}:es:${Region}:${Account}:domain/${DomainName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "es_role",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/developerguide/slr.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:role/aws-service-role/es.amazonaws.com/AWSServiceRoleForAmazonOpenSearchService",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "opensearchservice_role",
        referenceHref:
          "https://docs.aws.amazon.com/opensearch-service/latest/developerguide/slr.html",
        arnPattern:
          "arn:${Partition}:iam::${Account}:role/aws-service-role/opensearchservice.amazonaws.com/AWSServiceRoleForAmazonOpenSearchService",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  opsworks: {
    name: "AWS OpsWorks",
    servicePrefix: "opsworks",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsopsworks.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/opsworks/latest/APIReference/",
    resourceTypes: [
      {
        name: "stack",
        referenceHref:
          "https://docs.aws.amazon.com/opsworks/latest/userguide/workingstacks.html",
        arnPattern:
          "arn:${Partition}:opsworks:${Region}:${Account}:stack/${StackId}/",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  "opsworks-cm": {
    name: "AWS OpsWorks Configuration Management",
    servicePrefix: "opsworks-cm",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsopsworksconfigurationmanagement.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/opsworks-cm/latest/APIReference/",
    resourceTypes: [
      {
        name: "server",
        arnPattern:
          "arn:${Partition}:opsworks-cm::${Account}:server/${ServerName}/${UniqueId}",
        conditionKeys: [],
      },
      {
        name: "backup",
        arnPattern:
          "arn:${Partition}:opsworks-cm::${Account}:backup/${ServerName}-{Date-and-Time-Stamp-of-Backup}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  organizations: {
    name: "AWS Organizations",
    servicePrefix: "organizations",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsorganizations.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/organizations/latest/APIReference/",
    resourceTypes: [
      {
        name: "account",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_reference_arn-formats.html",
        arnPattern:
          "arn:${Partition}:organizations::${Account}:account/o-${OrganizationId}/${AccountId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "handshake",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_reference_arn-formats.html",
        arnPattern:
          "arn:${Partition}:organizations::${Account}:handshake/o-${OrganizationId}/${HandshakeType}/h-${HandshakeId}",
        conditionKeys: [],
      },
      {
        name: "organization",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_reference_arn-formats.html",
        arnPattern:
          "arn:${Partition}:organizations::${Account}:organization/o-${OrganizationId}",
        conditionKeys: [],
      },
      {
        name: "organizationalunit",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_reference_arn-formats.html",
        arnPattern:
          "arn:${Partition}:organizations::${Account}:ou/o-${OrganizationId}/ou-${OrganizationalUnitId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "policy",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_reference_arn-formats.html",
        arnPattern:
          "arn:${Partition}:organizations::${Account}:policy/o-${OrganizationId}/${PolicyType}/p-${PolicyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "resourcepolicy",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_reference_arn-formats.html",
        arnPattern:
          "arn:${Partition}:organizations::${Account}:resourcepolicy/o-${OrganizationId}/rp-${ResourcePolicyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "awspolicy",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_reference_arn-formats.html",
        arnPattern:
          "arn:${Partition}:organizations::aws:policy/${PolicyType}/p-${PolicyId}",
        conditionKeys: [],
      },
      {
        name: "root",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_reference_arn-formats.html",
        arnPattern:
          "arn:${Partition}:organizations::${Account}:root/o-${OrganizationId}/r-${RootId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "organizations:PolicyType",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_permissions_overview.html#orgs_permissions_conditionkeys",
        description: "Filters access by the specified policy type names",
        type: "String",
      },
      {
        name: "organizations:ServicePrincipal",
        referenceHref:
          "https://docs.aws.amazon.com/organizations/latest/userguide/orgs_permissions_overview.html#orgs_permissions_conditionkeys",
        description: "Filters access by the specified service principal names",
        type: "String",
      },
    ],
  },
  outposts: {
    name: "AWS Outposts",
    servicePrefix: "outposts",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsoutposts.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/outposts/latest/APIReference/",
    resourceTypes: [
      {
        name: "outpost",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/work-with-outposts.html",
        arnPattern:
          "arn:${Partition}:outposts:${Region}:${Account}:outpost/${OutpostId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "site",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/work-with-outposts.html",
        arnPattern:
          "arn:${Partition}:outposts:${Region}:${Account}:site/${SiteId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/identity-access-management.html",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/identity-access-management.html",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/outposts/latest/userguide/identity-access-management.html",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  panorama: {
    name: "AWS Panorama",
    servicePrefix: "panorama",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awspanorama.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/panorama/latest/api/Welcome.html",
    resourceTypes: [
      {
        name: "device",
        referenceHref:
          "https://docs.aws.amazon.com/panorama/latest/dev/gettingstarted-concepts.html#gettingstarted-concepts-appliance",
        arnPattern:
          "arn:${Partition}:panorama:${Region}:${Account}:device/${DeviceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "package",
        referenceHref:
          "https://docs.aws.amazon.com/panorama/latest/dev/gettingstarted-concepts.html#gettingstarted-concepts-node",
        arnPattern:
          "arn:${Partition}:panorama:${Region}:${Account}:package/${PackageId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "applicationInstance",
        referenceHref:
          "https://docs.aws.amazon.com/panorama/latest/dev/gettingstarted-concepts.html#gettingstarted-concepts-application",
        arnPattern:
          "arn:${Partition}:panorama:${Region}:${Account}:applicationInstance/${ApplicationInstanceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "partnercentral-account-management": {
    name: "AWS Partner central account management",
    servicePrefix: "partnercentral-account-management",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awspartnercentralaccountmanagement.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/partner-central/latest/getting-started/controlling-access-in-apc-account-management.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  "payment-cryptography": {
    name: "AWS Payment Cryptography",
    servicePrefix: "payment-cryptography",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awspaymentcryptography.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/payment-cryptography/latest/APIReference/",
    resourceTypes: [
      {
        name: "key",
        referenceHref: "${APIReferenceDocPage}API_Key.html",
        arnPattern:
          "arn:${Partition}:payment-cryptography:${Region}:${Account}:key/${KeyId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "payment-cryptography:ResourceAliases",
        ],
      },
      {
        name: "alias",
        referenceHref: "${APIReferenceDocPage}API_Alias.html",
        arnPattern:
          "arn:${Partition}:payment-cryptography:${Region}:${Account}:alias/${Alias}",
        conditionKeys: ["payment-cryptography:ResourceAliases"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by both the key and value of the tag in the request for the specified operation",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/payment-cryptography/latest/APIReference/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by tags assigned to a key for the specified operation",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys in the request for the specified operation",
        type: "ArrayOfString",
      },
      {
        name: "payment-cryptography:CertificateAuthorityPublicKeyIdentifier",
        referenceHref: "{ActionsDocRoot}security-iam.html",
        description:
          "Filters access by the CertificateAuthorityPublicKeyIdentifier specified in the request or the ImportKey, and ExportKey operations",
        type: "String",
      },
      {
        name: "payment-cryptography:ImportKeyMaterial",
        referenceHref: "{ActionsDocRoot}security-iam.html",
        description:
          "Filters access by the type of key material being imported [RootCertificatePublicKey, TrustedCertificatePublicKey, Tr34KeyBlock, Tr31KeyBlock] for the ImportKey operation",
        type: "String",
      },
      {
        name: "payment-cryptography:KeyAlgorithm",
        referenceHref: "{ActionsDocRoot}security-iam.html",
        description:
          "Filters access by KeyAlgorithm specified in the request for the CreateKey operation",
        type: "String",
      },
      {
        name: "payment-cryptography:KeyClass",
        referenceHref: "{ActionsDocRoot}security-iam.html",
        description:
          "Filters access by KeyClass specified in the request for the CreateKey operation",
        type: "String",
      },
      {
        name: "payment-cryptography:KeyUsage",
        referenceHref: "{ActionsDocRoot}security-iam.html",
        description:
          "Filters access by KeyClass specified in the request or associated with a key for the CreateKey operation",
        type: "String",
      },
      {
        name: "payment-cryptography:RequestAlias",
        referenceHref: "{ActionsDocRoot}security-iam.html",
        description:
          "Filters access by aliases in the request for the specified operation",
        type: "String",
      },
      {
        name: "payment-cryptography:ResourceAliases",
        referenceHref: "{ActionsDocRoot}security-iam.html",
        description:
          "Filters access by aliases associated with a key for the specified operation",
        type: "ArrayOfString",
      },
      {
        name: "payment-cryptography:WrappingKeyIdentifier",
        referenceHref: "{ActionsDocRoot}security-iam.html",
        description:
          "Filters access by the WrappingKeyIdentifier specified in the request for the ImportKey, and ExportKey operations",
        type: "String",
      },
    ],
  },
  payments: {
    name: "AWS Payments",
    servicePrefix: "payments",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awspayments.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/billing-permissions-ref.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  pi: {
    name: "AWS Performance Insights",
    servicePrefix: "pi",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsperformanceinsights.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/performance-insights/latest/APIReference/",
    resourceTypes: [
      {
        name: "metric-resource",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_PerfInsights.access-control.html",
        arnPattern:
          "arn:${Partition}:pi:${Region}:${Account}:metrics/${ServiceType}/${Identifier}",
        conditionKeys: [],
      },
      {
        name: "perf-reports-resource",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_PerfInsights.access-control.html",
        arnPattern:
          "arn:${Partition}:pi:${Region}:${Account}:perf-reports/${ServiceType}/${Identifier}/${ReportId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref: "#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref: "#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref: "#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  personalize: {
    name: "Amazon Personalize",
    servicePrefix: "personalize",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonpersonalize.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/personalize/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "schema",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/how-it-works-dataset-schema.html#schema-examples",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:schema/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "featureTransformation",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_FeatureTransformation.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:feature-transformation/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "dataset",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_Dataset.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:dataset/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "datasetGroup",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_DatasetGroup.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:dataset-group/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "datasetImportJob",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_DatasetImportJob.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:dataset-import-job/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "dataInsightsJob",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/analyzing-data.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:data-insights-job/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "datasetExportJob",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_DatasetExportJob.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:dataset-export-job/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "solution",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_Solution.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:solution/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "campaign",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_Campaign.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:campaign/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "eventTracker",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_EventTracker.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:event-tracker/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "recipe",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_Recipe.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:recipe/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "algorithm",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_Algorithm.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:algorithm/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "batchInferenceJob",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_BatchInferenceJob.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:batch-inference-job/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "filter",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_Filter.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:filter/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "recommender",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_Recommender.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:recommender/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "batchSegmentJob",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_BatchSegmentJob.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:batch-segment-job/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "metricAttribution",
        referenceHref:
          "https://docs.aws.amazon.com/personalize/latest/dg/API_MetricAttribution.html",
        arnPattern:
          "arn:${Partition}:personalize:${Region}:${Account}:metric-attribution/${ResourceId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  mobiletargeting: {
    name: "Amazon Pinpoint",
    servicePrefix: "mobiletargeting",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonpinpoint.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/pinpoint/latest/apireference/",
    resourceTypes: [
      {
        name: "app",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "apps",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/*",
        conditionKeys: [],
      },
      {
        name: "campaign",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-campaigns-campaign-id.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/campaigns/${CampaignId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "journey",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-journeys-journey-id.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/journeys/${JourneyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "journeys",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-journeys.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/journeys",
        conditionKeys: [],
      },
      {
        name: "segment",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-segments-segment-id.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/segments/${SegmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "template",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/templates.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:templates/${TemplateName}/${TemplateType}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "templates",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/templates.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:templates",
        conditionKeys: [],
      },
      {
        name: "recommender",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/recommenders.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:recommenders/${RecommenderId}",
        conditionKeys: [],
      },
      {
        name: "recommenders",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/recommenders.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:recommenders/*",
        conditionKeys: [],
      },
      {
        name: "phone-number-validate",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/phone-number-validate.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:phone/number/validate",
        conditionKeys: [],
      },
      {
        name: "channels",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-channels.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/channels",
        conditionKeys: [],
      },
      {
        name: "channel",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-channels.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/channels/${ChannelType}",
        conditionKeys: [],
      },
      {
        name: "event-stream",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-eventstream.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/eventstream",
        conditionKeys: [],
      },
      {
        name: "events",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-events.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/events",
        conditionKeys: [],
      },
      {
        name: "messages",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-messages.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/messages",
        conditionKeys: [],
      },
      {
        name: "verify-otp",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-verify-otp.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/verify-otp",
        conditionKeys: [],
      },
      {
        name: "otp",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-verify-otp.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/otp",
        conditionKeys: [],
      },
      {
        name: "attribute",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-attributes-attribute-type.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/attributes/${AttributeType}",
        conditionKeys: [],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-users-user-id.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/users/${UserId}",
        conditionKeys: [],
      },
      {
        name: "endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-endpoints-endpoint-id.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/endpoints/${EndpointId}",
        conditionKeys: [],
      },
      {
        name: "import-job",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-jobs-import-job-id.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/jobs/import/${JobId}",
        conditionKeys: [],
      },
      {
        name: "export-job",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-jobs-export-job-id.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/jobs/export/${JobId}",
        conditionKeys: [],
      },
      {
        name: "application-metrics",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-kpis-daterange-kpi-name.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/kpis/daterange/${KpiName}",
        conditionKeys: [],
      },
      {
        name: "campaign-metrics",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-campaigns-campaign-id-kpis-daterange-kpi-name.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/campaigns/${CampaignId}/kpis/daterange/${KpiName}",
        conditionKeys: [],
      },
      {
        name: "journey-metrics",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-journeys-journey-id-kpis-daterange-kpi-name.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/journeys/${JourneyId}/kpis/daterange/${KpiName}",
        conditionKeys: [],
      },
      {
        name: "journey-execution-metrics",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-journeys-journey-id-execution-metrics.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/journeys/${JourneyId}/execution-metrics",
        conditionKeys: [],
      },
      {
        name: "journey-execution-activity-metrics",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/apps-application-id-journeys-journey-id-activities-journey-activity-id-execution-metrics.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:apps/${AppId}/journeys/${JourneyId}/activities/${JourneyActivityId}/execution-metrics",
        conditionKeys: [],
      },
      {
        name: "reports",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference/reports.html",
        arnPattern:
          "arn:${Partition}:mobiletargeting:${Region}:${Account}:reports",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by a key that is present in the request the user makes to the pinpoint service",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description: "Filters access by a tag key and value pair",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the list of all the tag key names present in the request the user makes to the pinpoint service",
        type: "ArrayOfString",
      },
    ],
  },
  ses: {
    name: "Amazon Simple Email Service v2",
    servicePrefix: "ses",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsimpleemailservicev2.html",
    apiReferenceHref: "https://docs.aws.amazon.com/ses/latest/APIReference-V2/",
    resourceTypes: [
      {
        name: "configuration-set",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference/API_ConfigurationSet.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:configuration-set/${ConfigurationSetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "contact-list",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference-V2/API_ContactList.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:contact-list/${ContactListName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "custom-verification-email-template",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference-V2/API_CustomVerificationEmailTemplateMetadata.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:custom-verification-email-template/${TemplateName}",
        conditionKeys: [],
      },
      {
        name: "dedicated-ip-pool",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference-V2/API_DedicatedIp.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:dedicated-ip-pool/${DedicatedIPPool}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deliverability-test-report",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference-V2/API_DeliverabilityTestReport.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:deliverability-test-report/${ReportId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "export-job",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference-V2/API_ExportJobSummary.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:export-job/${ExportJobId}",
        conditionKeys: [],
      },
      {
        name: "identity",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference-V2/API_IdentityInfo.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:identity/${IdentityName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "import-job",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference-V2/API_ImportJobSummary.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:import-job/${ImportJobId}",
        conditionKeys: [],
      },
      {
        name: "template",
        referenceHref:
          "https://docs.aws.amazon.com/ses/latest/APIReference-V2/API_Template.html",
        arnPattern:
          "arn:${Partition}:ses:${Region}:${Account}:template/${TemplateName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "ses:ApiVersion",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonses.html#amazonses-policy-keys",
        description: "Filters access by the SES API version",
        type: "String",
      },
      {
        name: "ses:ExportSourceType",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonses.html#amazonses-policy-keys",
        description: "Filters access by the export source type",
        type: "String",
      },
      {
        name: "ses:FeedbackAddress",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonses.html#amazonses-policy-keys",
        description:
          'Filters access by the "Return-Path" address, which specifies where bounces and complaints are sent by email feedback forwarding',
        type: "String",
      },
      {
        name: "ses:FromAddress",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonses.html#amazonses-policy-keys",
        description: 'Filters access by the "From" address of a message',
        type: "String",
      },
      {
        name: "ses:FromDisplayName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonses.html#amazonses-policy-keys",
        description:
          'Filters access by the "From" address that is used as the display name of a message',
        type: "String",
      },
      {
        name: "ses:Recipients",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonses.html#amazonses-policy-keys",
        description:
          'Filters access by the recipient addresses of a message, which include the "To", "CC", and "BCC" addresses',
        type: "ArrayOfString",
      },
    ],
  },
  "sms-voice": {
    name: "Amazon Pinpoint SMS Voice V2",
    servicePrefix: "sms-voice",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonpinpointsmsvoicev2.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/Welcome.html",
    resourceTypes: [
      {
        name: "ConfigurationSet",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/API_CreateConfigurationSet.html",
        arnPattern:
          "arn:${Partition}:sms-voice:${Region}:${Account}:configuration-set/${ConfigurationSetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "OptOutList",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/API_CreateOptOutList.html",
        arnPattern:
          "arn:${Partition}:sms-voice:${Region}:${Account}:opt-out-list/${OptOutListName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "PhoneNumber",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/API_RequestPhoneNumber.html",
        arnPattern:
          "arn:${Partition}:sms-voice:${Region}:${Account}:phone-number/${PhoneNumberId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Pool",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/API_CreatePool.html",
        arnPattern:
          "arn:${Partition}:sms-voice:${Region}:${Account}:pool/${PoolId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "SenderId",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/API_DescribeSenderIds.html",
        arnPattern:
          "arn:${Partition}:sms-voice:${Region}:${Account}:sender-id/${SenderId}/${IsoCountryCode}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Registration",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/API_DescribeRegistrations.html",
        arnPattern:
          "arn:${Partition}:sms-voice:${Region}:${Account}:registration/${RegistrationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "RegistrationAttachment",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/API_DescribeRegistrationAttachments.html",
        arnPattern:
          "arn:${Partition}:sms-voice:${Region}:${Account}:registration-attachment/${RegistrationAttachmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "VerifiedDestinationNumber",
        referenceHref:
          "https://docs.aws.amazon.com/pinpoint/latest/apireference_smsvoicev2/API_DescribeVerifiedDestinationNumbers.html",
        arnPattern:
          "arn:${Partition}:sms-voice:${Region}:${Account}:verified-destination-number/${VerifiedDestinationNumberId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  polly: {
    name: "Amazon Polly",
    servicePrefix: "polly",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonpolly.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/polly/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "lexicon",
        referenceHref:
          "https://docs.aws.amazon.com/polly/latest/dg/managing-lexicons.html",
        arnPattern:
          "arn:${Partition}:polly:${Region}:${Account}:lexicon/${LexiconName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  pricing: {
    name: "AWS Price List",
    servicePrefix: "pricing",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awspricelist.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/API_Operations_AWS_Price_List_Service.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  "pca-connector-ad": {
    name: "AWS Private CA Connector for Active Directory",
    servicePrefix: "pca-connector-ad",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsprivatecaconnectorforactivedirectory.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/pca-connector-ad/latest/APIReference/",
    resourceTypes: [
      {
        name: "Connector",
        referenceHref:
          "https://docs.aws.amazon.com/pca-connector-ad/latest/userguide/API_Connector.html",
        arnPattern:
          "arn:${Partition}:pca-connector-ad:${Region}:${Account}:connector/${ConnectorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "DirectoryRegistration",
        referenceHref:
          "https://docs.aws.amazon.com/pca-connector-ad/latest/userguide/API_DirectoryRegistration.html",
        arnPattern:
          "arn:${Partition}:pca-connector-ad:${Region}:${Account}:directory-registration/${DirectoryId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ServicePrincipalName",
        referenceHref:
          "https://docs.aws.amazon.com/pca-connector-ad/latest/userguide/API_ServicePrincipalName.html",
        arnPattern:
          "arn:${Partition}:pca-connector-ad:${Region}:${Account}:directory-registration/${DirectoryId}",
        conditionKeys: [],
      },
      {
        name: "Template",
        referenceHref:
          "https://docs.aws.amazon.com/pca-connector-ad/latest/userguide/API_Template.html",
        arnPattern:
          "arn:${Partition}:pca-connector-ad:${Region}:${Account}:connector/${ConnectorId}/template/${TemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "TemplateGroupAccessControlEntry",
        referenceHref:
          "https://docs.aws.amazon.com/pca-connector-ad/latest/userguide/API_TemplateGroupAccessControlEntry.html",
        arnPattern:
          "arn:${Partition}:pca-connector-ad:${Region}:${Account}:connector/${ConnectorId}/template/${TemplateId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/pca-connector-ad/latest/userguide/reference_policies_iam-condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/pca-connector-ad/latest/userguide/reference_policies_iam-condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/pca-connector-ad/latest/userguide/reference_policies_iam-condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "acm-pca": {
    name: "AWS Private Certificate Authority",
    servicePrefix: "acm-pca",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsprivatecertificateauthority.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/privateca/latest/APIReference/",
    resourceTypes: [
      {
        name: "certificate-authority",
        referenceHref:
          "https://docs.aws.amazon.com/privateca/latest/userguide/api-permissions.html",
        arnPattern:
          "arn:${Partition}:acm-pca:${Region}:${Account}:certificate-authority/${CertificateAuthorityId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "acm-pca:TemplateArn",
        referenceHref:
          "https://docs.aws.amazon.com/privateca/latest/userguide/UsingTemplates.html#template-varieties",
        description:
          "Filters access by the arn of the certificate template used in Issue Certificate request",
        type: "ARN",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  proton: {
    name: "AWS Proton",
    servicePrefix: "proton",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsproton.html",
    apiReferenceHref: "https://docs.aws.amazon.com/proton/latest/APIReference/",
    resourceTypes: [
      {
        name: "environment-template",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-env-templates.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:environment-template/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "environment-template-version",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-env-templates.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:environment-template/${TemplateName}:${MajorVersion}.${MinorVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "environment-template-major-version",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-env-templates.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:environment-template/${TemplateName}:${MajorVersionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "environment-template-minor-version",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-env-templates.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:environment-template/${TemplateName}:${MajorVersionId}.${MinorVersionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "service-template",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/managing-svc-templates.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:service-template/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "service-template-version",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/managing-svc-templates.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:service-template/${TemplateName}:${MajorVersion}.${MinorVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "service-template-major-version",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/managing-svc-templates.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:service-template/${TemplateName}:${MajorVersionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "service-template-minor-version",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/managing-svc-templates.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:service-template/${TemplateName}:${MajorVersionId}.${MinorVersionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-environments.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:environment/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "service",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-services.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:service/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "service-instance",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-services.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:service/${ServiceName}/service-instance/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "environment-account-connection",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-env-account-connections.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:environment-account-connection/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "repository",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-repositories.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:repository/${Provider}:${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "component",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-components.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:component/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deployment",
        referenceHref:
          "https://docs.aws.amazon.com/proton/latest/adminguide/ag-deployments.html",
        arnPattern:
          "arn:${Partition}:proton:${Region}:${Account}:deployment/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "proton:EnvironmentTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html",
        description:
          "Filters access by specified environment template related to resource",
        type: "String",
      },
      {
        name: "proton:ServiceTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html",
        description:
          "Filters access by specified service template related to resource",
        type: "String",
      },
    ],
  },
  "purchase-orders": {
    name: "AWS Purchase Orders Console",
    servicePrefix: "purchase-orders",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awspurchaseordersconsole.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/",
    resourceTypes: [
      {
        name: "purchase-order",
        referenceHref:
          "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/billing-permissions-ref.html#user-permissions",
        arnPattern:
          "arn:${Partition}:purchase-orders::${Account}:purchase-order/${ResourceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the set of tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
    ],
  },
  q: {
    name: "Amazon Q",
    servicePrefix: "q",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonq.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amazonq/latest/aws-builder-use-ug/security-iam-service-with-iam.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  qbusiness: {
    name: "Amazon Q Business",
    servicePrefix: "qbusiness",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonqbusiness.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amazonq/latest/api-reference/",
    resourceTypes: [
      {
        name: "application",
        referenceHref: "${UserGuideDocPage}create-application.html",
        arnPattern:
          "arn:${Partition}:qbusiness:${Region}:${Account}:application/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "retriever",
        referenceHref: "${UserGuideDocPage}select-retriever.html",
        arnPattern:
          "arn:${Partition}:qbusiness:${Region}:${Account}:application/${ApplicationId}/retriever/${RetrieverId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "index",
        referenceHref: "${UserGuideDocPage}select-retriever.html",
        arnPattern:
          "arn:${Partition}:qbusiness:${Region}:${Account}:application/${ApplicationId}/index/${IndexId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "data-source",
        referenceHref: "${UserGuideDocPage}connect-data.html",
        arnPattern:
          "arn:${Partition}:qbusiness:${Region}:${Account}:application/${ApplicationId}/index/${IndexId}/data-source/${DataSourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "plugin",
        referenceHref: "${UserGuideDocPage}plugins.html",
        arnPattern:
          "arn:${Partition}:qbusiness:${Region}:${Account}:application/${ApplicationId}/plugin/${PluginId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "web-experience",
        referenceHref: "${UserGuideDocPage}using-web-experience.html",
        arnPattern:
          "arn:${Partition}:qbusiness:${Region}:${Account}:application/${ApplicationId}/web-experience/${WebExperienceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "user-license",
        referenceHref: "${UserGuideDocPage}provisioning.html",
        arnPattern:
          "arn:${Partition}:qbusiness:${Region}:${Account}:application/${ApplicationId}/user-license/${UserLicenseId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  wisdom: {
    name: "Amazon Q in Connect",
    servicePrefix: "wisdom",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonqinconnect.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/wisdom/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "Assistant",
        referenceHref:
          "https://docs.aws.amazon.com/wisdom/latest/APIReference/API_AssistantData.html",
        arnPattern:
          "arn:${Partition}:wisdom:${Region}:${Account}:assistant/${AssistantId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "AssistantAssociation",
        referenceHref:
          "https://docs.aws.amazon.com/wisdom/latest/APIReference/API_AssistantAssociationData.html",
        arnPattern:
          "arn:${Partition}:wisdom:${Region}:${Account}:association/${AssistantId}/${AssistantAssociationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Content",
        referenceHref:
          "https://docs.aws.amazon.com/wisdom/latest/APIReference/API_ContentData.html",
        arnPattern:
          "arn:${Partition}:wisdom:${Region}:${Account}:content/${KnowledgeBaseId}/${ContentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "KnowledgeBase",
        referenceHref:
          "https://docs.aws.amazon.com/wisdom/latest/APIReference/API_KnowledgeBaseData.html",
        arnPattern:
          "arn:${Partition}:wisdom:${Region}:${Account}:knowledge-base/${KnowledgeBaseId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Session",
        referenceHref:
          "https://docs.aws.amazon.com/wisdom/latest/APIReference/API_SessionData.html",
        arnPattern:
          "arn:${Partition}:wisdom:${Region}:${Account}:session/${AssistantId}/${SessionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "QuickResponse",
        referenceHref:
          "https://docs.aws.amazon.com/wisdom/latest/APIReference/API_QuickResponseData.html",
        arnPattern:
          "arn:${Partition}:wisdom:${Region}:${Account}:quick-response/${KnowledgeBaseId}/${QuickResponseId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "wisdom:SearchFilter/RoutingProfileArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonconnectwisdom.html#amazonconnectwisdom-policy-keys",
        description:
          "Filters access by the connect routing profile arn that is passed in the request",
        type: "ARN",
      },
    ],
  },
  qldb: {
    name: "Amazon QLDB",
    servicePrefix: "qldb",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonqldb.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/qldb/latest/developerguide/api-reference.html",
    resourceTypes: [
      {
        name: "ledger",
        referenceHref:
          "https://docs.aws.amazon.com/qldb/latest/developerguide/ledger-structure.html",
        arnPattern:
          "arn:${Partition}:qldb:${Region}:${Account}:ledger/${LedgerName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "stream",
        referenceHref:
          "https://docs.aws.amazon.com/qldb/latest/developerguide/streams.html",
        arnPattern:
          "arn:${Partition}:qldb:${Region}:${Account}:stream/${LedgerName}/${StreamId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "table",
        referenceHref:
          "https://docs.aws.amazon.com/qldb/latest/developerguide/working.manage-tables.html",
        arnPattern:
          "arn:${Partition}:qldb:${Region}:${Account}:ledger/${LedgerName}/table/${TableId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "catalog",
        referenceHref:
          "https://docs.aws.amazon.com/qldb/latest/developerguide/working.catalog.html",
        arnPattern:
          "arn:${Partition}:qldb:${Region}:${Account}:ledger/${LedgerName}/information_schema/user_tables",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "qldb:Purge",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-purge",
        description:
          "Filters access by the value of purge that is specified in a PartiQL DROP statement",
        type: "String",
      },
    ],
  },
  quicksight: {
    name: "Amazon QuickSight",
    servicePrefix: "quicksight",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonquicksight.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/quicksight/latest/APIReference/",
    resourceTypes: [
      {
        name: "account",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_AccountInfo.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:account/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_User.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:user/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "group",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_Group.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:group/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "analysis",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_Analysis.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:analysis/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dashboard",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_Dashboard.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:dashboard/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "template",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_Template.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:template/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vpcconnection",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_VPCConnection.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:vpcConnection/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "assetBundleExportJob",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_AssetBundleExportJob.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:asset-bundle-export-job/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "assetBundleImportJob",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_AssetBundleImportJob.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:asset-bundle-import-job/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "datasource",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_DataSource.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:datasource/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dataset",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_DataSet.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:dataset/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ingestion",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_Ingestion.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:dataset/${DatasetId}/ingestion/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "refreshschedule",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_RefreshSchedule.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:dataset/${DatasetId}/refresh-schedule/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "theme",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_Theme.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:theme/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "assignment",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_IAMPolicyAssignment.html",
        arnPattern:
          "arn:${Partition}:quicksight::${Account}:assignment/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "customization",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_AccountCustomization.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:customization/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "namespace",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_NamespaceInfoV2.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:namespace/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "folder",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_Folder.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:folder/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "emailCustomizationTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/user/customizing-quicksight-email-templates.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:email-customization-template/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "topic",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_TopicDetails.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:topic/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dashboardSnapshotJob",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/APIReference/API_DashboardSnapshotJob.html",
        arnPattern:
          "arn:${Partition}:quicksight:${Region}:${Account}:dashboard/${DashboardId}/snapshot-job/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by tag keys",
        type: "ArrayOfString",
      },
      {
        name: "quicksight:AllowedEmbeddingDomains",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/user/embedded-dashboards-for-authenticated-users-step-1.html",
        description: "Filters access by the allowed embedding domains",
        type: "ArrayOfString",
      },
      {
        name: "quicksight:DirectoryType",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/user/security-scp.html",
        description: "Filters access by the user management options",
        type: "String",
      },
      {
        name: "quicksight:Edition",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/user/security-scp.html",
        description: "Filters access by the edition of QuickSight",
        type: "String",
      },
      {
        name: "quicksight:IamArn",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/user/iam-actions.html",
        description: "Filters access by IAM user or role ARN",
        type: "ARN",
      },
      {
        name: "quicksight:SessionName",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/user/iam-actions.html",
        description: "Filters access by session name",
        type: "String",
      },
      {
        name: "quicksight:UserName",
        referenceHref:
          "https://docs.aws.amazon.com/quicksight/latest/user/iam-actions.html",
        description: "Filters access by user name",
        type: "String",
      },
    ],
  },
  rds: {
    name: "Amazon RDS",
    servicePrefix: "rds",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonrds.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonRDS/latest/APIReference/",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/AuroraUserGuide/CHAP_Aurora.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:cluster:${DbClusterInstanceName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "rds:cluster-tag/${TagKey}",
        ],
      },
      {
        name: "cluster-auto-backup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/AuroraUserGuide/Aurora.Managing.Backups.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:cluster-auto-backup:${DbClusterAutomatedBackupId}",
        conditionKeys: [],
      },
      {
        name: "auto-backup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_WorkingWithAutomatedBackups.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:auto-backup:${DbInstanceAutomatedBackupId}",
        conditionKeys: [],
      },
      {
        name: "cluster-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/AuroraUserGuide/Aurora.Overview.Endpoints.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:cluster-endpoint:${DbClusterEndpoint}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "cluster-pg",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/AuroraUserGuide/USER_WorkingWithParamGroups.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:cluster-pg:${ClusterParameterGroupName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "rds:cluster-pg-tag/${TagKey}",
        ],
      },
      {
        name: "cluster-snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/AuroraUserGuide/Aurora.Managing.Backups.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:cluster-snapshot:${ClusterSnapshotName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "rds:cluster-snapshot-tag/${TagKey}",
        ],
      },
      {
        name: "db",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/Overview.DBInstance.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:db:${DbInstanceName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "rds:DatabaseClass",
          "rds:DatabaseEngine",
          "rds:DatabaseName",
          "rds:MultiAz",
          "rds:Piops",
          "rds:StorageEncrypted",
          "rds:StorageSize",
          "rds:Vpc",
          "rds:db-tag/${TagKey}",
        ],
      },
      {
        name: "es",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_Events.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:es:${SubscriptionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "rds:es-tag/${TagKey}"],
      },
      {
        name: "global-cluster",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/AuroraUserGuide/aurora-global-database.html",
        arnPattern:
          "arn:${Partition}:rds::${Account}:global-cluster:${GlobalCluster}",
        conditionKeys: [],
      },
      {
        name: "og",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_WorkingWithOptionGroups.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:og:${OptionGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "rds:og-tag/${TagKey}"],
      },
      {
        name: "pg",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_WorkingWithParamGroups.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:pg:${ParameterGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "rds:pg-tag/${TagKey}"],
      },
      {
        name: "proxy",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/rds-proxy.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:db-proxy:${DbProxyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "proxy-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/rds-proxy.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:db-proxy-endpoint:${DbProxyEndpointId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ri",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_WorkingWithReservedDBInstances.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:ri:${ReservedDbInstanceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "rds:ri-tag/${TagKey}"],
      },
      {
        name: "secgrp",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/Overview.RDSSecurityGroups.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:secgrp:${SecurityGroupName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "rds:secgrp-tag/${TagKey}",
        ],
      },
      {
        name: "snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_WorkingWithAutomatedBackups.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:snapshot:${SnapshotName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "rds:snapshot-tag/${TagKey}",
        ],
      },
      {
        name: "subgrp",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/USER_VPC.Scenarios.html#USER_VPC.Scenario1",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:subgrp:${SubnetGroupName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "rds:subgrp-tag/${TagKey}",
        ],
      },
      {
        name: "target",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/rds-proxy.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:target:${TargetId}",
        conditionKeys: [],
      },
      {
        name: "target-group",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/rds-proxy.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:target-group:${TargetGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "cev",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/custom-cev.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:cev:${Engine}/${EngineVersion}/${CustomDbEngineVersionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deployment",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/blue-green-deployments.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:deployment:${BlueGreenDeploymentIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "integration",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/AuroraUserGuide/zero-etl.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:integration:${IntegrationIdentifier}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "snapshot-tenant-database",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/Oracle.Concepts.single-tenant.snapshots.html#br-cdb.db-snapshots",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:snapshot-tenant-database:${SnapshotName}:${TenantResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "tenant-database",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/Oracle.Concepts.CDBs.html#multi-tenant-configuration",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:tenant-database:${TenantResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the set of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the set of tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the set of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "rds:BackupTarget",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the type of backup target. One of: REGION, OUTPOSTS",
        type: "String",
      },
      {
        name: "rds:CopyOptionGroup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the value that specifies whether the CopyDBSnapshot action requires copying the DB option group",
        type: "Bool",
      },
      {
        name: "rds:DatabaseClass",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description: "Filters access by the type of DB instance class",
        type: "String",
      },
      {
        name: "rds:DatabaseEngine",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the database engine. For possible values refer to the engine parameter in CreateDBInstance API",
        type: "String",
      },
      {
        name: "rds:DatabaseName",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the user-defined name of the database on the DB instance",
        type: "String",
      },
      {
        name: "rds:EndpointType",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the type of the endpoint. One of: READER, WRITER, CUSTOM",
        type: "String",
      },
      {
        name: "rds:ManageMasterUserPassword",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the value that specifies whether RDS manages master user password in AWS Secrets Manager for the DB instance or cluster",
        type: "Bool",
      },
      {
        name: "rds:MultiAz",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the value that specifies whether the DB instance runs in multiple Availability Zones. To indicate that the DB instance is using Multi-AZ, specify true",
        type: "Bool",
      },
      {
        name: "rds:MultiTenant",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the value that specifies whether the DB instance is in the multi-tenant configuration",
        type: "String",
      },
      {
        name: "rds:Piops",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the value that contains the number of Provisioned IOPS (PIOPS) that the instance supports. To indicate a DB instance that does not have PIOPS enabled, specify 0",
        type: "Numeric",
      },
      {
        name: "rds:StorageEncrypted",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the value that specifies whether the DB instance storage should be encrypted. To enforce storage encryption, specify true",
        type: "Bool",
      },
      {
        name: "rds:StorageSize",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description: "Filters access by the storage volume size (in GB)",
        type: "Numeric",
      },
      {
        name: "rds:TenantDatabaseName",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the tenant database name in CreateTenantDatabase and by the new tenant database name in ModifyTenantDatabase",
        type: "String",
      },
      {
        name: "rds:Vpc",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the value that specifies whether the DB instance runs in an Amazon Virtual Private Cloud (Amazon VPC). To indicate that the DB instance runs in an Amazon VPC, specify true",
        type: "Bool",
      },
      {
        name: "rds:cluster-pg-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the tag attached to a DB cluster parameter group",
        type: "String",
      },
      {
        name: "rds:cluster-snapshot-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the tag attached to a DB cluster snapshot",
        type: "String",
      },
      {
        name: "rds:cluster-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description: "Filters access by the tag attached to a DB cluster",
        type: "String",
      },
      {
        name: "rds:db-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description: "Filters access by the tag attached to a DB instance",
        type: "String",
      },
      {
        name: "rds:es-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the tag attached to an event subscription",
        type: "String",
      },
      {
        name: "rds:og-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description: "Filters access by the tag attached to a DB option group",
        type: "String",
      },
      {
        name: "rds:pg-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the tag attached to a DB parameter group",
        type: "String",
      },
      {
        name: "rds:req-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the set of tag keys and values that can be used to tag a resource",
        type: "String",
      },
      {
        name: "rds:ri-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the tag attached to a reserved DB instance",
        type: "String",
      },
      {
        name: "rds:secgrp-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description:
          "Filters access by the tag attached to a DB security group",
        type: "String",
      },
      {
        name: "rds:snapshot-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description: "Filters access by the tag attached to a DB snapshot",
        type: "String",
      },
      {
        name: "rds:subgrp-tag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/security_iam_service-with-iam.html#UsingWithRDS.IAM.Conditions",
        description: "Filters access by the tag attached to a DB subnet group",
        type: "String",
      },
    ],
  },
  "rds-data": {
    name: "Amazon RDS Data API",
    servicePrefix: "rds-data",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonrdsdataapi.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/rdsdataservice/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/Aurora.Managing.html",
        arnPattern:
          "arn:${Partition}:rds:${Region}:${Account}:cluster:${DbClusterInstanceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}", "aws:TagKeys"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys associated with the resource",
        type: "ArrayOfString",
      },
    ],
  },
  "rds-db": {
    name: "Amazon RDS IAM Authentication",
    servicePrefix: "rds-db",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonrdsiamauthentication.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonRDS/latest/APIReference/",
    resourceTypes: [
      {
        name: "db-user",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonRDS/latest/UserGuide/UsingWithRDS.IAMDBAuth.DBAccounts.html",
        arnPattern:
          "arn:${Partition}:rds-db:${Region}:${Account}:dbuser:${DbiResourceId}/${DbUserName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  repostspace: {
    name: "AWS re:Post Private",
    servicePrefix: "repostspace",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsre_postprivate.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/repostprivate/latest/APIReference/",
    resourceTypes: [
      {
        name: "space",
        referenceHref:
          "https://docs.aws.amazon.com/repostprivate/latest/UserGuide/",
        arnPattern:
          "arn:${Partition}:repostspace:${Region}:${Account}:space/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  rbin: {
    name: "AWS Recycle Bin",
    servicePrefix: "rbin",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsrecyclebin.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/recyclebin/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "rule",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/snapshot-recycle-bin.html#recycle-bin-concepts",
        arnPattern:
          "arn:${Partition}:rbin:${Region}:${Account}:rule/${ResourceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
      {
        name: "rbin:Attribute/ResourceType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/recycle-bin-perms.html#rbin-condition-keys",
        description: "Filters access by the resource type of the existing rule",
        type: "String",
      },
      {
        name: "rbin:Request/ResourceType",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/recycle-bin-perms.html#rbin-condition-keys",
        description: "Filters access by the resource type in a request",
        type: "String",
      },
    ],
  },
  redshift: {
    name: "Amazon Redshift",
    servicePrefix: "redshift",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonredshift.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/redshift/latest/APIReference/",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-clusters.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:cluster:${ClusterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "datashare",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/dg/datashare-overview.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:datashare:${ProducerClusterNamespace}/${DataShareName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dbgroup",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/dg/r_CREATE_GROUP.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:dbgroup:${ClusterName}/${DbGroup}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dbname",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/dg/t_creating_database.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:dbname:${ClusterName}/${DbName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dbuser",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/dg/r_Users.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:dbuser:${ClusterName}/${DbUser}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "eventsubscription",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-events.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:eventsubscription:${EventSubscriptionName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "hsmclientcertificate",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-db-encryption.html#working-with-HSM",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:hsmclientcertificate:${HSMClientCertificateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "hsmconfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-db-encryption.html#working-with-HSM",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:hsmconfiguration:${HSMConfigurationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "namespace",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/dg/concepts.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:namespace:${ClusterNamespace}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "parametergroup",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-parameter-groups.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:parametergroup:${ParameterGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "securitygroup",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-security-groups.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:securitygroup:${SecurityGroupName}/ec2securitygroup/${Owner}/${Ec2SecurityGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "securitygroupingress-cidr",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-security-groups.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:securitygroupingress:${SecurityGroupName}/cidrip/${IpRange}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "securitygroupingress-ec2securitygroup",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-security-groups.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:securitygroupingress:${SecurityGroupName}/ec2securitygroup/${Owner}/${Ece2SecuritygroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-snapshots.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:snapshot:${ClusterName}/${SnapshotName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "snapshotcopygrant",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-db-encryption.html#configure-snapshot-copy-grant",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:snapshotcopygrant:${SnapshotCopyGrantName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "snapshotschedule",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-snapshots.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:snapshotschedule:${ParameterGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "subnetgroup",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-cluster-subnet-groups.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:subnetgroup:${SubnetGroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "usagelimit",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/managing-cluster-usage-limits.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:usagelimit:${UsageLimitId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "redshiftidcapplication",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-idp-connect.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:redshiftidcapplication:${RedshiftIdcApplicationId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description:
          "Filters access by actions based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description:
          "Filters access by actions based on tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description:
          "Filters access by actions based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "redshift:AllowWrites",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description: "Filters access by the allowWrites input parameter",
        type: "Bool",
      },
      {
        name: "redshift:ConsumerArn",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description: "Filters access by the datashare consumer arn",
        type: "ARN",
      },
      {
        name: "redshift:ConsumerIdentifier",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description: "Filters access by the datashare consumer",
        type: "String",
      },
      {
        name: "redshift:DbName",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description: "Filters access by the database name",
        type: "String",
      },
      {
        name: "redshift:DbUser",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description: "Filters access by the database user name",
        type: "String",
      },
      {
        name: "redshift:DurationSeconds",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description:
          "Filters access by the number of seconds until a temporary credential set expires",
        type: "String",
      },
      {
        name: "redshift:InboundIntegrationArn",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description:
          "Filters access by the ARN of an inbound zero-ETL Integration resource",
        type: "String",
      },
    ],
  },
  "redshift-data": {
    name: "Amazon Redshift Data API",
    servicePrefix: "redshift-data",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonredshiftdataapi.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/redshift-data/latest/APIReference/",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-clusters.html",
        arnPattern:
          "arn:${Partition}:redshift:${Region}:${Account}:cluster:${ClusterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workgroup",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/working-with-serverless.html",
        arnPattern:
          "arn:${Partition}:redshift-serverless:${Region}:${Account}:workgroup/${WorkgroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "redshift-data:statement-owner-iam-userid",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-iam-access-control-overview.html#redshift-policy-resources.conditions",
        description: "Filters access by statement owner iam userid",
        type: "String",
      },
    ],
  },
  "redshift-serverless": {
    name: "Amazon Redshift Serverless",
    servicePrefix: "redshift-serverless",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonredshiftserverless.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/redshift-serverless/latest/APIReference/",
    resourceTypes: [
      {
        name: "namespace",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/serverless-workgroup-namespace.html",
        arnPattern:
          "arn:${Partition}:redshift-serverless:${Region}:${Account}:namespace/${NamespaceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "snapshot",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/serverless-snapshots-recovery.html",
        arnPattern:
          "arn:${Partition}:redshift-serverless:${Region}:${Account}:snapshot/${SnapshotId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workgroup",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/serverless-workgroup-namespace.html",
        arnPattern:
          "arn:${Partition}:redshift-serverless:${Region}:${Account}:workgroup/${WorkgroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "recoveryPoint",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/serverless-snapshots-recovery.html",
        arnPattern:
          "arn:${Partition}:redshift-serverless:${Region}:${Account}:recoverypoint/${RecoveryPointId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "endpointAccess",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/serverless-connecting.html",
        arnPattern:
          "arn:${Partition}:redshift-serverless:${Region}:${Account}:managedvpcendpoint/${EndpointAccessId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "redshift-serverless:endpointAccessId",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-policy-resources.resource-permissions.html",
        description: "Filters access by the endpoint access identifier",
        type: "String",
      },
      {
        name: "redshift-serverless:namespaceId",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-policy-resources.resource-permissions.html",
        description: "Filters access by the namespace identifier",
        type: "String",
      },
      {
        name: "redshift-serverless:recoveryPointId",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-policy-resources.resource-permissions.html",
        description: "Filters access by the recovery point identifier",
        type: "String",
      },
      {
        name: "redshift-serverless:snapshotId",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-policy-resources.resource-permissions.html",
        description: "Filters access by the snapshot identifier",
        type: "String",
      },
      {
        name: "redshift-serverless:tableRestoreRequestId",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-policy-resources.resource-permissions.html",
        description: "Filters access by the table restore request identifier",
        type: "String",
      },
      {
        name: "redshift-serverless:workgroupId",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/redshift-policy-resources.resource-permissions.html",
        description: "Filters access by the workgroup identifier",
        type: "String",
      },
    ],
  },
  rekognition: {
    name: "Amazon Rekognition",
    servicePrefix: "rekognition",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonrekognition.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/rekognition/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "collection",
        referenceHref:
          "https://docs.aws.amazon.com/rekognition/latest/dg/collections.html",
        arnPattern:
          "arn:${Partition}:rekognition:${Region}:${Account}:collection/${CollectionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "streamprocessor",
        referenceHref:
          "https://docs.aws.amazon.com/rekognition/latest/dg/streaming-video.html",
        arnPattern:
          "arn:${Partition}:rekognition:${Region}:${Account}:streamprocessor/${StreamprocessorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/rekognition/latest/customlabels-dg/mp-create-project.html",
        arnPattern:
          "arn:${Partition}:rekognition:${Region}:${Account}:project/${ProjectName}/${CreationTimestamp}",
        conditionKeys: [],
      },
      {
        name: "projectversion",
        referenceHref:
          "https://docs.aws.amazon.com/rekognition/latest/customlabels-dg/training-model.html",
        arnPattern:
          "arn:${Partition}:rekognition:${Region}:${Account}:project/${ProjectName}/version/${VersionName}/${CreationTimestamp}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "dataset",
        referenceHref:
          "https://docs.aws.amazon.com/rekognition/latest/customlabels-dg/creating-datasets.html",
        arnPattern:
          "arn:${Partition}:rekognition:${Region}:${Account}:project/${ProjectName}/dataset/${DatasetType}/${CreationTimestamp}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  resiliencehub: {
    name: "AWS Resilience Hub",
    servicePrefix: "resiliencehub",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsresiliencehub.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/resilience-hub/latest/APIReference/",
    resourceTypes: [
      {
        name: "resiliency-policy",
        referenceHref:
          "https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_ResiliencyPolicy.html",
        arnPattern:
          "arn:${Partition}:resiliencehub:${Region}:${Account}:resiliency-policy/${ResiliencyPolicyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "application",
        referenceHref:
          "https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_App.html",
        arnPattern:
          "arn:${Partition}:resiliencehub:${Region}:${Account}:app/${AppId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "app-assessment",
        referenceHref:
          "https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_AppAssessment.html",
        arnPattern:
          "arn:${Partition}:resiliencehub:${Region}:${Account}:app-assessment/${AppAssessmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "recommendation-template",
        referenceHref:
          "https://docs.aws.amazon.com/resilience-hub/latest/APIReference/API_RecommendationTemplate.html",
        arnPattern:
          "arn:${Partition}:resiliencehub:${Region}:${Account}:recommendation-template/${RecommendationTemplateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  ram: {
    name: "AWS Resource Access Manager (RAM)",
    servicePrefix: "ram",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsresourceaccessmanagerram.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/ram/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "resource-share",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/APIReference/API_ResourceShare.html",
        arnPattern:
          "arn:${Partition}:ram:${Region}:${Account}:resource-share/${ResourcePath}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ram:AllowsExternalPrincipals",
          "ram:ResourceShareName",
        ],
      },
      {
        name: "resource-share-invitation",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/APIReference/API_ResourceShareInvitation.html",
        arnPattern:
          "arn:${Partition}:ram:${Region}:${Account}:resource-share-invitation/${ResourcePath}",
        conditionKeys: ["ram:ShareOwnerAccountId"],
      },
      {
        name: "permission",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/APIReference/API_ResourceSharePermissionDetail.html",
        arnPattern:
          "arn:${Partition}:ram::${Account}:permission/${ResourcePath}",
        conditionKeys: ["ram:PermissionArn", "ram:PermissionResourceType"],
      },
      {
        name: "customer-managed-permission",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/APIReference/API_ResourceSharePermissionDetail.html",
        arnPattern:
          "arn:${Partition}:ram:${Region}:${Account}:permission/${ResourcePath}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "ram:PermissionArn",
          "ram:PermissionResourceType",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request when creating or tagging a resource share. If users don't pass these specific tags, or if they don't specify tags at all, the request fails",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed when creating or tagging a resource share",
        type: "ArrayOfString",
      },
      {
        name: "ram:AllowsExternalPrincipals",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description:
          "Filters access by resource shares that allow or deny sharing with external principals. For example, specify true if the action can only be performed on resource shares that allow sharing with external principals. External principals are AWS accounts that are outside of its AWS organization",
        type: "Bool",
      },
      {
        name: "ram:PermissionArn",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description: "Filters access by the specified Permission ARN",
        type: "ARN",
      },
      {
        name: "ram:PermissionResourceType",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description: "Filters access by permissions of specified resource type",
        type: "String",
      },
      {
        name: "ram:Principal",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description: "Filters access by format of the specified principal",
        type: "String",
      },
      {
        name: "ram:RequestedAllowsExternalPrincipals",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description:
          "Filters access by the specified value for 'allowExternalPrincipals'. External principals are AWS accounts that are outside of its AWS Organization",
        type: "Bool",
      },
      {
        name: "ram:RequestedResourceType",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description: "Filters access by the specified resource type",
        type: "String",
      },
      {
        name: "ram:ResourceArn",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description: "Filters access by the specified ARN",
        type: "ARN",
      },
      {
        name: "ram:ResourceShareName",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description:
          "Filters access by a resource share with the specified name",
        type: "String",
      },
      {
        name: "ram:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "ram:ShareOwnerAccountId",
        referenceHref:
          "https://docs.aws.amazon.com/ram/latest/userguide/iam-policies.html#iam-policies-condition",
        description:
          "Filters access by resource shares owned by a specific account. For example, you can use this condition key to specify which resource share invitations can be accepted or rejected based on the resource share owner’s account ID",
        type: "String",
      },
    ],
  },
  "resource-explorer-2": {
    name: "AWS Resource Explorer",
    servicePrefix: "resource-explorer-2",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsresourceexplorer.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/resource-explorer/latest/apireference/",
    resourceTypes: [
      {
        name: "view",
        referenceHref:
          "https://docs.aws.amazon.com/resource-explorer/latest/apireference/API_View.html",
        arnPattern:
          "arn:${Partition}:resource-explorer-2:${Region}:${Account}:view/${ViewName}/${ViewUuid}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "index",
        referenceHref:
          "https://docs.aws.amazon.com/resource-explorer/latest/apireference/API_Index.html",
        arnPattern:
          "arn:${Partition}:resource-explorer-2:${Region}:${Account}:index/${IndexUuid}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tag keyss attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  tag: {
    name: "Amazon Resource Group Tagging API",
    servicePrefix: "tag",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonresourcegrouptaggingapi.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/resourcegroupstagging/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "resource-groups": {
    name: "AWS Resource Groups",
    servicePrefix: "resource-groups",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsresourcegroups.html",
    apiReferenceHref: "https://docs.aws.amazon.com/ARG/latest/APIReference/",
    resourceTypes: [
      {
        name: "group",
        referenceHref:
          "https://docs.aws.amazon.com/ARG/latest/userguide/resource-groups.html",
        arnPattern:
          "arn:${Partition}:resource-groups:${Region}:${Account}:group/${GroupName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  rhelkb: {
    name: "Amazon RHEL Knowledgebase Portal",
    servicePrefix: "rhelkb",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonrhelknowledgebaseportal.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/systems-manager/latest/userguide/fleet-rhel.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  robomaker: {
    name: "AWS RoboMaker",
    servicePrefix: "robomaker",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsrobomaker.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/robomaker/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "robotApplication",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/managing-robot-applications.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:robot-application/${ApplicationName}/${CreatedOnEpoch}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "simulationApplication",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/managing-simulation-applications.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:simulation-application/${ApplicationName}/${CreatedOnEpoch}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "simulationJob",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/simulation.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:simulation-job/${SimulationJobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "simulationJobBatch",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/simulation-job-batch.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:simulation-job-batch/${SimulationJobBatchId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deploymentJob",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/deployment.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:deployment-job/${DeploymentJobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "robot",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/fleets.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:robot/${RobotName}/${CreatedOnEpoch}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "deploymentFleet",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/managing-simulation-applications.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:deployment-fleet/${FleetName}/${CreatedOnEpoch}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "worldGenerationJob",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/worlds-managing-generation-jobs.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:world-generation-job/${WorldGenerationJobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "worldExportJob",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/worlds-managing-export-jobs.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:world-export-job/${WorldExportJobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "worldTemplate",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/worlds-managing-simworld-templates.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:world-template/${WorldTemplateJobId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "world",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/worlds-managing-generated-worlds.html",
        arnPattern:
          "arn:${Partition}:robomaker:${Region}:${Account}:world/${WorldId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/tagging-resources-iam-policies.html",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/tagging-resources-iam-policies.html",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/robomaker/latest/dg/tagging-resources-iam-policies.html",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  route53: {
    name: "Amazon Route 53",
    servicePrefix: "route53",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/Route53/latest/APIReference/",
    resourceTypes: [
      {
        name: "cidrcollection",
        referenceHref: "API_CidrCollection.html",
        arnPattern: "arn:${Partition}:route53:::cidrcollection/${Id}",
        conditionKeys: [],
      },
      {
        name: "change",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/APIReference/API_Change.html",
        arnPattern: "arn:${Partition}:route53:::change/${Id}",
        conditionKeys: [],
      },
      {
        name: "delegationset",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/route-53-concepts.html#route-53-concepts-reusable-delegation-set",
        arnPattern: "arn:${Partition}:route53:::delegationset/${Id}",
        conditionKeys: [],
      },
      {
        name: "healthcheck",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/route-53-concepts.html#route-53-concepts-health-check",
        arnPattern: "arn:${Partition}:route53:::healthcheck/${Id}",
        conditionKeys: [],
      },
      {
        name: "hostedzone",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/route-53-concepts.html#route-53-concepts-hosted-zone",
        arnPattern: "arn:${Partition}:route53:::hostedzone/${Id}",
        conditionKeys: [],
      },
      {
        name: "trafficpolicy",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/traffic-policies.html",
        arnPattern: "arn:${Partition}:route53:::trafficpolicy/${Id}",
        conditionKeys: [],
      },
      {
        name: "trafficpolicyinstance",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/traffic-policy-records.html",
        arnPattern: "arn:${Partition}:route53:::trafficpolicyinstance/${Id}",
        conditionKeys: [],
      },
      {
        name: "queryloggingconfig",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/query-logs.html",
        arnPattern: "arn:${Partition}:route53:::queryloggingconfig/${Id}",
        conditionKeys: [],
      },
      {
        name: "vpc",
        referenceHref:
          "https://docs.aws.amazon.com/vpc/latest/userguide/VPC_Subnets.html",
        arnPattern: "arn:${Partition}:ec2:${Region}:${Account}:vpc/${VpcId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "route53:ChangeResourceRecordSetsActions",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/specifying-rrset-conditions.html#route53_rrset_ConditionKeys",
        description:
          "Filters access by the change actions, CREATE, UPSERT, or DELETE, in a ChangeResourceRecordSets request",
        type: "ArrayOfString",
      },
      {
        name: "route53:ChangeResourceRecordSetsNormalizedRecordNames",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/specifying-rrset-conditions.html#route53_rrset_ConditionKeys",
        description:
          "Filters access by the normalized DNS record names in a ChangeResourceRecordSets request",
        type: "ArrayOfString",
      },
      {
        name: "route53:ChangeResourceRecordSetsRecordTypes",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/specifying-rrset-conditions.html#route53_rrset_ConditionKeys",
        description:
          "Filters access by the DNS record types in a ChangeResourceRecordSets request",
        type: "ArrayOfString",
      },
    ],
  },
  "arc-zonal-shift": {
    name: "Amazon Route 53 Application Recovery Controller - Zonal Shift",
    servicePrefix: "arc-zonal-shift",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53applicationrecoverycontroller-zonalshift.html",
    apiReferenceHref: "https://docs.aws.amazon.com/arc-zonal-shift/latest/api/",
    resourceTypes: [
      {
        name: "ALB",
        referenceHref:
          "https://docs.aws.amazon.com/r53recovery/latest/dg/arc-zonal-shift.resource-types.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:loadbalancer/app/${LoadBalancerName}/${LoadBalancerId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "NLB",
        referenceHref:
          "https://docs.aws.amazon.com/r53recovery/latest/dg/arc-zonal-shift.resource-types.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:loadbalancer/net/${LoadBalancerName}/${LoadBalancerId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "elasticloadbalancing:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/userguide/load-balancer-authentication-access-control.html#elb-condition-keys",
        description:
          "Filters access by the tags associated with the managed resource",
        type: "String",
      },
      {
        name: "elasticloadbalancing:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/elasticloadbalancing/latest/userguide/load-balancer-authentication-access-control.html#elb-condition-keys",
        description:
          "Filters access by the tags associated with the managed resource",
        type: "String",
      },
    ],
  },
  route53domains: {
    name: "Amazon Route 53 Domains",
    servicePrefix: "route53domains",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53domains.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/Route53/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  "route53-recovery-cluster": {
    name: "Amazon Route 53 Recovery Cluster",
    servicePrefix: "route53-recovery-cluster",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53recoverycluster.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/routing-control/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "routingcontrol",
        referenceHref:
          "https://docs.aws.amazon.com/recovery-cluster/latest/api/routingcontrol.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-control::${Account}:controlpanel/${ControlPanelId}/routingcontrol/${RoutingControlId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "route53-recovery-cluster:AllowSafetyRulesOverrides",
        referenceHref:
          "https://docs.aws.amazon.com/routing-control/latest/APIReference/API_UpdateRoutingControlState.html",
        description:
          "Override safety rules to allow routing control state updates",
        type: "Bool",
      },
    ],
  },
  "route53-recovery-control-config": {
    name: "Amazon Route 53 Recovery Controls",
    servicePrefix: "route53-recovery-control-config",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53recoverycontrols.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/recovery-cluster/latest/api/resources.html",
    resourceTypes: [
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/recovery-cluster/latest/api/cluster.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-control::${Account}:cluster/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "controlpanel",
        referenceHref:
          "https://docs.aws.amazon.com/recovery-cluster/latest/api/controlpanel.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-control::${Account}:controlpanel/${ControlPanelId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "routingcontrol",
        referenceHref:
          "https://docs.aws.amazon.com/recovery-cluster/latest/api/routingcontrol.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-control::${Account}:controlpanel/${ControlPanelId}/routingcontrol/${RoutingControlId}",
        conditionKeys: [],
      },
      {
        name: "safetyrule",
        referenceHref:
          "https://docs.aws.amazon.com/recovery-cluster/latest/api/safetyrule.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-control::${Account}:controlpanel/${ControlPanelId}/safetyrule/${SafetyRuleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "route53-recovery-readiness": {
    name: "Amazon Route 53 Recovery Readiness",
    servicePrefix: "route53-recovery-readiness",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53recoveryreadiness.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/recovery-readiness/latest/api/resources.html",
    resourceTypes: [
      {
        name: "readinesscheck",
        referenceHref:
          "https://docs.aws.amazon.com/r53recovery/latest/dg/recovery-readiness.readiness-checks.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-readiness::${Account}:readiness-check/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "resourceset",
        referenceHref:
          "https://docs.aws.amazon.com/r53recovery/latest/dg/recovery-readiness.readiness-checks.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-readiness::${Account}:resource-set/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "cell",
        referenceHref:
          "https://docs.aws.amazon.com/r53recovery/latest/dg/recovery-readiness.recovery-groups.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-readiness::${Account}:cell/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "recoverygroup",
        referenceHref:
          "https://docs.aws.amazon.com/r53recovery/latest/dg/recovery-readiness.recovery-groups.html",
        arnPattern:
          "arn:${Partition}:route53-recovery-readiness::${Account}:recovery-group/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  route53resolver: {
    name: "Amazon Route 53 Resolver",
    servicePrefix: "route53resolver",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonroute53resolver.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/Route53/latest/APIReference/",
    resourceTypes: [
      {
        name: "resolver-dnssec-config",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:resolver-dnssec-config/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "resolver-query-log-config",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:resolver-query-log-config/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "resolver-rule",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:resolver-rule/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "resolver-endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:resolver-endpoint/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "firewall-rule-group",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:firewall-rule-group/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "firewall-rule-group-association",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:firewall-rule-group-association/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "firewall-domain-list",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:firewall-domain-list/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "firewall-config",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:firewall-config/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "resolver-config",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:resolver-config/${ResourceId}",
        conditionKeys: [],
      },
      {
        name: "outpost-resolver",
        referenceHref:
          "https://docs.aws.amazon.com/Route53/latest/DeveloperGuide/access-control-overview.html#access-control-resources",
        arnPattern:
          "arn:${Partition}:route53resolver:${Region}:${Account}:outpost-resolver/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the presence of tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  s3: {
    name: "Amazon S3",
    servicePrefix: "s3",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazons3.html",
    apiReferenceHref: "https://docs.aws.amazon.com/AmazonS3/latest/API/",
    resourceTypes: [
      {
        name: "accesspoint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/access-points.html",
        arnPattern:
          "arn:${Partition}:s3:${Region}:${Account}:accesspoint/${AccessPointName}",
        conditionKeys: [],
      },
      {
        name: "bucket",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/UsingBucket.html",
        arnPattern: "arn:${Partition}:s3:::${BucketName}",
        conditionKeys: [],
      },
      {
        name: "object",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/UsingObjects.html",
        arnPattern: "arn:${Partition}:s3:::${BucketName}/${ObjectName}",
        conditionKeys: [],
      },
      {
        name: "job",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/batch-ops-managing-jobs.html",
        arnPattern: "arn:${Partition}:s3:${Region}:${Account}:job/${JobId}",
        conditionKeys: [],
      },
      {
        name: "storagelensconfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/storage_lens.html",
        arnPattern:
          "arn:${Partition}:s3:${Region}:${Account}:storage-lens/${ConfigId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "storagelensgroup",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/storage_lens_group.html",
        arnPattern:
          "arn:${Partition}:s3:${Region}:${Account}:storage-lens-group/${Name}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "objectlambdaaccesspoint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/transforming-objects.html",
        arnPattern:
          "arn:${Partition}:s3-object-lambda:${Region}:${Account}:accesspoint/${AccessPointName}",
        conditionKeys: [],
      },
      {
        name: "multiregionaccesspoint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/MultiRegionAccessPointRequests.html",
        arnPattern:
          "arn:${Partition}:s3::${Account}:accesspoint/${AccessPointAlias}",
        conditionKeys: [],
      },
      {
        name: "multiregionaccesspointrequestarn",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/MultiRegionAccessPointRequests.html",
        arnPattern:
          "arn:${Partition}:s3:us-west-2:${Account}:async-request/mrap/${Operation}/${Token}",
        conditionKeys: [],
      },
      {
        name: "accessgrantsinstance",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/AccessGrantsInstance.html",
        arnPattern:
          "arn:${Partition}:s3:${Region}:${Account}:access-grants/default",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "accessgrantslocation",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/AccessGrantsLocation.html",
        arnPattern:
          "arn:${Partition}:s3:${Region}:${Account}:access-grants/default/location/${Token}",
        conditionKeys: [],
      },
      {
        name: "accessgrant",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/AccessGrant.html",
        arnPattern:
          "arn:${Partition}:s3:${Region}:${Account}:access-grants/default/grant/${Token}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "s3:AccessGrantsInstanceArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/access-grants-instance.html",
        description: "Filters access by access grants instance ARN",
        type: "ARN",
      },
      {
        name: "s3:AccessPointNetworkOrigin",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/creating-access-points.html#access-points-policies",
        description: "Filters access by the network origin (Internet or VPC)",
        type: "String",
      },
      {
        name: "s3:DataAccessPointAccount",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/creating-access-points.html#access-points-policies",
        description:
          "Filters access by the AWS Account ID that owns the access point",
        type: "String",
      },
      {
        name: "s3:DataAccessPointArn",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/creating-access-points.html#access-points-policies",
        description:
          "Filters access by an access point Amazon Resource Name (ARN)",
        type: "ARN",
      },
      {
        name: "s3:ExistingJobOperation",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/batch-ops-job-tags-examples.html",
        description: "Filters access by operation to updating the job priority",
        type: "String",
      },
      {
        name: "s3:ExistingJobPriority",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/batch-ops-job-tags-examples.html",
        description:
          "Filters access by priority range to cancelling existing jobs",
        type: "Numeric",
      },
      {
        name: "s3:ExistingObjectTag/<key>",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-tagging.html#tagging-and-policies",
        description: "Filters access by existing object tag key and value",
        type: "String",
      },
      {
        name: "s3:JobSuspendedCause",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/batch-ops-job-tags-examples.html",
        description:
          "Filters access by a specific job suspended cause (for example, AWAITING_CONFIRMATION) to cancelling suspended jobs",
        type: "String",
      },
      {
        name: "s3:RequestJobOperation",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/batch-ops-job-tags-examples.html",
        description: "Filters access by operation to creating jobs",
        type: "String",
      },
      {
        name: "s3:RequestJobPriority",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/batch-ops-job-tags-examples.html",
        description: "Filters access by priority range to creating new jobs",
        type: "Numeric",
      },
      {
        name: "s3:RequestObjectTag/<key>",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-tagging.html#tagging-and-policies",
        description:
          "Filters access by the tag keys and values to be added to objects",
        type: "String",
      },
      {
        name: "s3:RequestObjectTagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-tagging.html#tagging-and-policies",
        description: "Filters access by the tag keys to be added to objects",
        type: "ArrayOfString",
      },
      {
        name: "s3:ResourceAccount",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#example-object-resource-account",
        description: "Filters access by the resource owner AWS account ID",
        type: "String",
      },
      {
        name: "s3:TlsVersion",
        referenceHref: "#example-object-tls-version",
        description: "Filters access by the TLS version used by the client",
        type: "Numeric",
      },
      {
        name: "s3:authType",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description: "Filters access by authentication method",
        type: "String",
      },
      {
        name: "s3:delimiter",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/walkthrough1.html",
        description: "Filters access by delimiter parameter",
        type: "String",
      },
      {
        name: "s3:locationconstraint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#condition-key-bucket-ops-1",
        description: "Filters access by a specific Region",
        type: "String",
      },
      {
        name: "s3:max-keys",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#example-numeric-condition-operators",
        description:
          "Filters access by maximum number of keys returned in a ListBucket request",
        type: "Numeric",
      },
      {
        name: "s3:object-lock-legal-hold",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-lock-overview.html#object-lock-legal-holds",
        description: "Filters access by object legal hold status",
        type: "String",
      },
      {
        name: "s3:object-lock-mode",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-lock-overview.html#object-lock-retention-modes",
        description:
          "Filters access by object retention mode (COMPLIANCE or GOVERNANCE)",
        type: "String",
      },
      {
        name: "s3:object-lock-remaining-retention-days",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-lock-managing.html#object-lock-managing-retention-limits",
        description: "Filters access by remaining object retention days",
        type: "Numeric",
      },
      {
        name: "s3:object-lock-retain-until-date",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-lock-overview.html#object-lock-retention-periods",
        description: "Filters access by object retain-until date",
        type: "Date",
      },
      {
        name: "s3:prefix",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#condition-key-bucket-ops-2",
        description: "Filters access by key name prefix",
        type: "String",
      },
      {
        name: "s3:signatureAge",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by the age in milliseconds of the request signature",
        type: "Numeric",
      },
      {
        name: "s3:signatureversion",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by the version of AWS Signature used on the request",
        type: "String",
      },
      {
        name: "s3:versionid",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#getobjectversion-limit-access-to-specific-version-3",
        description: "Filters access by a specific object version",
        type: "String",
      },
      {
        name: "s3:x-amz-acl",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/acl-overview.html#permissions",
        description:
          "Filters access by canned ACL in the request's x-amz-acl header",
        type: "String",
      },
      {
        name: "s3:x-amz-content-sha256",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description: "Filters access by unsigned content in your bucket",
        type: "String",
      },
      {
        name: "s3:x-amz-copy-source",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#putobject-limit-copy-source-3",
        description:
          "Filters access by copy source bucket, prefix, or object in the copy object requests",
        type: "String",
      },
      {
        name: "s3:x-amz-grant-full-control",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/acl-overview.html#permissions",
        description:
          "Filters access by x-amz-grant-full-control (full control) header",
        type: "String",
      },
      {
        name: "s3:x-amz-grant-read",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/acl-overview.html#permissions",
        description: "Filters access by x-amz-grant-read (read access) header",
        type: "String",
      },
      {
        name: "s3:x-amz-grant-read-acp",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/acl-overview.html#permissions",
        description:
          "Filters access by the x-amz-grant-read-acp (read permissions for the ACL) header",
        type: "String",
      },
      {
        name: "s3:x-amz-grant-write",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/acl-overview.html#permissions",
        description:
          "Filters access by the x-amz-grant-write (write access) header",
        type: "String",
      },
      {
        name: "s3:x-amz-grant-write-acp",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/acl-overview.html#permissions",
        description:
          "Filters access by the x-amz-grant-write-acp (write permissions for the ACL) header",
        type: "String",
      },
      {
        name: "s3:x-amz-metadata-directive",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/API_CopyObject.html",
        description:
          "Filters access by object metadata behavior (COPY or REPLACE) when objects are copied",
        type: "String",
      },
      {
        name: "s3:x-amz-object-ownership",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/ensure-object-ownership.html#object-ownership-requiring-bucket-owner-enforced",
        description: "Filters access by Object Ownership",
        type: "String",
      },
      {
        name: "s3:x-amz-server-side-encryption",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/UsingServerSideEncryption.html",
        description: "Filters access by server-side encryption",
        type: "String",
      },
      {
        name: "s3:x-amz-server-side-encryption-aws-kms-key-id",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/UsingKMSEncryption.html#require-sse-kms",
        description:
          "Filters access by AWS KMS customer managed CMK for server-side encryption",
        type: "ARN",
      },
      {
        name: "s3:x-amz-server-side-encryption-customer-algorithm",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/ServerSideEncryptionCustomerKeys.html",
        description:
          "Filters access by customer specified algorithm for server-side encryption",
        type: "String",
      },
      {
        name: "s3:x-amz-storage-class",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/storage-class-intro.html#sc-howtoset",
        description: "Filters access by storage class",
        type: "String",
      },
      {
        name: "s3:x-amz-website-redirect-location",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/how-to-page-redirect.html#page-redirect-using-rest-api",
        description:
          "Filters access by a specific website redirect location for buckets that are configured as static websites",
        type: "String",
      },
    ],
  },
  s3express: {
    name: "Amazon S3 Express",
    servicePrefix: "s3express",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazons3express.html",
    apiReferenceHref: "https://docs.aws.amazon.com/AmazonS3/latest/API/",
    resourceTypes: [
      {
        name: "bucket",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/s3-express-zonal-buckets.html",
        arnPattern:
          "arn:${Partition}:s3express:${Region}:${Account}:bucket/${BucketName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "s3express:LocationName",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-express-zonal-policy-keys.html#example-location-name",
        description: "Filters access by a specific Availability Zone ID",
        type: "String",
      },
      {
        name: "s3express:ResourceAccount",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-express-zonal-policy-keys.html#example-object-resource-account",
        description: "Filters access by the resource owner AWS account ID",
        type: "String",
      },
      {
        name: "s3express:SessionMode",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-express-zonal-policy-keys.html#example-session-mode",
        description:
          "Filters access by the permission requested by CreateSession API, such as ReadOnly and ReadWrite",
        type: "String",
      },
      {
        name: "s3express:TlsVersion",
        referenceHref: "#example-object-tls-version",
        description: "Filters access by the TLS version used by the client",
        type: "Numeric",
      },
      {
        name: "s3express:authType",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description: "Filters access by authentication method",
        type: "String",
      },
      {
        name: "s3express:signatureAge",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by the age in milliseconds of the request signature",
        type: "Numeric",
      },
      {
        name: "s3express:signatureversion",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by the AWS Signature Version used on the request",
        type: "String",
      },
      {
        name: "s3express:x-amz-content-sha256",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description: "Filters access by unsigned content in your bucket",
        type: "String",
      },
    ],
  },
  glacier: {
    name: "Amazon S3 Glacier",
    servicePrefix: "glacier",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazons3glacier.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amazonglacier/latest/dev/amazon-glacier-api.html",
    resourceTypes: [
      {
        name: "vault",
        referenceHref:
          "https://docs.aws.amazon.com/amazonglacier/latest/dev/working-with-vaults.html",
        arnPattern:
          "arn:${Partition}:glacier:${Region}:${Account}:vaults/${VaultName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "glacier:ArchiveAgeInDays",
        referenceHref:
          "https://docs.aws.amazon.com/amazonglacier/latest/dev/access-control-overview.html#specifying-conditions",
        description:
          "Filters access by how long an archive has been stored in the vault, in days",
        type: "String",
      },
      {
        name: "glacier:ResourceTag/",
        referenceHref:
          "https://docs.aws.amazon.com/amazonglacier/latest/dev/access-control-overview.html#specifying-conditions",
        description: "Filters access by a customer-defined tag",
        type: "String",
      },
    ],
  },
  "s3-object-lambda": {
    name: "Amazon S3 Object Lambda",
    servicePrefix: "s3-object-lambda",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazons3objectlambda.html",
    apiReferenceHref: "https://docs.aws.amazon.com/AmazonS3/latest/API/",
    resourceTypes: [
      {
        name: "objectlambdaaccesspoint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/dev/transforming-objects.html",
        arnPattern:
          "arn:${Partition}:s3-object-lambda:${Region}:${Account}:accesspoint/${AccessPointName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "s3-object-lambda:TlsVersion",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description: "Filters access by the TLS version used by the client",
        type: "Numeric",
      },
      {
        name: "s3-object-lambda:authType",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description: "Filters access by authentication method",
        type: "String",
      },
      {
        name: "s3-object-lambda:signatureAge",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by the age in milliseconds of the request signature",
        type: "Numeric",
      },
      {
        name: "s3-object-lambda:versionid",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/dev/amazon-s3-policy-keys.html/#getobjectversion-limit-access-to-specific-version-3",
        description: "Filters access by a specific object version",
        type: "String",
      },
    ],
  },
  "s3-outposts": {
    name: "Amazon S3 on Outposts",
    servicePrefix: "s3-outposts",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazons3onoutposts.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonS3/latest/API/Type_API_Reference.html",
    resourceTypes: [
      {
        name: "accesspoint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/access-points.html",
        arnPattern:
          "arn:${Partition}:s3-outposts:${Region}:${Account}:outpost/${OutpostId}/accesspoint/${AccessPointName}",
        conditionKeys: [],
      },
      {
        name: "bucket",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/UsingBucket.html",
        arnPattern:
          "arn:${Partition}:s3-outposts:${Region}:${Account}:outpost/${OutpostId}/bucket/${BucketName}",
        conditionKeys: [],
      },
      {
        name: "endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/outposts-endpoints.html",
        arnPattern:
          "arn:${Partition}:s3-outposts:${Region}:${Account}:outpost/${OutpostId}/endpoint/${EndpointId}",
        conditionKeys: [],
      },
      {
        name: "object",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/UsingObjects.html",
        arnPattern:
          "arn:${Partition}:s3-outposts:${Region}:${Account}:outpost/${OutpostId}/bucket/${BucketName}/object/${ObjectName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "s3-outposts:AccessPointNetworkOrigin",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/creating-access-points.html#access-points-policies",
        description: "Filters access by the network origin (Internet or VPC)",
        type: "String",
      },
      {
        name: "s3-outposts:DataAccessPointAccount",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/creating-access-points.html#access-points-policies",
        description:
          "Filters access by the AWS Account ID that owns the access point",
        type: "String",
      },
      {
        name: "s3-outposts:DataAccessPointArn",
        description:
          "Filters access by an access point Amazon Resource Name (ARN)",
        type: "ARN",
      },
      {
        name: "s3-outposts:ExistingObjectTag/<key>",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-tagging.html#tagging-and-policies",
        description:
          "Filters access by requiring that an existing object tag has a specific tag key and value",
        type: "String",
      },
      {
        name: "s3-outposts:RequestObjectTag/<key>",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-tagging.html#tagging-and-policies",
        description:
          "Filters access by restricting the tag keys and values allowed on objects",
        type: "String",
      },
      {
        name: "s3-outposts:RequestObjectTagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-tagging.html#tagging-and-policies",
        description:
          "Filters access by restricting the tag keys allowed on objects",
        type: "String",
      },
      {
        name: "s3-outposts:authType",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by restricting incoming requests to a specific authentication method",
        type: "String",
      },
      {
        name: "s3-outposts:delimiter",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/walkthrough1.html",
        description: "Filters access by requiring the delimiter parameter",
        type: "String",
      },
      {
        name: "s3-outposts:max-keys",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#example-numeric-condition-operators",
        description:
          "Filters access by limiting the maximum number of keys returned in a ListBucket request",
        type: "Numeric",
      },
      {
        name: "s3-outposts:prefix",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#condition-key-bucket-ops-2",
        description: "Filters access by key name prefix",
        type: "String",
      },
      {
        name: "s3-outposts:signatureAge",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by identifying the length of time, in milliseconds, that a signature is valid in an authenticated request",
        type: "Numeric",
      },
      {
        name: "s3-outposts:signatureversion",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by identifying the version of AWS Signature that is supported for authenticated requests",
        type: "String",
      },
      {
        name: "s3-outposts:versionid",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#getobjectversion-limit-access-to-specific-version-3",
        description: "Filters access by a specific object version",
        type: "String",
      },
      {
        name: "s3-outposts:x-amz-acl",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/acl-overview.html#permissions",
        description:
          "Filters access by requiring the x-amz-acl header with a specific canned ACL in a request",
        type: "String",
      },
      {
        name: "s3-outposts:x-amz-content-sha256",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/bucket-policy-s3-sigv4-conditions.html",
        description:
          "Filters access by disallowing unsigned content in your bucket",
        type: "String",
      },
      {
        name: "s3-outposts:x-amz-copy-source",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/amazon-s3-policy-keys.html#putobject-limit-copy-source-3",
        description:
          "Filters access by restricting the copy source to a specific bucket, prefix, or object",
        type: "String",
      },
      {
        name: "s3-outposts:x-amz-metadata-directive",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/API/API_CopyObject.html",
        description:
          "Filters access by enabling enforcement of object metadata behavior (COPY or REPLACE) when objects are copied",
        type: "String",
      },
      {
        name: "s3-outposts:x-amz-server-side-encryption",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/UsingServerSideEncryption.html",
        description: "Filters access by requiring server-side encryption",
        type: "String",
      },
      {
        name: "s3-outposts:x-amz-storage-class",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonS3/latest/userguide/storage-class-intro.html#sc-howtoset",
        description: "Filters access by storage class",
        type: "String",
      },
    ],
  },
  sagemaker: {
    name: "Amazon SageMaker",
    servicePrefix: "sagemaker",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsagemaker.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/sagemaker/latest/APIReference/",
    resourceTypes: [
      {
        name: "device",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/neo-edge-devices.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:device-fleet/${DeviceFleetName}/device/${DeviceName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "device-fleet",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/edge-device-fleet.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:device-fleet/${DeviceFleetName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "edge-packaging-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/edge-packaging-job.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:edge-packaging-job/${EdgePackagingJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "edge-deployment-plan",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/edge.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:edge-deployment/${EdgeDeploymentPlanName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "human-loop",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/a2i-start-human-loop.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:human-loop/${HumanLoopName}",
        conditionKeys: [],
      },
      {
        name: "flow-definition",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/a2i-create-flow-definition.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:flow-definition/${FlowDefinitionName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "human-task-ui",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/a2i-instructions-overview.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:human-task-ui/${HumanTaskUiName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "hub",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/jumpstart-content-sharing.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:hub/${HubName}",
        conditionKeys: [],
      },
      {
        name: "hub-content",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/jumpstart-content-sharing.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:hub-content/${HubName}/${HubContentType}/${HubContentName}",
        conditionKeys: [],
      },
      {
        name: "inference-recommendations-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/inference-recommender-recommendation-jobs.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:inference-recommendations-job/${InferenceRecommendationsJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "inference-experiment",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/inference-experiment.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:inference-experiment/${InferenceExperimentName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "labeling-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/sms.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:labeling-job/${LabelingJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "workteam",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/sms-workforce-management.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:workteam/${WorkteamName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "workforce",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/sms-workforce-management.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:workforce/${WorkforceName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "domain",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/studio-entity-status.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:domain/${DomainId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "user-profile",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/studio-entity-status.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:user-profile/${DomainId}/${UserProfileName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "space",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/studio-entity-status.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:space/${DomainId}/${SpaceName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "app",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/studio-entity-status.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:app/${DomainId}/${UserProfileName}/${AppType}/${AppName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "app-image-config",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/studio-byoi-create.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:app-image-config/${AppImageConfigName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "studio-lifecycle-config",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/studio-lcc.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:studio-lifecycle-config/${StudioLifecycleConfigName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "notebook-instance",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/nbi.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:notebook-instance/${NotebookInstanceName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "notebook-instance-lifecycle-config",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/notebook-lifecycle-config.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:notebook-instance-lifecycle-config/${NotebookInstanceLifecycleConfigName}",
        conditionKeys: [],
      },
      {
        name: "code-repository",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/nbi-git-repo.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:code-repository/${CodeRepositoryName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "image",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/studio-byoi.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:image/${ImageName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "image-version",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/studio-byoi.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:image-version/${ImageName}/${Version}",
        conditionKeys: [],
      },
      {
        name: "algorithm",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/algorithms-choose.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:algorithm/${AlgorithmName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "cluster",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/sagemaker-cluster.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:cluster/${ClusterId}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "training-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/how-it-works-training.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:training-job/${TrainingJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "processing-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/processing-job.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:processing-job/${ProcessingJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "hyper-parameter-tuning-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/automatic-model-tuning-how-it-works.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:hyper-parameter-tuning-job/${HyperParameterTuningJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "project",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/sagemaker-projects-whatis.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:project/${ProjectName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "model-package",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_ModelPackage.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:model-package/${ModelPackageName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "model-package-group",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/model-registry-model-group.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:model-package-group/${ModelPackageGroupName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "model",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/realtime-endpoints.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:model/${ModelName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "endpoint-config",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/realtime-endpoints.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:endpoint-config/${EndpointConfigName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/realtime-endpoints.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:endpoint/${EndpointName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "inference-component",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/realtime-endpoints.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:inference-component/${InferenceComponentName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "transform-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_TransformJob.html.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:transform-job/${TransformJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "compilation-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_CompilationJobSummary.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:compilation-job/${CompilationJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "automl-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/autopilot-automate-model-development.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:automl-job/${AutoMLJobJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "monitoring-schedule",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/model-monitor-scheduling.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:monitoring-schedule/${MonitoringScheduleName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "monitoring-schedule-alert",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/model-monitor-scheduling.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:monitoring-schedule/${MonitoringScheduleName}/alert/${MonitoringScheduleAlertName}",
        conditionKeys: [],
      },
      {
        name: "data-quality-job-definition",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/model-monitor-data-quality.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:data-quality-job-definition/${DataQualityJobDefinitionName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "model-quality-job-definition",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/model-monitor-model-quality.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:model-quality-job-definition/${ModelQualityJobDefinitionName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "model-bias-job-definition",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/clarify-detect-post-training-bias.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:model-bias-job-definition/${ModelBiasJobDefinitionName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "model-explainability-job-definition",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/clarify-model-explainability.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:model-explainability-job-definition/${ModelExplainabilityJobDefinitionName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "experiment",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_Experiment.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:experiment/${ExperimentName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "experiment-trial",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_Trial.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:experiment-trial/${TrialName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "experiment-trial-component",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_TrialComponent.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:experiment-trial-component/${TrialComponentName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "feature-group",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/feature-store.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:feature-group/${FeatureGroupName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "pipeline",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_Pipeline.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:pipeline/${PipelineName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "pipeline-execution",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_PipelineExecution.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:pipeline/${PipelineName}/execution/${RandomString}",
        conditionKeys: [],
      },
      {
        name: "artifact",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_ArtifactSummary.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:artifact/${HashOfArtifactSource}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "context",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_ContextSummary.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:context/${ContextName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "action",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_ActionSummary.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:action/${ActionName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "lineage-group",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_LineageGroupSummary.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:lineage-group/${LineageGroupName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "model-card",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_ModelCard.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:model-card/${ModelCardName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "model-card-export-job",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_ModelCardExportJob.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:model-card/${ModelCardName}/export-job/${ExportJobName}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "sagemaker:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "shared-model",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/canvas-collaborate-permissions.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:shared-model/${SharedModelId}",
        conditionKeys: [],
      },
      {
        name: "shared-model-event",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/canvas-collaborate-permissions.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:shared-model-event/${EventId}",
        conditionKeys: [],
      },
      {
        name: "sagemaker-catalog",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_ResourceCatalog.html",
        arnPattern:
          "arn:${Partition}:sagemaker:${Region}:${Account}:sagemaker-catalog/${ResourceCatalogName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by a key that is present in the request the user makes to the SageMaker service",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description: "Filters access by a tag key and value pair",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the list of all the tag key names associated with the resource in the request",
        type: "ArrayOfString",
      },
      {
        name: "sagemaker:AcceleratorTypes",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the list of all accelerator types associated with the resource in the request",
        type: "ArrayOfString",
      },
      {
        name: "sagemaker:AppNetworkAccessType",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the app network access type associated with the resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:CustomerMetadataProperties/${MetadataKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description: "Filters access by a metadata key and value pair",
        type: "String",
      },
      {
        name: "sagemaker:CustomerMetadataPropertiesToRemove",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the list of metadata properties associated with the model-package resource in the request",
        type: "ArrayOfString",
      },
      {
        name: "sagemaker:DirectInternetAccess",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the direct internet access associated with the resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:DomainSharingOutputKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the Domain sharing output KMS key associated with the resource in the request",
        type: "ARN",
      },
      {
        name: "sagemaker:EnableRemoteDebug",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description: "Filters access by the remote debug config in the request",
        type: "Bool",
      },
      {
        name: "sagemaker:FeatureGroupDisableGlueTableCreation",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the DisableGlueTableCreation flag associated with the feature group resource in the request",
        type: "Bool",
      },
      {
        name: "sagemaker:FeatureGroupEnableOnlineStore",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the EnableOnlineStore flag associated with feature group in the request",
        type: "Bool",
      },
      {
        name: "sagemaker:FeatureGroupOfflineStoreConfig",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the presence of an OfflineStoreConfig in the feature group resource in the request. This access filter only supports the null-conditional operator",
        type: "Bool",
      },
      {
        name: "sagemaker:FeatureGroupOfflineStoreKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the offline store kms key associated with the feature group resource in the request",
        type: "ARN",
      },
      {
        name: "sagemaker:FeatureGroupOfflineStoreS3Uri",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the offline store s3 uri associated with the feature group resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:FeatureGroupOnlineStoreKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the online store kms key associated with the feature group resource in the request",
        type: "ARN",
      },
      {
        name: "sagemaker:FileSystemAccessMode",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by a file system access mode associated with the resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:FileSystemDirectoryPath",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by a file system directory path associated with the resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:FileSystemId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by a file system ID associated with the resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:FileSystemType",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by a file system type associated with the resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:HomeEfsFileSystemKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by a key that is present in the request the user makes to the SageMaker service. This key is deprecated. It has been replaced by sagemaker:VolumeKmsKey",
        type: "ARN",
      },
      {
        name: "sagemaker:ImageArns",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the list of all image arns associated with the resource in the request",
        type: "ArrayOfARN",
      },
      {
        name: "sagemaker:ImageVersionArns",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the list of all image version arns associated with the resource in the request",
        type: "ArrayOfARN",
      },
      {
        name: "sagemaker:InstanceTypes",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the list of all instance types associated with the resource in the request",
        type: "ArrayOfString",
      },
      {
        name: "sagemaker:InterContainerTrafficEncryption",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the inter container traffic encryption associated with the resource in the request",
        type: "Bool",
      },
      {
        name: "sagemaker:KeepAlivePeriod",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the keep-alive period associated with the resource in the request",
        type: "Numeric",
      },
      {
        name: "sagemaker:MaxRuntimeInSeconds",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the max runtime in seconds associated with the resource in the request",
        type: "Numeric",
      },
      {
        name: "sagemaker:MinimumInstanceMetadataServiceVersion",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the minimum instance metadata service version used by the resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:ModelApprovalStatus",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the model approval status with the model-package in the request",
        type: "String",
      },
      {
        name: "sagemaker:ModelArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the model arn associated with the resource in the request",
        type: "ARN",
      },
      {
        name: "sagemaker:NetworkIsolation",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the network isolation associated with the resource in the request",
        type: "Bool",
      },
      {
        name: "sagemaker:OutputKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the output kms key associated with the resource in the request",
        type: "ARN",
      },
      {
        name: "sagemaker:OwnerUserProfileArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the OwnerUserProfile arn associated with the space in the request",
        type: "ARN",
      },
      {
        name: "sagemaker:ResourceTag/",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the preface string for a tag key and value pair attached to a resource",
        type: "String",
      },
      {
        name: "sagemaker:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description: "Filters access by a tag key and value pair",
        type: "String",
      },
      {
        name: "sagemaker:RootAccess",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the root access associated with the resource in the request",
        type: "String",
      },
      {
        name: "sagemaker:ServerlessMaxConcurrency",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by limiting maximum concurrency used for Serverless inference in the request",
        type: "Numeric",
      },
      {
        name: "sagemaker:ServerlessMemorySize",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by limiting memory size used for Serverless inference in the request",
        type: "Numeric",
      },
      {
        name: "sagemaker:SpaceSharingType",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the sharing type associated with the space in the request",
        type: "String",
      },
      {
        name: "sagemaker:TaggingAction",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the API actions to which a user can apply tags. Uses the name of the API operation that creates a taggable resource to filter access",
        type: "String",
      },
      {
        name: "sagemaker:TargetModel",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the target model associated with the Multi-Model Endpoint in the request",
        type: "String",
      },
      {
        name: "sagemaker:VolumeKmsKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the volume kms key associated with the resource in the request",
        type: "ARN",
      },
      {
        name: "sagemaker:VpcSecurityGroupIds",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the list of all VPC security group ids associated with the resource in the request",
        type: "ArrayOfString",
      },
      {
        name: "sagemaker:VpcSubnets",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the list of all VPC subnets associated with the resource in the request",
        type: "ArrayOfString",
      },
      {
        name: "sagemaker:WorkteamArn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the workteam arn associated to the request",
        type: "ARN",
      },
      {
        name: "sagemaker:WorkteamType",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazonsagemaker.html#amazonsagemaker-policy-keys",
        description:
          "Filters access by the workteam type associated to the request. This can be public-crowd, private-crowd or vendor-crowd",
        type: "String",
      },
    ],
  },
  "sagemaker-geospatial": {
    name: "Amazon SageMaker geospatial capabilities",
    servicePrefix: "sagemaker-geospatial",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsagemakergeospatialcapabilities.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/sagemaker/latest/APIReference/API_Operations_Amazon_SageMaker_geospatial_capabilities.html",
    resourceTypes: [
      {
        name: "EarthObservationJob",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/geospatial-eoj.html",
        arnPattern:
          "arn:${Partition}:sagemaker-geospatial:${Region}:${Account}:earth-observation-job/${JobID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "RasterDataCollection",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/geospatial-data-collections.html",
        arnPattern:
          "arn:${Partition}:sagemaker-geospatial:${Region}:${Account}:raster-data-collection/${CollectionID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "VectorEnrichmentJob",
        referenceHref:
          "https://docs.aws.amazon.com/sagemaker/latest/dg/geospatial-vej.html",
        arnPattern:
          "arn:${Partition}:sagemaker-geospatial:${Region}:${Account}:vector-enrichment-job/${JobID}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "sagemaker-groundtruth-synthetic": {
    name: "Amazon SageMaker Ground Truth Synthetic",
    servicePrefix: "sagemaker-groundtruth-synthetic",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsagemakergroundtruthsynthetic.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/sagemaker/latest/dg/gts.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  savingsplans: {
    name: "AWS Savings Plans",
    servicePrefix: "savingsplans",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssavingsplans.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/savingsplans/latest/APIReference/",
    resourceTypes: [
      {
        name: "savingsplan",
        referenceHref:
          "https://docs.aws.amazon.com/savingsplans/latest/userguide/API_SavingsPlan.html",
        arnPattern:
          "arn:${Partition}:savingsplans::${Account}:savingsplan/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag-value assoicated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  secretsmanager: {
    name: "AWS Secrets Manager",
    servicePrefix: "secretsmanager",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssecretsmanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/secretsmanager/latest/apireference/",
    resourceTypes: [
      {
        name: "Secret",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-resources",
        arnPattern:
          "arn:${Partition}:secretsmanager:${Region}:${Account}:secret:${SecretId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "secretsmanager:ResourceTag/tag-key",
          "secretsmanager:resource/AllowRotationLambdaArn",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by a key that is present in the request the user makes to the Secrets Manager service",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the list of all the tag key names present in the request the user makes to the Secrets Manager service",
        type: "ArrayOfString",
      },
      {
        name: "secretsmanager:AddReplicaRegions",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the list of Regions in which to replicate the secret",
        type: "ArrayOfString",
      },
      {
        name: "secretsmanager:BlockPublicPolicy",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by whether the resource policy blocks broad AWS account access",
        type: "Bool",
      },
      {
        name: "secretsmanager:Description",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description: "Filters access by the description text in the request",
        type: "String",
      },
      {
        name: "secretsmanager:ForceDeleteWithoutRecovery",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by whether the secret is to be deleted immediately without any recovery window",
        type: "Bool",
      },
      {
        name: "secretsmanager:ForceOverwriteReplicaSecret",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by whether to overwrite a secret with the same name in the destination Region",
        type: "Bool",
      },
      {
        name: "secretsmanager:KmsKeyId",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description: "Filters access by the ARN of the KMS key in the request",
        type: "String",
      },
      {
        name: "secretsmanager:ModifyRotationRules",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by whether the rotation rules of the secret are to be modified",
        type: "Bool",
      },
      {
        name: "secretsmanager:Name",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the friendly name of the secret in the request",
        type: "String",
      },
      {
        name: "secretsmanager:RecoveryWindowInDays",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the number of days that Secrets Manager waits before it can delete the secret",
        type: "Numeric",
      },
      {
        name: "secretsmanager:ResourceTag/tag-key",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description: "Filters access by a tag key and value pair",
        type: "String",
      },
      {
        name: "secretsmanager:RotateImmediately",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by whether the secret is to be rotated immediately",
        type: "Bool",
      },
      {
        name: "secretsmanager:RotationLambdaARN",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the ARN of the rotation Lambda function in the request",
        type: "ARN",
      },
      {
        name: "secretsmanager:SecretId",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description: "Filters access by the SecretID value in the request",
        type: "ARN",
      },
      {
        name: "secretsmanager:SecretPrimaryRegion",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by primary region in which the secret is created",
        type: "String",
      },
      {
        name: "secretsmanager:VersionId",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the unique identifier of the version of the secret in the request",
        type: "String",
      },
      {
        name: "secretsmanager:VersionStage",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the list of version stages in the request",
        type: "String",
      },
      {
        name: "secretsmanager:resource/AllowRotationLambdaArn",
        referenceHref:
          "https://docs.aws.amazon.com/secretsmanager/latest/userguide/reference_iam-permissions.html#iam-contextkeys",
        description:
          "Filters access by the ARN of the rotation Lambda function associated with the secret",
        type: "ARN",
      },
    ],
  },
  securityhub: {
    name: "AWS Security Hub",
    servicePrefix: "securityhub",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssecurityhub.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/securityhub/1.0/APIReference/",
    resourceTypes: [
      {
        name: "hub",
        referenceHref:
          "https://docs.aws.amazon.com/securityhub/latest/userguide/securityhub-access.html#resources",
        arnPattern:
          "arn:${Partition}:securityhub:${Region}:${Account}:hub/default",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "product",
        referenceHref:
          "https://docs.aws.amazon.com/securityhub/latest/userguide/securityhub-access.html#resources",
        arnPattern:
          "arn:${Partition}:securityhub:${Region}:${Account}:product/${Company}/${ProductId}",
        conditionKeys: [],
      },
      {
        name: "finding-aggregator",
        referenceHref:
          "https://docs.aws.amazon.com/securityhub/latest/userguide/securityhub-access.html#resources",
        arnPattern:
          "arn:${Partition}:securityhub:${Region}:${Account}:finding-aggregator/${FindingAggregatorId}",
        conditionKeys: [],
      },
      {
        name: "automation-rule",
        referenceHref:
          "https://docs.aws.amazon.com/securityhub/latest/userguide/automation-rules",
        arnPattern:
          "arn:${Partition}:securityhub:${Region}:${Account}:automation-rule/${AutomationRuleId}",
        conditionKeys: [],
      },
      {
        name: "configuration-policy",
        referenceHref:
          "https://docs.aws.amazon.com/securityhub/latest/userguide/central-configuration-intro.html",
        arnPattern:
          "arn:${Partition}:securityhub:${Region}:${Account}:configuration-policy/${ConfigurationPolicyId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "securityhub:ASFFSyntaxPath/${ASFFSyntaxPath}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-asffsyntaxpath",
        description:
          "Filters access by the specified fields and values in the request",
        type: "String",
      },
      {
        name: "securityhub:TargetAccount",
        referenceHref:
          "https://docs.aws.amazon.com/securityhub/latest/userguide/securityhub-access.html#conditions",
        description:
          "Filters access by the AwsAccountId field that is specified in the request",
        type: "String",
      },
    ],
  },
  securitylake: {
    name: "Amazon Security Lake",
    servicePrefix: "securitylake",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsecuritylake.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/security-lake/latest/APIReference/",
    resourceTypes: [
      {
        name: "data-lake",
        referenceHref:
          "https://docs.aws.amazon.com/security-lake/latest/APIReference/API_DataLakeResource.html",
        arnPattern:
          "arn:${Partition}:securitylake:${Region}:${Account}:data-lake/default",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "subscriber",
        referenceHref:
          "https://docs.aws.amazon.com/security-lake/latest/APIReference/API_SubscriberResource.html",
        arnPattern:
          "arn:${Partition}:securitylake:${Region}:${Account}:subscriber/${SubscriberId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  sts: {
    name: "AWS Security Token Service",
    servicePrefix: "sts",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssecuritytokenservice.html",
    apiReferenceHref: "https://docs.aws.amazon.com/STS/latest/APIReference/",
    resourceTypes: [
      {
        name: "role",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles.html",
        arnPattern: "arn:${Partition}:iam::${Account}:role/${RoleNameWithPath}",
        conditionKeys: [
          "aws:ResourceTag/${TagKey}",
          "iam:ResourceTag/${TagKey}",
        ],
      },
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/id_users.html",
        arnPattern: "arn:${Partition}:iam::${Account}:user/${UserNameWithPath}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "accounts.google.com:aud",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_aud",
        description: "Filters access by the Google application ID",
        type: "String",
      },
      {
        name: "accounts.google.com:oaud",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_oaud",
        description: "Filters access by the Google audience",
        type: "String",
      },
      {
        name: "accounts.google.com:sub",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_sub",
        description:
          "Filters access by the subject of the claim (the Google user ID)",
        type: "String",
      },
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "cognito-identity.amazonaws.com:amr",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_amr",
        description:
          "Filters access by the login information for Amazon Cognito",
        type: "String",
      },
      {
        name: "cognito-identity.amazonaws.com:aud",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_aud",
        description: "Filters access by the Amazon Cognito identity pool ID",
        type: "String",
      },
      {
        name: "cognito-identity.amazonaws.com:sub",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_sub",
        description:
          "Filters access by the subject of the claim (the Amazon Cognito user ID)",
        type: "String",
      },
      {
        name: "graph.facebook.com:app_id",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_id",
        description: "Filters access by the Facebook application ID",
        type: "String",
      },
      {
        name: "graph.facebook.com:id",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_id",
        description: "Filters access by the Facebook user ID",
        type: "String",
      },
      {
        name: "iam:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_ResourceTag",
        description:
          "Filters access by the tags that are attached to the role that is being assumed",
        type: "String",
      },
      {
        name: "saml:aud",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_aud",
        description:
          "Filters access by the endpoint URL to which SAML assertions are presented",
        type: "String",
      },
      {
        name: "saml:cn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_cn",
        description: "Filters access by the eduOrg attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:commonName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_commonname",
        description: "Filters access by the commonName attribute",
        type: "String",
      },
      {
        name: "saml:doc",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_doc",
        description:
          "Filters access by on the principal that was used to assume the role",
        type: "String",
      },
      {
        name: "saml:eduorghomepageuri",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_eduorghomepageuri",
        description: "Filters access by the eduOrg attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:eduorgidentityauthnpolicyuri",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_aud",
        description: "Filters access by the eduOrg attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:eduorglegalname",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_eduorglegalname",
        description: "Filters access by the eduOrg attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:eduorgsuperioruri",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_eduorgsuperioruri",
        description: "Filters access by the eduOrg attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:eduorgwhitepagesuri",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_eduorgwhitepagesuri",
        description: "Filters access by the eduOrg attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:edupersonaffiliation",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonaffiliation",
        description: "Filters access by the eduPerson attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:edupersonassurance",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonassurance",
        description: "Filters access by the eduPerson attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:edupersonentitlement",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonentitlement",
        description: "Filters access by the eduPerson attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:edupersonnickname",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonnickname",
        description: "Filters access by the eduPerson attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:edupersonorgdn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonorgdn",
        description: "Filters access by the eduPerson attribute",
        type: "String",
      },
      {
        name: "saml:edupersonorgunitdn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonorgunitdn",
        description: "Filters access by the eduPerson attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:edupersonprimaryaffiliation",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonprimaryaffiliation",
        description: "Filters access by the eduPerson attribute",
        type: "String",
      },
      {
        name: "saml:edupersonprimaryorgunitdn",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonprimaryorgunitdn",
        description: "Filters access by the eduPerson attribute",
        type: "String",
      },
      {
        name: "saml:edupersonprincipalname",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonprincipalname",
        description: "Filters access by the eduPerson attribute",
        type: "String",
      },
      {
        name: "saml:edupersonscopedaffiliation",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersonscopedaffiliation",
        description: "Filters access by the eduPerson attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:edupersontargetedid",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_edupersontargetedid",
        description: "Filters access by the eduPerson attribute",
        type: "ArrayOfString",
      },
      {
        name: "saml:givenName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_givenname",
        description: "Filters access by the givenName attribute",
        type: "String",
      },
      {
        name: "saml:iss",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_iss",
        description:
          "Filters access by on the issuer, which is represented by a URN",
        type: "String",
      },
      {
        name: "saml:mail",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_mail",
        description: "Filters access by the mail attribute",
        type: "String",
      },
      {
        name: "saml:name",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_name",
        description: "Filters access by the name attribute",
        type: "String",
      },
      {
        name: "saml:namequalifier",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_namequalifier",
        description:
          "Filters access by the hash value of the issuer, account ID, and friendly name",
        type: "String",
      },
      {
        name: "saml:organizationStatus",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_organizationstatus",
        description: "Filters access by the organizationStatus attribute",
        type: "String",
      },
      {
        name: "saml:primaryGroupSID",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_primarygroupsid",
        description: "Filters access by the primaryGroupSID attribute",
        type: "String",
      },
      {
        name: "saml:sub",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_sub",
        description:
          "Filters access by the subject of the claim (the SAML user ID)",
        type: "String",
      },
      {
        name: "saml:sub_type",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_subtype",
        description:
          "Filters access by the value persistent, transient, or the full Format URI",
        type: "String",
      },
      {
        name: "saml:surname",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_surname",
        description: "Filters access by the surname attribute",
        type: "String",
      },
      {
        name: "saml:uid",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_uid",
        description: "Filters access by the uid attribute",
        type: "String",
      },
      {
        name: "saml:x500UniqueIdentifier",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_x500uniqueidentifier",
        description: "Filters access by the uid attribute",
        type: "String",
      },
      {
        name: "sts:AWSServiceName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_awsservicename",
        description:
          "Filters access by the service that is obtaining a bearer token",
        type: "String",
      },
      {
        name: "sts:DurationSeconds",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_durationseconds",
        description:
          "Filters access by the duration in seconds when getting a bearer token",
        type: "String",
      },
      {
        name: "sts:ExternalId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_externalid",
        description:
          "Filters access by the unique identifier required when you assume a role in another account",
        type: "String",
      },
      {
        name: "sts:RequestContext/${ContextKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#condition-keys-sts",
        description:
          "Filters access by the session context key-value pairs embedded in the signed context assertion retrieved from a trusted context provider",
        type: "String",
      },
      {
        name: "sts:RequestContextProviders",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#condition-keys-sts",
        description: "Filters access by the context provider ARNs",
        type: "ArrayOfARN",
      },
      {
        name: "sts:RoleSessionName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_rolesessionname",
        description:
          "Filters access by the role session name required when you assume a role",
        type: "String",
      },
      {
        name: "sts:SourceIdentity",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_sourceidentity",
        description:
          "Filters access by the source identity that is passed in the request",
        type: "String",
      },
      {
        name: "sts:TransitiveTagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_TransitiveTagKeys",
        description:
          "Filters access by the transitive tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "www.amazon.com:app_id",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_id",
        description: "Filters access by the Login with Amazon application ID",
        type: "String",
      },
      {
        name: "www.amazon.com:user_id",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_iam-condition-keys.html#ck_id",
        description: "Filters access by the Login with Amazon user ID",
        type: "String",
      },
    ],
  },
  sms: {
    name: "AWS Server Migration Service",
    servicePrefix: "sms",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsservermigrationservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/server-migration-service/latest/APIReference/API_Operations.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  serverlessrepo: {
    name: "AWS Serverless Application Repository",
    servicePrefix: "serverlessrepo",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsserverlessapplicationrepository.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/serverlessrepo/latest/devguide/resources.html",
    resourceTypes: [
      {
        name: "applications",
        referenceHref:
          "https://docs.aws.amazon.com/serverlessrepo/latest/devguide/applications.html",
        arnPattern:
          "arn:${Partition}:serverlessrepo:${Region}:${Account}:applications/${ResourceId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "serverlessrepo:applicationType",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/applications.html",
        description: "Filters access by application type",
        type: "String",
      },
    ],
  },
  servicecatalog: {
    name: "AWS Service Catalog",
    servicePrefix: "servicecatalog",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsservicecatalog.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/servicecatalog/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "Application",
        referenceHref:
          "https://docs.aws.amazon.com/servicecatalog/latest/dg/API_app-registry_CreateApplication.html",
        arnPattern:
          "arn:${Partition}:servicecatalog:${Region}:${Account}:/applications/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "AttributeGroup",
        referenceHref:
          "https://docs.aws.amazon.com/servicecatalog/latest/dg/API_app-registry_CreateAttributeGroup.html",
        arnPattern:
          "arn:${Partition}:servicecatalog:${Region}:${Account}:/attribute-groups/${AttributeGroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Portfolio",
        referenceHref:
          "https://docs.aws.amazon.com/servicecatalog/latest/dg/API_PortfolioDetail.html",
        arnPattern:
          "arn:${Partition}:catalog:${Region}:${Account}:portfolio/${PortfolioId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "Product",
        referenceHref:
          "https://docs.aws.amazon.com/servicecatalog/latest/dg/API_ProductViewDetail.html",
        arnPattern:
          "arn:${Partition}:catalog:${Region}:${Account}:product/${ProductId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [],
  },
  "private-networks": {
    name: "AWS service providing managed private networks",
    servicePrefix: "private-networks",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsserviceprovidingmanagedprivatenetworks.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/private-networks/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "network",
        referenceHref:
          "https://docs.aws.amazon.com/private-networks/latest/userguide/identity-access-management.html",
        arnPattern:
          "arn:${Partition}:private-networks:${Region}:${Account}:network/${NetworkName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "network-site",
        referenceHref:
          "https://docs.aws.amazon.com/private-networks/latest/userguide/identity-access-management.html",
        arnPattern:
          "arn:${Partition}:private-networks:${Region}:${Account}:network-site/${NetworkName}/${NetworkSiteName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "network-resource",
        referenceHref:
          "https://docs.aws.amazon.com/private-networks/latest/userguide/identity-access-management.html",
        arnPattern:
          "arn:${Partition}:private-networks:${Region}:${Account}:network-resource/${NetworkName}/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "order",
        referenceHref:
          "https://docs.aws.amazon.com/private-networks/latest/userguide/identity-access-management.html",
        arnPattern:
          "arn:${Partition}:private-networks:${Region}:${Account}:order/${NetworkName}/${OrderId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "device-identifier",
        referenceHref:
          "https://docs.aws.amazon.com/private-networks/latest/userguide/identity-access-management.html",
        arnPattern:
          "arn:${Partition}:private-networks:${Region}:${Account}:device-identifier/${NetworkName}/${DeviceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by checking the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by checking tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  servicequotas: {
    name: "Service Quotas",
    servicePrefix: "servicequotas",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_servicequotas.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/servicequotas/2019-06-24/apireference/",
    resourceTypes: [
      {
        name: "quota",
        referenceHref:
          "https://docs.aws.amazon.com/servicequotas/latest/userguide/identity-access-management.html#resources",
        arnPattern:
          "arn:${Partition}:servicequotas:${Region}:${Account}:${ServiceCode}/${QuotaCode}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "servicequotas:service",
        referenceHref:
          "https://docs.aws.amazon.com/servicequotas/latest/userguide/identity-access-management.html#condition-keys",
        description: "Filters access by the specified AWS service",
        type: "String",
      },
    ],
  },
  ssmmessages: {
    name: "Amazon Session Manager Message Gateway Service",
    servicePrefix: "ssmmessages",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsessionmanagermessagegatewayservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/systems-manager/latest/userguide/systems-manager-setting-up-messageAPIs.html",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "ec2:SourceInstanceARN",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the instance from which the request originated",
        type: "ARN",
      },
      {
        name: "ssm:SourceInstanceARN",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/security_iam_service-with-iam.html#policy-conditions",
        description:
          "Filters access by verifying the Amazon Resource Name (ARN) of the AWS Systems Manager's managed instance from which the request is made. This key is not present when the request comes from the managed instance authenticated with an IAM role associated with EC2 instance profile",
        type: "ARN",
      },
    ],
  },
  shield: {
    name: "AWS Shield",
    servicePrefix: "shield",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsshield.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/waf/latest/DDOSAPIReference/",
    resourceTypes: [
      {
        name: "attack",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/DDOSAPIReference/API_AttackDetail.html",
        arnPattern: "arn:${Partition}:shield::${Account}:attack/${Id}",
        conditionKeys: [],
      },
      {
        name: "protection",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/DDOSAPIReference/API_Protection.html",
        arnPattern: "arn:${Partition}:shield::${Account}:protection/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "protection-group",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/DDOSAPIReference/API_ProtectionGroup.html",
        arnPattern:
          "arn:${Partition}:shield::${Account}:protection-group/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  signer: {
    name: "AWS Signer",
    servicePrefix: "signer",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssigner.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/signer/latest/api/API_Operations.html",
    resourceTypes: [
      {
        name: "signing-profile",
        referenceHref:
          "https://docs.aws.amazon.com/signer/latest/developerguide/gs-profile.html",
        arnPattern:
          "arn:${Partition}:signer:${Region}:${Account}:/signing-profiles/${ProfileName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "signing-job",
        referenceHref:
          "https://docs.aws.amazon.com/signer/latest/developerguide/gs-job.html",
        arnPattern:
          "arn:${Partition}:signer:${Region}:${Account}:/signing-jobs/${JobId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "signer:ProfileVersion",
        referenceHref:
          "https://docs.aws.amazon.com/signer/latest/developerguide/authen-apipermissions.html",
        description: "Filters access by version of the Signing Profile",
        type: "String",
      },
    ],
  },
  swf: {
    name: "Amazon Simple Workflow Service",
    servicePrefix: "swf",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsimpleworkflowservice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/amazonswf/latest/apireference/",
    resourceTypes: [
      {
        name: "domain",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-domains.html",
        arnPattern: "arn:${Partition}:swf::${Account}:/domain/${DomainName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tag of the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag of the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag of the key",
        type: "ArrayOfString",
      },
      {
        name: "swf:activityType.name",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the name of the activity type",
        type: "String",
      },
      {
        name: "swf:activityType.version",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the version of the activity type",
        type: "String",
      },
      {
        name: "swf:defaultTaskList.name",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the name of the default task list",
        type: "String",
      },
      {
        name: "swf:name",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the name of activities or workflows",
        type: "String",
      },
      {
        name: "swf:tagFilter.tag",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the value of tagFilter.tag",
        type: "String",
      },
      {
        name: "swf:tagList.member.0",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the specified tag",
        type: "String",
      },
      {
        name: "swf:tagList.member.1",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the specified tag",
        type: "String",
      },
      {
        name: "swf:tagList.member.2",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the specified tag",
        type: "String",
      },
      {
        name: "swf:tagList.member.3",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the specified tag",
        type: "String",
      },
      {
        name: "swf:tagList.member.4",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the specified tag",
        type: "String",
      },
      {
        name: "swf:taskList.name",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the name of the tasklist",
        type: "String",
      },
      {
        name: "swf:typeFilter.name",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the name of the type filter",
        type: "String",
      },
      {
        name: "swf:typeFilter.version",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the version of the type filter",
        type: "String",
      },
      {
        name: "swf:version",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the version of activities or workflows",
        type: "String",
      },
      {
        name: "swf:workflowType.name",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the name of the workflow type",
        type: "String",
      },
      {
        name: "swf:workflowType.version",
        referenceHref:
          "https://docs.aws.amazon.com/amazonswf/latest/developerguide/swf-dev-iam.html##swf-dev-iam.api",
        description: "Filters access by the version of the workflow type",
        type: "String",
      },
    ],
  },
  sdb: {
    name: "Amazon SimpleDB",
    servicePrefix: "sdb",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsimpledb.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AmazonSimpleDB/latest/DeveloperGuide/SDB_API.html",
    resourceTypes: [
      {
        name: "domain",
        referenceHref:
          "https://docs.aws.amazon.com/AmazonSimpleDB/latest/DeveloperGuide/DataModel.html",
        arnPattern:
          "arn:${Partition}:sdb:${Region}:${Account}:domain/${DomainName}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  simspaceweaver: {
    name: "AWS SimSpace Weaver",
    servicePrefix: "simspaceweaver",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssimspaceweaver.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/simspaceweaver/latest/APIReference/",
    resourceTypes: [
      {
        name: "Simulation",
        referenceHref:
          "https://docs.aws.amazon.com/simspaceweaver/latest/userguide/working-with_configuring-simulation.html",
        arnPattern:
          "arn:${Partition}:simspaceweaver:${Region}:${Account}:simulation/${SimulationName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "snow-device-management": {
    name: "AWS Snow Device Management",
    servicePrefix: "snow-device-management",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssnowdevicemanagement.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/snowball/latest/snowcone-guide/sdms-cli-commands.html",
    resourceTypes: [
      {
        name: "managed-device",
        referenceHref:
          "https://docs.aws.amazon.com/snowball/latest/snowcone-guide/aws-sdms.html",
        arnPattern:
          "arn:${Partition}:snow-device-management:${Region}:${Account}:managed-device/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "task",
        referenceHref:
          "https://docs.aws.amazon.com/snowball/latest/snowcone-guide/aws-sdms.html",
        arnPattern:
          "arn:${Partition}:snow-device-management:${Region}:${Account}:task/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the presence of tag keys in the request",
        type: "String",
      },
    ],
  },
  snowball: {
    name: "AWS Snowball",
    servicePrefix: "snowball",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssnowball.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/snowball/latest/api-reference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  sns: {
    name: "Amazon SNS",
    servicePrefix: "sns",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsns.html",
    apiReferenceHref: "https://docs.aws.amazon.com/sns/latest/api/",
    resourceTypes: [
      {
        name: "topic",
        referenceHref:
          "https://docs.aws.amazon.com/sns/latest/dg/CreateTopic.html",
        arnPattern: "arn:${Partition}:sns:${Region}:${Account}:${TopicName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags from request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by tag keys from request",
        type: "ArrayOfString",
      },
      {
        name: "sns:Endpoint",
        referenceHref:
          "https://docs.aws.amazon.com/sns/latest/dg/UsingIAMwithSNS.html#w2ab1c11c23c19",
        description:
          "Filters access by the URL, email address, or ARN from a Subscribe request or a previously confirmed subscription",
        type: "String",
      },
      {
        name: "sns:Protocol",
        referenceHref:
          "https://docs.aws.amazon.com/sns/latest/dg/UsingIAMwithSNS.html#w2ab1c11c23c19",
        description:
          "Filters access by the protocol value from a Subscribe request or a previously confirmed subscription",
        type: "String",
      },
    ],
  },
  sqlworkbench: {
    name: "AWS SQL Workbench",
    servicePrefix: "sqlworkbench",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssqlworkbench.html",
    apiReferenceHref: "https://docs.aws.amazon.com/redshift/latest/mgmt/",
    resourceTypes: [
      {
        name: "connection",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/query-editor-v2.html",
        arnPattern:
          "arn:${Partition}:sqlworkbench:${Region}:${Account}:connection/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "query",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/query-editor-v2.html",
        arnPattern:
          "arn:${Partition}:sqlworkbench:${Region}:${Account}:query/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "chart",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/query-editor-v2.html",
        arnPattern:
          "arn:${Partition}:sqlworkbench:${Region}:${Account}:chart/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "notebook",
        referenceHref:
          "https://docs.aws.amazon.com/redshift/latest/mgmt/query-editor-v2.html",
        arnPattern:
          "arn:${Partition}:sqlworkbench:${Region}:${Account}:notebook/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tags that are associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  sqs: {
    name: "Amazon SQS",
    servicePrefix: "sqs",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonsqs.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AWSSimpleQueueService/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  states: {
    name: "AWS Step Functions",
    servicePrefix: "states",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsstepfunctions.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/step-functions/latest/apireference/",
    resourceTypes: [
      {
        name: "activity",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/concepts-activities.html",
        arnPattern:
          "arn:${Partition}:states:${Region}:${Account}:activity:${ActivityName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "execution",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/concepts-state-machine-executions.html",
        arnPattern:
          "arn:${Partition}:states:${Region}:${Account}:execution:${StateMachineName}:${ExecutionId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "express",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/concepts-state-machine-executions.html",
        arnPattern:
          "arn:${Partition}:states:${Region}:${Account}:express:${StateMachineName}:${ExecutionId}:${ExpressId}",
        conditionKeys: [],
      },
      {
        name: "statemachine",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/concepts-amazon-states-language.html",
        arnPattern:
          "arn:${Partition}:states:${Region}:${Account}:stateMachine:${StateMachineName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "statemachineversion",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/concepts-cd-aliasing-versioning.html",
        arnPattern:
          "arn:${Partition}:states:${Region}:${Account}:stateMachine:${StateMachineName}:${StateMachineVersionId}",
        conditionKeys: [],
      },
      {
        name: "statemachinealias",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/concepts-cd-aliasing-versioning.html",
        arnPattern:
          "arn:${Partition}:states:${Region}:${Account}:stateMachine:${StateMachineName}:${StateMachineAliasName}",
        conditionKeys: [],
      },
      {
        name: "maprun",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/concepts-examine-map-run.html",
        arnPattern:
          "arn:${Partition}:states:${Region}:${Account}:mapRun:${StateMachineName}/${MapRunLabel}:${MapRunId}",
        conditionKeys: [],
      },
      {
        name: "labelled execution",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/concepts-examine-map-run.html",
        arnPattern:
          "arn:${Partition}:states:${Region}:${Account}:execution:${StateMachineName}/${MapRunLabel}:${ExecutionId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by a tag key and value pair that is allowed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by a tag key and value pair of a resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by a list of tag keys that are allowed in the request",
        type: "ArrayOfString",
      },
      {
        name: "states:HTTPEndpoint",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/connect-third-party-apis.html",
        description:
          "Filters access by the endpoint that the HTTP Task state allows in the request",
        type: "String",
      },
      {
        name: "states:HTTPMethod",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/connect-third-party-apis.html",
        description:
          "Filters access by the method that the HTTP Task state allows in the request",
        type: "String",
      },
      {
        name: "states:StateMachineQualifier",
        referenceHref:
          "https://docs.aws.amazon.com/step-functions/latest/dg/auth-version-alias.html",
        description: "Filters access by the qualifier of a state machine ARN",
        type: "String",
      },
    ],
  },
  storagegateway: {
    name: "AWS Storage Gateway",
    servicePrefix: "storagegateway",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsstoragegateway.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/storagegateway/latest/APIReference/",
    resourceTypes: [
      {
        name: "device",
        referenceHref:
          "https://docs.aws.amazon.com/storagegateway/latest/userguide/resource_vtl-devices.html",
        arnPattern:
          "arn:${Partition}:storagegateway:${Region}:${Account}:gateway/${GatewayId}/device/${Vtldevice}",
        conditionKeys: [],
      },
      {
        name: "fs-association",
        referenceHref:
          "https://docs.aws.amazon.com/storagegateway/latest/userguide/API_AssociateFileSystem.html",
        arnPattern:
          "arn:${Partition}:storagegateway:${Region}:${Account}:fs-association/${FsaId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "gateway",
        referenceHref:
          "https://docs.aws.amazon.com/storagegateway/latest/userguide/StorageGatewayConcepts.html",
        arnPattern:
          "arn:${Partition}:storagegateway:${Region}:${Account}:gateway/${GatewayId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "share",
        referenceHref:
          "https://docs.aws.amazon.com/storagegateway/latest/userguide/GettingStartedCreateFileShare.html",
        arnPattern:
          "arn:${Partition}:storagegateway:${Region}:${Account}:share/${ShareId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "tape",
        referenceHref:
          "https://docs.aws.amazon.com/storagegateway/latest/userguide/StorageGatewayConcepts.html#storage-gateway-vtl-concepts",
        arnPattern:
          "arn:${Partition}:storagegateway:${Region}:${Account}:tape/${TapeBarcode}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "tapepool",
        referenceHref:
          "https://docs.aws.amazon.com/storagegateway/latest/userguide/CreatingCustomTapePool.html",
        arnPattern:
          "arn:${Partition}:storagegateway:${Region}:${Account}:tapepool/${PoolId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "target",
        referenceHref:
          "https://docs.aws.amazon.com/storagegateway/latest/userguide/GettingStartedCreateVolumes.html",
        arnPattern:
          "arn:${Partition}:storagegateway:${Region}:${Account}:gateway/${GatewayId}/target/${IscsiTarget}",
        conditionKeys: [],
      },
      {
        name: "volume",
        referenceHref:
          "https://docs.aws.amazon.com/storagegateway/latest/userguide/StorageGatewayConcepts.html#volume-gateway-concepts",
        arnPattern:
          "arn:${Partition}:storagegateway:${Region}:${Account}:gateway/${GatewayId}/volume/${VolumeId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  scn: {
    name: "AWS Supply Chain",
    servicePrefix: "scn",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssupplychain.html",
    apiReferenceHref: "https://docs.aws.amazon.com/aws-supply-chain/",
    resourceTypes: [
      {
        name: "instance",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssupplychain.html",
        arnPattern:
          "arn:${Partition}:scn:${Region}:${Account}:instance/${InstanceId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by using tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by using tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by using tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  support: {
    name: "AWS Support",
    servicePrefix: "support",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssupport.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awssupport/latest/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  supportapp: {
    name: "AWS Support App in Slack",
    servicePrefix: "supportapp",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssupportappinslack.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/supportapp/latest/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  supportplans: {
    name: "AWS Support Plans",
    servicePrefix: "supportplans",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssupportplans.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awssupport/latest/user/security-support-plans.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  sustainability: {
    name: "AWS Sustainability",
    servicePrefix: "sustainability",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssustainability.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/aws-cost-management/latest/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  ssm: {
    name: "AWS Systems Manager",
    servicePrefix: "ssm",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/systems-manager/latest/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by 'Create' requests based on the allowed set of values for a specified tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by based on a tag key-value pair assigned to the AWS resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by 'Create' requests based on whether mandatory tags are included in the request",
        type: "ArrayOfString",
      },
      {
        name: "ec2:SourceInstanceARN",
        referenceHref:
          "https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/iam-policy-structure.html#amazon-ec2-keys",
        description:
          "Filters access by the ARN of the instance from which the request originated",
        type: "ARN",
      },
      {
        name: "ssm:AutoApprove",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/change-manager-auto-approval-access.html",
        description:
          "Filters access by verifying that a user has permission to start Change Manager workflows without a review step (with the exception of change freeze events)",
        type: "Bool",
      },
      {
        name: "ssm:DocumentCategories",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by verifying that a user has permission to access a document belonging to a specific category enum",
        type: "ArrayOfString",
      },
      {
        name: "ssm:Overwrite",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by controling whether Systems Manager parameters can be overwritten",
        type: "String",
      },
      {
        name: "ssm:Recursive",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by Systems Manager parameters created in a hierarchical structure",
        type: "String",
      },
      {
        name: "ssm:SessionDocumentAccessCheck",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/getting-started-sessiondocumentaccesscheck.html",
        description:
          "Filters access by verifying that a user has permission to access either the default Session Manager configuration document or the custom configuration document specified in a request",
        type: "Bool",
      },
      {
        name: "ssm:SourceInstanceARN",
        referenceHref:
          "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanager.html#awssystemsmanager-policy-keys",
        description:
          "Filters access by verifying the Amazon Resource Name (ARN) of the AWS Systems Manager's managed instance from which the request is made. This key is not present when the request comes from the managed instance authenticated with an IAM role associated with EC2 instance profile",
        type: "ARN",
      },
      {
        name: "ssm:SyncType",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by verifying that a user also has access to the ResourceDataSync SyncType specified in the request",
        type: "String",
      },
      {
        name: "ssm:resourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/security_iam_service-with-iam.html#policy-conditions",
        description:
          "Filters access by a tag key-value pair assigned to the Systems Manager resource",
        type: "String",
      },
      {
        name: "ssm:resourceTag/aws:ssmmessages:session-id",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by based on a tag key-value pair assigned to the Systems Manager session resource",
        type: "String",
      },
      {
        name: "ssm:resourceTag/aws:ssmmessages:target-id",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by based on a tag key-value pair assigned to the Systems Manager session resource",
        type: "String",
      },
      {
        name: "ssm:resourceTag/tag-key",
        referenceHref:
          "https://docs.aws.amazon.com/systems-manager/latest/userguide/auth-and-access-control-iam-access-control-identity-based.html#policy-conditions",
        description:
          "Filters access by based on a tag key-value pair assigned to the Systems Manager resource",
        type: "String",
      },
    ],
  },
  "ssm-sap": {
    name: "AWS Systems Manager for SAP",
    servicePrefix: "ssm-sap",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanagerforsap.html",
    apiReferenceHref: "https://docs.aws.amazon.com/systems-manager/index.html",
    resourceTypes: [
      {
        name: "application",
        referenceHref: "https://docs.aws.amazon.com/systems-manager/index.html",
        arnPattern:
          "arn:${Partition}:ssm-sap:${Region}:${Account}:${ApplicationType}/${ApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "component",
        referenceHref: "https://docs.aws.amazon.com/systems-manager/index.html",
        arnPattern:
          "arn:${Partition}:ssm-sap:${Region}:${Account}:${ApplicationType}/${ApplicationId}/COMPONENT/${ComponentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "database",
        referenceHref: "https://docs.aws.amazon.com/systems-manager/index.html",
        arnPattern:
          "arn:${Partition}:ssm-sap:${Region}:${Account}:${ApplicationType}/${ApplicationId}/DB/${DatabaseId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref: "https://docs.aws.amazon.com/systems-manager/index.html",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref: "https://docs.aws.amazon.com/systems-manager/index.html",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref: "https://docs.aws.amazon.com/systems-manager/index.html",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "ssm-guiconnect": {
    name: "AWS Systems Manager GUI Connect",
    servicePrefix: "ssm-guiconnect",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanagerguiconnect.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/systems-manager/latest/userguide/fleet-rdp.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  "ssm-incidents": {
    name: "AWS Systems Manager Incident Manager",
    servicePrefix: "ssm-incidents",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanagerincidentmanager.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/incident-manager/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "response-plan",
        referenceHref:
          "https://docs.aws.amazon.com/incident-manager/latest/userguide/response-plans.html",
        arnPattern:
          "arn:${Partition}:ssm-incidents::${Account}:response-plan/${ResponsePlan}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "incident-record",
        referenceHref:
          "https://docs.aws.amazon.com/incident-manager/latest/userguide/tracking-details.html",
        arnPattern:
          "arn:${Partition}:ssm-incidents::${Account}:incident-record/${ResponsePlan}/${IncidentRecord}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "replication-set",
        referenceHref:
          "https://docs.aws.amazon.com/incident-manager/latest/userguide/disaster-recovery-resiliency.html#replication",
        arnPattern:
          "arn:${Partition}:ssm-incidents::${Account}:replication-set/${ReplicationSet}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "ssm-contacts": {
    name: "AWS Systems Manager Incident Manager Contacts",
    servicePrefix: "ssm-contacts",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanagerincidentmanagercontacts.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/incident-manager/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "contact",
        referenceHref:
          "https://docs.aws.amazon.com/incident-manager/latest/userguide/contacts.html",
        arnPattern:
          "arn:${Partition}:ssm-contacts:${Region}:${Account}:contact/${ContactAlias}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "contactchannel",
        referenceHref:
          "https://docs.aws.amazon.com/incident-manager/latest/userguide/contacts.html",
        arnPattern:
          "arn:${Partition}:ssm-contacts:${Region}:${Account}:contactchannel/${ContactAlias}/${ContactChannelId}",
        conditionKeys: [],
      },
      {
        name: "engagement",
        referenceHref:
          "https://docs.aws.amazon.com/incident-manager/latest/userguide/escalation.html",
        arnPattern:
          "arn:${Partition}:ssm-contacts:${Region}:${Account}:engagement/${ContactAlias}/${EngagementId}",
        conditionKeys: [],
      },
      {
        name: "page",
        referenceHref:
          "https://docs.aws.amazon.com/incident-manager/latest/userguide/escalation.html",
        arnPattern:
          "arn:${Partition}:ssm-contacts:${Region}:${Account}:page/${ContactAlias}/${PageId}",
        conditionKeys: [],
      },
      {
        name: "rotation",
        referenceHref:
          "https://docs.aws.amazon.com/incident-manager/latest/userguide/incident-manager-on-call-schedule.html",
        arnPattern:
          "arn:${Partition}:ssm-contacts:${Region}:${Account}:rotation/${RotationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  tax: {
    name: "AWS Tax Settings",
    servicePrefix: "tax",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awstaxsettings.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/api-reference.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  tnb: {
    name: "AWS Telco Network Builder",
    servicePrefix: "tnb",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awstelconetworkbuilder.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/tnb/latest/APIReference/Welcome.html",
    resourceTypes: [
      {
        name: "function-package",
        referenceHref:
          "https://docs.aws.amazon.com/tnb/latest/ug/function-packages.html",
        arnPattern:
          "arn:${Partition}:tnb:${Region}:${Account}:function-package/${FunctionPackageId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "network-package",
        referenceHref:
          "https://docs.aws.amazon.com/tnb/latest/ug/network-packages.html",
        arnPattern:
          "arn:${Partition}:tnb:${Region}:${Account}:network-package/${NetworkPackageId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "network-instance",
        referenceHref:
          "https://docs.aws.amazon.com/tnb/latest/ug/network-instances.html",
        arnPattern:
          "arn:${Partition}:tnb:${Region}:${Account}:network-instance/${NetworkInstanceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "function-instance",
        referenceHref:
          "https://docs.aws.amazon.com/tnb/latest/ug/function-packages.html",
        arnPattern:
          "arn:${Partition}:tnb:${Region}:${Account}:function-instance/${FunctionInstanceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "network-operation",
        referenceHref:
          "https://docs.aws.amazon.com/tnb/latest/ug/network-operations.html",
        arnPattern:
          "arn:${Partition}:tnb:${Region}:${Account}:network-operation/${NetworkOperationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by checking the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by checking tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  textract: {
    name: "Amazon Textract",
    servicePrefix: "textract",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazontextract.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/textract/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "adapter",
        referenceHref:
          "https://docs.aws.amazon.com/textract/latest/dg/API_AdapterOverview.html",
        arnPattern:
          "arn:${Partition}:textract:${Region}:${Account}:/adapters/${AdapterId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "adapterversion",
        referenceHref:
          "https://docs.aws.amazon.com/textract/latest/dg/API_AdapterVersionOverview.html",
        arnPattern:
          "arn:${Partition}:textract:${Region}:${Account}:/adapters/${AdapterId}/versions/${AdapterVersion}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  timestream: {
    name: "Amazon Timestream",
    servicePrefix: "timestream",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazontimestream.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/timestream/latest/developerguide/",
    resourceTypes: [
      {
        name: "database",
        referenceHref:
          "https://docs.aws.amazon.com/timestream/latest/developerguide/API_Database.html",
        arnPattern:
          "arn:${Partition}:timestream:${Region}:${Account}:database/${DatabaseName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "table",
        referenceHref:
          "https://docs.aws.amazon.com/timestream/latest/developerguide/API_Table.html",
        arnPattern:
          "arn:${Partition}:timestream:${Region}:${Account}:database/${DatabaseName}/table/${TableName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "scheduled-query",
        referenceHref:
          "https://docs.aws.amazon.com/timestream/latest/developerguide/API_ScheduledQuery.html",
        arnPattern:
          "arn:${Partition}:timestream:${Region}:${Account}:scheduled-query/${ScheduledQueryName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/timestream/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/timestream/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/timestream/latest/developerguide/security_iam_service-with-iam.html#security_iam_service-with-iam-tags",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  tiros: {
    name: "AWS Tiros",
    servicePrefix: "tiros",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awstiros.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AWSEC2/latest/APIReference/Welcome.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  transcribe: {
    name: "Amazon Transcribe",
    servicePrefix: "transcribe",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazontranscribe.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/transcribe/latest/dg/API_Reference.html",
    resourceTypes: [
      {
        name: "transcriptionjob",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_TranscriptionJob.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:transcription-job/${JobName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vocabulary",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_CreateVocabulary.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:vocabulary/${VocabularyName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "vocabularyfilter",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_CreateVocabularyFilter.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:vocabulary-filter/${VocabularyFilterName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "languagemodel",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_LanguageModel.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:language-model/${ModelName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "medicaltranscriptionjob",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_MedicalTranscriptionJob.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:medical-transcription-job/${JobName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "medicalvocabulary",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_CreateMedicalVocabulary.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:medical-vocabulary/${VocabularyName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "callanalyticsjob",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_CallAnalyticsJob.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:analytics-job/${JobName}",
        conditionKeys: [],
      },
      {
        name: "callanalyticscategory",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_CreateCallAnalyticsCategory.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:analytics-category/${CategoryName}",
        conditionKeys: [],
      },
      {
        name: "medicalscribejob",
        referenceHref:
          "https://docs.aws.amazon.com/transcribe/latest/dg/API_MedicalScribeJob.html",
        arnPattern:
          "arn:${Partition}:transcribe:${Region}:${Account}:medical-scribe-job/${JobName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring tag values present in a resource creation request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring tag value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
      {
        name: "transcribe:OutputBucketName",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazontranscribe.html#amazontranscribe-policy-keys",
        description:
          "Filters access based on the output bucket name included in the request",
        type: "String",
      },
      {
        name: "transcribe:OutputEncryptionKMSKeyId",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazontranscribe.html#amazontranscribe-policy-keys",
        description:
          "Filters access based on the KMS key id included in the request",
        type: "String",
      },
      {
        name: "transcribe:OutputKey",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazontranscribe.html#amazontranscribe-policy-keys",
        description:
          "Filters access based on the output key included in the request",
        type: "String",
      },
      {
        name: "transcribe:OutputLocation",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/list_amazontranscribe.html#amazontranscribe-policy-keys",
        description:
          "Filters access based on the output location included in the request",
        type: "String",
      },
    ],
  },
  transfer: {
    name: "AWS Transfer Family",
    servicePrefix: "transfer",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awstransferfamily.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/transfer/latest/userguide/api_reference.html",
    resourceTypes: [
      {
        name: "user",
        referenceHref:
          "https://docs.aws.amazon.com/transfer/latest/userguide/create-user.html",
        arnPattern:
          "arn:${Partition}:transfer:${Region}:${Account}:user/${ServerId}/${UserName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "server",
        referenceHref:
          "https://docs.aws.amazon.com/transfer/latest/userguide/configuring-servers.html",
        arnPattern:
          "arn:${Partition}:transfer:${Region}:${Account}:server/${ServerId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workflow",
        referenceHref:
          "https://docs.aws.amazon.com/transfer/latest/userguide/transfer-workflows.html",
        arnPattern:
          "arn:${Partition}:transfer:${Region}:${Account}:workflow/${WorkflowId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "certificate",
        referenceHref:
          "https://docs.aws.amazon.com/transfer/latest/userguide/create-b2b-server.html",
        arnPattern:
          "arn:${Partition}:transfer:${Region}:${Account}:certificate/${CertificateId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "connector",
        referenceHref:
          "https://docs.aws.amazon.com/transfer/latest/userguide/create-b2b-server.html",
        arnPattern:
          "arn:${Partition}:transfer:${Region}:${Account}:connector/${ConnectorId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "profile",
        referenceHref:
          "https://docs.aws.amazon.com/transfer/latest/userguide/create-b2b-server.html",
        arnPattern:
          "arn:${Partition}:transfer:${Region}:${Account}:profile/${ProfileId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "agreement",
        referenceHref:
          "https://docs.aws.amazon.com/transfer/latest/userguide/create-b2b-server.html",
        arnPattern:
          "arn:${Partition}:transfer:${Region}:${Account}:agreement/${AgreementId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "host-key",
        referenceHref:
          "https://docs.aws.amazon.com/transfer/latest/userguide/edit-server-config.html",
        arnPattern:
          "arn:${Partition}:transfer:${Region}:${Account}:host-key/${ServerId}/${HostKeyId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  translate: {
    name: "Amazon Translate",
    servicePrefix: "translate",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazontranslate.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/translate/latest/APIReference/API_Operations.html",
    resourceTypes: [
      {
        name: "terminology",
        referenceHref:
          "https://docs.aws.amazon.com/translate/latest/dg/how-custom-terminology.html",
        arnPattern:
          "arn:${Partition}:translate:${Region}:${Account}:terminology/${ResourceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "parallel-data",
        referenceHref:
          "https://docs.aws.amazon.com/translate/latest/dg/customizing-translations-parallel-data.html",
        arnPattern:
          "arn:${Partition}:translate:${Region}:${Account}:parallel-data/${ResourceName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring tag values present in a resource creation request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring tag value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-globally-available",
        description:
          "Filters access by requiring the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  trustedadvisor: {
    name: "AWS Trusted Advisor",
    servicePrefix: "trustedadvisor",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awstrustedadvisor.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/awssupport/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  notifications: {
    name: "AWS User Notifications",
    servicePrefix: "notifications",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsusernotifications.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/notifications/latest/userguide/resource-level-permissions.html",
    resourceTypes: [
      {
        name: "EventRule",
        referenceHref:
          "https://docs.aws.amazon.com/notifications/latest/userguide/resource-level-permissions.html",
        arnPattern:
          "arn:${Partition}:notifications::${Account}:configuration/${NotificationConfigurationId}/rule/${EventRuleId}",
        conditionKeys: [],
      },
      {
        name: "NotificationConfiguration",
        referenceHref:
          "https://docs.aws.amazon.com/notifications/latest/userguide/resource-level-permissions.html",
        arnPattern:
          "arn:${Partition}:notifications::${Account}:configuration/${NotificationConfigurationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "NotificationEvent",
        referenceHref:
          "https://docs.aws.amazon.com/notifications/latest/userguide/resource-level-permissions.html",
        arnPattern:
          "arn:${Partition}:notifications:${Region}:${Account}:configuration/${NotificationConfigurationId}/event/${NotificationEventId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "notifications-contacts": {
    name: "AWS User Notifications Contacts",
    servicePrefix: "notifications-contacts",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsusernotificationscontacts.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/notifications/latest/userguide/resource-level-permissions.html",
    resourceTypes: [
      {
        name: "EmailContactResource",
        referenceHref:
          "https://docs.aws.amazon.com/notifications/latest/userguide/resource-level-permissions.html",
        arnPattern:
          "arn:${Partition}:notifications-contacts::${Account}:emailcontact/${EmailContactId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "verified-access": {
    name: "AWS Verified Access",
    servicePrefix: "verified-access",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsverifiedaccess.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/AWSEC2/latest/APIReference/operation-list-verified-access.html",
    resourceTypes: [],
    conditionKeys: [],
  },
  verifiedpermissions: {
    name: "Amazon Verified Permissions",
    servicePrefix: "verifiedpermissions",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonverifiedpermissions.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/verifiedpermissions/latest/apireference/",
    resourceTypes: [
      {
        name: "policy-store",
        referenceHref:
          "https://docs.aws.amazon.com/verifiedpermissions/latest/apireference/policy-stores.html",
        arnPattern:
          "arn:${Partition}:verifiedpermissions::${Account}:policy-store/${PolicyStoreId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  "vpc-lattice": {
    name: "Amazon VPC Lattice",
    servicePrefix: "vpc-lattice",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonvpclattice.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/vpc-lattice/latest/APIReference/",
    resourceTypes: [
      {
        name: "ServiceNetwork",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/service-networks.html",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:servicenetwork/${ServiceNetworkId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "vpc-lattice:AuthType",
        ],
      },
      {
        name: "Service",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/services.html",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:service/${ServiceId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "vpc-lattice:AuthType",
        ],
      },
      {
        name: "ServiceNetworkVpcAssociation",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/service-network-associations.html#service-network-vpc-associations",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:servicenetworkvpcassociation/${ServiceNetworkVpcAssociationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "vpc-lattice:SecurityGroupIds",
          "vpc-lattice:ServiceNetworkArn",
          "vpc-lattice:VpcId",
        ],
      },
      {
        name: "ServiceNetworkServiceAssociation",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/service-network-associations.html#service-network-service-associations",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:servicenetworkserviceassociation/${ServiceNetworkServiceAssociationId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "vpc-lattice:ServiceArn",
          "vpc-lattice:ServiceNetworkArn",
        ],
      },
      {
        name: "TargetGroup",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/target-groups.html",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:targetgroup/${TargetGroupId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "vpc-lattice:VpcId",
        ],
      },
      {
        name: "Listener",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/listeners.html",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:service/${ServiceId}/listener/${ListenerId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "vpc-lattice:Protocol",
          "vpc-lattice:TargetGroupArns",
        ],
      },
      {
        name: "Rule",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/listeners.html#listener-rules",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:service/${ServiceId}/listener/${ListenerId}/rule/${RuleId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
          "vpc-lattice:TargetGroupArns",
        ],
      },
      {
        name: "AccessLogSubscription",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/monitoring-access-logs.html",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:accesslogsubscription/${AccessLogSubscriptionId}",
        conditionKeys: [
          "aws:RequestTag/${TagKey}",
          "aws:ResourceTag/${TagKey}",
          "aws:TagKeys",
        ],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of tag keys in the request",
        type: "ArrayOfString",
      },
      {
        name: "vpc-lattice:AuthType",
        referenceHref: "https://docs.aws.amazon.com/vpc-lattice/latest/ug/",
        description: "Filters access by the auth type specified in the request",
        type: "String",
      },
      {
        name: "vpc-lattice:Protocol",
        referenceHref: "https://docs.aws.amazon.com/vpc-lattice/latest/ug/",
        description: "Filters access by the protocol specified in the request",
        type: "String",
      },
      {
        name: "vpc-lattice:SecurityGroupIds",
        referenceHref: "https://docs.aws.amazon.com/vpc-lattice/latest/ug/",
        description: "Filters access by the IDs of security groups",
        type: "ArrayOfString",
      },
      {
        name: "vpc-lattice:ServiceArn",
        referenceHref: "https://docs.aws.amazon.com/vpc-lattice/latest/ug/",
        description: "Filters access by the ARN of a service",
        type: "ARN",
      },
      {
        name: "vpc-lattice:ServiceNetworkArn",
        referenceHref: "https://docs.aws.amazon.com/vpc-lattice/latest/ug/",
        description: "Filters access by the ARN of a service network",
        type: "ARN",
      },
      {
        name: "vpc-lattice:TargetGroupArns",
        referenceHref: "https://docs.aws.amazon.com/vpc-lattice/latest/ug/",
        description: "Filters access by the ARNs of target groups",
        type: "ArrayOfARN",
      },
      {
        name: "vpc-lattice:VpcId",
        referenceHref: "https://docs.aws.amazon.com/vpc-lattice/latest/ug/",
        description:
          "Filters access by the ID of a virtual private cloud (VPC)",
        type: "String",
      },
    ],
  },
  "vpc-lattice-svcs": {
    name: "Amazon VPC Lattice Services",
    servicePrefix: "vpc-lattice-svcs",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonvpclatticeservices.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/vpc-lattice/latest/APIReference/",
    resourceTypes: [
      {
        name: "Service",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/services.html",
        arnPattern:
          "arn:${Partition}:vpc-lattice:${Region}:${Account}:service/${ServiceId}/${RequestPath}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "vpc-lattice-svcs:Port",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/auth-policies.html#auth-policies-condition-keys",
        description:
          "Filters access by the destination port the request is made to",
        type: "Numeric",
      },
      {
        name: "vpc-lattice-svcs:RequestHeader/${HeaderName}",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/auth-policies.html#auth-policies-condition-keys",
        description:
          "Filters access by a header name-value pair in the request headers",
        type: "String",
      },
      {
        name: "vpc-lattice-svcs:RequestMethod",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/auth-policies.html#auth-policies-condition-keys",
        description: "Filters access by the method of the request",
        type: "String",
      },
      {
        name: "vpc-lattice-svcs:RequestQueryString/${QueryStringKey}",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/auth-policies.html#auth-policies-condition-keys",
        description:
          "Filters access by the query string key-value pairs in the request URL",
        type: "ArrayOfString",
      },
      {
        name: "vpc-lattice-svcs:ServiceArn",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/auth-policies.html#auth-policies-condition-keys",
        description:
          "Filters access by the ARN of the service receiving the request",
        type: "ARN",
      },
      {
        name: "vpc-lattice-svcs:ServiceNetworkArn",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/auth-policies.html#auth-policies-condition-keys",
        description:
          "Filters access by the ARN of the service network receiving the request",
        type: "ARN",
      },
      {
        name: "vpc-lattice-svcs:SourceVpc",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/auth-policies.html#auth-policies-condition-keys",
        description: "Filters access by the VPC the request is made from",
        type: "String",
      },
      {
        name: "vpc-lattice-svcs:SourceVpcOwnerAccount",
        referenceHref:
          "https://docs.aws.amazon.com/vpc-lattice/latest/ug/auth-policies.html#auth-policies-condition-keys",
        description:
          "Filters access by the owning account of the VPC the request is made from",
        type: "String",
      },
    ],
  },
  waf: {
    name: "AWS WAF",
    servicePrefix: "waf",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awswaf.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/waf/latest/APIReference/API_Operations_AWS_WAF.html",
    resourceTypes: [
      {
        name: "bytematchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_ByteMatchSet.html",
        arnPattern: "arn:${Partition}:waf::${Account}:bytematchset/${Id}",
        conditionKeys: [],
      },
      {
        name: "ipset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_IPSet.html",
        arnPattern: "arn:${Partition}:waf::${Account}:ipset/${Id}",
        conditionKeys: [],
      },
      {
        name: "ratebasedrule",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_RateBasedRule.html",
        arnPattern: "arn:${Partition}:waf::${Account}:ratebasedrule/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "rule",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_Rule.html",
        arnPattern: "arn:${Partition}:waf::${Account}:rule/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "sizeconstraintset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_SizeConstraintSet.html",
        arnPattern: "arn:${Partition}:waf::${Account}:sizeconstraintset/${Id}",
        conditionKeys: [],
      },
      {
        name: "sqlinjectionmatchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_SqlInjectionMatchSet.html",
        arnPattern: "arn:${Partition}:waf::${Account}:sqlinjectionset/${Id}",
        conditionKeys: [],
      },
      {
        name: "webacl",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_WebACL.html",
        arnPattern: "arn:${Partition}:waf::${Account}:webacl/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "xssmatchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_XssMatchSet.html",
        arnPattern: "arn:${Partition}:waf::${Account}:xssmatchset/${Id}",
        conditionKeys: [],
      },
      {
        name: "regexmatchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_RegexMatchSet.html",
        arnPattern: "arn:${Partition}:waf::${Account}:regexmatch/${Id}",
        conditionKeys: [],
      },
      {
        name: "regexpatternset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_RegexPatternSet.html",
        arnPattern: "arn:${Partition}:waf::${Account}:regexpatternset/${Id}",
        conditionKeys: [],
      },
      {
        name: "geomatchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_GeoMatchSet.html",
        arnPattern: "arn:${Partition}:waf::${Account}:geomatchset/${Id}",
        conditionKeys: [],
      },
      {
        name: "rulegroup",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_waf_RuleGroup.html",
        arnPattern: "arn:${Partition}:waf::${Account}:rulegroup/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "waf-regional": {
    name: "AWS WAF Regional",
    servicePrefix: "waf-regional",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awswafregional.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/waf/latest/APIReference/API_Operations_AWS_WAF_Regional.html",
    resourceTypes: [
      {
        name: "bytematchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_ByteMatchSet.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:bytematchset/${Id}",
        conditionKeys: [],
      },
      {
        name: "ipset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_IPSet.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:ipset/${Id}",
        conditionKeys: [],
      },
      {
        name: "loadbalancer/app/",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_WebACL.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:loadbalancer/app/${LoadBalancerName}/${LoadBalancerId}",
        conditionKeys: [],
      },
      {
        name: "ratebasedrule",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_RateBasedRule.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:ratebasedrule/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "rule",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_Rule.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:rule/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "sizeconstraintset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_SizeConstraintSet.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:sizeconstraintset/${Id}",
        conditionKeys: [],
      },
      {
        name: "sqlinjectionmatchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_SqlInjectionMatchSet.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:sqlinjectionset/${Id}",
        conditionKeys: [],
      },
      {
        name: "webacl",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_WebACL.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:webacl/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "xssmatchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_XssMatchSet.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:xssmatchset/${Id}",
        conditionKeys: [],
      },
      {
        name: "regexmatchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_RegexMatchSet.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:regexmatch/${Id}",
        conditionKeys: [],
      },
      {
        name: "regexpatternset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_RegexPatternSet.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:regexpatternset/${Id}",
        conditionKeys: [],
      },
      {
        name: "geomatchset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_GeoMatchSet.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:geomatchset/${Id}",
        conditionKeys: [],
      },
      {
        name: "rulegroup",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_wafRegional_RuleGroup.html",
        arnPattern:
          "arn:${Partition}:waf-regional:${Region}:${Account}:rulegroup/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag-value assoicated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  wafv2: {
    name: "AWS WAF V2",
    servicePrefix: "wafv2",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awswafv2.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/waf/latest/APIReference/API_Operations_AWS_WAFV2.html",
    resourceTypes: [
      {
        name: "webacl",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_WebACL.html",
        arnPattern:
          "arn:${Partition}:wafv2:${Region}:${Account}:${Scope}/webacl/${Name}/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ipset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_IPSet.html",
        arnPattern:
          "arn:${Partition}:wafv2:${Region}:${Account}:${Scope}/ipset/${Name}/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "managedruleset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_ManagedRuleSet.html",
        arnPattern:
          "arn:${Partition}:wafv2:${Region}:${Account}:${Scope}/managedruleset/${Name}/${Id}",
        conditionKeys: [],
      },
      {
        name: "rulegroup",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_RuleGroup.html",
        arnPattern:
          "arn:${Partition}:wafv2:${Region}:${Account}:${Scope}/rulegroup/${Name}/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "regexpatternset",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_RegexPatternSet.html",
        arnPattern:
          "arn:${Partition}:wafv2:${Region}:${Account}:${Scope}/regexpatternset/${Name}/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "loadbalancer/app/",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_WebACL.html",
        arnPattern:
          "arn:${Partition}:elasticloadbalancing:${Region}:${Account}:loadbalancer/app/${LoadBalancerName}/${LoadBalancerId}",
        conditionKeys: [],
      },
      {
        name: "apigateway",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_WebACL.html",
        arnPattern:
          "arn:${Partition}:apigateway:${Region}::/restapis/${ApiId}/stages/${StageName}",
        conditionKeys: [],
      },
      {
        name: "appsync",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_WebACL.html",
        arnPattern:
          "arn:${Partition}:appsync:${Region}:${Account}:apis/${GraphQLAPIId}",
        conditionKeys: [],
      },
      {
        name: "userpool",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_WebACL.html",
        arnPattern:
          "arn:${Partition}:cognito-idp:${Region}:${Account}:userpool/${UserPoolId}",
        conditionKeys: [],
      },
      {
        name: "apprunner",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_WebACL.html",
        arnPattern:
          "arn:${Partition}:apprunner:${Region}:${Account}:service/${ServiceName}/${ServiceId}",
        conditionKeys: [],
      },
      {
        name: "verified-access-instance",
        referenceHref:
          "https://docs.aws.amazon.com/waf/latest/APIReference/API_WebACL.html",
        arnPattern:
          "arn:${Partition}:ec2:${Region}:${Account}:verified-access-instance/${VerifiedAccessInstanceId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the allowed set of values for each of the tags",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by tag-value associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the presence of mandatory tags in the request",
        type: "ArrayOfString",
      },
    ],
  },
  wellarchitected: {
    name: "AWS Well-Architected Tool",
    servicePrefix: "wellarchitected",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awswell-architectedtool.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/wellarchitected/latest/APIReference/",
    resourceTypes: [
      {
        name: "workload",
        referenceHref:
          "https://docs.aws.amazon.com/wellarchitected/latest/APIReference/API_Workload.html",
        arnPattern:
          "arn:${Partition}:wellarchitected:${Region}:${Account}:workload/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "lens",
        referenceHref:
          "https://docs.aws.amazon.com/wellarchitected/latest/APIReference/API_Lens.html",
        arnPattern:
          "arn:${Partition}:wellarchitected:${Region}:${Account}:lens/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "profile",
        referenceHref:
          "https://docs.aws.amazon.com/wellarchitected/latest/APIReference/API_Profile.html",
        arnPattern:
          "arn:${Partition}:wellarchitected:${Region}:${Account}:profile/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "review-template",
        referenceHref:
          "https://docs.aws.amazon.com/wellarchitected/latest/APIReference/API_ReviewTemplate.html",
        arnPattern:
          "arn:${Partition}:wellarchitected:${Region}:${Account}:review-template/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  wickr: {
    name: "AWS Wickr",
    servicePrefix: "wickr",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awswickr.html",
    apiReferenceHref: "https://docs.aws.amazon.com/wickr/latest/adminguide/",
    resourceTypes: [
      {
        name: "network",
        referenceHref: "https://docs.aws.amazon.com/wickr/latest/adminguide/",
        arnPattern:
          "arn:${Partition}:wickr:${Region}:${Account}:network/${NetworkId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description: "Filters access by a tag's key and value in a request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description: "Filters access by the tag keys in a request",
        type: "ArrayOfString",
      },
    ],
  },
  workdocs: {
    name: "Amazon WorkDocs",
    servicePrefix: "workdocs",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonworkdocs.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/workdocs/latest/APIReference/",
    resourceTypes: [],
    conditionKeys: [],
  },
  worklink: {
    name: "Amazon WorkLink",
    servicePrefix: "worklink",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonworklink.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/worklink/latest/api/Welcome.html",
    resourceTypes: [
      {
        name: "fleet",
        referenceHref:
          "https://docs.aws.amazon.com/worklink/latest/api/API_CreateFleet.html",
        arnPattern: "arn:${Partition}:worklink::${Account}:fleet/${FleetName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters actions based on the presence of tag key-value pairs in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters actions based on tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters actions based on the presence of tag keys in the request",
        type: "ArrayOfString",
      },
    ],
  },
  workmail: {
    name: "Amazon WorkMail",
    servicePrefix: "workmail",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonworkmail.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/workmail/latest/APIReference/",
    resourceTypes: [
      {
        name: "organization",
        referenceHref:
          "https://docs.aws.amazon.com/workmail/latest/adminguide/organizations_overview.html",
        arnPattern:
          "arn:${Partition}:workmail:${Region}:${Account}:organization/${ResourceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tag key-value pairs that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access by the tag key-value pairs attached to the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  workmailmessageflow: {
    name: "Amazon WorkMail Message Flow",
    servicePrefix: "workmailmessageflow",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonworkmailmessageflow.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/workmail/latest/APIReference/",
    resourceTypes: [
      {
        name: "RawMessage",
        referenceHref:
          "https://docs.aws.amazon.com/workmail/latest/adminguide/lambda-content.html",
        arnPattern:
          "arn:${Partition}:workmailmessageflow:${Region}:${Account}:message/${OrganizationId}/${Context}/${MessageId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [],
  },
  workspaces: {
    name: "Amazon WorkSpaces",
    servicePrefix: "workspaces",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonworkspaces.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/workspaces/latest/api/welcome.html",
    resourceTypes: [
      {
        name: "directoryid",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces/latest/adminguide/manage-workspaces-directory.html",
        arnPattern:
          "arn:${Partition}:workspaces:${Region}:${Account}:directory/${DirectoryId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workspacebundle",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces/latest/adminguide/bundles.html",
        arnPattern:
          "arn:${Partition}:workspaces:${Region}:${Account}:workspacebundle/${BundleId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workspaceid",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces/latest/adminguide/wsp_workspace_management.html",
        arnPattern:
          "arn:${Partition}:workspaces:${Region}:${Account}:workspace/${WorkspaceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workspaceimage",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces/latest/adminguide/bundles.html",
        arnPattern:
          "arn:${Partition}:workspaces:${Region}:${Account}:workspaceimage/${ImageId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workspaceipgroup",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces/latest/adminguide/amazon-workspaces-ip-access-control-groups.html",
        arnPattern:
          "arn:${Partition}:workspaces:${Region}:${Account}:workspaceipgroup/${GroupId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "connectionalias",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces/latest/adminguide/cross-region-redirection.html",
        arnPattern:
          "arn:${Partition}:workspaces:${Region}:${Account}:connectionalias/${ConnectionAliasId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "workspaceapplication",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces/latest/adminguide/application-bundle-management.html",
        arnPattern:
          "arn:${Partition}:workspaces:${Region}:${Account}:workspaceapplication/${WorkSpaceApplicationId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access based on the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description:
          "Filters access based on the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access based on the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
      {
        name: "workspaces:userId",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces/latest/adminguide/external-identity-providers-setting-up-saml.html#external-identity-providers-embed-inline-policy-for-IAM-role",
        description: "Filters access by the ID of the Workspaces user",
        type: "String",
      },
    ],
  },
  wam: {
    name: "Amazon WorkSpaces Application Manager",
    servicePrefix: "wam",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonworkspacesapplicationmanager.html",
    apiReferenceHref: "https://docs.aws.amazon.com/wam/latest/adminguide/",
    resourceTypes: [],
    conditionKeys: [],
  },
  thinclient: {
    name: "Amazon WorkSpaces Thin Client",
    servicePrefix: "thinclient",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonworkspacesthinclient.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/workspaces-thin-client/latest/api/",
    resourceTypes: [
      {
        name: "environment",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-thin-client/latest/api/API_Environment.html",
        arnPattern:
          "arn:${Partition}:thinclient::${Account}:environment/${EnvironmentId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "device",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-thin-client/latest/api/API_Device.html",
        arnPattern:
          "arn:${Partition}:thinclient::${Account}:device/${DeviceId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "softwareset",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-thin-client/latest/api/API_SoftwareSet.html",
        arnPattern:
          "arn:${Partition}:thinclient::${Account}:softwareset/${SoftwareSetId}",
        conditionKeys: [],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  "workspaces-web": {
    name: "Amazon WorkSpaces Web",
    servicePrefix: "workspaces-web",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_amazonworkspacesweb.html",
    apiReferenceHref:
      "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/",
    resourceTypes: [
      {
        name: "browserSettings",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/API_CreateBrowserSettings.html",
        arnPattern:
          "arn:${Partition}:workspaces-web:${Region}:${Account}:browserSettings/${BrowserSettingsId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "identityProvider",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/API_CreateIdentityProvider.html",
        arnPattern:
          "arn:${Partition}:workspaces-web:${Region}:${Account}:identityProvider/${PortalId}/${IdentityProviderId}",
        conditionKeys: [],
      },
      {
        name: "networkSettings",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/API_CreateNetworkSettings.html",
        arnPattern:
          "arn:${Partition}:workspaces-web:${Region}:${Account}:networkSettings/${NetworkSettingsId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "portal",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/API_CreatePortal.html",
        arnPattern:
          "arn:${Partition}:workspaces-web:${Region}:${Account}:portal/${PortalId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "trustStore",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/API_CreateTrustStore.html",
        arnPattern:
          "arn:${Partition}:workspaces-web:${Region}:${Account}:trustStore/${TrustStoreId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "userSettings",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/API_CreateUserSettings.html",
        arnPattern:
          "arn:${Partition}:workspaces-web:${Region}:${Account}:userSettings/${UserSettingsId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "userAccessLoggingSettings",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/API_CreateUserAccessLoggingSettings.html",
        arnPattern:
          "arn:${Partition}:workspaces-web:${Region}:${Account}:userAccessLoggingSettings/${UserAccessLoggingSettingsId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "ipAccessSettings",
        referenceHref:
          "https://docs.aws.amazon.com/workspaces-web/latest/APIReference/API_CreateIpAccessSettings.html",
        arnPattern:
          "arn:${Partition}:workspaces-web:${Region}:${Account}:ipAccessSettings/${IpAccessSettingsId}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
  xray: {
    name: "AWS X-Ray",
    servicePrefix: "xray",
    authReferenceHref:
      "https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsx-ray.html",
    apiReferenceHref: "https://docs.aws.amazon.com/xray/latest/api/",
    resourceTypes: [
      {
        name: "group",
        referenceHref:
          "https://docs.aws.amazon.com/xray/latest/devguide/xray-concepts.html#xray-concepts-groups",
        arnPattern:
          "arn:${Partition}:xray:${Region}:${Account}:group/${GroupName}/${Id}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
      {
        name: "sampling-rule",
        referenceHref:
          "https://docs.aws.amazon.com/xray/latest/devguide/xray-concepts.html#xray-concepts-sampling",
        arnPattern:
          "arn:${Partition}:xray:${Region}:${Account}:sampling-rule/${SamplingRuleName}",
        conditionKeys: ["aws:ResourceTag/${TagKey}"],
      },
    ],
    conditionKeys: [
      {
        name: "aws:RequestTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-requesttag",
        description:
          "Filters access by the tags that are passed in the request",
        type: "String",
      },
      {
        name: "aws:ResourceTag/${TagKey}",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-resourcetag",
        description: "Filters access by the tags associated with the resource",
        type: "String",
      },
      {
        name: "aws:TagKeys",
        referenceHref:
          "https://docs.aws.amazon.com/IAM/latest/UserGuide/reference_policies_condition-keys.html#condition-keys-tagkeys",
        description:
          "Filters access by the tag keys that are passed in the request",
        type: "ArrayOfString",
      },
    ],
  },
};
